import * as React from 'react';
import React__default, { useContext, createElement as createElement$1, Fragment as Fragment$1, createContext, forwardRef, useState, useMemo, useRef, useEffect, useCallback, useReducer } from 'react';
import { jsx as jsx$1, jsxs as jsxs$1, Fragment as Fragment$2 } from 'react/jsx-runtime';
import { UserDataProvider, useConfig, useRoutes, useCurrentPerson, useConnection, useLocalize, useBanners, useLogisticBanners, UserPublicDataProvider, DesktopNotificationsProvider, LogisticBannersProvider, WorkflowDefinitionTrackerProvider, OngoingWorkflowTrackerProvider, BannersProvider, useIntersectObserver, useResources, useKitModels, useKit, usePatients, usePatientGroup, useLogisticsNotes, useKitAssignment, usePeople, useItem, PatientsProvider, PatientGroupProvider, LogisticsNotesProvider, KitModelsProvider, KitProvider, CurrentPersonProvider, PeopleProvider, OrganizationNamesProvider, KitAssignmentProvider, useReportSchema, useOrgSchemas, useRawReport, useAllPatients, useOrgGroups, useCustomReportsList, OrgSchemasProvider, RawReportProvider, ReportSchemaProvider, AllPatientsProvider, OrgGroupsProvider, CustomReportsListProvider, useAdminOrganization, AdminOrganizationProvider, ItemProvider, ItemModelsProvider, useItemModels, useOrganizationNames, KitStates, PatientStates, useCustomIndicators, useWorkflow, WorkflowProvider, CustomIndicatorsProvider } from '@aetonix/hooks';
import { ListItemText, ListItem, Collapse, Button, Badge, IconButton, Drawer, AppBar, Toolbar, List, Divider, Link as Link$1, Typography, Checkbox, makeStyles, createStyles, Tooltip, TextField, InputLabel, FormControl, ThemeProvider, Menu as Menu$1, MenuItem as MenuItem$1, DialogTitle, Dialog, DialogContent, DialogActions as DialogActions$1, LinearProgress, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, ListSubheader, Snackbar, Box, Select as Select$1, Tabs, Tab, ListItemAvatar, Avatar, CircularProgress, TextareaAutosize, FormGroup, Chip, TableContainer, Paper, Table as Table$1, TableHead, TableRow, TableCell as TableCell$1, TableBody, withStyles as withStyles$2, Modal, ListItemSecondaryAction, Slide, Fab } from '@material-ui/core';
import aeAPI from '@aetonix/ae-api';
import { Link } from 'react-router-dom';
import { ExpandLess, ExpandMore, Notifications as Notifications$2, LocalShipping, Menu, ExitToApp, Launch, Search, Close, Delete, LocalHospital, Stop, Sync, Note, History, Edit, Info, BugReport, Lock, Person, PermIdentity, Reply, DeleteForever, HourglassEmpty, Remove, MoreVert, Add, FileDownload, Save, Build, Call, ContactPhone, Home, KeyboardArrowDown } from '@material-ui/icons';
import { useUserMetrics } from '@aetonix/user-metrics';
import Button$1 from '@material-ui/core/Button';
import { styled, withStyles as withStyles$1, ThemeProvider as ThemeProvider$2 } from '@material-ui/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { createTheme, withStyles, makeStyles as makeStyles$1, styled as styled$1, ThemeProvider as ThemeProvider$1 } from '@material-ui/core/styles';
import { cyan, red, grey } from '@material-ui/core/colors';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { DebounceInput } from 'react-debounce-input';
import BugReportIcon from '@material-ui/icons/BugReport';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import clsx from 'clsx';
import { AutoSizer, Table, Column, WindowScroller } from 'react-virtualized';
import TableCell from '@material-ui/core/TableCell';
import CloseIcon from '@material-ui/icons/Close';
import 'date-fns';
import addBusinessDays from 'date-fns/addBusinessDays';
import format from 'date-fns/format';
import { useFormik } from 'formik';
import * as yup from 'yup';
import InputMask from 'react-input-mask';
import { CA, US, GB } from 'country-flag-icons/react/3x2';
import { Alert, Autocomplete as Autocomplete$1 } from '@material-ui/lab';
import * as Sentry from '@sentry/react';
import { getOverallStatus, sentryErrorHandler } from '@aetonix/common';
import { useStatusStore } from '@aetonix/stores';
import IconButton$1 from '@material-ui/core/IconButton';
import Grid$1 from '@material-ui/core/Grid';
import Divider$1 from '@material-ui/core/Divider';
import TextField$1 from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import { z as z$1 } from 'zod';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Snackbar$1 from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import debounce from 'lodash/debounce';
import { buildFormSection } from '@aetonix/report-generator/src/schema-builder/section-builders/formSection';
import { shouldRenderProperty } from '@aetonix/report-generator/src/schema-builder/section-builders/helpers/shouldRenderProperty';
import { buildWorkflowActionSection } from '@aetonix/report-generator/src/schema-builder/section-builders/workflowActionSection';
import { DEFAULT_INDICATORS } from '@aetonix/db-interface/types';
import { buildSection } from '@aetonix/report-generator/src/schema-builder/section-builders';
import { getUserName } from '@aetonix/report-generator/src/utils';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import Typography$1 from '@material-ui/core/Typography';
import Dialog$1 from '@material-ui/core/Dialog';
import DialogActions$2 from '@material-ui/core/DialogActions';
import DialogContent$1 from '@material-ui/core/DialogContent';
import Paper$1 from '@material-ui/core/Paper';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';
import Form from 'ae-forms';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var globalThis_1 =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$m = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$l = fails$m;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$l(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});

var fails$k = fails$m;

var functionBindNative = !fails$k(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$3 = functionBindNative;

var call$d = Function.prototype.call;

var functionCall = NATIVE_BIND$3 ? call$d.bind(call$d) : function () {
  return call$d.apply(call$d, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$2 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$2(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$3 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND$2 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var call$c = FunctionPrototype$2.call;
var uncurryThisWithBind = NATIVE_BIND$2 && FunctionPrototype$2.bind.bind(call$c, call$c);

var functionUncurryThis = NATIVE_BIND$2 ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$c.apply(fn, arguments);
  };
};

var uncurryThis$m = functionUncurryThis;

var toString$b = uncurryThis$m({}.toString);
var stringSlice$7 = uncurryThis$m(''.slice);

var classofRaw$2 = function (it) {
  return stringSlice$7(toString$b(it), 8, -1);
};

var uncurryThis$l = functionUncurryThis;
var fails$j = fails$m;
var classof$7 = classofRaw$2;

var $Object$4 = Object;
var split = uncurryThis$l(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$j(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$7(it) === 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$4 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$3 = isNullOrUndefined$4;

var $TypeError$a = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$9 = function (it) {
  if (isNullOrUndefined$3(it)) throw new $TypeError$a("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$2 = indexedObject;
var requireObjectCoercible$8 = requireObjectCoercible$9;

var toIndexedObject$5 = function (it) {
  return IndexedObject$2(requireObjectCoercible$8(it));
};

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var isCallable$i = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$h = isCallable$i;

var isObject$a = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$h(it);
};

var globalThis$i = globalThis_1;
var isCallable$g = isCallable$i;

var aFunction = function (argument) {
  return isCallable$g(argument) ? argument : undefined;
};

var getBuiltIn$4 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(globalThis$i[namespace]) : globalThis$i[namespace] && globalThis$i[namespace][method];
};

var uncurryThis$k = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$k({}.isPrototypeOf);

var globalThis$h = globalThis_1;

var navigator = globalThis$h.navigator;
var userAgent$2 = navigator && navigator.userAgent;

var environmentUserAgent = userAgent$2 ? String(userAgent$2) : '';

var globalThis$g = globalThis_1;
var userAgent$1 = environmentUserAgent;

var process$1 = globalThis$g.process;
var Deno$1 = globalThis$g.Deno;
var versions = process$1 && process$1.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match$1, version;

if (v8) {
  match$1 = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match$1[0] > 0 && match$1[0] < 4 ? 1 : +(match$1[0] + match$1[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$1) {
  match$1 = userAgent$1.match(/Edge\/(\d+)/);
  if (!match$1 || match$1[1] >= 74) {
    match$1 = userAgent$1.match(/Chrome\/(\d+)/);
    if (match$1) version = +match$1[1];
  }
}

var environmentV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = environmentV8Version;
var fails$i = fails$m;
var globalThis$f = globalThis_1;

var $String$5 = globalThis$f.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$i(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$5(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL$2 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$2 &&
  !Symbol.sham &&
  typeof Symbol.iterator == 'symbol';

var getBuiltIn$3 = getBuiltIn$4;
var isCallable$f = isCallable$i;
var isPrototypeOf$2 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$3 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$3('Symbol');
  return isCallable$f($Symbol) && isPrototypeOf$2($Symbol.prototype, $Object$3(it));
};

var $String$4 = String;

var tryToString$1 = function (argument) {
  try {
    return $String$4(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$e = isCallable$i;
var tryToString = tryToString$1;

var $TypeError$9 = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$4 = function (argument) {
  if (isCallable$e(argument)) return argument;
  throw new $TypeError$9(tryToString(argument) + ' is not a function');
};

var aCallable$3 = aCallable$4;
var isNullOrUndefined$2 = isNullOrUndefined$4;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$3 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined$2(func) ? undefined : aCallable$3(func);
};

var call$b = functionCall;
var isCallable$d = isCallable$i;
var isObject$9 = isObject$a;

var $TypeError$8 = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$d(fn = input.toString) && !isObject$9(val = call$b(fn, input))) return val;
  if (isCallable$d(fn = input.valueOf) && !isObject$9(val = call$b(fn, input))) return val;
  if (pref !== 'string' && isCallable$d(fn = input.toString) && !isObject$9(val = call$b(fn, input))) return val;
  throw new $TypeError$8("Can't convert object to primitive value");
};

var sharedStore = {exports: {}};

var globalThis$e = globalThis_1;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$6 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$6(globalThis$e, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    globalThis$e[key] = value;
  } return value;
};

var globalThis$d = globalThis_1;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = sharedStore.exports = globalThis$d[SHARED] || defineGlobalProperty$2(SHARED, {});

(store$3.versions || (store$3.versions = [])).push({
  version: '3.39.0',
  mode: 'global',
  copyright: '© 2014-2024 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.39.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var store$2 = sharedStore.exports;

var shared$4 = function (key, value) {
  return store$2[key] || (store$2[key] = value || {});
};

var requireObjectCoercible$7 = requireObjectCoercible$9;

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$6 = function (argument) {
  return $Object$2(requireObjectCoercible$7(argument));
};

var uncurryThis$j = functionUncurryThis;
var toObject$5 = toObject$6;

var hasOwnProperty$1 = uncurryThis$j({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty$1(toObject$5(it), key);
};

var uncurryThis$i = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$a = uncurryThis$i(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$a(++id + postfix, 36);
};

var globalThis$c = globalThis_1;
var shared$3 = shared$4;
var hasOwn$a = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL$1 = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var Symbol$2 = globalThis$c.Symbol;
var WellKnownSymbolsStore = shared$3('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$2['for'] || Symbol$2 : Symbol$2 && Symbol$2.withoutSetter || uid$1;

var wellKnownSymbol$d = function (name) {
  if (!hasOwn$a(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL$1 && hasOwn$a(Symbol$2, name)
      ? Symbol$2[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var call$a = functionCall;
var isObject$8 = isObject$a;
var isSymbol$1 = isSymbol$2;
var getMethod$2 = getMethod$3;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$c = wellKnownSymbol$d;

var $TypeError$7 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$c('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$8(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$2(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$a(exoticToPrim, input, pref);
    if (!isObject$8(result) || isSymbol$1(result)) return result;
    throw new $TypeError$7("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var globalThis$b = globalThis_1;
var isObject$7 = isObject$a;

var document$1 = globalThis$b.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$7(document$1) && isObject$7(document$1.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

var DESCRIPTORS$a = descriptors;
var fails$h = fails$m;
var createElement = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$a && !fails$h(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});

var DESCRIPTORS$9 = descriptors;
var call$9 = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$2 = createPropertyDescriptor$3;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$9 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$9 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$9(O, P)) return createPropertyDescriptor$2(!call$9(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$8 = descriptors;
var fails$g = fails$m;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$8 && fails$g(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});

var isObject$6 = isObject$a;

var $String$3 = String;
var $TypeError$6 = TypeError;

// `Assert: Type(argument) is Object`
var anObject$9 = function (argument) {
  if (isObject$6(argument)) return argument;
  throw new $TypeError$6($String$3(argument) + ' is not an object');
};

var DESCRIPTORS$7 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$8 = anObject$9;
var toPropertyKey = toPropertyKey$2;

var $TypeError$5 = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$7 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$8(O);
  P = toPropertyKey(P);
  anObject$8(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$8(O);
  P = toPropertyKey(P);
  anObject$8(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$5('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$6 = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor$1 = createPropertyDescriptor$3;

var createNonEnumerableProperty$5 = DESCRIPTORS$6 ? function (object, key, value) {
  return definePropertyModule$3.f(object, key, createPropertyDescriptor$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$3 = {exports: {}};

var DESCRIPTORS$5 = descriptors;
var hasOwn$8 = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$5 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$8(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$5 || (DESCRIPTORS$5 && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$h = functionUncurryThis;
var isCallable$c = isCallable$i;
var store$1 = sharedStore.exports;

var functionToString = uncurryThis$h(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$c(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$2 = store$1.inspectSource;

var globalThis$a = globalThis_1;
var isCallable$b = isCallable$i;

var WeakMap$2 = globalThis$a.WeakMap;

var weakMapBasicDetection = isCallable$b(WeakMap$2) && /native code/.test(String(WeakMap$2));

var shared$2 = shared$4;
var uid = uid$2;

var keys = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var globalThis$9 = globalThis_1;
var isObject$5 = isObject$a;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$5;
var hasOwn$7 = hasOwnProperty_1;
var shared$1 = sharedStore.exports;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = globalThis$9.TypeError;
var WeakMap$1 = globalThis$9.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$5(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap$1());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn$7(it, STATE)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$4(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$7(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$7(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var uncurryThis$g = functionUncurryThis;
var fails$f = fails$m;
var isCallable$a = isCallable$i;
var hasOwn$6 = hasOwnProperty_1;
var DESCRIPTORS$4 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource$1 = inspectSource$2;
var InternalStateModule$1 = internalState;

var enforceInternalState = InternalStateModule$1.enforce;
var getInternalState$2 = InternalStateModule$1.get;
var $String$2 = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$5 = Object.defineProperty;
var stringSlice$6 = uncurryThis$g(''.slice);
var replace$5 = uncurryThis$g(''.replace);
var join = uncurryThis$g([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS$4 && !fails$f(function () {
  return defineProperty$5(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$2 = makeBuiltIn$3.exports = function (value, name, options) {
  if (stringSlice$6($String$2(name), 0, 7) === 'Symbol(') {
    name = '[' + replace$5($String$2(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$6(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$4) defineProperty$5(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$6(options, 'arity') && value.length !== options.arity) {
    defineProperty$5(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$6(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$4) defineProperty$5(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$6(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$2(function toString() {
  return isCallable$a(this) && getInternalState$2(this).source || inspectSource$1(this);
}, 'toString');

var isCallable$9 = isCallable$i;
var definePropertyModule$2 = objectDefineProperty;
var makeBuiltIn$1 = makeBuiltIn$3.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$5 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$9(value)) makeBuiltIn$1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$2.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor$1 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$1 : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$5 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$4 = toIntegerOrInfinity$5;

var max$1 = Math.max;
var min$3 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$4(index);
  return integer < 0 ? max$1(integer + length, 0) : min$3(integer, length);
};

var toIntegerOrInfinity$3 = toIntegerOrInfinity$5;

var min$2 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$3 = function (argument) {
  var len = toIntegerOrInfinity$3(argument);
  return len > 0 ? min$2(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength$2 = toLength$3;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$4 = function (obj) {
  return toLength$2(obj.length);
};

var toIndexedObject$3 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$3 = lengthOfArrayLike$4;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$3 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = lengthOfArrayLike$3(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$3(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$3(false)
};

var uncurryThis$f = functionUncurryThis;
var hasOwn$5 = hasOwnProperty_1;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push$1 = uncurryThis$f([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$5(hiddenKeys$2, key) && hasOwn$5(O, key) && push$1(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$5(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$1(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$2 = getBuiltIn$4;
var uncurryThis$e = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$7 = anObject$9;

var concat$2 = uncurryThis$e([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$2('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$7(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$2(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$4 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$1 = objectDefineProperty;

var copyConstructorProperties$2 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$1.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$4(target, key) && !(exceptions && hasOwn$4(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$e = fails$m;
var isCallable$8 = isCallable$i;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable$8(detection) ? fails$e(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var globalThis$8 = globalThis_1;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$5;
var defineBuiltIn$4 = defineBuiltIn$5;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = globalThis$8;
  } else if (STATIC) {
    target = globalThis$8[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = globalThis$8[TARGET] && globalThis$8[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$3(sourceProperty, 'sham', true);
    }
    defineBuiltIn$4(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$3 = descriptors;
var uncurryThis$d = functionUncurryThis;
var call$8 = functionCall;
var fails$d = fails$m;
var objectKeys$1 = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$4 = toObject$6;
var IndexedObject$1 = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$4 = Object.defineProperty;
var concat$1 = uncurryThis$d([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$d(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$3 && $assign({ b: 1 }, $assign(defineProperty$4({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$4(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys$1($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$4(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject$1(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$1(objectKeys$1(S), getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$3 || call$8(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$a = _export;
var assign$1 = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$a({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign$1 }, {
  assign: assign$1
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var isDevelopment$1 = false;

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/

function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  } // this function should always return with a value
  // TS can't understand it though so we make it stop complaining here


  return undefined;
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? !isDevelopment$1 : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    this.tags.forEach(function (tag) {
      var _tag$parentNode;

      return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();

var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';

var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';
var LAYER = '@layer';

/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return charat(value, 0) ^ 45 ? (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim$1 (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace$4 (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine (array, callback) {
	return array.map(callback).join('')
}

var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy (root, props) {
	return assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? charat(characters, --position) : 0;

	if (column--, character === 10)
		column = 1, line--;

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < length ? charat(characters, position++) : 0;

	if (column++, character === 10)
		column = 1, line++;

	return character
}

/**
 * @return {number}
 */
function peek () {
	return charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, length = strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim$1(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next();
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character);
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type);
				break
			// \
			case 92:
				next();
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next();

	return slice(index, position)
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0;
	var offset = 0;
	var length = pseudo;
	var atrule = 0;
	var property = 0;
	var previous = 0;
	var variable = 1;
	var scanning = 1;
	var ampersand = 1;
	var character = 0;
	var type = '';
	var props = rules;
	var children = rulesets;
	var reference = rule;
	var characters = type;

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && charat(characters, length - 1) == 58) {
					if (indexof(characters += replace$4(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1;
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character);
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous);
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7);
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						append(comment(commenter(next(), caret()), root, parent), declarations);
						break
					default:
						characters += '/';
				}
				break
			// {
			case 123 * variable:
				points[index++] = strlen(characters) * ampersand;
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0;
					// ;
					case 59 + offset: if (ampersand == -1) characters = replace$4(characters, /\f/g, '');
						if (property > 0 && (strlen(characters) - length))
							append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace$4(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
						break
					// @ ;
					case 59: characters += ';';
					// { rule/at-rule
					default:
						append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children);
							else
								switch (atrule === 99 && charat(characters, 3) === 110 ? 100 : atrule) {
									// d l m s
									case 100: case 108: case 109: case 115:
										parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children);
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
				break
			// :
			case 58:
				length = 1 + strlen(characters), property = previous;
			default:
				if (variable < 1)
					if (character == 123)
						--variable;
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1);
						break
					// ,
					case 44:
						points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next());

						atrule = peek(), offset = length = strlen(type = characters += identifier(caret())), character++;
						break
					// -
					case 45:
						if (previous === 45 && strlen(characters) == 2)
							variable = 0;
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1;
	var rule = offset === 0 ? rules : [''];
	var size = sizeof(rule);

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim$1(j > 0 ? rule[x] + ' ' + y : replace$4(y, /&\f/g, rule[x])))
				props[k++] = z;

	return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length)
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = '';
	var length = sizeof(children);

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || '';

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case LAYER: if (element.children.length) break
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
		case RULESET: element.value = element.props.join(',');
	}

	return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = sizeof(collection);

	return function (element, index, children, callback) {
		var output = '';

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || '';

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element);
	}
}

var weakMemoize = function weakMemoize(func) {
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // Use non-null assertion because we just checked that the cache `has` it
      // This allows us to remove `undefined` from the return value
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var isBrowser$3 = typeof document !== 'undefined';

var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};

/* eslint-disable no-fallthrough */

function prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    // order

    case 6165:
      return WEBKIT + value + MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return WEBKIT + value + replace$4(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return WEBKIT + value + MS + 'flex-item-' + replace$4(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return WEBKIT + value + MS + 'flex-line-pack' + replace$4(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return WEBKIT + value + MS + replace$4(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return WEBKIT + value + MS + replace$4(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return WEBKIT + 'box-' + replace$4(value, '-grow', '') + WEBKIT + value + MS + replace$4(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return WEBKIT + replace$4(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return replace$4(replace$4(replace$4(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return replace$4(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return replace$4(replace$4(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace$4(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (strlen(value) - 1 - length > 6) switch (charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return replace$4(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? prefix(replace$4(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return replace$4(value, ':', ':' + WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return replace$4(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + value + MS + replace$4(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return WEBKIT + value + MS + replace$4(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return WEBKIT + value + MS + replace$4(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return WEBKIT + value + MS + value + value;
  }

  return value;
}

var prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case DECLARATION:
      element["return"] = prefix(element.value, element.length);
      break;

    case KEYFRAMES:
      return serialize([copy(element, {
        value: replace$4(element.value, '@', '@' + WEBKIT)
      })], callback);

    case RULESET:
      if (element.length) return combine(element.props, function (value) {
        switch (match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return serialize([copy(element, {
              props: [replace$4(value, /:(read-\w+)/, ':' + MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return serialize([copy(element, {
              props: [replace$4(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]
            }), copy(element, {
              props: [replace$4(value, /:(plac\w+)/, ':' + MOZ + '$1')]
            }), copy(element, {
              props: [replace$4(value, /:(plac\w+)/, MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

/* import type { StylisPlugin } from './types' */

/*
export type Options = {
  nonce?: string,
  stylisPlugins?: StylisPlugin[],
  key: string,
  container?: HTMLElement,
  speedy?: boolean,
  prepend?: boolean,
  insertionPoint?: HTMLElement
}
*/

var getServerStylisCache = isBrowser$3 ? undefined : weakMemoize(function () {
  return memoize(function () {
    var cache = {};
    return function (name) {
      return cache[name];
    };
  });
});
var defaultStylisPlugins = [prefixer];

var createCache = function
  /*: EmotionCache */
createCache(options
/*: Options */
) {
  var key = options.key;

  if (isBrowser$3 && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node
    /*: HTMLStyleElement */
    ) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }

      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  var inserted = {};
  var container;
  /* : Node */

  var nodesToHydrate = [];

  if (isBrowser$3) {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node
    /*: HTMLStyleElement */
    ) {
      var attrib = node.getAttribute("data-emotion").split(' ');

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;
  /*: (
  selector: string,
  serialized: SerializedStyles,
  sheet: StyleSheet,
  shouldCache: boolean
  ) => string | void */


  var omnipresentPlugins = [compat, removeLabel];

  if (isBrowser$3) {
    var currentSheet;
    var finalizingPlugins = [stringify, rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };

    _insert = function
      /*: void */
    insert(selector
    /*: string */
    , serialized
    /*: SerializedStyles */
    , sheet
    /*: StyleSheet */
    , shouldCache
    /*: boolean */
    ) {
      currentSheet = sheet;

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [stringify];

    var _serializer = middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));

    var _stylis = function _stylis(styles) {
      return serialize(compile(styles), _serializer);
    };

    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);

    var getRules = function
      /*: string */
    getRules(selector
    /*: string */
    , serialized
    /*: SerializedStyles */
    ) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function
      /*: string | void */
    _insert(selector
    /*: string */
    , serialized
    /*: SerializedStyles */
    , sheet
    /*: StyleSheet */
    , shouldCache
    /*: boolean */
    ) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  var cache
  /*: EmotionCache */
  = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

var reactIs$1 = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development.AsyncMode = AsyncMode;
reactIs_development.ConcurrentMode = ConcurrentMode;
reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$1.exports = reactIs_production_min;
} else {
  reactIs$1.exports = reactIs_development;
}

var reactIs = reactIs$1.exports;
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

var isBrowser$2 = typeof document !== 'undefined';

function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else if (className) {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$2 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      if (!isBrowser$2 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$2 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var isDevelopment = false;

var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  var componentSelector = interpolation;

  if (componentSelector.__emotion_styles !== undefined) {

    return componentSelector;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        var keyframes = interpolation;

        if (keyframes.anim === 1) {
          cursor = {
            name: keyframes.name,
            styles: keyframes.styles,
            next: cursor
          };
          return keyframes.name;
        }

        var serializedStyles = interpolation;

        if (serializedStyles.styles !== undefined) {
          var next = serializedStyles.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = serializedStyles.styles + ";";

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        }

        break;
      }
  } // finalize string values (regular strings and functions interpolated into css calls)


  var asString = interpolation;

  if (registered == null) {
    return asString;
  }

  var cached = registered[asString];
  return cached !== undefined ? cached : asString;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var key in obj) {
      var value = obj[key];

      if (typeof value !== 'object') {
        var asString = value;

        if (registered != null && registered[asString] !== undefined) {
          string += key + "{" + registered[asString] + "}";
        } else if (isProcessableValue(asString)) {
          string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        }
      } else {
        if (key === 'NO_COMPONENT_SELECTOR' && isDevelopment) {
          throw new Error(noComponentSelectorMessage);
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(key) + ":" + interpolated + ";";
                break;
              }

            default:
              {

                string += key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    var asTemplateStringsArr = strings;

    styles += asTemplateStringsArr[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      var templateStringsArr = strings;

      styles += templateStringsArr[i];
    }
  }


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + match[1];
  }

  var name = murmur2(styles) + identifierName;

  return {
    name: name,
    styles: styles,
    next: cursor
  };
}

var isBrowser$1 = typeof document !== 'undefined';

var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = React['useInsertion' + 'Effect'] ? React['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = !isBrowser$1 ? syncFallback : useInsertionEffect || syncFallback;

var isBrowser = typeof document !== 'undefined';
var hasOwnProperty = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
  key: 'css'
}) : null);

if (process.env.NODE_ENV !== 'production') {
  EmotionCacheContext.displayName = 'EmotionCacheContext';
}

EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/forwardRef(function (props, ref) {
    // the cache will never be null in the browser
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

if (!isBrowser) {
  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      var cache = useContext(EmotionCacheContext);

      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = createCache({
          key: 'css'
        });
        return /*#__PURE__*/createElement$1(EmotionCacheContext.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}

var ThemeContext = /* #__PURE__ */createContext({});

if (process.env.NODE_ENV !== 'production') {
  ThemeContext.displayName = 'EmotionThemeContext';
}

var getLastPart = function getLastPart(functionName) {
  // The match may be something like 'Object.createEmotionProps' or
  // 'Loader.prototype.render'
  var parts = functionName.split('.');
  return parts[parts.length - 1];
};

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
  if (match) return getLastPart(match[1]); // Safari / Firefox

  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return getLastPart(match[1]);
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (process.env.NODE_ENV !== 'production' && typeof props.css === 'string' && // check if there is a css declaration
  props.css.indexOf(':') !== -1) {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + props.css + "`");
  }

  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (process.env.NODE_ENV !== 'production' && !!props.css && (typeof props.css !== 'object' || typeof props.css.name !== 'string' || props.css.name.indexOf('-') === -1)) {
    var label = getLabelFromStackTrace(new Error().stack);
    if (label) newProps[labelPropName] = label;
  }

  return newProps;
};

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  if (!isBrowser && rules !== undefined) {
    var _ref2;

    var serializedNames = serialized.name;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }

    return /*#__PURE__*/createElement$1("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles, undefined, useContext(ThemeContext));

  if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (process.env.NODE_ENV === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/createElement$1(Fragment$1, null, /*#__PURE__*/createElement$1(Insertion, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/createElement$1(WrappedComponent, newProps));
});

if (process.env.NODE_ENV !== 'production') {
  Emotion.displayName = 'EmotionCssPropInternal';
}

var Fragment = Fragment$2;
function jsx(type, props, key) {
  if (!hasOwnProperty.call(props, 'css')) {
    return jsx$1(type, props, key);
  }

  return jsx$1(Emotion, createEmotionProps(type, props), key);
}
function jsxs(type, props, key) {
  if (!hasOwnProperty.call(props, 'css')) {
    return jsxs$1(type, props, key);
  }

  return jsxs$1(Emotion, createEmotionProps(type, props), key);
}

function withProviders(WrappedComponent) {
  return function ProviderHoc(hocProps) {
    return jsx(UserDataProvider, {
      children: jsx(WrappedComponent, Object.assign({}, hocProps))
    });
  };
}

var img$2 = "data:image/png;base64,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";

var objectDefineProperties = {};

var DESCRIPTORS$2 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule = objectDefineProperty;
var anObject$6 = anObject$9;
var toIndexedObject$1 = toIndexedObject$5;
var objectKeys = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$2 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$6(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn$1 = getBuiltIn$4;

var html$1 = getBuiltIn$1('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */
var anObject$5 = anObject$9;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$1;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  // eslint-disable-next-line no-useless-assignment -- avoid memory leak
  activeXDocument = null;
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$5(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$b = wellKnownSymbol$d;
var create$2 = objectCreate;
var defineProperty$3 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$b('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty$3(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create$2(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$3 = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var $$9 = _export;
var $includes = arrayIncludes.includes;
var fails$c = fails$m;
var addToUnscopables$2 = addToUnscopables$3;

// FF99+ bug
var BROKEN_ON_SPARSE = fails$c(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$9({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$2('includes');

var iterators = {};

var fails$b = fails$m;

var correctPrototypeGetter = !fails$b(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$3 = hasOwnProperty_1;
var isCallable$7 = isCallable$i;
var toObject$3 = toObject$6;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object$1 = Object;
var ObjectPrototype = $Object$1.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object$1.getPrototypeOf : function (O) {
  var object = toObject$3(O);
  if (hasOwn$3(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$7(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object$1 ? ObjectPrototype : null;
};

var fails$a = fails$m;
var isCallable$6 = isCallable$i;
var isObject$4 = isObject$a;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltIn$3 = defineBuiltIn$5;
var wellKnownSymbol$a = wellKnownSymbol$d;

var ITERATOR$3 = wellKnownSymbol$a('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$4(IteratorPrototype$2) || fails$a(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$3].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$6(IteratorPrototype$2[ITERATOR$3])) {
  defineBuiltIn$3(IteratorPrototype$2, ITERATOR$3, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$2 = objectDefineProperty.f;
var hasOwn$2 = hasOwnProperty_1;
var wellKnownSymbol$9 = wellKnownSymbol$d;

var TO_STRING_TAG$2 = wellKnownSymbol$9('toStringTag');

var setToStringTag$3 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$2(target, TO_STRING_TAG$2)) {
    defineProperty$2(target, TO_STRING_TAG$2, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$1 = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$3;
var setToStringTag$2 = setToStringTag$3;
var Iterators$2 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$1(IteratorPrototype$1, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$2[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var uncurryThis$c = functionUncurryThis;
var aCallable$2 = aCallable$4;

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis$c(aCallable$2(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var isObject$3 = isObject$a;

var isPossiblePrototype$1 = function (argument) {
  return isObject$3(argument) || argument === null;
};

var isPossiblePrototype = isPossiblePrototype$1;

var $String$1 = String;
var $TypeError$4 = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError$4("Can't set " + $String$1(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = functionUncurryThisAccessor;
var isObject$2 = isObject$a;
var requireObjectCoercible$6 = requireObjectCoercible$9;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible$6(O);
    aPossiblePrototype(proto);
    if (!isObject$2(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$8 = _export;
var call$7 = functionCall;
var FunctionName = functionName;
var isCallable$5 = isCallable$i;
var createIteratorConstructor = iteratorCreateConstructor;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag$1 = setToStringTag$3;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$5;
var defineBuiltIn$2 = defineBuiltIn$5;
var wellKnownSymbol$8 = wellKnownSymbol$d;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$2 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$2 = wellKnownSymbol$8('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$2]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$5(CurrentIteratorPrototype[ITERATOR$2])) {
          defineBuiltIn$2(CurrentIteratorPrototype, ITERATOR$2, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$2 && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$2(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$7(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$2(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$8({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$2] !== defaultIterator) {
    defineBuiltIn$2(IterablePrototype, ITERATOR$2, defaultIterator, { name: DEFAULT });
  }
  Iterators$1[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$1 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables$1 = addToUnscopables$3;
var Iterators = iterators;
var InternalStateModule = internalState;
var defineProperty$1 = objectDefineProperty.f;
var defineIterator = iteratorDefine;
var createIterResultObject = createIterResultObject$1;
var DESCRIPTORS$1 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState$1 = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$1(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = null;
    return createIterResultObject(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject(index, false);
    case 'values': return createIterResultObject(target[index], false);
  } return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('keys');
addToUnscopables$1('values');
addToUnscopables$1('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$1 && values.name !== 'values') try {
  defineProperty$1(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

var aCallable$1 = aCallable$4;
var toObject$2 = toObject$6;
var IndexedObject = indexedObject;
var lengthOfArrayLike$2 = lengthOfArrayLike$4;

var $TypeError$3 = TypeError;

var REDUCE_EMPTY = 'Reduce of empty array with no initial value';

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$2 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    var O = toObject$2(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike$2(O);
    aCallable$1(callbackfn);
    if (length === 0 && argumentsLength < 2) throw new $TypeError$3(REDUCE_EMPTY);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw new $TypeError$3(REDUCE_EMPTY);
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$2(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod$2(true)
};

var fails$9 = fails$m;

var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$9(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

/* global Bun, Deno -- detection */
var globalThis$7 = globalThis_1;
var userAgent = environmentUserAgent;
var classof$6 = classofRaw$2;

var userAgentStartsWith = function (string) {
  return userAgent.slice(0, string.length) === string;
};

var environment = (function () {
  if (userAgentStartsWith('Bun/')) return 'BUN';
  if (userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
  if (userAgentStartsWith('Deno/')) return 'DENO';
  if (userAgentStartsWith('Node.js/')) return 'NODE';
  if (globalThis$7.Bun && typeof Bun.version == 'string') return 'BUN';
  if (globalThis$7.Deno && typeof Deno.version == 'object') return 'DENO';
  if (classof$6(globalThis$7.process) === 'process') return 'NODE';
  if (globalThis$7.window && globalThis$7.document) return 'BROWSER';
  return 'REST';
})();

var ENVIRONMENT = environment;

var environmentIsNode = ENVIRONMENT === 'NODE';

var $$7 = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict = arrayMethodIsStrict$1;
var CHROME_VERSION = environmentV8Version;
var IS_NODE = environmentIsNode;

// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED$1 = CHROME_BUG || !arrayMethodIsStrict('reduce');

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$$7({ target: 'Array', proto: true, forced: FORCED$1 }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

var isObject$1 = isObject$a;
var classof$5 = classofRaw$2;
var wellKnownSymbol$7 = wellKnownSymbol$d;

var MATCH$1 = wellKnownSymbol$7('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$1(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof$5(it) === 'RegExp');
};

var isRegExp = isRegexp;

var $TypeError$2 = TypeError;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw new $TypeError$2("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$6 = wellKnownSymbol$d;

var TO_STRING_TAG$1 = wellKnownSymbol$6('toStringTag');
var test = {};

test[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$4 = isCallable$i;
var classofRaw$1 = classofRaw$2;
var wellKnownSymbol$5 = wellKnownSymbol$d;

var TO_STRING_TAG = wellKnownSymbol$5('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw$1(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$4 = TO_STRING_TAG_SUPPORT ? classofRaw$1 : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw$1(O)
    // ES3 arguments fallback
    : (result = classofRaw$1(O)) === 'Object' && isCallable$4(O.callee) ? 'Arguments' : result;
};

var classof$3 = classof$4;

var $String = String;

var toString$9 = function (argument) {
  if (classof$3(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

var wellKnownSymbol$4 = wellKnownSymbol$d;

var MATCH = wellKnownSymbol$4('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$6 = _export;
var uncurryThis$b = functionUncurryThis;
var notARegExp$1 = notARegexp;
var requireObjectCoercible$5 = requireObjectCoercible$9;
var toString$8 = toString$9;
var correctIsRegExpLogic$1 = correctIsRegexpLogic;

var stringIndexOf$1 = uncurryThis$b(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$6({ target: 'String', proto: true, forced: !correctIsRegExpLogic$1('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf$1(
      toString$8(requireObjectCoercible$5(this)),
      toString$8(notARegExp$1(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var globalThis$6 = globalThis_1;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$5;
var setToStringTag = setToStringTag$3;
var wellKnownSymbol$3 = wellKnownSymbol$d;

var ITERATOR$1 = wellKnownSymbol$3('iterator');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$1] !== ArrayValues) try {
      createNonEnumerableProperty$1(CollectionPrototype, ITERATOR$1, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$1] = ArrayValues;
    }
    setToStringTag(CollectionPrototype, COLLECTION_NAME, true);
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$1(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(globalThis$6[COLLECTION_NAME] && globalThis$6[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

const SideBarButton = ({
  text,
  icon,
  onClick,
  className
}) => jsxs(ListItem, Object.assign({
  className: className,
  button: true,
  onClick: onClick
}, {
  children: [jsx(ListItemText, {
    primary: text
  }), icon]
}));

const SideBarLink = ({
  url,
  key,
  text,
  className
}) => {
  return jsx(Link, Object.assign({
    to: url,
    style: {
      textDecoration: 'none'
    }
  }, {
    children: jsx(SideBarButton, {
      className: className,
      text: text
    })
  }), key);
};

var img$1 = "data:image/png;base64,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";

const listItemTextStyle = {
  primary: 'ae-sidebar-primary',
  root: 'ae-center-text ae-listitemtext-padding'
};
const drawerWidth = {
  paper: 'ae-sidebar-width'
};
const helpLinkStyles = {
  margin: '10px',
  display: 'flex',
  alignItems: 'center',
  gap: '5px'
};
const PAGE_TYPES = ['dashboard', 'admin', 'logistics', 'org', 'group', 'user', 'monitor', 'history', 'myhealth'];
const IGNORE_FEATURE_FLAG_TYPE = ['logistics', 'admin'];
const PAGE_TYPE_HEADERS = {
  admin: 'dashboards_header_admin',
  logistics: 'dashboards_header_logistics',
  org: 'dashboards_header_orgmanage',
  group: 'dashboards_header_groupmanage',
  user: 'dashboards_header_usermanage',
  monitor: 'dashboards_header_livemonitor',
  history: 'dashboards_header_history',
  myhealth: 'dashboards_header_myhealth'
};
const SideBar = ({
  children
}) => {
  const config = useConfig();
  const routes = useRoutes();
  const {
    personal,
    org,
    group
  } = useCurrentPerson();
  const {
    connection
  } = useConnection();
  const {
    localize
  } = useLocalize();
  const {
    unreadNotifications
  } = useBanners();
  const {
    unreadLogisticsNotesCount
  } = useLogisticBanners();
  const {
    userMetrics
  } = useUserMetrics();
  const [open, setOpen] = useState(false);
  const [typesOpen, setTypesOpen] = useState({});
  const userTypes = useMemo(() => {
    var _a;
    return (_a = personal === null || personal === void 0 ? void 0 : personal.type) === null || _a === void 0 ? void 0 : _a.reduce((result, type) => {
      if (type === 'admin') result = result.concat(localize('sidebar_typeadmin'));else if (type === 'staff') result = result.concat(localize('sidebar_typestaff'));else if (type === 'org:manager') result = result.concat(localize('sidebar_typeorgmanager'));
      return result;
    }, []);
  }, [personal, localize]);
  const renderedRoutes = useMemo(() => PAGE_TYPES.reduce((result, pageType) => {
    if (pageType === 'dashboard') {
      result = result.concat(jsx(SideBarLink, {
        url: '/',
        text: localize('dashboards_header')
      }, 'dashboard'));
    } else {
      const featureFlag = (org === null || org === void 0 ? void 0 : org.featureFlag) || {};
      const routesToRender = Object.entries(routes).reduce((accumulator, [userType, subRoutes]) => {
        var _a;
        if ((_a = personal === null || personal === void 0 ? void 0 : personal.type) === null || _a === void 0 ? void 0 : _a.includes(userType)) {
          accumulator = accumulator.concat(subRoutes.filter(route => route.type === pageType && (IGNORE_FEATURE_FLAG_TYPE.includes(userType) || featureFlag[route.key] > 0)));
        }
        return accumulator;
      }, []);
      if (routesToRender.length) {
        result = result.concat(jsxs(React__default.Fragment, {
          children: [jsx(SideBarButton, {
            text: localize(PAGE_TYPE_HEADERS[pageType]),
            icon: typesOpen[`${pageType}Open`] ? jsx(ExpandLess, {}) : jsx(ExpandMore, {}),
            onClick: () => {
              const eventString = !typesOpen[`${pageType}Open`] ? `unfold sidebar category ${localize(PAGE_TYPE_HEADERS[pageType])}` : `fold sidebar category ${localize(PAGE_TYPE_HEADERS[pageType])}`;
              userMetrics.trackEvent(eventString, {
                open: !typesOpen[`${pageType}Open`]
              });
              setTypesOpen(prevTypesOpen => Object.assign(Object.assign({}, prevTypesOpen), {
                [`${pageType}Open`]: !prevTypesOpen[`${pageType}Open`]
              }));
            }
          }), jsx(Collapse, Object.assign({
            in: typesOpen[`${pageType}Open`],
            timeout: "auto",
            unmountOnExit: true
          }, {
            children: routesToRender.map(route => {
              const name = route === null || route === void 0 ? void 0 : route.name;
              const url = (route === null || route === void 0 ? void 0 : route.url) || '';
              return jsx(SideBarLink, {
                className: 'ae-nested-list',
                url: url,
                text: localize(name)
              }, name);
            })
          }))]
        }, `link_${pageType}`));
      }
    }
    return result;
  }, []), [localize, org === null || org === void 0 ? void 0 : org.featureFlag, routes, personal === null || personal === void 0 ? void 0 : personal.type, typesOpen, userMetrics]);
  return jsxs("div", {
    children: [jsxs("div", Object.assign({
      className: "ae-sidebar"
    }, {
      children: [connection && jsx(Button, Object.assign({
        className: "ae-offlineNotice"
      }, {
        children: localize('dashboard_offline')
      })), children, jsx(IconButton, Object.assign({
        "aria-label": "Patient Notifications Button",
        component: Link,
        to: '/patientNotifications'
      }, {
        children: jsx(Badge, Object.assign({
          overlap: "rectangular",
          badgeContent: unreadNotifications,
          color: "error"
        }, {
          children: jsx(Notifications$2, {
            color: "secondary"
          })
        }))
      })), jsx(IconButton, Object.assign({
        "aria-label": "Logistic Notifications Button",
        component: Link,
        to: '/logisticNotifications'
      }, {
        children: jsx(Badge, Object.assign({
          overlap: 'rectangular',
          badgeContent: unreadLogisticsNotesCount,
          color: "error"
        }, {
          children: jsx(LocalShipping, {
            color: "secondary"
          })
        }))
      })), jsx(IconButton, Object.assign({
        onClick: () => {
          userMetrics.trackEvent('open sidebar');
          setOpen(prevOpen => !prevOpen);
        },
        "aria-label": localize('sidebar_toggle_button_aria'),
        title: localize('sidebar_toggle_title'),
        role: "button"
      }, {
        children: jsx(Menu, {
          color: "secondary",
          "aria-labelledby": "sidebarButton",
          role: "tablist",
          "aria-label": "sidebar"
        })
      }))]
    })), jsx("div", {
      children: jsxs(Drawer, Object.assign({
        classes: drawerWidth,
        variant: "temporary",
        anchor: "right",
        open: open,
        onClose: () => setOpen(prevOpen => !prevOpen)
      }, {
        children: [jsx(AppBar, Object.assign({
          position: "relative"
        }, {
          children: jsx(Toolbar, {
            children: jsx(IconButton, Object.assign({
              onClick: () => {
                userMetrics.trackEvent('close sidebar');
                setOpen(prevOpen => !prevOpen);
              },
              "aria-label": localize('sidebar_toggle_button_aria_close'),
              title: localize('sidebar_toggle_title'),
              role: "button"
            }, {
              children: jsx(Menu, {
                color: "secondary",
                "aria-labelledby": "sidebarButton",
                role: "tablist",
                "aria-label": "sidebar"
              })
            }))
          })
        })), jsxs(List, Object.assign({
          component: "nav",
          disablePadding: true
        }, {
          children: [renderedRoutes, jsxs(ListItem, Object.assign({
            button: true,
            onClick: () => {
              userMetrics.trackEvent('click logout from sidebar');
              signOut(config);
            }
          }, {
            children: [jsx(ExitToApp, {}), jsx(ListItemText, {
              primary: localize('sidebar_logout')
            })]
          }))]
        })), jsx(Divider, {}), jsxs("div", Object.assign({
          className: "ae-center-text ae-padded"
        }, {
          children: [jsx(ListItem, {
            children: jsx(ListItemText, {
              classes: listItemTextStyle,
              color: "primary",
              primary: `${personal === null || personal === void 0 ? void 0 : personal.fname} ${personal === null || personal === void 0 ? void 0 : personal.lname}`,
              secondary: userTypes === null || userTypes === void 0 ? void 0 : userTypes.join(', ')
            })
          }), !!(org === null || org === void 0 ? void 0 : org.name) && jsx(ListItem, {
            children: jsx(ListItemText, {
              classes: listItemTextStyle,
              color: "primary",
              primary: org === null || org === void 0 ? void 0 : org.name,
              secondary: localize('sidebar_org')
            })
          }), !!(group === null || group === void 0 ? void 0 : group.name) && jsx(ListItem, {
            children: jsx(ListItemText, {
              classes: listItemTextStyle,
              primary: group === null || group === void 0 ? void 0 : group.name,
              secondary: localize('sidebar_group')
            })
          }), jsx(ListItem, {
            children: jsx(ListItemText, {
              classes: listItemTextStyle,
              primary: localStorage.getItem('region') || '',
              secondary: localize('sidebar_region')
            })
          }), jsx(Divider, {}), jsx("label", Object.assign({
            title: localize('sidebar_visitUs')
          }, {
            children: jsx("a", Object.assign({
              href: "https://aetonix.com/",
              target: "_blank",
              rel: "noreferrer"
            }, {
              children: jsx("img", {
                alt: localize('dashboards_home'),
                className: "ae-sidebar-logo",
                src: img$1,
                style: {
                  marginTop: '10px'
                }
              })
            }))
          })), jsx(Link$1, Object.assign({
            href: "https://info.aetonix.com/",
            target: "_blank",
            rel: "noreferrer"
          }, {
            children: jsxs(Typography, Object.assign({
              style: helpLinkStyles,
              color: "primary",
              variant: "body2"
            }, {
              children: [localize("sidebar_needHelp"), jsx(Launch, {
                fontSize: "small"
              })]
            }))
          })), jsx("div", Object.assign({
            className: "ae-version-text"
          }, {
            children: `v${config === null || config === void 0 ? void 0 : config.version}#${config === null || config === void 0 ? void 0 : config.build}`
          }))]
        }))]
      }))
    })]
  });
};
function signOut(config) {
  const region = localStorage.getItem('region') || 'Canada';
  const hosts = config.hosts || [];
  const foundHost = hosts === null || hosts === void 0 ? void 0 : hosts.find(host => host.name === region);
  const hostAPI = foundHost === null || foundHost === void 0 ? void 0 : foundHost.host;
  const token = localStorage.getItem('token');
  const host = config.host || hostAPI;
  const api = aeAPI({
    host
  });
  api.auth.logout(token);
  setTimeout(() => {
    localStorage.setItem('token', '');
    window.location.reload();
  }, 100);
}

const styles$c = {
  Title: {
    fontSize: 24,
    fontFamily: 'Poppins',
    fontWeight: 500,
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  CenteredContent: {
    display: 'flex',
    alignItems: 'center'
  },
  HomeIcon: {
    height: 38,
    marginRight: 10,
    marginLeft: 10
  },
  Toolbar: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr'
  },
  Centered: {
    display: 'flex',
    justifyContent: 'flex-start'
  },
  SideBar: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
};
const Header$2 = props => {
  const {
    children,
    titleKey,
    title
  } = props;
  const {
    localize
  } = useLocalize();
  logErrors(props);
  const titleString = title ? title : localize(titleKey);
  return jsx(AppBar, Object.assign({
    position: "relative"
  }, {
    children: jsxs(Toolbar, Object.assign({
      className: 'ae-header-justify ae-align-items',
      style: styles$c.Toolbar
    }, {
      children: [jsx("div", Object.assign({
        style: styles$c.Centered
      }, {
        children: jsx("a", Object.assign({
          href: "/"
        }, {
          children: jsx("img", {
            alt: "Aetonix Home Icon",
            className: "ae-home-boy",
            src: img$2,
            style: styles$c.HomeIcon
          })
        }))
      })), jsx("div", Object.assign({
        style: styles$c.Centered
      }, {
        children: titleKey && jsx("div", Object.assign({
          style: styles$c.Title
        }, {
          children: titleString
        }))
      })), jsx(UserPublicDataProvider, {
        children: jsx(DesktopNotificationsProvider, Object.assign({
          redirectLink: '/patientNotifications'
        }, {
          children: jsx(LogisticBannersProvider, {
            children: jsx(WorkflowDefinitionTrackerProvider, {
              children: jsx(OngoingWorkflowTrackerProvider, {
                children: jsx(BannersProvider, {
                  children: jsx(SideBar, {
                    children: children
                  })
                })
              })
            })
          })
        }))
      })]
    }))
  }));
};
function logErrors(props) {
  const {
    titleKey,
    title
  } = props;
  if (title && titleKey) console.warn(`Header was provided a title of ${title} AND a titleKey of ${titleKey}. Please only provide one`);
  if (!title && !titleKey) console.error(`Header did not receive a title nor a titleKey. Please provide one`);
}

const Page = ({
  headerTitle,
  children
}) => {
  return jsxs("div", Object.assign({
    className: "flex-vertical flex-1"
  }, {
    children: [jsx(Header$2, {
      titleKey: headerTitle
    }), jsx("div", Object.assign({
      className: "flex-vertical flex-1",
      style: {
        backgroundColor: '#F2F6F8'
      }
    }, {
      children: children
    }))]
  }));
};
const PageWithProviders = withProviders(Page);

var anObject$4 = anObject$9;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$4(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var call$6 = functionCall;
var hasOwn$1 = hasOwnProperty_1;
var isPrototypeOf$1 = objectIsPrototypeOf;
var regExpFlags = regexpFlags$1;

var RegExpPrototype$2 = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$2) && !hasOwn$1(R, 'flags') && isPrototypeOf$1(RegExpPrototype$2, R)
    ? call$6(regExpFlags, R) : flags;
};

var PROPER_FUNCTION_NAME$1 = functionName.PROPER;
var defineBuiltIn$1 = defineBuiltIn$5;
var anObject$3 = anObject$9;
var $toString = toString$9;
var fails$8 = fails$m;
var getRegExpFlags = regexpGetFlags;

var TO_STRING = 'toString';
var RegExpPrototype$1 = RegExp.prototype;
var nativeToString = RegExpPrototype$1[TO_STRING];

var NOT_GENERIC = fails$8(function () { return nativeToString.call({ source: 'a', flags: 'b' }) !== '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME$1 && nativeToString.name !== TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn$1(RegExpPrototype$1, TO_STRING, function toString() {
    var R = anObject$3(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

/* © 2022 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, September 12, 2022
 * For information or permission request, email info@aetonixsystems.com
 */
const primary$1 = '#285E63';
const light$1 = '#C4DFE0';
const backgroundContrast$1 = '#EAF4F4';
const DashboardsTheme = createTheme({
  palette: {
    primary: {
      main: primary$1
    },
    secondary: {
      main: light$1
    },
    text: {
      primary: cyan[900]
    },
    error: {
      main: red[700]
    }
  },
  typography: {},
  overrides: {
    MuiCheckbox: {
      colorSecondary: {
        '&$checked': {
          color: cyan[900]
        }
      }
    },
    MuiListItemText: {
      primary: {
        color: 'rgb(0, 96, 100)'
      },
      secondary: {
        color: 'rgba(0, 0, 0, 0.54)'
      }
    },
    MuiTable: {
      root: {
        backgroundColor: '#FFF'
      }
    },
    MuiButton: {
      root: {
        raised: {
          backgroundColor: 'rgb(0, 172, 193)',
          color: 'white'
        }
      }
    },
    MuiAvatar: {
      colorDefault: {
        color: 'rgb(117, 117, 117)',
        backgroundColor: 'transparent'
      }
    },
    MuiIcon: {
      root: {
        overflow: 'visible'
      }
    },
    MuiInput: {
      underline: {
        '&:before': {
          borderBottom: '1px solid #6DBFC3'
        },
        '&:after': {
          borderBottom: '1px solid #6DBFC3'
        }
      }
    },
    MuiTextField: {
      root: {
        '& input:disabled': {
          backgroundColor: '#00000033',
          borderRadius: '4px'
        }
      }
    },
    MuiTypography: {
      body1: {
        fontFamily: 'Poppins',
        fontSize: '14px',
        fontWeight: 400
      }
    },
    MuiTableCell: {
      root: {
        backgroundColor: '#FFFFFF'
      }
    },
    MuiInputLabel: {
      root: {
        fontFamily: 'Poppins',
        fontStyle: 'normal',
        lineHeight: '20px',
        fontSize: '14px',
        fontWeight: 400,
        color: '#102543'
      }
    },
    MuiDialogTitle: {
      root: {
        padding: '5px',
        paddingLeft: '15px',
        color: '#FFFFFF',
        backgroundColor: '#285E63',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
      }
    },
    MuiInputBase: {
      root: {
        borderRadius: '4px',
        borderColor: '#6DBFC3',
        hover: {
          color: '#6DBFC3'
        }
      }
    },
    MuiChip: {
      root: {
        borderRadius: '128px !important',
        width: '110px !important',
        height: '36px !important'
      },
      colorSecondary: {
        backgroundColor: '#EB0000',
        color: '#ffffff'
      },
      outlinedSecondary: {
        backgroundColor: '#EAECF3',
        border: '1px solid #506583',
        color: '#506583'
      }
    },
    MuiTableHead: {
      root: {
        backgroundColor: backgroundContrast$1
      }
    },
    MuiTableRow: {
      hover: {
        '&$hover:hover': {
          backgroundColor: backgroundContrast$1
        }
      }
    },
    MuiDialog: {
      paper: {
        color: cyan[900]
      }
    },
    MuiSelect: {
      root: {
        color: cyan[900],
        '&$disabled': {
          backgroundColor: '#00000033',
          borderRadius: '4px',
          paddingLeft: '10px'
        }
      }
    },
    MuiMenuItem: {
      root: {
        color: cyan[900]
      }
    },
    MuiListSubheader: {
      sticky: {
        color: cyan[900]
      }
    },
    MuiIconButton: {
      root: {
        width: 'auto'
      }
    },
    MuiFormLabel: {
      root: {
        fontFamily: 'Poppins',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '16px',
        color: '#285E63'
      }
    },
    MuiTabs: {
      root: {
        '& button.Mui-selected': {
          borderBottomStyle: 'solid',
          borderBottomWidth: 5,
          borderBottomColor: '#CAE7F5',
          color: 'white'
        }
      },
      indicator: {
        color: light$1
      }
    },
    MuiTab: {
      root: {
        maxWidth: 'none',
        background: primary$1,
        textTransform: 'uppercase',
        '&:not(:last-child)': {
          borderRight: '1px solid #285e63'
        }
      },
      textColorPrimary: {
        color: light$1
      }
    },
    MuiSvgIcon: {
      root: {
        color: '#285E63'
      }
    }
  }
});

/*
 * The way this component works is using the IntersectObserver hook we create an observer
 * to see if the viewport intersects with the <div ref={loader} /> (if it becomes visible)
 * if it does we call the load more function passed in through props.
 * TLDR if you scroll to the div, it loads more
 */
const InfiniteScroll = ({
  observerOptions: _observerOptions = {},
  loadMore,
  style,
  children,
  className,
  isLoading
}) => {
  const loader = useRef(null);
  useIntersectObserver(loader, loadMore, Object.assign(Object.assign({}, _observerOptions), {
    isLoading,
    rootMargin: '20px',
    threshold: 0
  }));
  const containerStyle = Object.assign(Object.assign({}, style), {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  });
  return jsxs("div", Object.assign({
    style: containerStyle,
    className: className
  }, {
    children: [children, jsx("div", {
      ref: loader
    })]
  }));
};

const Colors$1 = DashboardsTheme.palette;
const SelectContainer$1 = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center'
});
const Text$1 = styled('div')({
  fontFamily: 'Poppins',
  fontWeight: 500,
  fontSize: '14px',
  color: '#285E63'
});
const getWidth = ({
  width,
  size: _size = ''
}) => {
  var _a, _b;
  const widthMapping = {
    s: 100,
    m: 120,
    l: 250
  };
  return (_b = (_a = widthMapping[_size]) !== null && _a !== void 0 ? _a : width) !== null && _b !== void 0 ? _b : 250;
};
const StyledSelect$4 = styled(Select)(({
  width,
  size
}) => {
  return {
    width: getWidth({
      width,
      size
    }),
    color: Colors$1.primary.main,
    margin: '10px 10px',
    backgroundColor: 'unset',
    flexGrow: 1
  };
});
const StyledSelectOutline$1 = withStyles({
  outlined: {
    padding: '10.5px 14px'
  }
})(Select);
const TextMultiSelect = props => {
  const {
      options,
      children,
      onChange,
      value = [],
      outline = false,
      renderValue,
      placeholder,
      renderOptions,
      id,
      ariaLabel
    } = props,
    additionalProps = __rest(props, ["options", "children", "onChange", "value", "outline", "renderValue", "placeholder", "renderOptions", "id", "ariaLabel"]);
  const Select = outline ? StyledSelectOutline$1 : StyledSelect$4;
  const defaultRenderValue = values => {
    const selected = values;
    if (selected.length === 0) return outline ? jsx("div", Object.assign({
      style: {
        color: 'rgba(0, 96, 100, 0.4)'
      }
    }, {
      children: placeholder ? placeholder : 'All'
    })) : jsx("em", {
      children: placeholder ? placeholder : 'All'
    });
    return selected.map(value => {
      var _a;
      const option = options.find(opt => opt.value === value);
      return (_a = option === null || option === void 0 ? void 0 : option.text) !== null && _a !== void 0 ? _a : value;
    }).join(', ');
  };
  const defaultRenderOptions = () => options.map((option, index) => jsxs(MenuItem, Object.assign({
    value: option.value
  }, {
    children: [jsx(Checkbox, {
      checked: value.includes(option.value)
    }), jsx(ListItemText, {
      primary: option.text
    })]
  }), `text_select_${index}_${option}`));
  const renderOptionsFn = renderOptions !== null && renderOptions !== void 0 ? renderOptions : defaultRenderOptions;
  return jsxs(SelectContainer$1, {
    children: [jsx(Text$1, {
      children: children
    }), jsx(Select, Object.assign({
      id: id,
      "aria-label": ariaLabel,
      onChange: onChange,
      defaultValue: [],
      variant: outline ? 'outlined' : 'standard',
      value: value,
      renderValue: renderValue !== null && renderValue !== void 0 ? renderValue : defaultRenderValue,
      multiple: true,
      displayEmpty: true
    }, additionalProps, {
      children: renderOptionsFn()
    }))]
  });
};

const useStyles$3 = makeStyles(() => createStyles({
  rotateIcon: {
    display: 'flex',
    flexDirection: 'column',
    animation: '$spin 2s linear infinite'
  },
  icon: {
    display: 'flex',
    flexDirection: 'column'
  },
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(360deg)'
    },
    '100%': {
      transform: 'rotate(0deg)'
    }
  },
  label: {
    fontSize: '1rem'
  }
}));
const SpinningIcon = ({
  icon,
  spinning: _spinning = false,
  disabled: _disabled = false,
  highlighted: _highlighted = false,
  hoverLabel,
  onClick
}) => {
  const classes = useStyles$3();
  const MuiIcon = icon; // React doesn't like lowercase names
  return jsx(Tooltip, Object.assign({
    title: hoverLabel || '',
    arrow: true
  }, {
    children: jsx("span", {
      children: jsx(IconButton, Object.assign({
        onClick: onClick,
        "aria-label": hoverLabel,
        disabled: _disabled,
        className: _spinning ? classes.rotateIcon : classes.icon,
        style: _highlighted ? {
          backgroundColor: '#C4DFE0'
        } : undefined
      }, {
        children: jsx(MuiIcon, {
          style: {
            color: _disabled ? 'grey' : '#285E63'
          }
        })
      }))
    })
  }), "tooltip");
};

const StyledTextField = styled(TextField)(() => ({
  backgroundColor: 'transparent !important'
}));
const SearchBar = ({
  width,
  placeholder,
  theme,
  onChange,
  id,
  testId
}) => {
  return jsx(ThemeProvider, Object.assign({
    theme: theme || DashboardsTheme
  }, {
    children: jsxs(FormControl, Object.assign({
      style: {
        width: '100%'
      }
    }, {
      children: [jsx(InputLabel, {
        htmlFor: "search"
      }), jsx(DebounceInput, {
        element: StyledTextField,
        id: id,
        "test-id": testId,
        debounceTimeout: 800,
        style: {
          width: width,
          fontWeight: 600,
          fontSize: 16
        },
        InputProps: {
          startAdornment: jsx(Search, {
            color: "primary"
          })
        },
        onChange: onChange,
        placeholder: placeholder,
        variant: "standard",
        "aria-describedby": placeholder
      })]
    }))
  }));
};

/**
 * A tooltip that can be persistent or automatic
 * It is generally used for helping users something.
 * You can set it to persistent to give them a tip, and make it non-persistent when they've used it.
 *
 * @param persistent If true, the tooltip will always be visible unless it's marked as closed.
 * @param closed Only used if persistent. If true, the tooltip will be hidden.
 * @param label The text to display in the tooltip.
 * @param children The element to wrap with the tooltip.
 * @returns
 */
const SometimesPersistentTooltip = ({
  persistent,
  closed,
  label,
  children
}) => {
  const [isOpen, setIsOpen] = React__default.useState(persistent ? !closed : false);
  React__default.useEffect(() => {
    setIsOpen(persistent ? !closed : false);
  }, [persistent, closed]);
  const handleClose = () => {
    setIsOpen(false);
  };
  const handleOpen = () => {
    setIsOpen(true);
  };
  return jsx(Tooltip, Object.assign({
    open: isOpen,
    title: label,
    onClose: handleClose,
    onOpen: handleOpen,
    arrow: true
  }, {
    children: children
  }));
};

const useStyles$2 = makeStyles$1(() => ({
  iconButton: {
    display: 'flex',
    flexDirection: 'column'
  },
  label: {
    fontSize: '1rem'
  }
}));
/**
 *
 * @param icon The icon to display
 * @param children The content of the menu. Should probably be a list of MenuItems
 * @param hoverLabel The text that will appear when hovering over the icon
 * @param persistentTooltip Whether the tooltip should be persistent or not
 * @param disabled Whether the menu should be disabled or not
 * @param title The title of the menu
 * @param onOpen Callback for when the menu opens
 * @param onClose Callback for when the menu closes
 */
const IconButtonMenu = ({
  icon,
  children,
  hoverLabel: _hoverLabel = '',
  persistentTooltip: _persistentTooltip = false,
  disabled: _disabled = false,
  title: _title = '',
  onOpen: _onOpen = () => {},
  onClose: _onClose = () => {}
}) => {
  const classes = useStyles$2();
  const [anchorEl, setAnchorEl] = React__default.useState(null);
  const menuOpen = !!anchorEl;
  const openMenu = e => {
    setAnchorEl(e.currentTarget);
    _onOpen();
  };
  const closeMenu = () => {
    setAnchorEl(null);
    _onClose();
  };
  if (!icon) {
    throw new Error('IconButtonMenu requires an icon');
  }
  const Title = _title ? jsxs("div", {
    children: [jsx(Typography, Object.assign({
      style: {
        padding: 10
      }
    }, {
      children: _title.toString()
    })), jsx(Divider, {})]
  }) : null;
  const Icon = icon; // JSX doesn't like lowercase names
  return jsxs("div", {
    children: [jsx(SometimesPersistentTooltip, Object.assign({
      closed: menuOpen || _disabled,
      label: _hoverLabel || '',
      persistent: _persistentTooltip
    }, {
      children: jsx("div", {
        children: jsx(IconButton, Object.assign({
          disabled: _disabled,
          "aria-label": _hoverLabel,
          "aria-controls": menuOpen ? 'basic-menu' : undefined,
          "aria-haspopup": "true",
          "aria-expanded": menuOpen ? 'true' : undefined,
          onClick: openMenu,
          classes: {
            label: classes.iconButton
          }
        }, {
          children: jsx(Icon, {
            color: _disabled ? 'disabled' : 'primary'
          })
        }))
      })
    })), jsx(Menu$1, Object.assign({
      getContentAnchorEl: null,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'center'
      },
      onClick: closeMenu,
      anchorEl: anchorEl,
      open: menuOpen,
      onClose: closeMenu,
      MenuListProps: {
        'aria-labelledby': 'basic-button'
      }
    }, {
      children: jsxs("div", {
        children: [Title, children]
      })
    }))]
  });
};
const DefaultIconbuttonMenuItem = ({
  key,
  label: _label = '',
  icon,
  children,
  disabled: _disabled2 = false,
  onClickValue: _onClickValue = '',
  onClick: _onClick = () => {}
}) => {
  const Icon = icon; // jsx doesn't like lowercase names
  return jsxs(MenuItem$1, Object.assign({
    onClick: () => {
      _onClick(_onClickValue || _label);
    },
    value: _label,
    disabled: _disabled2
  }, {
    children: [Icon && jsx(Icon, {}), children, _label && jsx(Typography, Object.assign({
      style: {
        textTransform: 'capitalize'
      }
    }, {
      children: _label
    }))]
  }), key);
};

const DefaultHeaderRenderer = ({
  label,
  headerHeight,
  classes,
  style
}) => {
  return jsx(TableCell, Object.assign({
    component: "div",
    variant: "head",
    className: clsx(classes.tableCell, classes.flexContainer, classes.noClick),
    style: Object.assign(Object.assign({}, style), {
      flex: 1,
      height: headerHeight
    }),
    align: "left"
  }, {
    children: jsx("span", {
      children: label
    })
  }));
};

const DefaultRowRenderer = ({
  cellData,
  rowData,
  rowHeight,
  onClick,
  isSelected,
  classes,
  style
}) => {
  return jsx(TableCell, Object.assign({
    component: "div",
    variant: "body",
    className: clsx(classes.flexContainer, classes.tableCell, {
      [classes.noClick]: onClick == null,
      [classes.isSelected]: rowData.isSelected || isSelected
    }),
    style: Object.assign(Object.assign({}, style), {
      flex: 1,
      height: rowHeight,
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }),
    align: "left",
    onClick: onClick
  }, {
    children: cellData
  }));
};

const MuiVirtualizedTable = ({
  rowHeight: _rowHeight = 48,
  headerHeight: _headerHeight = 48,
  columns,
  rowGetter,
  rowCount,
  classes,
  onRowClick
}) => {
  return jsx(WindowScroller, {
    children: ({
      height,
      scrollTop
    }) => jsx(AutoSizer, Object.assign({
      disableHeight: true
    }, {
      children: ({
        width
      }) => jsx(Table, Object.assign({
        autoHeight: true,
        scrollTop: scrollTop,
        height: height,
        width: width,
        rowHeight: _rowHeight,
        headerHeight: _headerHeight,
        rowGetter: rowGetter,
        rowCount: rowCount,
        className: classes.table,
        rowClassName: clsx(classes.flexContainer, classes.tableRow),
        onRowClick: onRowClick,
        role: "table"
      }, {
        children: columns.map(_a => {
          var {
              header = DefaultHeaderRenderer,
              row = DefaultRowRenderer,
              dataKey,
              dataFn,
              width,
              onClick,
              isSelected,
              headerStyle,
              rowStyle
            } = _a,
            otherColumnData = __rest(_a, ["header", "row", "dataKey", "dataFn", "width", "onClick", "isSelected", "headerStyle", "rowStyle"]);
          return jsx(Column, Object.assign({
            dataKey: dataKey,
            headerRenderer: headerProps => header(Object.assign(Object.assign({}, headerProps), {
              headerHeight: _headerHeight,
              classes,
              style: headerStyle
            })),
            cellRenderer: cellProps => row(Object.assign(Object.assign({}, cellProps), {
              rowHeight: _rowHeight,
              classes,
              onClick,
              isSelected,
              style: rowStyle
            })),
            cellDataGetter: dataFn,
            flexGrow: 1,
            flexShrink: 0,
            width: width,
            className: classes.flexContainer
          }, otherColumnData), dataKey);
        })
      }))
    }))
  });
};
const styles$b = theme => ({
  flexContainer: {
    display: 'flex',
    alignItems: 'center',
    flex: 1
  },
  table: {
    // temporary right-to-left patch, waiting for
    // https://github.com/bvaughn/react-virtualized/issues/454
    '& .ReactVirtualized__Table__headerRow': {
      flip: false,
      paddingRight: theme.direction === 'rtl' ? '0 !important' : undefined
    },
    '& .ReactVirtualized__Table__headerColumn': {
      flex: 1,
      display: 'flex'
    }
    //   div.ReactVirtualized__Grid.ReactVirtualized__Table__Grid {
    //     height: auto!important;
    // }
  },
  tableRow: {
    cursor: 'pointer'
  },
  tableRowHover: {
    '&:hover': {
      backgroundColor: grey[200]
    }
  },
  tableCell: {
    flex: 1,
    borderBottomColor: '#D5E8F0',
    borderBottomWidth: 1,
    padding: 0,
    paddingRight: 6,
    paddingLeft: 6
  },
  isSelected: {
    backgroundColor: '#EAF4F4'
  },
  noClick: {
    cursor: 'initial'
  }
});
const VirtualizedTable = withStyles$1(styles$b)(MuiVirtualizedTable);

const noop$2 = () => {};
const ActionDialog = ({
  actions,
  title,
  reactKey,
  onClose: _onClose = noop$2,
  open: _open = false,
  children,
  showLoading: _showLoading = false
}) => {
  const handleClose = (event, reason) => {
    _onClose(event, reason);
  };
  return jsxs(Dialog, Object.assign({
    open: !!_open,
    maxWidth: "md",
    fullWidth: true,
    scroll: "body",
    onClose: _onClose,
    disableEnforceFocus: true
  }, {
    children: [jsxs(DialogTitle, Object.assign({
      disableTypography: true
    }, {
      children: [jsx(Typography, Object.assign({
        variant: "body2",
        component: 'h2',
        align: "center"
      }, {
        children: title
      })), jsx(IconButton, Object.assign({
        onClick: event => handleClose(event, 'onCloseModal'),
        style: {
          padding: '0px'
        }
      }, {
        children: jsx(CloseIcon, {
          color: "secondary",
          "aria-label": "Close Button"
        })
      }))]
    })), jsx(DialogContent, {
      children: children
    }), jsx(DialogActions$1, {
      children: actions
    }), _showLoading && jsx(LinearProgress, {})]
  }), reactKey || 'action_dialog_modal');
};

var fails$7 = fails$m;
var globalThis$5 = globalThis_1;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = globalThis$5.RegExp;

var UNSUPPORTED_Y$1 = fails$7(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y$1 || fails$7(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$1 || fails$7(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y$1
};

var fails$6 = fails$m;
var globalThis$4 = globalThis_1;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = globalThis$4.RegExp;

var regexpUnsupportedDotAll = fails$6(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.test('\n') && re.flags === 's');
});

var fails$5 = fails$m;
var globalThis$3 = globalThis_1;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = globalThis$3.RegExp;

var regexpUnsupportedNcg = fails$5(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$5 = functionCall;
var uncurryThis$a = functionUncurryThis;
var toString$7 = toString$9;
var regexpFlags = regexpFlags$1;
var stickyHelpers = regexpStickyHelpers;
var shared = shared$4;
var create = objectCreate;
var getInternalState = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$3 = uncurryThis$a(''.charAt);
var indexOf = uncurryThis$a(''.indexOf);
var replace$3 = uncurryThis$a(''.replace);
var stringSlice$5 = uncurryThis$a(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$5(nativeExec, re1, 'a');
  call$5(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString$7(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$5(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call$5(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$3(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$5(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$3(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$5(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$5(match.input, charsAdded);
        match[0] = stringSlice$5(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call$5(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $$5 = _export;
var exec$2 = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$5({ target: 'RegExp', proto: true, forced: /./.exec !== exec$2 }, {
  exec: exec$2
});

var NATIVE_BIND$1 = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$1 = FunctionPrototype.apply;
var call$4 = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND$1 ? call$4.bind(apply$1) : function () {
  return call$4.apply(apply$1, arguments);
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var call$3 = functionCall;
var defineBuiltIn = defineBuiltIn$5;
var regexpExec$1 = regexpExec$2;
var fails$4 = fails$m;
var wellKnownSymbol$2 = wellKnownSymbol$d;
var createNonEnumerableProperty = createNonEnumerableProperty$5;

var SPECIES$1 = wellKnownSymbol$2('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$2(KEY);

  var DELEGATES_TO_SYMBOL = !fails$4(function () {
    // String methods call symbol-named RegExp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) !== 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$4(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$1] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: call$3(nativeRegExpMethod, regexp, str, arg2) };
        }
        return { done: true, value: call$3(nativeMethod, str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};

var uncurryThis$9 = functionUncurryThis;
var toIntegerOrInfinity$2 = toIntegerOrInfinity$5;
var toString$6 = toString$9;
var requireObjectCoercible$4 = requireObjectCoercible$9;

var charAt$2 = uncurryThis$9(''.charAt);
var charCodeAt = uncurryThis$9(''.charCodeAt);
var stringSlice$4 = uncurryThis$9(''.slice);

var createMethod$1 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$6(requireObjectCoercible$4($this));
    var position = toIntegerOrInfinity$2(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$2(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$4(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$1(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$1(true)
};

var charAt$1 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$1 = function (S, index, unicode) {
  return index + (unicode ? charAt$1(S, index).length : 1);
};

var uncurryThis$8 = functionUncurryThis;
var toObject$1 = toObject$6;

var floor = Math.floor;
var charAt = uncurryThis$8(''.charAt);
var replace$2 = uncurryThis$8(''.replace);
var stringSlice$3 = uncurryThis$8(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject$1(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$2(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$3(str, 0, position);
      case "'": return stringSlice$3(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$3(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var call$2 = functionCall;
var anObject$2 = anObject$9;
var isCallable$3 = isCallable$i;
var classof$2 = classofRaw$2;
var regexpExec = regexpExec$2;

var $TypeError$1 = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$3(exec)) {
    var result = call$2(exec, R, S);
    if (result !== null) anObject$2(result);
    return result;
  }
  if (classof$2(R) === 'RegExp') return call$2(regexpExec, R, S);
  throw new $TypeError$1('RegExp#exec called on incompatible receiver');
};

var apply = functionApply;
var call$1 = functionCall;
var uncurryThis$7 = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
var fails$3 = fails$m;
var anObject$1 = anObject$9;
var isCallable$2 = isCallable$i;
var isNullOrUndefined$1 = isNullOrUndefined$4;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$5;
var toLength$1 = toLength$3;
var toString$5 = toString$9;
var requireObjectCoercible$3 = requireObjectCoercible$9;
var advanceStringIndex = advanceStringIndex$1;
var getMethod$1 = getMethod$3;
var getSubstitution = getSubstitution$1;
var regExpExec$1 = regexpExecAbstract;
var wellKnownSymbol$1 = wellKnownSymbol$d;

var REPLACE = wellKnownSymbol$1('replace');
var max = Math.max;
var min$1 = Math.min;
var concat = uncurryThis$7([].concat);
var push = uncurryThis$7([].push);
var stringIndexOf = uncurryThis$7(''.indexOf);
var stringSlice$2 = uncurryThis$7(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$3(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic$1('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible$3(this);
      var replacer = isNullOrUndefined$1(searchValue) ? undefined : getMethod$1(searchValue, REPLACE);
      return replacer
        ? call$1(replacer, searchValue, O, replaceValue)
        : call$1(nativeReplace, toString$5(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject$1(this);
      var S = toString$5(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable$2(replaceValue);
      if (!functionalReplace) replaceValue = toString$5(replaceValue);

      var global = rx.global;
      var fullUnicode;
      if (global) {
        fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }

      var results = [];
      var result;
      while (true) {
        result = regExpExec$1(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString$5(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength$1(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString$5(result[0]);
        var position = max(min$1(toIntegerOrInfinity$1(result.index), S.length), 0);
        var captures = [];
        var replacement;
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          replacement = toString$5(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice$2(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }

      return accumulatedResult + stringSlice$2(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

// a string of all valid unicode whitespaces
var whitespaces$3 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis$6 = functionUncurryThis;
var requireObjectCoercible$2 = requireObjectCoercible$9;
var toString$4 = toString$9;
var whitespaces$2 = whitespaces$3;

var replace$1 = uncurryThis$6(''.replace);
var ltrim = RegExp('^[' + whitespaces$2 + ']+');
var rtrim = RegExp('(^|[^' + whitespaces$2 + '])[' + whitespaces$2 + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString$4(requireObjectCoercible$2($this));
    if (TYPE & 1) string = replace$1(string, ltrim, '');
    if (TYPE & 2) string = replace$1(string, rtrim, '$1');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var fails$2 = fails$m;
var whitespaces$1 = whitespaces$3;

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails$2(function () {
    return !!whitespaces$1[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces$1[METHOD_NAME].name !== METHOD_NAME);
  });
};

var $$4 = _export;
var $trim = stringTrim.trim;
var forcedStringTrimMethod = stringTrimForced;

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$$4({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

const formData$1 = {
  regions: {
    CAC: {
      optGroup: 'regions.CAC'
    },
    AB: 'regions.AB',
    BC: 'regions.BC',
    MB: 'regions.MB',
    NB: 'regions.NB',
    NL: 'regions.NL',
    NS: 'regions.NS',
    NT: 'regions.NT',
    NU: 'regions.NU',
    ON: 'regions.ON',
    PE: 'regions.PE',
    QC: 'regions.QC',
    SK: 'regions.SK',
    YT: 'regions.YT',
    USC: {
      optGroup: 'regions.USC'
    },
    AL: 'regions.AL',
    AK: 'regions.AK',
    AZ: 'regions.AZ',
    AR: 'regions.AR',
    CA: 'regions.CA',
    CO: 'regions.CO',
    CT: 'regions.CT',
    DE: 'regions.DE',
    FL: 'regions.FL',
    GA: 'regions.GA',
    HI: 'regions.HI',
    ID: 'regions.ID',
    IL: 'regions.IL',
    IN: 'regions.IN',
    IA: 'regions.IA',
    KS: 'regions.KS',
    KY: 'regions.KY',
    LA: 'regions.LA',
    ME: 'regions.ME',
    MD: 'regions.MD',
    MA: 'regions.MA',
    MI: 'regions.MI',
    MN: 'regions.MN',
    MS: 'regions.MS',
    MO: 'regions.MO',
    MT: 'regions.MT',
    NE: 'regions.NE',
    NV: 'regions.NV',
    NH: 'regions.NH',
    NJ: 'regions.NJ',
    NM: 'regions.NM',
    NY: 'regions.NY',
    NC: 'regions.NC',
    ND: 'regions.ND',
    OH: 'regions.OH',
    OK: 'regions.OK',
    OR: 'regions.OR',
    PA: 'regions.PA',
    RI: 'regions.RI',
    SC: 'regions.SC',
    SD: 'regions.SD',
    TN: 'regions.TN',
    TX: 'regions.TX',
    UT: 'regions.UT',
    VT: 'regions.VT',
    VA: 'regions.VA',
    WA: 'regions.WA',
    WV: 'regions.WV',
    WI: 'regions.WI',
    WY: 'regions.WY',
    UKC: {
      optGroup: 'regions.UKC'
    },
    ENG: 'regions.ENG',
    NIR: 'regions.NIR',
    SCT: 'regions.SCT',
    WLS: 'regions.WLS'
  }
};
const createFormData = (dataKey, localization) => {
  let keys = Object.keys(formData$1[dataKey]);
  let arr = keys.reduce((result, key) => result.concat({
    value: key,
    label: localization(formData$1[dataKey][key]) || formData$1[dataKey][key]
  }), []);
  return arr;
};
const useKitRequestSchema = options => {
  const {
    postalCodeCountry
  } = options;
  const {
    localize
  } = useLocalize();
  return useMemo(() => yup.object({
    patientId: yup.string(),
    fname: yup.string().required(localize('patientCreation.helperText.required')).max(50),
    lname: yup.string().required(localize('patientCreation.helperText.required')).max(50),
    patientNumber: yup.string(),
    requestByDate: yup.date().required(localize('patientCreation.helperText.required')),
    requestKit: yup.string().required(localize('patientCreation.helperText.required')),
    street: yup.string().required(localize('patientCreation.helperText.required')).max(30, localize('patientCreation.helperText.maxLength')),
    apartment: yup.string().max(30, localize('patientCreation.helperText.maxLength')),
    country: yup.string().required(localize('patientCreation.helperText.required')),
    city: yup.string().required(localize('patientCreation.helperText.required')).max(25),
    province: yup.string().required(localize('patientCreation.helperText.required')),
    postal: yup.string().when([], {
      is: () => postalCodeCountry === 'canada',
      then: yup.string().matches(/^[A-Z]\d[A-Z] \d[A-Z]\d$/, localize('patientCreation.helperText.postalCanada'))
    }).when([], {
      is: () => postalCodeCountry === 'united states',
      then: yup.string().matches(/^\d{5}(?:[-\s]\d{4})?$/, localize('patientCreation.helperText.postalUS'))
    }).when([], {
      is: () => postalCodeCountry === 'united kingdom',
      then: yup.string().matches(/^([G][I][R] 0[A]{2})|((([A-Z][0-9]{1,2})|(([A-Z][A-HJ-Y][0-9]{1,2})|(([A-Z][0-9][A-Z])|([A-Z][A-HJ-Y][0-9][A-Z]?))))\s?[0-9][A-Z]{2})$/, localize('patientCreation.helperText.postalUK'))
    }).required(localize('patientCreation.helperText.required')),
    phone: yup.string().matches(/^((\+44 |44)??\d{4}?[- ]?\d{5})|((\+1 |1)?[(]?\d{3}[)]?[- ]?\d{3}[- ]?\d{4})$/, localize('patientCreation.helperText.validPhone')).required(localize('patientCreation.helperText.required')),
    phone2: yup.string().matches(/^((\+44 |44)??\d{4}?[- ]?\d{5})|((\+1 |1)?[(]?\d{3}[)]?[- ]?\d{3}[- ]?\d{4})$/, localize('patientCreation.helperText.validPhone')),
    note: yup.string()
  }), [localize, postalCodeCountry]);
};

var makeBuiltIn = makeBuiltIn$3.exports;
var defineProperty = objectDefineProperty;

var defineBuiltInAccessor$1 = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};

var $$3 = _export;
var DESCRIPTORS = descriptors;
var globalThis$2 = globalThis_1;
var uncurryThis$5 = functionUncurryThis;
var hasOwn = hasOwnProperty_1;
var isCallable$1 = isCallable$i;
var isPrototypeOf = objectIsPrototypeOf;
var toString$3 = toString$9;
var defineBuiltInAccessor = defineBuiltInAccessor$1;
var copyConstructorProperties = copyConstructorProperties$2;

var NativeSymbol = globalThis$2.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable$1(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString$3(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      // eslint-disable-next-line sonarjs/inconsistent-function-call -- ok
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('description detection')) === 'Symbol(description detection)';
  var thisSymbolValue = uncurryThis$5(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis$5(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis$5(''.replace);
  var stringSlice$1 = uncurryThis$5(''.slice);

  defineBuiltInAccessor(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice$1(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $$3({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

const CustomRadio = ({
  name,
  theme,
  value,
  options,
  onChange,
  disabled
}) => {
  const StyledFormControlLabel = styled(FormControlLabel)({
    color: '#285E63'
  });
  const style = {
    header: {
      fontWeight: '600'
    },
    radioInput: {
      alignItems: 'center'
    },
    radioBox: {
      width: '100%',
      borderBottom: '1px solid #D5E8F0',
      alignItems: 'center',
      padding: '15px'
    }
  };
  return jsxs(ThemeProvider, Object.assign({
    theme: theme
  }, {
    children: [jsx(FormLabel, Object.assign({
      component: "h2",
      style: style.header
    }, {
      children: name
    })), jsx(RadioGroup, Object.assign({
      "aria-label": name,
      name: name,
      value: value,
      onChange: onChange
    }, {
      children: jsx(Grid, Object.assign({
        container: true,
        style: style.radioInput
      }, {
        children: options.map(option => {
          return jsxs(Grid, Object.assign({
            container: true,
            style: style.radioBox
          }, {
            children: [jsx(Grid, Object.assign({
              item: true,
              xs: 2
            }, {
              children: jsx(StyledFormControlLabel, {
                disabled: disabled,
                value: option.value,
                control: jsx(Radio, {}),
                label: option.label
              })
            })), jsx(Grid, Object.assign({
              item: true,
              xs: 10
            }, {
              children: jsx(InputLabel, Object.assign({
                color: "primary"
              }, {
                children: option.description
              }))
            }))]
          }), option.label);
        })
      }))
    }))]
  }));
};

const Colors = DashboardsTheme.palette;
const SelectContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center'
});
const Text = styled('div')({
  fontFamily: 'Poppins',
  fontWeight: 500,
  fontSize: '14px',
  color: '#285E63'
});
const StyledSelect$3 = styled(Select)(({
  width
}) => ({
  width: width ? width : undefined,
  color: Colors.primary.main,
  backgroundColor: 'unset'
}));
const StyledSelectOutline = withStyles({
  outlined: {
    padding: '10.5px 14px'
  }
})(Select);
const TextSelect = props => {
  var _a, _b;
  const {
    options,
    children,
    onChange,
    id,
    outline = false,
    defaultValue
  } = props;
  const Select = outline ? StyledSelectOutline : StyledSelect$3;
  return jsxs(SelectContainer, {
    children: [jsx(Text, {
      children: children
    }), jsx(Select, Object.assign({
      id: id,
      name: id,
      fullWidth: true,
      onChange: onChange,
      disabled: props.disabled,
      defaultValue: (_b = defaultValue !== null && defaultValue !== void 0 ? defaultValue : (_a = options[0]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
      variant: outline ? 'outlined' : 'standard'
    }, {
      children: options.map((option, index) => jsx(MenuItem, Object.assign({
        value: option.value
      }, {
        children: option.text
      }), `text_select_${index}_${option}`))
    }))]
  });
};

/**
 * @property mask The mask to apply to the input. See InputMask for more details
 * @property maskChar The character to use for the mask. See InputMask for more details
 * @property value The value of the input. Must be a string. See TextField for more details
 * @property onChange The onChange handler. See TextField for more details.
 * @property rest All other props are passed to TextField
 */
const MaskedInput = _a => {
  var {
      mask,
      value = '',
      onChange,
      onBlur,
      maskChar = '',
      maskEnabled = true,
      characterLimit = 100,
      disabled,
      beforeMaskedValueChange
    } = _a,
    rest = __rest(_a, ["mask", "value", "onChange", "onBlur", "maskChar", "maskEnabled", "characterLimit", "disabled", "beforeMaskedValueChange"]);
  if (typeof value !== 'string' && typeof value !== 'undefined') {
    throw new Error('MaskedInput must be used with a string value');
  }
  mask = mask || Array(characterLimit).fill('*').join('');
  return jsx(InputMask, Object.assign({
    mask: mask,
    value: value,
    onChange: onChange,
    onBlur: onBlur,
    maskChar: maskChar,
    beforeMaskedValueChange: beforeMaskedValueChange,
    disabled: disabled
  }, {
    children:
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    props => jsx(TextField, Object.assign({}, props, rest, {
      disabled: disabled
    }))
  }));
};

/**
 * @property children These are the options that will be displayed in the dropdown. They should be MUI MenuItems and they should have a value that corresponds to the relevant Mask.
 */
const MaskedInputWithSelect = _a => {
  var {
      initialValue,
      valueToMask,
      valueToBeforeMaskedValueChange,
      children,
      disabled,
      onSelectChange
    } = _a,
    rest = __rest(_a, ["initialValue", "valueToMask", "valueToBeforeMaskedValueChange", "children", "disabled", "onSelectChange"]);
  // Maintain state internally so that we can update the mask when the value changes
  const [currentValue, setCurrentValue] = React__default.useState(initialValue || '');
  useEffect(() => {
    setCurrentValue(initialValue || '');
  }, [initialValue]);
  useEffect(() => {
    if (currentValue && !valueToMask[currentValue]) {
      setCurrentValue('');
    }
  }, [currentValue, valueToMask]);
  if (!valueToMask) {
    throw new Error('MaskedInputWithSelect: valueToMask is required but was not provided');
  }
  const currentMask = currentValue ? valueToMask[currentValue] : undefined;
  if (currentValue && !currentMask) {
    throw new Error(`MaskedInputWithSelect: No mask found for value ${currentValue}`);
  }
  const currentBeforeMaskedValueChange = valueToBeforeMaskedValueChange === null || valueToBeforeMaskedValueChange === void 0 ? void 0 : valueToBeforeMaskedValueChange[currentValue];
  return jsxs(Grid, Object.assign({
    container: true,
    wrap: "nowrap",
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start"
  }, {
    children: [jsx(Select, Object.assign({
      disableUnderline: true,
      value: currentValue,
      defaultValue: initialValue,
      disabled: disabled,
      onChange: e => {
        setCurrentValue(e.target.value);
        onSelectChange && onSelectChange(e.target.value);
      },
      style: {
        marginTop: '4px',
        marginRight: '8px'
      }
    }, {
      children: children
    })), jsx(MaskedInput, Object.assign({
      mask: currentMask,
      beforeMaskedValueChange: currentBeforeMaskedValueChange,
      disabled: disabled
    }, rest))]
  }));
};

const CA_PROVINCE = ['AB', 'BC', 'MB', 'NB', 'NL', 'NT', 'NS', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT', ''];
const MaskedHealthCardInput = _a => {
  var {
      initialValue
    } = _a,
    rest = __rest(_a, ["initialValue"]);
  const {
    localize
  } = useLocalize();
  initialValue = initialValue && CA_PROVINCE.includes(initialValue) ? initialValue : 'unfiltered';
  return jsxs(MaskedInputWithSelect, Object.assign({}, rest, {
    initialValue: initialValue,
    valueToMask: {
      AB: '99999-9999',
      BC: '9999 999 999',
      MB: '999999',
      NB: '999-999-999',
      NL: '999 999 999 999',
      NT: 'a9999999',
      NS: '9999 999 999',
      NU: '999999999',
      ON: '9999 999 999',
      PE: '99999999',
      QC: 'aaaa 9999 9999',
      SK: '999 999 999',
      YT: '999-999-999',
      unfiltered: '************'
    }
  }, {
    children: [jsx(ListSubheader, {
      children: localize('country.canada')
    }), jsx(MenuItem$1, Object.assign({
      value: "AB"
    }, {
      children: "AB"
    }), "AB"), jsx(MenuItem$1, Object.assign({
      value: "BC"
    }, {
      children: "BC"
    }), "BC"), jsx(MenuItem$1, Object.assign({
      value: "MB"
    }, {
      children: "MB"
    }), "MB"), jsx(MenuItem$1, Object.assign({
      value: "NB"
    }, {
      children: "NB"
    }), "NB"), jsx(MenuItem$1, Object.assign({
      value: "NL"
    }, {
      children: "NL"
    }), "NL"), jsx(MenuItem$1, Object.assign({
      value: "NT"
    }, {
      children: "NT"
    }), "NT"), jsx(MenuItem$1, Object.assign({
      value: "NS"
    }, {
      children: "NS"
    }), "NS"), jsx(MenuItem$1, Object.assign({
      value: "NU"
    }, {
      children: "NU"
    }), "NU"), jsx(MenuItem$1, Object.assign({
      value: "ON"
    }, {
      children: "ON"
    }), "ON"), jsx(MenuItem$1, Object.assign({
      value: "PE"
    }, {
      children: "PE"
    }), "PE"), jsx(MenuItem$1, Object.assign({
      value: "QC"
    }, {
      children: "QC"
    }), "QC"), jsx(MenuItem$1, Object.assign({
      value: "SK"
    }, {
      children: "SK"
    }), "SK"), jsx(MenuItem$1, Object.assign({
      value: "YT"
    }, {
      children: "YT"
    }), "YT"), jsx(ListSubheader, {
      children: localize('country.other')
    }), jsx(MenuItem$1, Object.assign({
      value: "unfiltered"
    }, {
      children: localize('patientCreation.noFilter')
    }))]
  }));
};

const MaskedPhoneInput = props => {
  const {
    localize
  } = useLocalize();
  const initialValue = props.initialValue || 'unfiltered';
  return jsxs(MaskedInputWithSelect, Object.assign({}, props, {
    initialValue: initialValue,
    valueToMask: {
      canada: '+1 (999) 999 9999',
      'united states': '+1 (999) 999-9999',
      'united kingdom': '+44 9999 999999',
      unfiltered: '9999999999999'
    }
  }, {
    children: [jsx(MenuItem$1, Object.assign({
      value: "canada"
    }, {
      children: jsx(CA, {
        style: {
          height: '15px'
        },
        title: localize('country.canada')
      })
    })), jsx(MenuItem$1, Object.assign({
      value: "united states"
    }, {
      children: jsx(US, {
        style: {
          height: '15px'
        },
        title: localize('country.united states')
      })
    })), jsx(MenuItem$1, Object.assign({
      value: "united kingdom"
    }, {
      children: jsx(GB, {
        style: {
          height: '15px'
        },
        title: localize('country.united kingdom')
      })
    })), jsx(MenuItem$1, Object.assign({
      value: "unfiltered"
    }, {
      children: localize('patientCreation.noFilter')
    }))]
  }));
};

const VALID_MASKS = ['canada', 'united states', 'united kingdom', 'unfiltered', ''];
const MaskedPostalInput = props => {
  const {
    localize
  } = useLocalize();
  const [usaMask, setUsaMask] = React__default.useState('99999');
  const initialValue = props.initialValue && VALID_MASKS.includes(props.initialValue) ? props.initialValue : 'unfiltered';
  // The US has a ten-digit zip code which is formatted as 99999-9999
  // This allows users to add a hyphen and type the last four digits
  const handleTenDigitZipCode = (newState, _oldState, userInput) => {
    var _a, _b, _c;
    if (userInput === '-' && ((_a = newState.selection) === null || _a === void 0 ? void 0 : _a.start) === 5) {
      setUsaMask(`99999${userInput}9999`);
      return {
        value: newState.value + userInput,
        selection: {
          start: newState.value.length + 1,
          end: newState.value.length + 1
        }
      };
    } else if (((_c = (_b = newState.selection) === null || _b === void 0 ? void 0 : _b.start) !== null && _c !== void 0 ? _c : 0) < 5) {
      setUsaMask('99999');
    }
    return Object.assign({}, newState);
  };
  return jsxs(MaskedInputWithSelect, Object.assign({}, props, {
    valueToMask: {
      canada: 'a9a 9a9',
      'united states': usaMask,
      'united kingdom': '**********',
      unfiltered: '**********'
    },
    valueToBeforeMaskedValueChange: {
      'united states': handleTenDigitZipCode
    },
    initialValue: initialValue
  }, {
    children: [jsx(MenuItem$1, Object.assign({
      value: "canada"
    }, {
      children: jsx(CA, {
        style: {
          height: '15px'
        },
        title: localize('country.canada')
      })
    })), jsx(MenuItem$1, Object.assign({
      value: "united states"
    }, {
      children: jsx(US, {
        style: {
          height: '15px'
        },
        title: localize('country.united states')
      })
    })), jsx(MenuItem$1, Object.assign({
      value: "united kingdom"
    }, {
      children: jsx(GB, {
        style: {
          height: '15px'
        },
        title: localize('country.united kingdom')
      })
    })), jsx(MenuItem$1, Object.assign({
      value: "unfiltered"
    }, {
      children: localize('patientCreation.noFilter')
    }))]
  }));
};

const ErrorToast = ({
  open,
  handleClose,
  message
}) => {
  return jsx(Snackbar, Object.assign({
    anchorOrigin: {
      vertical: "top",
      horizontal: "center"
    },
    open: open,
    autoHideDuration: 6000,
    onClose: handleClose
  }, {
    children: jsx(Alert, Object.assign({
      severity: "error",
      variant: "filled",
      action: jsx(IconButton, Object.assign({
        size: "small",
        "aria-label": "close",
        color: "inherit",
        onClick: handleClose
      }, {
        children: jsx(Close, {
          fontSize: "small"
        })
      }))
    }, {
      children: message
    }))
  }));
};

/**
 * This is a text editor that is designed to hidden when the user isn't interacting with it.
 * That's why it's covert, they don't know it's a text editor until they click on it 🕵️
 *
 * @param text The text to display in the editor.
 * @param onChange Called when the text changes.
 * @param placeholder The placeholder text to display when the editor is empty.
 * @param tooltip The tooltip to display when the user hovers over the editor.
 * @param tooltipPlacement The placement of the tooltip.
 * @param typographyProps The props to pass to the Typography component.
 */
const CovertTextEditor = ({
  text,
  placeholder,
  onChange,
  tooltip,
  tooltipPlacement,
  typographyProps
}) => {
  const [isFocussed, setIsFocussed] = React__default.useState(false);
  const {
    userMetrics
  } = useUserMetrics();
  return jsx("div", {
    children: !isFocussed ? jsx(Tooltip, Object.assign({
      title: tooltip || 'Click to edit',
      placement: tooltipPlacement || 'bottom-start',
      arrow: true
    }, {
      children: jsx(Box, Object.assign({
        fontStyle: !text ? 'italic' : 'normal'
      }, {
        children: jsx(Typography, Object.assign({}, typographyProps, {
          onClick: () => {
            userMetrics.trackEvent("click covert text editor", {
              value: text,
              tooltip: tooltip || 'Click to edit'
            });
            setIsFocussed(true);
          }
        }, {
          children: text || placeholder
        }))
      }))
    })) : jsx(TextField, {
      autoFocus: true,
      value: text || '',
      onChange: event => onChange(event.target.value),
      onBlur: () => setIsFocussed(false)
    })
  });
};

const StyledSelect$2 = styled(Select$1)({
  backgroundColor: 'transparent'
});
const Filters = ({
  label,
  options,
  theme,
  onChange
}) => {
  const styles = {
    container: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center'
    }
  };
  const {
    localize
  } = useLocalize();
  return jsx(ThemeProvider, Object.assign({
    theme: theme
  }, {
    children: jsxs(FormControl, Object.assign({
      style: styles.container,
      variant: "standard",
      color: "primary"
    }, {
      children: [jsx(InputLabel, {
        children: label
      }), jsxs(StyledSelect$2, Object.assign({
        "aria-label": label,
        onChange: onChange,
        fullWidth: true,
        defaultValue: '',
        MenuProps: {
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left'
          },
          getContentAnchorEl: null
        }
      }, {
        children: [jsx(MenuItem$1, Object.assign({
          value: ""
        }, {
          children: jsx(Typography, Object.assign({
            style: {
              textTransform: 'capitalize'
            }
          }, {
            children: localize('Clear_Filter')
          }))
        }), "clear"), options.map(o => jsx(MenuItem$1, Object.assign({
          value: o
        }, {
          children: jsx(Typography, Object.assign({
            style: {
              textTransform: 'capitalize'
            }
          }, {
            children: o
          }))
        }), o))]
      }))]
    }))
  }));
};

const TextInput = ({
  label,
  placeholder,
  disabled
}) => {
  const styles = {
    textField: {
      margin: '10px',
      display: 'flex',
      alignItems: 'center',
      width: '219px'
    }
  };
  return jsx(ThemeProvider, Object.assign({
    theme: DashboardsTheme
  }, {
    children: jsxs(Grid, Object.assign({
      item: true,
      xs: 6,
      style: styles.textField
    }, {
      children: [jsx(Grid, Object.assign({
        item: true,
        xs: 2
      }, {
        children: jsx(InputLabel, Object.assign({
          htmlFor: label.replace(/\s/g, '-')
        }, {
          children: label
        }))
      })), jsx(Grid, Object.assign({
        item: true,
        xs: 6
      }, {
        children: jsx(TextField, {
          id: label.replace(/\s/g, '-'),
          variant: "outlined",
          placeholder: placeholder,
          disabled: disabled
        })
      }))]
    }))
  }));
};

const TabNavigation = ({
  tabs,
  theme,
  variant,
  onChange
}) => {
  const [value, setValue] = React__default.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    onChange && onChange(newValue);
  };
  const containerStyle = variant === 'standard' ? {
    display: 'flex',
    paddingLeft: '2%'
  } : {};
  const tabPanelStyle = variant === 'standard' ? {
    backgroundColor: '#F2F6F8'
  } : {};
  const TabPanel = ({
    children,
    index,
    value
  }) => {
    return jsx("div", Object.assign({
      role: "tabpanel",
      hidden: value !== index,
      id: `tabpanel-${index}`,
      "aria-labelledby": `tab-${index}`,
      style: tabPanelStyle
    }, {
      children: value === index && jsx(Box, Object.assign({
        p: 3
      }, {
        children: children
      }))
    }));
  };
  return jsxs(ThemeProvider, Object.assign({
    theme: theme || DashboardsTheme
  }, {
    children: [jsx("div", Object.assign({
      style: containerStyle
    }, {
      children: jsx(Tabs, Object.assign({
        value: value,
        onChange: handleChange,
        "aria-label": "simple tabs example",
        textColor: "primary",
        variant: variant || 'fullWidth',
        TabIndicatorProps: {
          style: {
            backgroundColor: 'transparent'
          }
        }
      }, {
        children: tabs.map(tab => jsx(Tab, {
          textColor: "primary",
          label: tab.name,
          id: tab.name,
          "test-id": `${tab.name}_tab`,
          "aria-controls": tab.name
        }, tab.name))
      }))
    })), tabs.map(tab => jsx(TabPanel, Object.assign({
      value: value,
      index: tab.index
    }, {
      children: tab.body
    }), `${tab.name}-content`))]
  }));
};

const noop$1 = () => {};
const TabModal = ({
  actions,
  onClose: _onClose = noop$1,
  open: _open = false,
  children,
  tabs,
  theme
}) => jsxs(Dialog, Object.assign({
  open: !!_open,
  maxWidth: "md",
  fullWidth: true,
  scroll: "body",
  onClose: _onClose,
  disableEnforceFocus: true
}, {
  children: [jsx(TabNavigation, {
    tabs: tabs,
    theme: theme
  }), jsx(DialogContent, {
    children: children
  }), jsx(DialogActions$1, {
    children: actions
  })]
}));

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
var sameValue$1 = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x !== x && y !== y;
};

var call = functionCall;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var anObject = anObject$9;
var isNullOrUndefined = isNullOrUndefined$4;
var requireObjectCoercible$1 = requireObjectCoercible$9;
var sameValue = sameValue$1;
var toString$2 = toString$9;
var getMethod = getMethod$3;
var regExpExec = regexpExecAbstract;

// @@search logic
fixRegExpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible$1(this);
      var searcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, SEARCH);
      return searcher ? call(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString$2(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject(this);
      var S = toString$2(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

const SearchPeopleModal = _a => {
  var {
      multiple,
      onChange,
      onFinish,
      onClose,
      defaults,
      placeholder
    } = _a,
    props = __rest(_a, ["multiple", "onChange", "onFinish", "onClose", "defaults", "placeholder"]);
  const {
    localize
  } = useLocalize();
  const {
    api
  } = useResources();
  const {
    userMetrics
  } = useUserMetrics();
  const config = useConfig();
  const [searchQuery, setSearchQuery] = useState('');
  const [people, setPeople] = useState([]);
  const [selected, setSelected] = useState([]);
  useEffect(() => {
    if (searchQuery) searchPeople();
    function searchPeople() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const response = yield api.people.search(searchQuery);
          if (response && response.length) {
            setPeople(response);
          }
        } catch (e) {
          Sentry.captureException(e);
        }
      });
    }
  }, [api, searchQuery]);
  useEffect(() => {
    if (defaults) setSelected(defaults);
  }, [defaults]);
  const actions = [jsx(Button$1, Object.assign({
    onClick: onClose
  }, {
    children: localize('search_close')
  }), "close")];
  if (multiple) actions.push(jsx(Button$1, Object.assign({
    onClick: () => {
      userMetrics.trackEvent("click done on search people popup", {
        selected
      });
      onClose();
      if (onFinish) {
        onFinish(selected);
      }
    }
  }, {
    children: localize('search_done')
  }), "close"));
  return jsxs(ActionDialog, Object.assign({
    reactKey: "people_search_modal",
    onClose: onClose,
    actions: actions
  }, props, {
    children: [jsx(SearchBar, {
      id: "people_search",
      width: '30%',
      placeholder: placeholder,
      testId: 'people_search',
      onChange: event => setSearchQuery(event.target.value)
    }), jsx(List, {
      children: people.map(person => jsxs(ListItem, Object.assign({
        button: true,
        disabled: selected.includes(person._id),
        onClick: () => {
          userMetrics.trackEvent("click on person in search people popup", {
            who: person._id
          });
          onChange && onChange(person._id);
          if (multiple) {
            setSelected(prevSelected => prevSelected.concat(person._id));
          } else {
            onClose();
          }
        }
      }, {
        children: [jsx(ListItemAvatar, {
          children: jsx(Avatar, {
            style: {
              borderWidth: 1,
              borderColor: '#e8e8e8'
            },
            alt: `${person.fname} ${person.lname} Avatar`,
            src: `${config.image_cdn}${person.image}`
          })
        }), jsx(ListItemText, {
          primary: `${person.fname} ${person.lname}`
        })]
      }), `${person.fname}_${person.lname}_select`))
    })]
  }));
};

const StoreInitializerComponent = ({
  children,
  values
}) => {
  const statusStore = useStatusStore();
  const instances = values.map(value => {
    if (typeof value === 'function') {
      return value();
    }
    return value.loader();
  });
  // Use useMemo to calculate overall status from the status store
  const overallStatus = useMemo(() => {
    const statuses = values.map(value => {
      var _a;
      return (_a = statusStore.getStatus(value)) !== null && _a !== void 0 ? _a : "unset";
    });
    return getOverallStatus(statuses);
  }, [values, statusStore]);
  const argsMap = useMemo(() => values.map(hook => 'props' in hook ? hook.props : []), [values]);
  const isInitialized = overallStatus === "loaded";
  const isError = overallStatus === "error";
  useEffect(() => {
    instances.forEach((instance, index) => {
      var _a, _b;
      const loader = values[index];
      const status = (_a = statusStore.getStatus(loader)) !== null && _a !== void 0 ? _a : "unset";
      // This is a dangerous zone. If we overlooked this condition, we will end up with infinite recursion
      if (status === "unset") {
        statusStore.setStatus(loader, 'loading');
        instance.load(...((_b = argsMap[index]) !== null && _b !== void 0 ? _b : [])).then(() => {
          return statusStore.setStatus(loader, 'loaded');
        }).catch(error => {
          sentryErrorHandler(error);
          statusStore.setStatus(loader, 'error');
        });
      }
    });
    // Handle unloading by using the status store to set status
    const handleUnload = () => {
      instances.forEach((instance, index) => {
        var _a;
        const loader = values[index];
        statusStore.setStatus(loader, 'unset');
        (_a = instance.unload) === null || _a === void 0 ? void 0 : _a.call(instance);
      });
    };
    window.addEventListener("beforeunload", handleUnload);
    return () => window.removeEventListener("beforeunload", handleUnload);
  }, [values, instances, argsMap, statusStore]);
  if (isError) {
    return jsx(ErrorToast, {
      open: true,
      message: "Internal Error"
    });
  }
  if (!isInitialized) {
    return jsx(CircularProgress, {
      style: {
        position: "absolute"
      }
    });
  }
  return children;
};
const StoreInitializer = /*#__PURE__*/React__default.memo(StoreInitializerComponent);

/**
 * ChainStoreInitializerComponent orchestrates the initialization of resources or states in a structured, layered manner.
 * It recursively nests StoreInitializer components to handle a sequence of initialization steps, ensuring that each step
 * is ready before proceeding to the next.
 */
const ChainStoreInitializerComponent = ({
  children,
  values
}) => {
  // Recursive function to render nested StoreInitializers
  const renderNestedInitializers = (chains, content) => {
    if (!chains.length) {
      return content;
    }
    const [first, ...rest] = chains;
    return jsx(StoreInitializer, Object.assign({
      values: first
    }, {
      children: renderNestedInitializers(rest, content)
    }));
  };
  return renderNestedInitializers(values, children) || null;
};
const ChainStoreInitializer = /*#__PURE__*/React__default.memo(ChainStoreInitializerComponent);

const StyledInputLabel = styled(InputLabel)({
  color: '#102543',
  fontFamily: 'Poppins',
  fontWeight: 400,
  fontSize: '14px'
});
const StyledTextareaAutosize$1 = styled(TextareaAutosize)({
  width: '100%',
  border: '1px solid #88A4B0',
  borderRadius: '4px',
  fontFamily: 'Poppins',
  fontSize: '16px',
  fontWeight: 400,
  color: '#102543',
  resize: 'none',
  '&:disabled': {
    backgroundColor: '#00000033',
    borderRadius: '4px'
  }
});
const styles$a = {
  textField: {
    margin: '10px',
    display: 'flex',
    alignItems: 'center'
  },
  groupButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: '40px'
  },
  option: {
    marginLeft: '20px',
    marginRight: '20px'
  },
  grid: {
    flexWrap: 'nowrap',
    verticalAlign: 'middle'
  }
};
const defaultCountry = 'canada';
const StyledSelect$1 = withStyles$1({
  outlined: {
    padding: '10.5px 14px'
  }
})(Select$1);
const Request = ({
  user,
  submitRef,
  onClosed,
  handleSubmitRequest,
  handleSubmitRequestFailure
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
  const {
    localize
  } = useLocalize();
  const {
    kitModels
  } = useKitModels();
  const {
    requestKit
  } = useKit();
  const regions = createFormData('regions', localize);
  const [postalCodeCountry, setPostalCodeCountry] = useState(defaultCountry);
  const [orderErrMsg, setOrderErrMsg] = useState('');
  const inputDisabled = !!(user === null || user === void 0 ? void 0 : user.kit_assignment);
  function padZero(number) {
    if (number < 10) {
      return `0${number}`;
    } else {
      return number + '';
    }
  }
  const formatDate = d => {
    let date = d || 'Invalid Date';
    if (date.toString().includes('Z')) date = new Date(date.toString().replace('Z', ''));else if (date.toString().includes('-')) date = new Date(date.toString().replace(/-/g, '/'));else date = new Date(date);
    let displayedDate = '';
    if (date && date.toString() !== 'Invalid Date' && typeof date !== 'string') {
      displayedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())}`;
    }
    return displayedDate;
  };
  const formik = useFormik({
    initialValues: !inputDisabled ? {
      patientId: (user === null || user === void 0 ? void 0 : user._id) || '',
      fname: (user === null || user === void 0 ? void 0 : user.fname) || '',
      lname: (user === null || user === void 0 ? void 0 : user.lname) || '',
      patientNumber: user === null || user === void 0 ? void 0 : user.patientNumber,
      requestByDate: format(addBusinessDays(new Date(), 5), 'yyyy-MM-dd'),
      requestKit: kitModels[0] ? kitModels[0]._id : '',
      street: (user === null || user === void 0 ? void 0 : user.street) || '',
      apartment: (user === null || user === void 0 ? void 0 : user.apartment) || '',
      country: (user === null || user === void 0 ? void 0 : user.country) || defaultCountry,
      city: (user === null || user === void 0 ? void 0 : user.city) || '',
      province: (user === null || user === void 0 ? void 0 : user.province) || 'ON',
      postal: (user === null || user === void 0 ? void 0 : user.postal) || '',
      phone: (user === null || user === void 0 ? void 0 : user.phone) || '',
      phone2: (user === null || user === void 0 ? void 0 : user.phone2) || '',
      note: ''
    } : {
      patientId: ((_a = user === null || user === void 0 ? void 0 : user.kit_assignment) === null || _a === void 0 ? void 0 : _a.patientId) || '',
      fname: (user === null || user === void 0 ? void 0 : user.fname) || '',
      lname: (user === null || user === void 0 ? void 0 : user.lname) || '',
      patientNumber: user === null || user === void 0 ? void 0 : user.patientNumber,
      requestByDate: formatDate((_b = user === null || user === void 0 ? void 0 : user.kit_assignment) === null || _b === void 0 ? void 0 : _b.requestByDate),
      requestKit: ((_c = user === null || user === void 0 ? void 0 : user.kit_assignment) === null || _c === void 0 ? void 0 : _c.kitModelId) || '',
      street: ((_e = (_d = user === null || user === void 0 ? void 0 : user.kit_assignment) === null || _d === void 0 ? void 0 : _d.shippingAddress) === null || _e === void 0 ? void 0 : _e.street) || '',
      apartment: ((_f = user === null || user === void 0 ? void 0 : user.kit_assignment) === null || _f === void 0 ? void 0 : _f.shippingAddress.apartment) || '',
      country: ((_g = user === null || user === void 0 ? void 0 : user.kit_assignment) === null || _g === void 0 ? void 0 : _g.shippingAddress.country) || 'canada',
      city: ((_h = user === null || user === void 0 ? void 0 : user.kit_assignment) === null || _h === void 0 ? void 0 : _h.shippingAddress.city) || '',
      province: ((_j = user === null || user === void 0 ? void 0 : user.kit_assignment) === null || _j === void 0 ? void 0 : _j.shippingAddress.province) || 'ON',
      postal: ((_k = user === null || user === void 0 ? void 0 : user.kit_assignment) === null || _k === void 0 ? void 0 : _k.shippingAddress.postal) || '',
      phone: ((_l = user === null || user === void 0 ? void 0 : user.kit_assignment) === null || _l === void 0 ? void 0 : _l.shippingAddress.phone) || '',
      phone2: ((_m = user === null || user === void 0 ? void 0 : user.kit_assignment) === null || _m === void 0 ? void 0 : _m.shippingAddress.phone2) || '',
      note: ((_o = user === null || user === void 0 ? void 0 : user.kit_assignment) === null || _o === void 0 ? void 0 : _o.notes) && ((_q = (_p = user === null || user === void 0 ? void 0 : user.kit_assignment) === null || _p === void 0 ? void 0 : _p.notes) === null || _q === void 0 ? void 0 : _q.length) > 0 ? (_r = user === null || user === void 0 ? void 0 : user.kit_assignment) === null || _r === void 0 ? void 0 : _r.notes[0].comment : ''
    },
    validateOnChange: true,
    validationSchema: useKitRequestSchema({
      postalCodeCountry
    }),
    onSubmit: values => __awaiter(void 0, void 0, void 0, function* () {
      const kit = {
        kitModelId: values.requestKit,
        patientId: values.patientId,
        shippingAddress: {
          street: values.street,
          apartment: values.apartment,
          country: values.country,
          city: values.city,
          province: values.province,
          postal: values.postal.trim(),
          phone: values.phone,
          phone2: values.phone2
        },
        note: values.note,
        requestByDate: values.requestByDate
      };
      handleSubmitRequest();
      const apiResponse = yield requestKit(kit);
      if (apiResponse.status === 200) {
        onClosed();
        return;
      }
      setOrderErrMsg(localize(apiResponse.message));
      handleSubmitRequestFailure();
    })
  });
  const handleSelectChange = (name, event) => {
    formik.setFieldValue(name, event.target.value);
  };
  const handleDateChange = event => {
    formik.setFieldValue('requestByDate', event.target.value);
  };
  return jsx(ThemeProvider, Object.assign({
    theme: DashboardsTheme
  }, {
    children: jsxs("form", Object.assign({
      ref: submitRef,
      onSubmit: formik.handleSubmit
    }, {
      children: [jsx(Grid, Object.assign({
        item: true,
        container: true,
        direction: "row",
        justifyContent: "flex-start",
        alignItems: "center",
        xs: 12,
        spacing: 4,
        style: {
          paddingLeft: 20,
          paddingBottom: 20
        }
      }, {
        children: jsx(Grid, Object.assign({
          item: true,
          xs: 12
        }, {
          children: !(user === null || user === void 0 ? void 0 : user.kit_assignment) ? jsx(CustomRadio, {
            name: localize('Request-Kit'),
            theme: DashboardsTheme,
            value: formik.values.requestKit,
            options: kitModels.map(kit => ({
              label: kit.modelNumber,
              value: kit._id,
              description: kit.itemModels.map(item => item.itemModel.modelName).join(', ')
            })),
            onChange: event => {
              formik.setFieldValue('requestKit', event.currentTarget.value);
            }
          }) : jsx(CustomRadio, {
            name: localize('Request-Kit'),
            theme: DashboardsTheme,
            value: formik.values.requestKit,
            disabled: true,
            options: kitModels.filter(kit => {
              var _a;
              return kit._id === ((_a = user === null || user === void 0 ? void 0 : user.kit_assignment) === null || _a === void 0 ? void 0 : _a.kitModelId);
            }).map(kit => ({
              label: kit.modelNumber,
              value: kit._id,
              description: kit.itemModels.map(item => item.itemModel.modelName).join(', ')
            })),
            onChange: () => {}
          })
        }))
      })), jsxs(Grid, Object.assign({
        item: true,
        container: true,
        direction: "row",
        justifyContent: "flex-start",
        alignItems: "center",
        xs: 12,
        spacing: 4,
        style: {
          paddingLeft: 20,
          paddingBottom: 20
        }
      }, {
        children: [jsx(Grid, Object.assign({
          item: true,
          xs: 12
        }, {
          children: jsxs(FormLabel, Object.assign({
            component: "h2"
          }, {
            children: [localize('Request-By-Date'), "*"]
          }))
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12
        }, {
          children: jsx(TextField, {
            id: "date",
            disabled: inputDisabled,
            color: "secondary",
            inputProps: {
              'aria-label': localize('Request-By-Date')
            },
            type: "date",
            InputLabelProps: {
              shrink: true
            },
            size: "small",
            variant: "outlined",
            value: formik.values.requestByDate,
            onChange: handleDateChange,
            error: formik.touched.requestByDate && Boolean(formik.errors.requestByDate)
          })
        })), jsx("div", {
          style: {
            borderBottom: '1px solid #D5E8F0',
            width: '100%'
          }
        })]
      })), jsxs(Grid, Object.assign({
        item: true,
        container: true,
        direction: "row",
        justifyContent: "flex-start",
        alignItems: "center",
        xs: 12,
        spacing: 4,
        style: {
          paddingLeft: 20,
          paddingBottom: 20
        }
      }, {
        children: [jsx(Grid, Object.assign({
          item: true,
          xs: 12
        }, {
          children: jsx(FormLabel, Object.assign({
            component: "h2"
          }, {
            children: localize('group_users_overview_Info')
          }))
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12,
          sm: 2
        }, {
          children: jsxs(StyledInputLabel, Object.assign({
            htmlFor: "fname"
          }, {
            children: [localize('users_fname'), "*"]
          }))
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12,
          sm: 4
        }, {
          children: jsx(TextField, {
            id: "fname",
            color: "secondary",
            placeholder: localize('users_fname'),
            size: "small",
            fullWidth: true,
            variant: "outlined",
            value: formik.values.fname,
            onChange: formik.handleChange,
            onBlur: formik.handleBlur,
            error: formik.touched.fname && Boolean(formik.errors.fname),
            helperText: formik.touched.fname && formik.errors.fname,
            disabled: true
          })
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12,
          sm: 2
        }, {
          children: jsxs(StyledInputLabel, Object.assign({
            htmlFor: "lname"
          }, {
            children: [localize('users_lname'), "*"]
          }))
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12,
          sm: 4
        }, {
          children: jsx(TextField, {
            id: "lname",
            color: "secondary",
            placeholder: localize('users_lname'),
            size: "small",
            fullWidth: true,
            variant: "outlined",
            value: formik.values.lname,
            onChange: formik.handleChange,
            onBlur: formik.handleBlur,
            error: formik.touched.lname && Boolean(formik.errors.lname),
            helperText: formik.touched.lname && formik.errors.lname,
            disabled: true
          })
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12,
          sm: 2
        }, {
          children: jsx(StyledInputLabel, Object.assign({
            htmlFor: "patientNumber"
          }, {
            children: localize('Patient_Number')
          }))
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12,
          sm: 4
        }, {
          children: jsx(TextField, {
            id: "patientNumber",
            color: "secondary",
            placeholder: localize('Patient_Number'),
            size: "small",
            fullWidth: true,
            variant: "outlined",
            value: formik.values.patientNumber,
            onChange: formik.handleChange,
            onBlur: formik.handleBlur,
            error: formik.touched.patientNumber && Boolean(formik.errors.patientNumber),
            helperText: formik.touched.patientNumber && formik.errors.patientNumber,
            disabled: true
          })
        })), jsx("div", {
          style: {
            borderBottom: '1px solid #D5E8F0',
            width: '100%'
          }
        })]
      })), jsxs(Grid, Object.assign({
        item: true,
        container: true,
        direction: "row",
        justifyContent: "flex-start",
        alignItems: "center",
        xs: 12,
        spacing: 4,
        style: {
          paddingLeft: 20,
          paddingBottom: 20
        }
      }, {
        children: [jsx(Grid, Object.assign({
          item: true,
          xs: 12
        }, {
          children: jsx(FormLabel, Object.assign({
            component: "h2"
          }, {
            children: localize('Shipping-Address')
          }))
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12,
          sm: 2
        }, {
          children: jsxs(StyledInputLabel, Object.assign({
            htmlFor: "street"
          }, {
            children: [localize('patientCreation.address1'), "*"]
          }))
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12,
          sm: 4
        }, {
          children: jsx(TextField, {
            id: "street",
            color: "secondary",
            disabled: inputDisabled,
            placeholder: localize('patientCreation.address1'),
            size: "small",
            fullWidth: true,
            variant: "outlined",
            value: formik.values.street,
            onChange: formik.handleChange,
            onBlur: formik.handleBlur,
            error: formik.touched.street && Boolean(formik.errors.street),
            helperText: formik.touched.street && formik.errors.street || localize('patientCreation.address1HelperText')
          })
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12,
          sm: 2
        }, {
          children: jsx(StyledInputLabel, Object.assign({
            htmlFor: "apartment"
          }, {
            children: localize('patientCreation.address2')
          }))
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12,
          sm: 4
        }, {
          children: jsx(TextField, {
            id: "apartment",
            color: "secondary",
            disabled: inputDisabled,
            placeholder: localize('patientCreation.address2'),
            value: formik.values.apartment,
            size: "small",
            onChange: formik.handleChange,
            onBlur: formik.handleBlur,
            fullWidth: true,
            variant: "outlined",
            error: formik.touched.apartment && Boolean(formik.errors.apartment),
            helperText: formik.touched.apartment && formik.errors.apartment || localize('patientCreation.address2HelperText')
          })
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12,
          sm: 2
        }, {
          children: jsxs(StyledInputLabel, Object.assign({
            htmlFor: "country"
          }, {
            children: [localize('patientCreation.country'), "*"]
          }))
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12,
          sm: 4
        }, {
          children: jsx(TextSelect, {
            id: "country",
            disabled: inputDisabled,
            outline: true,
            options: [{
              value: 'canada',
              text: localize('country.canada')
            }, {
              value: 'united states',
              text: localize('country.united states')
            }, {
              value: 'united kingdom',
              text: localize('country.united kingdom')
            }],
            defaultValue: formik.values.country,
            onChange: e => {
              handleSelectChange('country', e);
              const country = e.target.value;
              setPostalCodeCountry(country);
            }
          })
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12,
          sm: 2
        }, {
          children: jsxs(StyledInputLabel, Object.assign({
            htmlFor: "city"
          }, {
            children: [localize('ae_careplan_city'), "*"]
          }))
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12,
          sm: 4
        }, {
          children: jsx(TextField, {
            id: "city",
            color: "secondary",
            disabled: inputDisabled,
            placeholder: localize('ae_careplan_city'),
            size: "small",
            fullWidth: true,
            variant: "outlined",
            value: formik.values.city,
            onChange: formik.handleChange,
            onBlur: formik.handleBlur,
            error: formik.touched.city && Boolean(formik.errors.city),
            helperText: formik.touched.city && formik.errors.city
          })
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12,
          sm: 2
        }, {
          children: jsxs(StyledInputLabel, Object.assign({
            htmlFor: "province"
          }, {
            children: [localize('sidebar_region'), "*"]
          }))
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12,
          sm: 4
        }, {
          children: jsx(StyledSelect$1, Object.assign({
            id: "province",
            color: "secondary",
            disabled: inputDisabled,
            value: formik.values.province,
            defaultValue: regions[1].value,
            onChange: e => {
              handleSelectChange('province', e);
            },
            error: formik.touched.province && Boolean(formik.errors.province),
            fullWidth: true,
            variant: "outlined"
          }, {
            children: regions.map(option => {
              if (typeof (option === null || option === void 0 ? void 0 : option.label) === 'object') {
                return jsx(ListSubheader, {
                  children: localize(option.label.optGroup)
                }, localize(option.label.optGroup));
              } else if (typeof option.label === 'string') {
                return jsx(MenuItem$1, Object.assign({
                  value: option.value
                }, {
                  children: option.label
                }), option.value);
              } else return null;
            })
          }))
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12,
          sm: 2
        }, {
          children: jsxs(StyledInputLabel, Object.assign({
            htmlFor: "postal"
          }, {
            children: [localize('patientCreation.postalCode'), "*"]
          }))
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12,
          sm: 4
        }, {
          children: jsx(MaskedPostalInput, {
            id: "postal",
            color: "secondary",
            disabled: inputDisabled,
            placeholder: localize('patientCreation.postalCode'),
            size: "small",
            fullWidth: true,
            variant: "outlined",
            value: formik.values.postal,
            onChange: event => formik.setFieldValue('postal', event.target.value.toUpperCase()),
            onSelectChange: c => setPostalCodeCountry(c),
            onBlur: formik.handleBlur,
            error: formik.touched.postal && Boolean(formik.errors.postal),
            helperText: formik.touched.postal && formik.errors.postal,
            initialValue: formik.values.country
          })
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12,
          sm: 2
        }, {
          children: jsxs(StyledInputLabel, Object.assign({
            htmlFor: "phone"
          }, {
            children: [localize('patientCreation.phone1'), "*"]
          }))
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12,
          sm: 4
        }, {
          children: jsx(MaskedPhoneInput, {
            id: "phone",
            color: "secondary",
            disabled: inputDisabled,
            placeholder: localize('patientCreation.phone1'),
            size: "small",
            fullWidth: true,
            variant: "outlined",
            value: formik.values.phone,
            onChange: formik.handleChange,
            onBlur: formik.handleBlur,
            error: formik.touched.phone && Boolean(formik.errors.phone),
            helperText: formik.touched.phone && formik.errors.phone,
            initialValue: formik.values.country
          })
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12,
          sm: 2
        }, {
          children: jsx(StyledInputLabel, Object.assign({
            htmlFor: "phone2"
          }, {
            children: localize('patientCreation.phone2')
          }))
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12,
          sm: 4
        }, {
          children: jsx(MaskedPhoneInput, {
            id: "phone2",
            color: "secondary",
            disabled: inputDisabled,
            placeholder: localize('patientCreation.phone2'),
            size: "small",
            fullWidth: true,
            variant: "outlined",
            value: formik.values.phone2,
            onChange: formik.handleChange,
            onBlur: formik.handleBlur,
            error: formik.touched.phone2 && Boolean(formik.errors.phone2),
            helperText: formik.touched.phone2 && formik.errors.phone2,
            initialValue: formik.values.country
          })
        })), jsx("div", {
          style: {
            borderBottom: '1px solid #D5E8F0',
            width: '100%'
          }
        })]
      })), jsx(FormLabel, Object.assign({
        component: "h2"
      }, {
        children: localize('Notes')
      })), jsx(StyledTextareaAutosize$1, {
        id: "note",
        disabled: inputDisabled,
        "aria-label": localize('Notes'),
        minRows: 3,
        maxRows: 8,
        value: formik.values.note,
        onChange: event => {
          var _a;
          return formik.setFieldValue('note', (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value);
        }
      }), jsx(Grid, {
        style: styles$a.groupButton
      }), jsx(ErrorToast, {
        open: Boolean(orderErrMsg),
        message: orderErrMsg,
        handleClose: () => setOrderErrMsg('')
      })]
    }))
  }));
};

var classof$1 = classofRaw$2;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$2 = Array.isArray || function isArray(argument) {
  return classof$1(argument) === 'Array';
};

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

var doesNotExceedSafeInteger$1 = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};

var classofRaw = classofRaw$2;
var uncurryThis$4 = functionUncurryThis;

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis$4(fn);
};

var uncurryThis$3 = functionUncurryThisClause;
var aCallable = aCallable$4;
var NATIVE_BIND = functionBindNative;

var bind$1 = uncurryThis$3(uncurryThis$3.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind$1(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var isArray$1 = isArray$2;
var lengthOfArrayLike$1 = lengthOfArrayLike$4;
var doesNotExceedSafeInteger = doesNotExceedSafeInteger$1;
var bind = functionBindContext;

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray$1 = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind(mapper, thisArg) : false;
  var element, elementLen;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray$1(element)) {
        elementLen = lengthOfArrayLike$1(element);
        targetIndex = flattenIntoArray$1(target, original, element, elementLen, targetIndex, depth - 1) - 1;
      } else {
        doesNotExceedSafeInteger(targetIndex + 1);
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

var flattenIntoArray_1 = flattenIntoArray$1;

var uncurryThis$2 = functionUncurryThis;
var fails$1 = fails$m;
var isCallable = isCallable$i;
var classof = classof$4;
var getBuiltIn = getBuiltIn$4;
var inspectSource = inspectSource$2;

var noop = function () { /* empty */ };
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$1 = uncurryThis$2(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, [], argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec$1(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$1 = !construct || fails$1(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var isArray = isArray$2;
var isConstructor = isConstructor$1;
var isObject = isObject$a;
var wellKnownSymbol = wellKnownSymbol$d;

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor$1 = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};

var arraySpeciesConstructor = arraySpeciesConstructor$1;

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$1 = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

var $$2 = _export;
var flattenIntoArray = flattenIntoArray_1;
var toObject = toObject$6;
var lengthOfArrayLike = lengthOfArrayLike$4;
var toIntegerOrInfinity = toIntegerOrInfinity$5;
var arraySpeciesCreate = arraySpeciesCreate$1;

// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
$$2({ target: 'Array', proto: true }, {
  flat: function flat(/* depthArg = 1 */) {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject(this);
    var sourceLen = lengthOfArrayLike(O);
    var A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toIntegerOrInfinity(depthArg));
    return A;
  }
});

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = addToUnscopables$3;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flat');

var $$1 = _export;
var uncurryThis$1 = functionUncurryThisClause;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var toLength = toLength$3;
var toString$1 = toString$9;
var notARegExp = notARegexp;
var requireObjectCoercible = requireObjectCoercible$9;
var correctIsRegExpLogic = correctIsRegexpLogic;

var stringSlice = uncurryThis$1(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$$1({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString$1(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString$1(searchString);
    return stringSlice(that, index, index + search.length) === search;
  }
});

const formData = {
  gender: {
    male: 'gender.male',
    female: 'gender.female',
    other: 'gender.other'
  },
  country: {
    canada: 'country.canada',
    'united states': 'country.united states',
    'united kingdom': 'country.united kingdom'
  },
  regions: {
    CAC: {
      optGroup: 'regions.CAC'
    },
    AB: 'regions.AB',
    BC: 'regions.BC',
    MB: 'regions.MB',
    NB: 'regions.NB',
    NL: 'regions.NL',
    NS: 'regions.NS',
    NT: 'regions.NT',
    NU: 'regions.NU',
    ON: 'regions.ON',
    PE: 'regions.PE',
    QC: 'regions.QC',
    SK: 'regions.SK',
    YT: 'regions.YT',
    USC: {
      optGroup: 'regions.USC'
    },
    AL: 'regions.AL',
    AK: 'regions.AK',
    AZ: 'regions.AZ',
    AR: 'regions.AR',
    CA: 'regions.CA',
    CO: 'regions.CO',
    CT: 'regions.CT',
    DE: 'regions.DE',
    FL: 'regions.FL',
    GA: 'regions.GA',
    HI: 'regions.HI',
    ID: 'regions.ID',
    IL: 'regions.IL',
    IN: 'regions.IN',
    IA: 'regions.IA',
    KS: 'regions.KS',
    KY: 'regions.KY',
    LA: 'regions.LA',
    ME: 'regions.ME',
    MD: 'regions.MD',
    MA: 'regions.MA',
    MI: 'regions.MI',
    MN: 'regions.MN',
    MS: 'regions.MS',
    MO: 'regions.MO',
    MT: 'regions.MT',
    NE: 'regions.NE',
    NV: 'regions.NV',
    NH: 'regions.NH',
    NJ: 'regions.NJ',
    NM: 'regions.NM',
    NY: 'regions.NY',
    NC: 'regions.NC',
    ND: 'regions.ND',
    OH: 'regions.OH',
    OK: 'regions.OK',
    OR: 'regions.OR',
    PA: 'regions.PA',
    RI: 'regions.RI',
    SC: 'regions.SC',
    SD: 'regions.SD',
    TN: 'regions.TN',
    TX: 'regions.TX',
    UT: 'regions.UT',
    VT: 'regions.VT',
    VA: 'regions.VA',
    WA: 'regions.WA',
    WV: 'regions.WV',
    WI: 'regions.WI',
    WY: 'regions.WY',
    UKC: {
      optGroup: 'regions.UKC'
    },
    ENG: 'regions.ENG',
    NIR: 'regions.NIR',
    SCT: 'regions.SCT',
    WLS: 'regions.WLS'
  },
  languages: {
    en: 'languages.en',
    fr: 'languages.fr',
    cn_s: 'languages.cn_s',
    cn_t: 'languages.cn_t',
    es: 'languages.es',
    pt: 'languages.pt',
    ta: 'languages.ta'
  },
  types: {
    aTouchAway: 'types.aTouchAway',
    Mobile: 'types.Mobile',
    Simplified: 'types.Simplified'
  },
  timezones: {
    'America/Los_Angeles': 'timezones.America/Los_Angeles',
    'America/Denver': 'timezones.America/Denver',
    'America/Chicago': 'timezones.America/Chicago',
    'America/Toronto': 'timezones.America/Toronto',
    'America/New_York': 'timezones.America/New_York',
    'America/Halifax': 'timezones.America/Halifax',
    'Europe/London': 'timezones.Europe/London',
    'Atlantic/St_Helena': 'timezones.Atlantic/St_Helena'
  },
  measureUnits: {
    metric: 'patientCreation.measureUnitType.metric',
    imperial: 'patientCreation.measureUnitType.imperial'
  },
  glucometerUnits: {
    mmol: 'patientCreation.glucometerType.mmol',
    mg: 'patientCreation.glucometerType.mg'
  },
  weightUnits: {
    kg: 'patientCreation.weightUnitType.kg',
    lbs: 'patientCreation.weightUnitType.lbs'
  },
  temperatureUnits: {
    celsius: 'patientCreation.temperatureUnitType.celsius',
    fahrenheit: 'patientCreation.temperatureUnitType.fahrenheit'
  }
};
const validationSchema = (editing, postalCodeCountry, healthCardProvince, localize) => {
  return yup.object(Object.assign(Object.assign({
    fname: yup.string().required(localize('patientCreation.helperText.required')).max(50, localize('patientCreation.helperText.firstNameMax')),
    lname: yup.string().required(localize('patientCreation.helperText.required')).max(50, localize('patientCreation.helperText.lastNameMax')),
    gender: yup.string(),
    dob: yup.date().max(new Date(), "Date of Birth should be in past"),
    language: yup.string().required(localize('patientCreation.helperText.required')),
    user_type: yup.string().required(localize('patientCreation.helperText.required')),
    street: yup.string().max(30, localize('patientCreation.helperText.maxLength')),
    apartment: yup.string().max(30, localize('patientCreation.helperText.maxLength')),
    country: yup.string(),
    city: yup.string().max(25),
    province: yup.string(),
    postal: yup.string().when([], {
      is: () => postalCodeCountry === 'canada',
      then: yup.string().matches(/^[A-Z]\d[A-Z] \d[A-Z]\d$/, localize('patientCreation.helperText.postalCanada'))
    }).when([], {
      is: () => postalCodeCountry === 'united states',
      then: yup.string().matches(/^\d{5}(?:[-\s]\d{4})?$/, localize('patientCreation.helperText.postalUS'))
    }).when([], {
      is: () => postalCodeCountry === 'united kingdom',
      then: yup.string().matches(/^([G][I][R] 0[A]{2})|((([A-Z][0-9]{1,2})|(([A-Z][A-HJ-Y][0-9]{1,2})|(([A-Z][0-9][A-Z])|([A-Z][A-HJ-Y][0-9][A-Z]?))))\s?[0-9][A-Z]{2})$/,
      // Official UK Gov't Regex
      localize('patientCreation.helperText.postalUK'))
    }),
    email: yup.string().email(localize('patientCreation.helperText.email')).max(40, localize('patientCreation.helperText.emailMax')),
    phone: yup.string().matches(/^((\+44 |44)??\d{4}?[- ]?\d{5})|((\+1 |1)?[(]?\d{3}[)]?[- ]?\d{3}[- ]?\d{4})$/, localize('patientCreation.helperText.validPhone')),
    phone2: yup.string().matches(/^((\+44 |44)??\d{4}?[- ]?\d{5})|((\+1 |1)?[(]?\d{3}[)]?[- ]?\d{3}[- ]?\d{4})$/, localize('patientCreation.helperText.validPhone')),
    timezone: yup.string(),
    healthCardNumber: yup.string().when([], {
      is: () => healthCardProvince === 'AB',
      then: yup.string().matches(/^\d{5}-\d{4}$/, localize('patientCreation.helperText.healthCardAB'))
    }).when([], {
      is: () => healthCardProvince === 'BC',
      then: yup.string().matches(/^\d{4} \d{3} \d{3}$/, localize('patientCreation.helperText.healthCardBC'))
    }).when([], {
      is: () => healthCardProvince === 'MB',
      then: yup.string().matches(/^\d{6}$/, localize('patientCreation.helperText.healthCardMB'))
    }).when([], {
      is: () => healthCardProvince === 'NB',
      then: yup.string().matches(/^\d{3}-\d{3}-\d{3}$/, localize('patientCreation.helperText.healthCardNB'))
    }).when([], {
      is: () => healthCardProvince === 'NL',
      then: yup.string().matches(/^\d{3} \d{3} \d{3} \d{3}$/, localize('patientCreation.helperText.healthCardNL'))
    }).when([], {
      is: () => healthCardProvince === 'NS',
      then: yup.string().matches(/^\d{4} \d{3} \d{3}$/, localize('patientCreation.helperText.healthCardNS'))
    }).when([], {
      is: () => healthCardProvince === 'NT',
      then: yup.string().matches(/^[a-zA-Z]\d{7}$/, localize('patientCreation.helperText.healthCardNT'))
    }).when([], {
      is: () => healthCardProvince === 'NU',
      then: yup.string().matches(/^\d{9}$/, localize('patientCreation.helperText.healthCardNU'))
    }).when([], {
      is: () => healthCardProvince === 'ON',
      then: yup.string().matches(/^\d{4} \d{3} \d{3}$/, localize('patientCreation.helperText.healthCardON'))
    }).when([], {
      is: () => healthCardProvince === 'PE',
      then: yup.string().matches(/^\d{8}$/, localize('patientCreation.helperText.healthCardPE'))
    }).when([], {
      is: () => healthCardProvince === 'QC',
      then: yup.string().matches(/^[a-zA-Z]{4} \d{4} \d{4}$/, localize('patientCreation.helperText.healthCardQC'))
    }).when([], {
      is: () => healthCardProvince === 'SK',
      then: yup.string().matches(/^\d{3} \d{3} \d{3}$/, localize('patientCreation.helperText.healthCardSK'))
    }).when([], {
      is: () => healthCardProvince === 'YT',
      then: yup.string().matches(/^\d{3}-\d{3}-\d{3}$/, localize('patientCreation.helperText.healthCardYT'))
    }),
    healthCardVersion: yup.string().matches(/^[A-Z]{2}$|^$/, localize('patientCreation.helperText.healthCardVersionFormat')),
    patientNumber: yup.string(),
    manageGroup: yup.array(),
    measureUnits: yup.string(),
    glucometerUnits: yup.string(),
    weightUnits: yup.string(),
    temperatureUnits: yup.string()
  }, !editing && {
    managers: yup.array()
  }), {
    searchHidden: yup.boolean(),
    user_note: yup.string().max(30, 'Pinned note must be less than 30 characters')
  }));
};

const StyledFormHelperText = withStyles({
  error: {
    paddingLeft: '14px',
    paddingRight: '14px'
  }
})(FormHelperText);
const StyledTextareaAutosize = styled$1(TextareaAutosize)({
  width: '100%',
  border: '1px solid #88A4B0',
  borderRadius: '4px',
  fontFamily: 'Poppins',
  fontSize: '16px',
  fontWeight: 400,
  color: '#102543',
  resize: 'none',
  '&:disabled': {
    backgroundColor: '#00000033',
    borderRadius: '4px'
  },
  minHeight: '80px',
  rows: 3,
  cols: 40,
  wordWrap: 'break-word',
  whiteSpace: 'pre-line',
  marginTop: -10
});
const StyledSelect = withStyles({
  outlined: {
    padding: '10.5px 14px'
  }
})(Select$1);
function padZero(number) {
  if (number < 10) {
    return `0${number}`;
  } else {
    return number + '';
  }
}
const PatientCreation = props => {
  var _a, _b;
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  const {
    emr,
    searchPeople,
    createUser,
    updateUser,
    apiResponse,
    resetApiResponse
  } = usePatients();
  const {
    rawPatientGroupData
  } = usePatientGroup();
  const user = props === null || props === void 0 ? void 0 : props.user;
  const [dateChanged, setDateChanged] = useState(!!(user === null || user === void 0 ? void 0 : user.dob));
  const [searchUserModalOpen, setSearchUserModalOpen] = useState(false);
  const [searchManagersModalOpen, setSearchManagersModalOpen] = useState(false);
  const [selectedManagers, setSelectedManagers] = useState([]);
  const [showDuplicateMsg, setShowDuplicateMsg] = useState(false);
  const [submitDuplicate, setSubmitDuplicate] = useState(false);
  const [postalCodeCountry, setPostalCodeCountry] = useState((user === null || user === void 0 ? void 0 : user.country) || '');
  const [healthCardProvince, setHealthCardProvince] = useState();
  const defaultData = useMemo(() => {
    var _a;
    let timeZone = 'America/Toronto';
    if (user) {
      let date = user.dob || '';
      if (date.toString().includes('Z')) date = new Date(date.toString().replace('Z', ''));else if (date.toString().includes('-')) date = new Date(date.toString().replace(/-/g, '/'));else date = new Date(date);
      let user_type = 'aTouchAway';
      if (user.type.includes('user:mobile')) user_type = 'Mobile';else if ((_a = user === null || user === void 0 ? void 0 : user.type) === null || _a === void 0 ? void 0 : _a.includes('simplified')) user_type = 'Simplified';
      let displayedDate = '';
      if (date && date.toString() !== 'Invalid Date' && typeof date !== 'string') {
        displayedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())}`;
      }
      if (Object.keys(formData.timezones).includes(Intl.DateTimeFormat().resolvedOptions().timeZone) && !user.timezone) {
        timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      }
      let defaultNotes;
      if (user.user_notes) {
        defaultNotes = user.user_notes[0];
      }
      return Object.assign(Object.assign({}, user), {
        user_type,
        dob: displayedDate,
        timezone: user.timezone,
        defaultNotes
      });
    }
    if (Object.keys(formData.timezones).includes(Intl.DateTimeFormat().resolvedOptions().timeZone)) {
      timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    const data = {
      fname: '',
      lname: '',
      timezone: timeZone
    };
    return data;
  }, [user]);
  const defaultValues = {
    fname: (defaultData === null || defaultData === void 0 ? void 0 : defaultData.fname) || '',
    lname: (defaultData === null || defaultData === void 0 ? void 0 : defaultData.lname) || '',
    gender: (defaultData === null || defaultData === void 0 ? void 0 : defaultData.gender) || '',
    dob: (defaultData === null || defaultData === void 0 ? void 0 : defaultData.dob) || '',
    language: (defaultData === null || defaultData === void 0 ? void 0 : defaultData.language) || 'en',
    user_type: (defaultData === null || defaultData === void 0 ? void 0 : defaultData.user_type) || 'aTouchAway',
    street: (defaultData === null || defaultData === void 0 ? void 0 : defaultData.street) || '',
    apartment: (defaultData === null || defaultData === void 0 ? void 0 : defaultData.apartment) || '',
    country: (defaultData === null || defaultData === void 0 ? void 0 : defaultData.country) || '',
    city: (defaultData === null || defaultData === void 0 ? void 0 : defaultData.city) || '',
    province: (defaultData === null || defaultData === void 0 ? void 0 : defaultData.province) || '',
    postal: (defaultData === null || defaultData === void 0 ? void 0 : defaultData.postal) || '',
    email: (defaultData === null || defaultData === void 0 ? void 0 : defaultData.email) || '',
    phone: (defaultData === null || defaultData === void 0 ? void 0 : defaultData.phone) || '',
    phone2: (defaultData === null || defaultData === void 0 ? void 0 : defaultData.phone2) || '',
    timezone: (defaultData === null || defaultData === void 0 ? void 0 : defaultData.timezone) || 'America/Toronto',
    healthCardVersion: (defaultData === null || defaultData === void 0 ? void 0 : defaultData.healthCardVersion) || '',
    healthCardNumber: (defaultData === null || defaultData === void 0 ? void 0 : defaultData.healthCardNumber) || '',
    patientNumber: (defaultData === null || defaultData === void 0 ? void 0 : defaultData.patientNumber) || '',
    measureUnits: defaultData === null || defaultData === void 0 ? void 0 : defaultData.measureUnits,
    glucometerUnits: defaultData === null || defaultData === void 0 ? void 0 : defaultData.glucometerUnits,
    weightUnits: defaultData === null || defaultData === void 0 ? void 0 : defaultData.weightUnits,
    temperatureUnits: defaultData === null || defaultData === void 0 ? void 0 : defaultData.temperatureUnits,
    manageGroup: (defaultData === null || defaultData === void 0 ? void 0 : defaultData.manage_group) ? [defaultData === null || defaultData === void 0 ? void 0 : defaultData.manage_group].flat() : [],
    searchHidden: user ? defaultData === null || defaultData === void 0 ? void 0 : defaultData.searchHidden : true,
    user_note: (defaultData === null || defaultData === void 0 ? void 0 : defaultData.user_notes) && ((_a = defaultData === null || defaultData === void 0 ? void 0 : defaultData.user_notes) === null || _a === void 0 ? void 0 : _a.length) > 0 ? defaultData === null || defaultData === void 0 ? void 0 : defaultData.user_notes[0].comment : ''
  };
  if (!user) defaultValues.managers = [];
  const formik = useFormik({
    initialValues: defaultValues,
    validateOnChange: true,
    validationSchema: validationSchema(!!user, postalCodeCountry, healthCardProvince, localize),
    onSubmit: values => __awaiter(void 0, void 0, void 0, function* () {
      if (!user) {
        if (submitDuplicate) {
          const {
              patientNumber: createPatientNumber
            } = values,
            rest = __rest(values, ["patientNumber"]);
          createUser(rest, createPatientNumber);
        } else yield createUser(values);
      } else {
        if (submitDuplicate) {
          const newValues = Object.assign({
            duplicateNumber: true
          }, values);
          updateUser(user._id, newValues);
        } else yield updateUser(user._id, values);
      }
    })
  });
  useEffect(() => {
    if (apiResponse.status.toString().startsWith('2')) {
      setShowDuplicateMsg(false);
      props && (props === null || props === void 0 ? void 0 : props.onClose) && props.onClose();
    }
    if (apiResponse.message === localize('users_exists_err_msg')) {
      setShowDuplicateMsg(true);
    }
    if (apiResponse.message === localize('patient_number_exists_err_msg')) {
      setShowDuplicateMsg(true);
    }
  }, [apiResponse, localize, props]);
  useEffect(() => {
    if (formik.values.province) setHealthCardProvince(formik.values.province);
  }, [formik.values.province]);
  const handleSelectChange = name => {
    return event => {
      formik.setFieldValue(name, event.target.value);
    };
  };
  const handleProceed = () => {
    resetApiResponse();
    setShowDuplicateMsg(false);
    setSubmitDuplicate(true);
    userMetrics.trackEvent('patients: clicked proceed creating duplicate patient');
    formik.handleSubmit();
  };
  const handleDateChange = event => {
    const value = event.target.value;
    formik.setFieldValue('dob', value);
    if (event.target.value === '' && dateChanged) {
      setDateChanged(false);
    } else if (!dateChanged) {
      setDateChanged(true);
    }
  };
  const dateToday = new Date().toISOString().split('T')[0];
  const DuplicateDialog = () => {
    return jsx(ActionDialog, Object.assign({
      title: localize('users_exists'),
      reactKey: "duplicateModal",
      onClose: () => setShowDuplicateMsg(false),
      open: showDuplicateMsg,
      actions: [jsx(Button, Object.assign({
        onClick: handleProceed
      }, {
        children: localize('users_exists_proceed')
      }), "proceed"), jsx(Button, Object.assign({
        onClick: () => {
          userMetrics.trackEvent('patients: clicked cancel duplicate patient');
          resetApiResponse();
          setShowDuplicateMsg(false);
        }
      }, {
        children: localize('users_cancel')
      }), "close")]
    }, {
      children: apiResponse.message === localize('patient_number_exists_err_msg') ? jsxs("div", {
        children: [localize('user_edit_exists_message'), " ", localize('users_exists_message2'), " ", jsx("em", {
          children: localize('users_cancel')
        }), " ", localize('users_exists_message3'), " ", jsx("em", {
          children: localize('users_exists_proceed')
        })]
      }) : jsxs("div", {
        children: [localize('users_exists_message1'), " ", localize('users_exists_message2'), " ", jsx("em", {
          children: localize('users_cancel')
        }), " ", localize('users_exists_message3'), " ", jsx("em", {
          children: localize('users_exists_proceed')
        })]
      })
    }));
  };
  const SearchUserModal = () => {
    const [searchResults, setSearchResults] = useState([]);
    return jsxs(ActionDialog, Object.assign({
      title: localize('search_displayname'),
      reactKey: "userModal",
      actions: [jsx(Button, Object.assign({
        onClick: () => {
          userMetrics.trackEvent('patients: open search user modal');
          setSearchUserModalOpen(false);
        }
      }, {
        children: localize('search_close')
      }), "close")],
      open: searchUserModalOpen,
      onClose: () => setSearchUserModalOpen(false)
    }, {
      children: [jsx(SearchBar, {
        width: "250px",
        placeholder: "",
        id: "search-managers",
        testId: "search-managers",
        theme: DashboardsTheme,
        onChange: event => __awaiter(void 0, void 0, void 0, function* () {
          const result = yield emr(event.target.value);
          setSearchResults(result);
        })
      }), (searchResults === null || searchResults === void 0 ? void 0 : searchResults.length) >= 1 && (searchResults === null || searchResults === void 0 ? void 0 : searchResults.map(user => {
        return jsx("div", Object.assign({
          onClick: () => {
            userMetrics.trackEvent('patients: select user from search modal');
            formik.setFieldValue('fname', user.fname);
            formik.setFieldValue('lname', user.lname);
            formik.setFieldValue('patientNumber', user.patientNumber);
            setSearchUserModalOpen(false);
          }
        }, {
          children: jsx(ListItem, {
            children: jsx(ListItemText, {
              primary: `${user.fname} ${user.lname} `
            })
          })
        }), user.patientNumber);
      }))]
    }));
  };
  const SearchManagersModalOpen = () => {
    const [searchResults, setSearchResults] = useState([]);
    return jsxs(ActionDialog, Object.assign({
      title: localize('search_displayname'),
      onClose: () => setSearchManagersModalOpen(false),
      actions: [jsx(Button, Object.assign({
        onClick: () => {
          userMetrics.trackEvent('patients: open search manager modal');
          setSearchManagersModalOpen(false);
        }
      }, {
        children: localize('search_close')
      }), "close")],
      open: searchManagersModalOpen
    }, {
      children: [jsx(SearchBar, {
        id: "search-default-managers",
        testId: "search-default-managers",
        width: "250px",
        placeholder: "",
        theme: DashboardsTheme,
        onChange: event => {
          var _a;
          searchPeople((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value).then(setSearchResults);
        }
      }), (searchResults === null || searchResults === void 0 ? void 0 : searchResults.length) >= 1 && (searchResults === null || searchResults === void 0 ? void 0 : searchResults.map(user => {
        if (formik.values.managers) {
          const managers = formik.values.managers;
          const isAdded = managers.map(m => m._id).includes(user._id);
          return jsx(ListItem, Object.assign({
            onClick: () => {
              userMetrics.trackEvent('patients: select manager from search modal', {
                manager: user._id
              });
              if (!isAdded) {
                let managers;
                if (formik.values.managers) managers = [...formik.values.managers, user._id];else managers = [user._id];
                formik.setFieldValue('managers', managers);
                setSelectedManagers([...selectedManagers, user]);
              }
            },
            disabled: isAdded
          }, {
            children: jsx(ListItemText, {
              primary: `${user.fname} ${user.lname} `
            })
          }), user._id);
        }
        return null;
      }))]
    }), "ManagerModal");
  };
  return jsx(ThemeProvider, Object.assign({
    theme: DashboardsTheme
  }, {
    children: jsxs("form", Object.assign({
      ref: props === null || props === void 0 ? void 0 : props.submitRef,
      onSubmit: formik.handleSubmit
    }, {
      children: [jsx(SearchUserModal, {}), jsx(SearchManagersModalOpen, {}), jsx(DuplicateDialog, {}), jsxs(Grid$1, Object.assign({
        container: true,
        direction: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        spacing: 2,
        style: {
          marginTop: 5
        }
      }, {
        children: [jsxs(Grid$1, Object.assign({
          item: true,
          container: true,
          direction: "row",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          xs: 12,
          spacing: 4,
          style: {
            paddingLeft: 20,
            paddingBottom: 20
          }
        }, {
          children: [jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: !user ? 6 : 12
          }, {
            children: jsx(FormLabel, Object.assign({
              component: "h3"
            }, {
              children: localize('patientCreation.personalinfo')
            }))
          })), !user && jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 6
          }, {
            children: jsxs("div", Object.assign({
              style: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-end'
              }
            }, {
              children: [jsx(FormLabel, Object.assign({
                component: "body",
                style: {
                  fontWeight: 400
                }
              }, {
                children: localize('search_exist_user')
              })), jsx(IconButton$1, {
                id: "edit-user-search",
                color: "primary",
                className: "fa fa-edit",
                "aria-label": "edit-user-search",
                onClick: () => {
                  userMetrics.trackEvent('patients: open search user modal');
                  setSearchUserModalOpen(true);
                }
              }), ' ']
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 2
          }, {
            children: jsx(InputLabel, Object.assign({
              htmlFor: "fname"
            }, {
              children: localize('users_fname')
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 4
          }, {
            children: jsx(TextField$1, {
              id: "fname",
              color: "secondary",
              placeholder: localize('users_fname'),
              size: "small",
              fullWidth: true,
              variant: "outlined",
              value: formik.values.fname,
              onChange: formik.handleChange('fname'),
              onBlur: formik.handleBlur,
              error: formik.touched.fname && Boolean(formik.errors.fname),
              helperText: formik.touched.fname && formik.errors.fname
            })
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 2
          }, {
            children: jsx(InputLabel, Object.assign({
              htmlFor: "lname"
            }, {
              children: localize('users_lname')
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 4
          }, {
            children: jsx(TextField$1, {
              id: "lname",
              color: "secondary",
              placeholder: localize('users_lname'),
              size: "small",
              fullWidth: true,
              variant: "outlined",
              value: formik.values.lname,
              onChange: formik.handleChange('lname'),
              onBlur: formik.handleBlur,
              error: formik.touched.lname && Boolean(formik.errors.lname),
              helperText: formik.touched.lname && formik.errors.lname
            })
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 2
          }, {
            children: jsx(InputLabel, Object.assign({
              htmlFor: "gender"
            }, {
              children: localize('ae_careplan_gender')
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 4
          }, {
            children: jsx(StyledSelect, Object.assign({
              displayEmpty: true,
              id: "gender",
              inputProps: {
                'aria-label': localize('ae_careplan_gender')
              },
              color: "secondary",
              renderValue: value => value ? localize(`gender.${value}`) : jsx("div", Object.assign({
                style: {
                  color: 'rgba(0, 96, 100, 0.4)'
                }
              }, {
                children: localize('patientCreation.selectGender')
              })),
              value: formik.values.gender,
              onChange: handleSelectChange('gender'),
              error: formik.touched.gender && Boolean(formik.errors.gender),
              fullWidth: true,
              variant: "outlined"
            }, {
              children: Object.keys(formData.gender).map(key => {
                return jsx(MenuItem$1, Object.assign({
                  value: key
                }, {
                  children: localize(formData.gender[key])
                }), key);
              })
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 2
          }, {
            children: jsx(InputLabel, Object.assign({
              htmlFor: "dob"
            }, {
              children: localize('ae_careplan_dob')
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 4
          }, {
            children: jsx(TextField$1, {
              id: "dob",
              color: "secondary",
              type: "date",
              InputLabelProps: {
                shrink: true
              },
              size: "small",
              fullWidth: true,
              variant: "outlined",
              value: formik.values.dob,
              defaultValue: formik.values.dob,
              onChange: handleDateChange,
              onBlur: formik.handleBlur,
              inputProps: {
                max: dateToday
              },
              error: formik.touched.dob && Boolean(formik.errors.dob),
              helperText: formik.touched.dob && formik.errors.dob,
              InputProps: {
                style: !dateChanged ? {
                  color: 'rgba(0, 96, 100, 0.4)'
                } : {}
              }
            })
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 2
          }, {
            children: jsx(InputLabel, Object.assign({
              htmlFor: "language"
            }, {
              children: localize('ae_careplan_language')
            }))
          })), jsxs(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 4
          }, {
            children: [jsx(StyledSelect, Object.assign({
              displayEmpty: true,
              id: "language",
              inputProps: {
                'aria-label': localize('ae_careplan_language')
              },
              color: "secondary",
              renderValue: value => value ? localize(`languages.${value}`) : jsx("div", Object.assign({
                style: {
                  color: 'rgba(0, 96, 100, 0.4)'
                }
              }, {
                children: localize('ae_careplan_language')
              })),
              value: formik.values.language,
              onChange: handleSelectChange('language'),
              error: formik.touched.language && Boolean(formik.errors.language),
              fullWidth: true,
              variant: "outlined"
            }, {
              children: Object.keys(formData.languages).map(key => {
                return jsx(MenuItem$1, Object.assign({
                  value: key
                }, {
                  children: localize(formData.languages[key])
                }), key);
              })
            })), !!formik.touched.language && !!formik.errors.language && jsx(StyledFormHelperText, Object.assign({
              error: true
            }, {
              children: formik.errors.language
            }))]
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 2
          }, {
            children: jsx(InputLabel, Object.assign({
              htmlFor: "user_type"
            }, {
              children: localize('user_type_select')
            }))
          })), jsxs(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 4
          }, {
            children: [jsx(StyledSelect, Object.assign({
              displayEmpty: true,
              id: "user_type",
              inputProps: {
                'aria-label': localize('user_type_select')
              },
              color: "secondary",
              renderValue: value => value ? localize(`types.${value}`) : jsx("div", Object.assign({
                style: {
                  color: 'rgba(0, 96, 100, 0.4)'
                }
              }, {
                children: localize('user_type_select')
              })),
              value: formik.values.user_type,
              onChange: handleSelectChange('user_type'),
              error: formik.touched.user_type && Boolean(formik.errors.user_type),
              fullWidth: true,
              variant: "outlined"
            }, {
              children: Object.keys(formData.types).map(key => {
                return jsx(MenuItem$1, Object.assign({
                  value: key
                }, {
                  children: localize(formData.types[key])
                }), key);
              })
            })), !!formik.touched.user_type && !!formik.errors.user_type && jsx(StyledFormHelperText, Object.assign({
              error: true
            }, {
              children: formik.errors.user_type
            }))]
          }))]
        })), jsx(Divider$1, {
          light: true,
          variant: "middle"
        }), jsxs(Grid$1, Object.assign({
          item: true,
          container: true,
          direction: "row",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          xs: 12,
          spacing: 4,
          style: {
            paddingLeft: 20,
            paddingBottom: 20
          }
        }, {
          children: [jsx(Grid$1, Object.assign({
            item: true,
            xs: 12
          }, {
            children: jsx(FormLabel, Object.assign({
              component: "h3"
            }, {
              children: localize('patientCreation.addressInfo')
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 2
          }, {
            children: jsx(InputLabel, Object.assign({
              htmlFor: "street"
            }, {
              children: localize('patientCreation.address1')
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 4
          }, {
            children: jsx(TextField$1, {
              id: "street",
              color: "secondary",
              placeholder: localize('patientCreation.address1'),
              size: "small",
              fullWidth: true,
              variant: "outlined",
              value: formik.values.street,
              onChange: formik.handleChange('street'),
              onBlur: formik.handleBlur,
              error: formik.touched.street && Boolean(formik.errors.street),
              helperText: formik.touched.street && formik.errors.street
            })
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 2
          }, {
            children: jsx(InputLabel, Object.assign({
              htmlFor: "apartment"
            }, {
              children: localize('patientCreation.address2')
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 4
          }, {
            children: jsx(TextField$1, {
              id: "apartment",
              color: "secondary",
              placeholder: localize('patientCreation.address2'),
              size: "small",
              onChange: formik.handleChange('apartment'),
              onBlur: formik.handleBlur,
              fullWidth: true,
              variant: "outlined",
              value: formik.values.apartment,
              error: formik.touched.apartment && Boolean(formik.errors.apartment),
              helperText: formik.touched.apartment && formik.errors.apartment
            })
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 2
          }, {
            children: jsx(InputLabel, Object.assign({
              htmlFor: "country"
            }, {
              children: localize('patientCreation.country')
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 4
          }, {
            children: jsx(StyledSelect, Object.assign({
              displayEmpty: true,
              id: "country",
              inputProps: {
                'aria-label': localize('patientCreation.country')
              },
              color: "secondary",
              renderValue: value => value ? localize(`country.${value}`) : jsx("div", Object.assign({
                style: {
                  color: 'rgba(0, 96, 100, 0.4)'
                }
              }, {
                children: localize('patientCreation.country')
              })),
              value: formik.values.country,
              onChange: event => {
                const newCountry = event.target.value;
                setPostalCodeCountry(newCountry);
                formik.setFieldValue('country', newCountry);
              },
              error: formik.touched.country && Boolean(formik.errors.country),
              fullWidth: true,
              variant: "outlined"
            }, {
              children: Object.keys(formData.country).map(key => {
                return jsx(MenuItem$1, Object.assign({
                  value: key
                }, {
                  children: localize(formData.country[key])
                }), key);
              })
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 2
          }, {
            children: jsx(InputLabel, Object.assign({
              htmlFor: "city"
            }, {
              children: localize('ae_careplan_city')
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 4
          }, {
            children: jsx(TextField$1, {
              id: "city",
              color: "secondary",
              placeholder: localize('ae_careplan_city'),
              size: "small",
              fullWidth: true,
              variant: "outlined",
              value: formik.values.city,
              onChange: formik.handleChange('city'),
              onBlur: formik.handleBlur,
              error: formik.touched.city && Boolean(formik.errors.city),
              helperText: formik.touched.city && formik.errors.city
            })
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 2
          }, {
            children: jsx(InputLabel, Object.assign({
              htmlFor: "province"
            }, {
              children: localize('sidebar_region')
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 4
          }, {
            children: jsx(StyledSelect, Object.assign({
              displayEmpty: true,
              id: "province",
              inputProps: {
                'aria-label': localize('patientCreation.selectRegion')
              },
              color: "secondary",
              renderValue: value => value ? localize(`regions.${value}`) : jsx("div", Object.assign({
                style: {
                  color: 'rgba(0, 96, 100, 0.4)'
                }
              }, {
                children: localize('patientCreation.selectRegion')
              })),
              value: formik.values.province,
              onChange: event => {
                const newProvince = event.target.value;
                setHealthCardProvince(newProvince);
                formik.setFieldValue('province', newProvince);
              },
              error: formik.touched.province && Boolean(formik.errors.province),
              fullWidth: true,
              variant: "outlined"
            }, {
              children: Object.keys(formData.regions).map(key => {
                const region = formData.regions[key];
                if (typeof region === 'object') {
                  return jsx(ListSubheader, {
                    children: localize(region.optGroup)
                  }, localize(region.optGroup));
                } else if (typeof region === 'string') {
                  return jsx(MenuItem$1, Object.assign({
                    value: key
                  }, {
                    children: localize(region)
                  }), key);
                }
                return null;
              })
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 2
          }, {
            children: jsx(InputLabel, Object.assign({
              htmlFor: "postal"
            }, {
              children: localize('patientCreation.postalCode')
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 4,
            alignItems: "flex-start"
          }, {
            children: jsx(MaskedPostalInput, {
              id: "postal",
              color: "secondary",
              placeholder: localize('patientCreation.postalCode'),
              size: "small",
              fullWidth: true,
              variant: "outlined",
              value: formik.values.postal,
              onChange: event => formik.setFieldValue('postal', event.target.value.toUpperCase()),
              onSelectChange: c => setPostalCodeCountry(c),
              onBlur: formik.handleBlur,
              error: formik.touched.postal && Boolean(formik.errors.postal),
              helperText: formik.touched.postal && formik.errors.postal,
              initialValue: formik.values.country
            })
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 2
          }, {
            children: jsx(InputLabel, Object.assign({
              htmlFor: "email"
            }, {
              children: localize('login_email')
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 4
          }, {
            children: jsx(TextField$1, {
              id: "email",
              color: "secondary",
              disabled: !!(user === null || user === void 0 ? void 0 : user.type.includes('user:mobile')),
              placeholder: localize('login_email'),
              size: "small",
              fullWidth: true,
              variant: "outlined",
              value: formik.values.email,
              onChange: formik.handleChange('email'),
              onBlur: formik.handleBlur,
              error: formik.touched.email && Boolean(formik.errors.email),
              helperText: formik.touched.email && formik.errors.email
            })
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 2
          }, {
            children: jsx(InputLabel, Object.assign({
              htmlFor: "phone"
            }, {
              children: localize('patientCreation.phone1')
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 4
          }, {
            children: jsx(MaskedPhoneInput, {
              id: "phone",
              color: "secondary",
              placeholder: localize('patientCreation.phone1'),
              size: "small",
              fullWidth: true,
              variant: "outlined",
              value: formik.values.phone,
              onChange: formik.handleChange('phone'),
              onBlur: formik.handleBlur,
              error: formik.touched.phone && Boolean(formik.errors.phone),
              helperText: formik.touched.phone && formik.errors.phone,
              initialValue: formik.values.country
            })
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 2
          }, {
            children: jsx(InputLabel, Object.assign({
              htmlFor: "phone2"
            }, {
              children: localize('patientCreation.phone2')
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 4
          }, {
            children: jsx(MaskedPhoneInput, {
              id: "phone2",
              color: "secondary",
              placeholder: localize('patientCreation.phone2'),
              size: "small",
              fullWidth: true,
              variant: "outlined",
              value: formik.values.phone2,
              onChange: formik.handleChange('phone2'),
              onBlur: formik.handleBlur,
              error: formik.touched.phone2 && Boolean(formik.errors.phone2),
              helperText: formik.touched.phone2 && formik.errors.phone2,
              initialValue: formik.values.country
            })
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 2
          }, {
            children: jsx(InputLabel, Object.assign({
              htmlFor: "timezone"
            }, {
              children: localize('patientCreation.timezone')
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 4
          }, {
            children: jsx(StyledSelect, Object.assign({
              displayEmpty: true,
              id: "timezone",
              inputProps: {
                'aria-label': localize('patientCreation.timezone')
              },
              color: "secondary",
              renderValue: value => value ? localize(`timezones.${value}`) : jsx("div", Object.assign({
                style: {
                  color: 'rgba(0, 96, 100, 0.4)'
                }
              }, {
                children: localize('patientCreation.selectTimezone')
              })),
              value: formik.values.timezone,
              onChange: handleSelectChange('timezone'),
              error: formik.touched.timezone && Boolean(formik.errors.timezone),
              fullWidth: true,
              variant: "outlined"
            }, {
              children: Object.keys(formData.timezones).map(key => {
                return jsx(MenuItem$1, Object.assign({
                  value: key
                }, {
                  children: localize(formData.timezones[key])
                }), key);
              })
            }))
          }))]
        })), jsx(Divider$1, {
          light: true,
          variant: "middle"
        }), jsxs(Grid$1, Object.assign({
          item: true,
          container: true,
          direction: "row",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          xs: 12,
          spacing: 4,
          style: {
            paddingLeft: 20,
            paddingBottom: 20
          }
        }, {
          children: [jsx(Grid$1, Object.assign({
            item: true,
            xs: 12
          }, {
            children: jsx(FormLabel, Object.assign({
              component: "h3"
            }, {
              children: localize('patientCreation.healthInfo')
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 2
          }, {
            children: jsx(InputLabel, Object.assign({
              htmlFor: "healthCardNumber"
            }, {
              children: localize('ae_careplan_card_number')
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 4
          }, {
            children: jsx(MaskedHealthCardInput, {
              id: "healthCardNumber",
              color: "secondary",
              placeholder: localize('ae_careplan_card_number'),
              size: "small",
              fullWidth: true,
              variant: "outlined",
              value: formik.values.healthCardNumber,
              onChange: event => formik.setFieldValue('healthCardNumber', event.target.value.toUpperCase()),
              onSelectChange: c => setHealthCardProvince(c),
              onBlur: formik.handleBlur,
              error: formik.touched.healthCardNumber && Boolean(formik.errors.healthCardNumber),
              helperText: formik.touched.healthCardNumber && formik.errors.healthCardNumber,
              initialValue: formik.values.province
            })
          })), healthCardProvince === 'ON' ? jsxs(Fragment, {
            children: [jsx(Grid$1, Object.assign({
              item: true,
              xs: 12,
              sm: 2
            }, {
              children: jsx(InputLabel, Object.assign({
                htmlFor: "healthCardVersion"
              }, {
                children: localize('ae_careplan_card_version')
              }))
            })), jsx(Grid$1, Object.assign({
              item: true,
              xs: 12,
              sm: 4
            }, {
              children: jsx(MaskedInput, {
                id: "healthCardVersion",
                color: "secondary",
                placeholder: localize('ae_careplan_card_version'),
                size: "small",
                fullWidth: true,
                variant: "outlined",
                value: formik.values.healthCardVersion,
                onChange: event => formik.setFieldValue('healthCardVersion', event.target.value.toUpperCase()),
                onBlur: formik.handleBlur,
                error: formik.touched.healthCardVersion && Boolean(formik.errors.healthCardVersion),
                helperText: formik.touched.healthCardVersion && formik.errors.healthCardVersion,
                mask: "aa"
              })
            }))]
          }) : null, jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 2
          }, {
            children: jsx(InputLabel, Object.assign({
              htmlFor: "patientNumber"
            }, {
              children: localize('patientCreation.patientNumber')
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 4
          }, {
            children: jsx(TextField$1, {
              id: "patientNumber",
              color: "secondary",
              placeholder: localize('patientCreation.patientNumber'),
              size: "small",
              fullWidth: true,
              variant: "outlined",
              value: formik.values.patientNumber,
              onChange: formik.handleChange('patientNumber'),
              onBlur: formik.handleBlur,
              error: formik.touched.patientNumber && Boolean(formik.errors.patientNumber),
              helperText: formik.touched.patientNumber && formik.errors.patientNumber
            })
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 2
          }, {
            children: jsx(InputLabel, Object.assign({
              htmlFor: "managergroups_usergroup"
            }, {
              children: localize('managergroups_usergroup')
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 4
          }, {
            children: jsx(TextMultiSelect, {
              id: "manageGroup",
              "aria-label": localize('managergroups_usergroup'),
              placeholder: localize('patientCreation.selectGroup'),
              outline: true,
              value: ((_b = formik.values.manageGroup) === null || _b === void 0 ? void 0 : _b.filter(group => {
                return rawPatientGroupData.find(rawGroup => rawGroup._id === group);
              })) || [],
              options: rawPatientGroupData.map(group => {
                return {
                  value: group._id,
                  text: group.name
                };
              }),
              fullWidth: true,
              onChange: handleSelectChange('manageGroup')
            })
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 2
          }, {
            children: jsx(InputLabel, Object.assign({
              htmlFor: "glucometerUnits"
            }, {
              children: localize('patientCreation.glucometerUnits')
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 4
          }, {
            children: jsx(StyledSelect, Object.assign({
              displayEmpty: true,
              id: "glucometerUnits",
              inputProps: {
                'aria-label': localize('patientCreation.glucometerUnits')
              },
              color: "secondary",
              renderValue: value => value ? localize(`patientCreation.glucometerType.${value}`) : jsx("div", Object.assign({
                style: {
                  color: 'rgba(0, 96, 100, 0.4)'
                }
              }, {
                children: localize('patientCreation.glucometerUnits')
              })),
              value: formik.values.glucometerUnits,
              onChange: handleSelectChange('glucometerUnits'),
              error: formik.touched.glucometerUnits && Boolean(formik.errors.glucometerUnits),
              fullWidth: true,
              variant: "outlined"
            }, {
              children: Object.keys(formData.glucometerUnits).map(key => {
                return jsx(MenuItem$1, Object.assign({
                  value: key
                }, {
                  children: localize(formData.glucometerUnits[key])
                }), key);
              })
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 2
          }, {
            children: jsx(InputLabel, Object.assign({
              htmlFor: "weightUnits"
            }, {
              children: localize('patientCreation.weightUnits')
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 4
          }, {
            children: jsx(StyledSelect, Object.assign({
              displayEmpty: true,
              id: "weightUnits",
              inputProps: {
                'aria-label': localize('patientCreation.weightUnits')
              },
              color: "secondary",
              renderValue: value => value ? localize(`patientCreation.weightUnitType.${value}`) : jsx("div", Object.assign({
                style: {
                  color: 'rgba(0, 96, 100, 0.4)'
                }
              }, {
                children: localize('patientCreation.weightUnits')
              })),
              value: formik.values.weightUnits,
              onChange: handleSelectChange('weightUnits'),
              error: formik.touched.weightUnits && Boolean(formik.errors.weightUnits),
              fullWidth: true,
              variant: "outlined"
            }, {
              children: Object.keys(formData.weightUnits).map(key => {
                return jsx(MenuItem$1, Object.assign({
                  value: key
                }, {
                  children: localize(formData.weightUnits[key])
                }), key);
              })
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 2
          }, {
            children: jsx(InputLabel, Object.assign({
              htmlFor: "temperatureUnits"
            }, {
              children: localize('patientCreation.temperatureUnits')
            }))
          })), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12,
            sm: 4
          }, {
            children: jsx(StyledSelect, Object.assign({
              displayEmpty: true,
              id: "temperatureUnits",
              inputProps: {
                'aria-label': localize('patientCreation.temperatureUnits')
              },
              color: "secondary",
              renderValue: value => value ? localize(`patientCreation.temperatureUnitType.${value}`) : jsx("div", Object.assign({
                style: {
                  color: 'rgba(0, 96, 100, 0.4)'
                }
              }, {
                children: localize('patientCreation.temperatureUnits')
              })),
              value: formik.values.temperatureUnits,
              onChange: handleSelectChange('temperatureUnits'),
              error: formik.touched.temperatureUnits && Boolean(formik.errors.temperatureUnits),
              fullWidth: true,
              variant: "outlined"
            }, {
              children: Object.keys(formData.temperatureUnits).map(key => {
                return jsx(MenuItem$1, Object.assign({
                  value: key
                }, {
                  children: localize(formData.temperatureUnits[key])
                }), key);
              })
            }))
          })), user && jsxs(Fragment, {
            children: [jsx(Grid$1, Object.assign({
              item: true,
              xs: 12,
              sm: 2
            }, {
              children: jsx(InputLabel, Object.assign({
                htmlFor: "searchHidden"
              }, {
                children: localize('private_title')
              }))
            })), jsx(Grid$1, Object.assign({
              item: true,
              xs: 12,
              sm: 4
            }, {
              children: jsx(StyledSelect, Object.assign({
                displayEmpty: true,
                id: "searchHidden",
                inputProps: {
                  'aria-label': localize('private_title')
                },
                color: "secondary",
                value: formik.values.searchHidden,
                renderValue: value => {
                  return value === true ? localize('private_hidden') : localize('private_visible');
                },
                onChange: handleSelectChange('searchHidden'),
                error: formik.touched.timezone && Boolean(formik.errors.searchHidden),
                fullWidth: true,
                variant: "outlined"
              }, {
                children: [{
                  label: 'private_hidden',
                  value: true
                }, {
                  label: 'private_visible',
                  value: false
                }].map(item => {
                  return jsx(MenuItem$1, Object.assign({
                    value: item.value
                  }, {
                    children: localize(item.label)
                  }), localize(item.label));
                })
              }))
            }))]
          }), jsx(Grid$1, Object.assign({
            item: true,
            xs: 12
          }, {
            children: jsx(FormLabel, Object.assign({
              component: "h2"
            }, {
              children: localize('pinned_note')
            }))
          })), jsxs(Grid$1, Object.assign({
            item: true,
            style: {
              paddingTop: '5px'
            },
            xs: 12
          }, {
            children: [jsx(StyledTextareaAutosize, {
              id: "user_note",
              "aria-label": localize('pinned_note'),
              minRows: 1,
              maxRows: 2,
              defaultValue: formik.values.user_note,
              onBlur: formik.handleBlur('user_note'),
              onChange: formik.handleChange('user_note')
            }), formik.touched.user_note && formik.errors.user_note && jsx("span", Object.assign({
              style: {
                color: 'red'
              }
            }, {
              children: formik.errors.user_note
            }))]
          })), !user && jsxs(Fragment, {
            children: [jsx(Grid$1, Object.assign({
              item: true,
              xs: 12,
              sm: 12
            }, {
              children: jsxs("div", Object.assign({
                style: {
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center'
                }
              }, {
                children: [jsx(FormLabel, Object.assign({
                  component: "body",
                  style: {
                    fontWeight: 400
                  }
                }, {
                  children: localize('user_carecoordinator')
                })), jsx(IconButton$1, {
                  id: "edit-managers",
                  color: "primary",
                  className: "fa fa-edit",
                  "aria-label": "edit-managers",
                  onClick: () => {
                    userMetrics.trackEvent('patients: open search manager modal');
                    setSearchManagersModalOpen(true);
                  }
                }), ' ']
              }))
            })), jsx(Grid$1, Object.assign({
              item: true,
              xs: 12
            }, {
              children: selectedManagers && (selectedManagers === null || selectedManagers === void 0 ? void 0 : selectedManagers.length) > 0 && selectedManagers.map(manager => {
                return jsxs("div", Object.assign({
                  style: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center'
                  }
                }, {
                  children: [jsx(ListItem, {
                    children: jsx(ListItemText, {
                      primary: `${manager.fname} ${manager.lname} `
                    })
                  }), jsx(IconButton$1, Object.assign({
                    color: "primary",
                    onClick: () => {
                      userMetrics.trackEvent('patients: remove manager from list', {
                        manager: manager._id
                      });
                      const managers = (selectedManagers === null || selectedManagers === void 0 ? void 0 : selectedManagers.length) ? [...selectedManagers] : [];
                      const index = managers.map(m => m._id).indexOf(manager._id);
                      if (index > -1) {
                        managers.splice(index, 1);
                      }
                      formik.setFieldValue('managers', managers.filter(id => id !== manager._id));
                      setSelectedManagers(managers);
                    }
                  }, {
                    children: jsx(Delete, {})
                  }))]
                }), manager._id);
              })
            }))]
          })]
        }))]
      }))]
    }))
  }));
};

const InactiveWarning = ({
  id,
  isOpen,
  onClose
}) => {
  const [shouldRemoveManagers, setShouldRemoveManagers] = useState(false);
  const [shouldRemoveContacts, setShouldRemoveContacts] = useState(false);
  const [shouldStopWorkflows, setShouldStopWorkflows] = useState(false);
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  const {
    updateInactive
  } = usePatients();
  const actions = [jsx(Button, Object.assign({
    onClick: () => __awaiter(void 0, void 0, void 0, function* () {
      userMetrics.trackEvent('patients: deactivate patient', {
        patient: id
      });
      try {
        yield updateInactive(id, true, shouldRemoveManagers, shouldStopWorkflows, shouldRemoveContacts);
        onClose();
      } catch (e) {
        Sentry.captureException(e);
      }
    })
  }, {
    children: localize('users_inactive_deactive')
  }), 'buttondeactivate'), jsx(Button, Object.assign({
    onClick: onClose
  }, {
    children: localize('users_cancel')
  }), 'buttoncancel')];
  return jsxs(ActionDialog, Object.assign({
    actions: actions,
    open: !!isOpen,
    onClose: onClose,
    title: localize('users_setinactive_title')
  }, {
    children: [jsx(Typography, {
      children: localize('users_inactive_change')
    }), jsxs(FormGroup, Object.assign({
      style: {
        paddingTop: '0.5em'
      }
    }, {
      children: [jsx(FormControlLabel, {
        control: jsx(Checkbox, {
          checked: !!shouldRemoveManagers,
          onChange: event => {
            setShouldRemoveManagers(event.target.checked);
            setShouldStopWorkflows(event.target.checked);
          }
        }),
        label: localize('users_inactive_remove_managers')
      }), jsx(FormControlLabel, {
        control: jsx(Checkbox, {
          checked: !!shouldRemoveContacts,
          onChange: event => setShouldRemoveContacts(event.target.checked)
        }),
        label: localize('users_inactive_remove_contacts')
      }), jsx(FormControlLabel, {
        control: jsx(Checkbox, {
          checked: !!shouldStopWorkflows,
          disabled: !!shouldRemoveManagers,
          onChange: event => setShouldStopWorkflows(event.target.checked)
        }),
        label: localize('users_inactive_stop_workflows')
      })]
    }))]
  }));
};

const Header$1 = styled(Typography)(() => ({
  marginTop: '10px'
}));
const OnHold = ({
  user,
  isOpen,
  requestKitOpen,
  updateReason,
  onClose
}) => {
  var _a;
  const {
    localize
  } = useLocalize();
  const {
    updatePatientState,
    apiResponse
  } = usePatients();
  const patientStates = [{
    value: 'waiting-for-onboarding',
    text: localize('Patient_States.waiting-for-onboarding')
  }, {
    value: 'on-boarded',
    text: localize('Patient_States.on-boarded')
  }, {
    value: 'active-care',
    text: localize('Patient_States.active-care')
  }, {
    value: 'discharged',
    text: localize('Patient_States.discharged')
  }];
  const [holdReasons, setHoldReasons] = useState([{
    value: 'patientAdmittedToHospital',
    text: localize('OnHold.reasons.patientAdmittedToHospital')
  }, {
    value: 'PatientOnVacation',
    text: localize('OnHold.reasons.PatientOnVacation')
  }, {
    value: 'waitingForKitReplacement',
    text: localize('OnHold.reasons.waitingForKitReplacement')
  }, {
    value: 'other',
    text: localize('OnHold.reasons.other')
  }]);
  const [reason, setReason] = useState(holdReasons[0].value);
  const [customReason, setCustomReason] = useState('');
  const [patientState, setPatientState] = useState(patientStates[0].value);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [lostOpen, setLostOpen] = useState(false);
  useEffect(() => {
    if (apiResponse.status.toString().startsWith('2')) {
      if (reason === 'kitLost' && (user === null || user === void 0 ? void 0 : user.state) !== 'on-hold') {
        setConfirmOpen(false);
        setLostOpen(true);
      } else {
        setConfirmOpen(false);
        if (isOpen) onClose();
      }
    }
  }, [apiResponse, onClose, isOpen, user === null || user === void 0 ? void 0 : user.kit, user === null || user === void 0 ? void 0 : user.kit_assignment, holdReasons, reason, user === null || user === void 0 ? void 0 : user.state]);
  useEffect(() => {
    setConfirmOpen(false);
    setLostOpen(false);
  }, [isOpen]);
  useMemo(() => {
    var _a;
    if (['shipping', 'received', 'setup', 'return-prep', 'returning'].includes(((_a = user === null || user === void 0 ? void 0 : user.kit) === null || _a === void 0 ? void 0 : _a.state) || '') || (user === null || user === void 0 ? void 0 : user.state) === 'on-hold') {
      setHoldReasons(holdReasons => {
        const isKitLostReason = holdReasons.filter(reason => reason.value === 'kitLost').length;
        if (isKitLostReason) return holdReasons;
        holdReasons.pop();
        return [...holdReasons, {
          value: 'kitLost',
          text: localize('OnHold.reasons.kitLost')
        }, {
          value: 'other',
          text: localize('OnHold.reasons.other')
        }];
      });
    } else {
      setHoldReasons(holdReasons => {
        return holdReasons.filter(reason => {
          if (reason.value === 'kitLost') return false;else return reason;
        });
      });
    }
  }, [localize, (_a = user === null || user === void 0 ? void 0 : user.kit) === null || _a === void 0 ? void 0 : _a.state, user === null || user === void 0 ? void 0 : user.state]);
  useMemo(() => {
    const userReason = user === null || user === void 0 ? void 0 : user.reason;
    if ((user === null || user === void 0 ? void 0 : user.state) === 'on-hold' && userReason) {
      const isCustomReason = holdReasons.filter(reason => reason.value === user.reason).length === 0;
      if (isCustomReason) {
        setReason('other');
        setCustomReason(userReason);
      } else setReason(userReason);
    } else if (!userReason) {
      setReason(holdReasons[0].value);
    }
  }, [holdReasons, user === null || user === void 0 ? void 0 : user.reason, user === null || user === void 0 ? void 0 : user.state]);
  const actions = [jsx(Button, Object.assign({
    onClick: () => __awaiter(void 0, void 0, void 0, function* () {
      setConfirmOpen(true);
    })
  }, {
    children: (user === null || user === void 0 ? void 0 : user.state) !== 'on-hold' ? localize('OnHold.setOnHold') : localize('OnHold.move_to_state')
  }), 'onHold'), jsx(Button, Object.assign({
    onClick: onClose
  }, {
    children: localize('users_cancel')
  }), 'buttoncancel')];
  const confirmActions = [jsx(Button, Object.assign({
    onClick: () => __awaiter(void 0, void 0, void 0, function* () {
      try {
        if ((user === null || user === void 0 ? void 0 : user.state) === 'on-hold') yield updatePatientState(user._id, patientState);else if (user && reason !== 'other') yield updatePatientState(user._id, 'on-hold', reason);else if (user && reason === 'other') yield updatePatientState(user._id, 'on-hold', customReason);else if (!user) {
          updateReason(reason === 'other' ? customReason || " " : reason);
          setConfirmOpen(false);
          onClose();
        }
        setConfirmOpen(false);
      } catch (e) {
        Sentry.captureException(e);
      }
    })
  }, {
    children: localize('common.confirm')
  }), 'confirm'), jsx(Button, Object.assign({
    onClick: () => setConfirmOpen(false)
  }, {
    children: localize('users_cancel')
  }), 'buttoncancel')];
  const lostActions = [jsx(Button, Object.assign({
    onClick: () => {
      setConfirmOpen(false);
      setLostOpen(false);
      onClose();
      requestKitOpen();
    }
  }, {
    children: localize('common.confirm')
  }), 'confirm'), jsx(Button, Object.assign({
    onClick: () => {
      setLostOpen(false);
      setConfirmOpen(false);
      onClose();
    }
  }, {
    children: localize('users_cancel')
  }), 'buttoncancel')];
  return jsxs(ActionDialog, Object.assign({
    actions: actions,
    open: !!isOpen,
    onClose: onClose,
    title: (user === null || user === void 0 ? void 0 : user.state) === 'on-hold' ? localize('OnHold.moveStateTitle') : localize('OnHold.title')
  }, {
    children: [jsx(Header$1, {
      children: localize('OnHold.reason')
    }), jsx(TextSelect, {
      id: 'inactive-reason',
      options: holdReasons,
      defaultValue: reason,
      onChange: event => {
        setReason(event.target.value);
      },
      disabled: (user === null || user === void 0 ? void 0 : user.state) === 'on-hold'
    }), reason === 'other' && jsxs(Fragment, {
      children: [jsx(Header$1, {
        children: localize('OnHold.enter_reason')
      }), jsx(TextField, {
        id: 'inactive-reason-other',
        variant: "outlined",
        value: customReason,
        onChange: event => {
          setCustomReason(event.target.value);
        },
        disabled: (user === null || user === void 0 ? void 0 : user.state) === 'on-hold',
        fullWidth: true
      })]
    }), (user === null || user === void 0 ? void 0 : user.state) === 'on-hold' && jsxs(Fragment, {
      children: [jsx(Header$1, {
        children: localize('OnHold.select_state')
      }), jsx(TextSelect, {
        id: 'patient-state-change',
        defaultValue: patientState,
        onChange: event => {
          setPatientState(event.target.value);
        },
        options: patientStates
      })]
    }), jsx(ActionDialog, Object.assign({
      actions: confirmActions,
      open: !!confirmOpen,
      onClose: onClose,
      title: localize('OnHold.are_you_sure')
    }, {
      children: jsx(Typography, {
        children: (user === null || user === void 0 ? void 0 : user.state) === 'on-hold' ? localize('OnHold.moveStateDescription') : localize('OnHold.description')
      })
    })), jsx(ActionDialog, Object.assign({
      actions: lostActions,
      open: !!lostOpen,
      onClose: onClose,
      title: localize('OnHold.requestNewKit')
    }, {
      children: jsx(Typography, {
        children: localize('OnHold.lostKitDescription')
      })
    }))]
  }));
};

const Header = styled(Typography)(() => ({
  marginTop: '10px'
}));
const OnHoldReason = ({
  user,
  isOpen,
  onClose
}) => {
  var _a;
  const {
    localize
  } = useLocalize();
  const [holdReasons, setHoldReasons] = useState([{
    value: 'patientAdmittedToHospital',
    text: localize('OnHold.reasons.patientAdmittedToHospital')
  }, {
    value: 'PatientOnVacation',
    text: localize('OnHold.reasons.PatientOnVacation')
  }, {
    value: 'waitingForKitReplacement',
    text: localize('OnHold.reasons.waitingForKitReplacement')
  }, {
    value: 'other',
    text: localize('OnHold.reasons.other')
  }]);
  const [reason, setReason] = useState(holdReasons[0].value);
  const [customReason, setCustomReason] = useState('');
  useMemo(() => {
    var _a;
    if (['shipping', 'received', 'setup', 'return-prep', 'returning'].includes(((_a = user === null || user === void 0 ? void 0 : user.kit) === null || _a === void 0 ? void 0 : _a.state) || '') || (user === null || user === void 0 ? void 0 : user.state) === 'on-hold') {
      setHoldReasons(holdReasons => {
        const isKitLostReason = holdReasons.filter(reason => reason.value === 'kitLost').length;
        if (isKitLostReason) return holdReasons;
        holdReasons.pop();
        return [...holdReasons, {
          value: 'kitLost',
          text: localize('OnHold.reasons.kitLost')
        }, {
          value: 'other',
          text: localize('OnHold.reasons.other')
        }];
      });
    } else {
      setHoldReasons(holdReasons => {
        return holdReasons.filter(reason => {
          if (reason.value === 'kitLost') return false;else return reason;
        });
      });
    }
  }, [localize, (_a = user === null || user === void 0 ? void 0 : user.kit) === null || _a === void 0 ? void 0 : _a.state, user === null || user === void 0 ? void 0 : user.state]);
  useMemo(() => {
    const userReason = user === null || user === void 0 ? void 0 : user.reason;
    if ((user === null || user === void 0 ? void 0 : user.state) === 'on-hold' && userReason) {
      const isCustomReason = holdReasons.filter(reason => reason.value === user.reason).length === 0;
      if (isCustomReason) {
        setReason('other');
        setCustomReason(userReason);
      } else setReason(userReason);
    } else if (!userReason) {
      setReason(holdReasons[0].value);
    }
  }, [holdReasons, user === null || user === void 0 ? void 0 : user.reason, user === null || user === void 0 ? void 0 : user.state]);
  const actions = [jsx(Button, Object.assign({
    onClick: onClose
  }, {
    children: localize('users_cancel')
  }), 'buttoncancel')];
  return jsxs(ActionDialog, Object.assign({
    actions: actions,
    open: !!isOpen,
    onClose: onClose,
    title: localize('OnHold.displayReasonTitle')
  }, {
    children: [jsx(Header, {
      children: localize('OnHold.reason')
    }), jsx(TextSelect, {
      id: 'inactive-reason',
      options: holdReasons,
      defaultValue: reason || "",
      onChange: event => {
        setReason(event.target.value);
      },
      disabled: (user === null || user === void 0 ? void 0 : user.state) === 'on-hold'
    }), reason === 'other' && jsxs(Fragment, {
      children: [jsx(Header, {
        children: localize('OnHold.enter_reason')
      }), jsx(TextField, {
        id: 'inactive-reason-other',
        variant: "outlined",
        value: customReason,
        onChange: event => {
          setCustomReason(event.target.value);
        },
        disabled: (user === null || user === void 0 ? void 0 : user.state) === 'on-hold',
        fullWidth: true
      })]
    })]
  }));
};

const StateMenu = ({
  currentState,
  states,
  title: _title = '',
  onChange,
  icon,
  showAll: _showAll = false,
  localizationPrefix: _localizationPrefix = ''
}) => {
  const {
    localize
  } = useLocalize();
  const nextStates = useMemo(() => {
    var _a;
    if (!currentState || !states) return [];
    return ((_a = states.filter(state => state.name === currentState)[0]) === null || _a === void 0 ? void 0 : _a.next) || [];
  }, [states, currentState]);
  const otherStates = useMemo(() => states.map(state => state.name).filter(stateName => !nextStates.concat(currentState).includes(stateName)), [states, currentState, nextStates]);
  const list = useMemo(() => {
    if (currentState === 'requested') {
      return ['assign_kit'];
    }
    if (!currentState) {
      return states.map(state => state.name);
    }
    return _showAll ? [nextStates[0], currentState, ...nextStates.slice(1)].concat(otherStates) : [nextStates[0], currentState, ...nextStates.slice(1)];
  }, [_showAll, currentState, nextStates, otherStates, states]);
  const icons = useMemo(() => list.map(state => {
    if (state === 'assign_kit') {
      return jsx(LocalHospital, {
        color: "primary"
      }, 'assign-kit');
    }
    if (state === 'lost' || state === 'inactive') {
      return jsx(Stop, {
        style: {
          color: 'red'
        }
      }, state);
    }
    if (state === currentState) {
      return jsx(Stop, {
        color: "disabled"
      }, state);
    }
    if (nextStates.includes(state)) {
      return jsx(Stop, {
        color: "primary"
      }, state);
    }
    if (!currentState) {
      return jsx(Stop, {
        color: "primary"
      }, 'noState');
    }
    return jsx(Stop, {
      color: "disabled"
    }, state);
  }), [currentState, nextStates, list]);
  return jsx(IconButtonMenu, Object.assign({
    hoverLabel: localize('Change_State'),
    title: _title,
    icon: icon
  }, {
    children: list.map((item, index) => jsx(DefaultIconbuttonMenuItem, Object.assign({
      disabled: currentState ? otherStates.includes(item) : false,
      label: localize(`${_localizationPrefix && _localizationPrefix.concat('.')}${item}`),
      onClickValue: item,
      onClick: onChange
    }, {
      children: icons[index]
    }), item))
  }));
};

const StateHistory = ({
  data,
  tableWidth,
  theme
}) => {
  const {
    localize
  } = useLocalize();
  return jsx(ThemeProvider, Object.assign({
    theme: theme
  }, {
    children: jsx(VirtualizedTable, {
      rowGetter: ({
        index
      }) => data[index],
      rowCount: data.length,
      columns: [{
        label: localize('State'),
        dataFn: ({
          rowData: {
            toState
          }
        }) => {
          if (toState === 'waiting-for-onboarding' || toState === 'setup') {
            return jsx(Chip, {
              color: "primary",
              label: toState
            }, toState);
          }
          return jsx(Chip, {
            variant: "outlined",
            color: "secondary",
            label: toState
          }, toState);
        },
        dataKey: 'state',
        width: tableWidth * 0.5
      }, {
        label: localize('Date'),
        dataFn: ({
          rowData: {
            timestamp
          }
        }) => {
          const date = new Date(timestamp);
          return jsx(Typography, {
            children: `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
          });
        },
        dataKey: 'date',
        width: tableWidth * 0.2
      }]
    })
  }));
};

const KitModelDetails = ({
  kitModel,
  theme
}) => {
  const {
    localize
  } = useLocalize();
  const {
    kits
  } = useKit();
  const [kitsInStock, setKitsInStock] = useState([]);
  const [assignedKits, setAssignenedKits] = useState([]);
  const modelKits = useMemo(() => kits.filter(kit => kit.modelId === kitModel._id), [kitModel, kits]);
  useEffect(() => {
    setKitsInStock(modelKits.filter(kit => kit.state === 'waiting-for-onboarding' || kit.state === 'assembling'));
    setAssignenedKits(modelKits.filter(kit => kit.state !== 'waiting-for-onboarding' && kit.state !== 'assembling'));
  }, [modelKits]);
  function getChip(state) {
    if (state === 'setup' || state === 'waiting-for-onboarding') {
      return jsx(Chip, {
        color: "primary",
        label: localize(state)
      });
    }
    if (state === 'requested') {
      return jsx(Chip, {
        color: "secondary",
        label: localize(state)
      });
    }
    return jsx(Chip, {
      variant: "outlined",
      color: "secondary",
      label: localize(state)
    });
  }
  return jsx(ThemeProvider, Object.assign({
    theme: theme
  }, {
    children: jsxs(Grid, Object.assign({
      container: true,
      spacing: 2
    }, {
      children: [jsx(Grid, Object.assign({
        item: true,
        xs: 2
      }, {
        children: jsx(Typography, {
          children: `${localize('Kit_Model')}:`
        })
      })), jsx(Grid, Object.assign({
        item: true,
        xs: 10
      }, {
        children: jsx(Typography, Object.assign({
          style: {
            fontSize: 15,
            fontWeight: 500
          }
        }, {
          children: `${kitModel.modelName} ${kitModel.modelNumber}`
        }))
      })), jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsx(TableContainer, Object.assign({
          component: Paper
        }, {
          children: jsxs(Table$1, {
            children: [jsx(TableHead, {
              children: jsxs(TableRow, {
                children: [jsx(TableCell$1, {
                  children: localize('Class')
                }), jsx(TableCell$1, {
                  children: localize('Make')
                }), jsx(TableCell$1, {
                  children: localize('Model')
                }), jsx(TableCell$1, {
                  children: localize('Model_Number')
                })]
              })
            }), jsx(TableBody, {
              children: kitModel.itemModels.map(model => {
                return jsxs(TableRow, {
                  children: [jsx(TableCell$1, {
                    children: model.itemModel.itemClass
                  }), jsx(TableCell$1, {
                    children: model.itemModel.make
                  }), jsx(TableCell$1, {
                    children: model.itemModel.modelName
                  }), jsx(TableCell$1, {
                    children: model.itemModel.modelNumber
                  })]
                }, model.itemModel._id);
              })
            })]
          })
        }))
      })), jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsx(Chip, {
          color: "primary",
          label: `${localize('In_Stock')} ${kitsInStock.length}`
        })
      })), jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsx(Paper, Object.assign({
          elevation: 2
        }, {
          children: jsx(Box, Object.assign({
            sx: {
              overflow: 'scroll',
              minHeight: 400,
              height: 500,
              maxHeight: 750
            }
          }, {
            children: jsx(VirtualizedTable, {
              rowGetter: ({
                index
              }) => kitsInStock[index],
              rowCount: kitsInStock.length,
              rowHeight: 50,
              columns: [{
                label: localize('Kit_Number'),
                width: 100,
                minWidth: 150,
                dataKey: 'serialNumber'
              }, {
                label: localize('Kit_State'),
                dataFn: ({
                  rowData
                }) => getChip(rowData === null || rowData === void 0 ? void 0 : rowData.state),
                width: 100,
                minWidth: 150,
                dataKey: 'state'
              }]
            })
          }))
        }))
      })), jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsx(Chip, {
          color: "primary",
          variant: "outlined",
          label: `${localize('Assigned')} ${assignedKits.length}`
        })
      })), jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsx(Paper, Object.assign({
          elevation: 2
        }, {
          children: jsx(Box, Object.assign({
            sx: {
              overflow: 'scroll',
              minHeight: 400,
              height: 500,
              maxHeight: 750
            }
          }, {
            children: jsx(VirtualizedTable, {
              rowGetter: ({
                index
              }) => assignedKits[index],
              rowCount: assignedKits.length,
              rowHeight: 50,
              columns: [{
                label: localize('Kit_Number'),
                width: 100,
                minWidth: 150,
                dataKey: 'serialNumber'
              }, {
                label: localize('Kit_State'),
                dataFn: ({
                  rowData
                }) => getChip(rowData === null || rowData === void 0 ? void 0 : rowData.state),
                width: 100,
                minWidth: 150,
                dataKey: 'state'
              }]
            })
          }))
        }))
      }))]
    }))
  }));
};

/* © 2022 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, September 12, 2022
 * For information or permission request, email info@aetonixsystems.com
 */
const primaryText = '#102543';
const primary = '#285E63';
const light = '#C4DFE0';
const backgroundContrast = '#EAF4F4';
const backgroundColor = '#FFFFFF';
const backgroundLight = '#F2F6F8';
const LogisticsTheme = createTheme({
  palette: {
    primary: {
      main: primary
    },
    secondary: {
      main: light
    },
    background: {
      default: backgroundColor
    },
    text: {
      primary: primaryText
    }
  },
  typography: {
    fontFamily: 'Poppins',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 550,
    fontWeightBold: 700,
    fontSize: 14
  },
  overrides: {
    MuiTypography: {
      body1: {
        fontSize: 14
      }
    },
    MuiButton: {
      root: {
        fontWeight: 500
      }
    },
    MuiTable: {
      root: {
        backgroundColor: backgroundColor
      }
    },
    MuiChip: {
      root: {
        borderRadius: 50,
        width: 110,
        height: 36,
        textTransform: 'capitalize'
      },
      colorSecondary: {
        backgroundColor: '#EB0000',
        color: '#ffffff'
      },
      outlinedSecondary: {
        backgroundColor: '#EAECF3',
        borderColor: '#506583',
        color: '#506583'
      }
    },
    MuiTableHead: {
      root: {
        backgroundColor: light
      }
    },
    MuiTableRow: {
      root: {
        '&:nth-of-type(even)': {
          backgroundColor: backgroundContrast
        }
      }
    },
    MuiTableCell: {
      root: {
        fontSize: 14,
        background: backgroundColor
      },
      head: {
        backgroundColor: light,
        maxHeight: 46,
        fontWeight: 500,
        color: primary
      }
    },
    MuiMenuItem: {
      root: {
        backgroundColor: backgroundColor
      }
    },
    MuiFormLabel: {
      root: {
        fontFamily: 'Poppins',
        fontSize: '14px',
        fontWeight: 400,
        textAlign: 'left',
        color: '#102543'
      }
    },
    MuiMenu: {
      list: {
        backgroundColor: backgroundColor
      }
    },
    MuiInputLabel: {
      root: {
        color: primary
      }
    },
    MuiSelect: {
      icon: {
        fill: primary
      }
    },
    MuiInput: {
      input: {
        '&::placeholder': {
          fontSize: 16,
          fontWeight: 500
        }
      },
      underline: {
        '&:before': {
          borderBottom: '1px solid #6DBFC3'
        },
        '&:after': {
          borderBottom: '1px solid #6DBFC3'
        }
      }
    },
    MuiPaper: {
      rounded: {
        borderRadius: 4
      }
    },
    MuiTab: {
      root: {
        background: light,
        textTransform: 'none',
        fontWeight: 500,
        fontSize: 16,
        borderLeft: '1px solid #285e63',
        borderTop: '1px solid #285e63',
        borderBottom: '1px solid #285e63',
        '&$selected': {
          borderBottom: '0px solid #285e63',
          backgroundColor: backgroundLight
        },
        '&:last-child': {
          borderRight: '1px solid #285e63',
          borderTopRightRadius: '4px'
        },
        '&:first-of-type': {
          borderTopLeftRadius: '4px'
        }
      },
      textColorPrimary: {
        color: primary
      }
    },
    MuiDialogTitle: {
      root: {
        padding: '5px',
        paddingLeft: '15px',
        color: '#FFFFFF',
        backgroundColor: '#285E63',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
      }
    }
  }
});

var index = /*#__PURE__*/Object.freeze({
	__proto__: null,
	LogisticsTheme: LogisticsTheme,
	DashboardsTheme: DashboardsTheme
});

const styles$9 = {
  actionsContainer: {
    width: "100%",
    paddingRight: "1.5rem",
    paddingBottom: "1rem",
    paddingLeft: "1.5rem"
  },
  actionsButtonContainer: {
    paddingTop: '1rem'
  },
  divider: {
    width: "100%"
  }
};
const Notes = ({
  assignmentId,
  patient,
  open,
  onCloseCallback,
  theme: _theme = LogisticsTheme
}) => {
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  const {
    personal
  } = useCurrentPerson();
  const {
    notes,
    sendNote,
    markNotesRead,
    setPatient,
    isLoading,
    getUnreadNotes
  } = useLogisticsNotes();
  const {
    fetchAssignment,
    kitAssignments
  } = useKitAssignment();
  const {
    people,
    trackPerson
  } = usePeople();
  const [noteData, setNoteData] = useState([]);
  const [content, setContent] = useState('');
  useEffect(() => {
    if (open) {
      const notesToMarkRead = getUnreadNotes();
      if (notesToMarkRead.length > 0) {
        markNotesRead(notesToMarkRead, assignmentId, {
          markAsReadForTeam: false
        });
      }
    }
  }, [markNotesRead, open, assignmentId, getUnreadNotes]);
  const from = useMemo(() => personal._id ? personal._id : '', [personal._id]);
  const kitAssignment = useMemo(() => {
    const kitAssignment = kitAssignments.find(assignment => assignment._id === assignmentId);
    if (kitAssignment) {
      return kitAssignment;
    } else {
      fetchAssignment(assignmentId);
      return undefined;
    }
  }, [kitAssignments, assignmentId, fetchAssignment]);
  const kitSerialNumber = useMemo(() => {
    var _a;
    if (kitAssignment) {
      return (_a = kitAssignment.kit) === null || _a === void 0 ? void 0 : _a.serialNumber;
    }
    return undefined;
  }, [kitAssignment]);
  const patientId = useMemo(() => {
    if (patient) {
      return patient;
    }
    if (kitAssignment) {
      return kitAssignment.patientId;
    }
    return undefined;
  }, [patient, kitAssignment]);
  const patientNumber = useMemo(() => {
    if (kitAssignment) {
      return kitAssignment.patient.patientNumber;
    }
    return undefined;
  }, [kitAssignment]);
  useEffect(() => {
    if (patientId) {
      setNoteData([]);
      setPatient(patientId);
    }
  }, [patientId, setPatient]);
  useEffect(() => {
    if (notes) {
      setNoteData(notes);
    }
    setTimeout(() => scrollToBottom(), 100);
  }, [notes]);
  useEffect(() => {
    if (open) {
      setTimeout(() => scrollToBottom(), 100);
    }
  }, [open]);
  useEffect(() => {
    const people = new Set();
    noteData.forEach(note => {
      people.add(note.from);
      const noteSentTo = Array.isArray(note.to) ? note.to : [note.to];
      noteSentTo.forEach(user => {
        people.add(user);
      });
    });
    trackPerson([...people]);
  }, [noteData, trackPerson]);
  function scrollToBottom() {
    const element = document.getElementById('noteBox');
    if (element) element.scrollTop = element.scrollHeight - element.clientHeight;
  }
  const lastReadMap = useMemo(() => {
    const map = new Map();
    notes.forEach(note => {
      if (note.readBy.length > 0) {
        Array.from(note.readBy).forEach(readBy => {
          const lastRead = map.get(readBy);
          if (!lastRead || note.created_at > lastRead) {
            map.set(readBy, note.created_at);
          }
        });
      }
    });
    return map;
  }, [notes]);
  return jsx(ThemeProvider, Object.assign({
    theme: _theme
  }, {
    children: jsx(ActionDialog, Object.assign({
      title: localize('Notes'),
      open: open,
      onClose: () => {
        setContent('');
        onCloseCallback();
        userMetrics.trackEvent('logistics: close kit notes popup');
      },
      reactKey: "Notes_Modal",
      actions: jsx(DialogActions, {
        assignmentId: assignmentId,
        setContent: setContent,
        onCloseCallback: onCloseCallback
      })
    }, {
      children: jsxs(Grid, Object.assign({
        container: true,
        spacing: 2,
        style: {
          paddingLeft: 5,
          paddingRight: 3,
          alignItems: 'center'
        }
      }, {
        children: [jsxs(Grid, Object.assign({
          item: true,
          xs: 12,
          direction: 'row',
          container: true,
          justifyContent: 'flex-start',
          spacing: 1
        }, {
          children: [jsx(Grid, Object.assign({
            item: true,
            xs: 2,
            style: {
              marginTop: 1
            }
          }, {
            children: jsx(Typography, {
              children: localize('Notes_Header_Patient')
            })
          })), jsx(Grid, Object.assign({
            item: true,
            xs: 10
          }, {
            children: jsx(Typography, Object.assign({
              style: {
                userSelect: 'text'
              }
            }, {
              children: patientNumber ? `${patientNumber}` : ''
            }))
          })), jsx(Grid, Object.assign({
            item: true,
            xs: 2
          }, {
            children: jsx(Typography, {
              children: localize('Notes_Header_Kit')
            })
          })), jsx(Grid, Object.assign({
            item: true,
            xs: 10
          }, {
            children: jsx(Typography, Object.assign({
              style: {
                userSelect: 'text'
              }
            }, {
              children: kitSerialNumber ? `${kitSerialNumber}` : localize('Kit_Not_Assigned')
            }))
          }))]
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12,
          container: true,
          direction: "column-reverse",
          spacing: 1
        }, {
          children: jsx(Paper, Object.assign({
            variant: "outlined"
          }, {
            children: jsxs(Box, Object.assign({
              id: "noteBox",
              height: 650,
              overflow: "auto",
              style: {
                padding: 5,
                scrollBehavior: 'smooth'
              }
            }, {
              children: [noteData.map((message, index) => {
                var _a;
                const sender = ((_a = people[message.from]) === null || _a === void 0 ? void 0 : _a.fname) || 'default';
                const timestamp = new Date(message.created_at);
                const date = `${timestamp.getDate()}/${timestamp.getMonth() + 1}/${timestamp.getFullYear()}  ${timestamp.getHours()}:${timestamp.getMinutes()}`;
                const justify = from === message.from ? 'flex-end' : 'flex-start';
                const readByString = Array.from(lastReadMap.entries()).reduce((acc, [personId, date]) => {
                  var _a;
                  if (date === message.created_at) {
                    const name = ((_a = people[personId]) === null || _a === void 0 ? void 0 : _a.fname) || '';
                    if (name) {
                      acc.push(name);
                    }
                  }
                  return acc;
                }, []).join(', ');
                const finalString = readByString ? `Read by: ${readByString}` : '';
                if (date && message.content) {
                  return jsxs(Grid, Object.assign({
                    item: true,
                    xs: 12,
                    container: true,
                    style: {
                      padding: 5,
                      justifyContent: justify
                    }
                  }, {
                    children: [jsx(Grid, Object.assign({
                      container: true,
                      justifyContent: justify,
                      item: true,
                      xs: 12
                    }, {
                      children: jsx(Typography, Object.assign({
                        color: "textPrimary"
                      }, {
                        children: sender
                      }))
                    })), jsx(Grid, Object.assign({
                      item: true
                    }, {
                      children: jsx(Paper, Object.assign({
                        variant: "outlined"
                      }, {
                        children: jsx(Typography, Object.assign({
                          color: "textPrimary",
                          style: {
                            whiteSpace: 'pre-line',
                            padding: 12,
                            backgroundColor: '#EAF4F4',
                            userSelect: 'text',
                            maxWidth: 600,
                            overflowWrap: 'break-word'
                          }
                        }, {
                          children: message.content
                        }))
                      }))
                    })), jsx(Grid, Object.assign({
                      container: true,
                      justifyContent: justify,
                      item: true,
                      xs: 12
                    }, {
                      children: jsx(Typography, Object.assign({
                        color: "primary",
                        style: {
                          fontSize: 12,
                          fontWeight: 300,
                          paddingLeft: 5
                        }
                      }, {
                        children: date
                      }))
                    })), jsx(Grid, Object.assign({
                      container: true,
                      justifyContent: justify,
                      item: true,
                      xs: 12
                    }, {
                      children: jsx(Typography, Object.assign({
                        color: 'primary',
                        style: {
                          fontSize: 10,
                          paddingLeft: 5
                        }
                      }, {
                        children: finalString
                      }))
                    }))]
                  }), index);
                } else {
                  return null;
                }
              }), isLoading && jsx(Box, Object.assign({
                sx: {
                  display: 'flex',
                  justifyContent: 'center',
                  paddingTop: 350,
                  color: 'primary'
                }
              }, {
                children: jsx(SpinningIcon, {
                  icon: Sync,
                  spinning: true
                })
              }))]
            }))
          }))
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 10
        }, {
          children: jsx(TextField, {
            value: content,
            multiline: true,
            fullWidth: true,
            onChange: event => setContent(event.target.value),
            variant: "outlined"
          })
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 2
        }, {
          children: jsx(Button, Object.assign({
            color: "primary",
            variant: "contained",
            "aria-label": "Add Note",
            size: "large",
            disabled: !content,
            onClick: () => {
              userMetrics.trackEvent('logistics: add note', {
                assignmentId
              });
              sendNote(content, assignmentId);
              setContent('');
            }
          }, {
            children: localize('Add_Note')
          }))
        }))]
      }))
    }))
  }));
};
const DialogActions = props => {
  const {
    assignmentId,
    onCloseCallback,
    setContent
  } = props;
  const [isChecked, setChecked] = useState(false);
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  const {
    markNotesRead,
    getUnreadNotes
  } = useLogisticsNotes();
  const handleMarkNotesRead = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
    const unreadNotes = getUnreadNotes({
      includePartialRead: false
    });
    if (unreadNotes.length > 0) {
      yield markNotesRead(unreadNotes, assignmentId, {
        markAsReadForTeam: true
      });
    }
  }), [assignmentId, getUnreadNotes, markNotesRead]);
  return jsxs(Grid, Object.assign({
    container: true,
    style: styles$9.actionsContainer
  }, {
    children: [jsx(Divider, {
      style: styles$9.divider
    }), jsxs(Grid, Object.assign({
      container: true,
      justifyContent: "space-between",
      direction: "row-reverse",
      style: styles$9.actionsButtonContainer
    }, {
      children: [jsx(Button, Object.assign({
        onClick: () => {
          if (isChecked) handleMarkNotesRead();
          userMetrics.trackEvent('logistics: close kit notes popup');
          setContent('');
          onCloseCallback();
        }
      }, {
        children: localize('Close')
      }), "Close_Notes_Button"), jsx(FormControlLabel, {
        control: jsx(Checkbox, {
          checked: isChecked,
          onChange: () => setChecked(prevChecked => !prevChecked),
          color: "primary"
        }),
        label: localize('mark_read_for_everyone')
      }, "Mark_as_Read")]
    }))]
  }));
};

const NewItem = ({
  open,
  onCloseCallback,
  itemModel
}) => {
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  const {
    CreateItem,
    SpecialFields
  } = useItem();
  const [errorFields, setErrorFields] = useState([]);
  const [createAnother, setCreateAnother] = useState(false);
  const uniqueFields = itemModel ? SpecialFields(itemModel === null || itemModel === void 0 ? void 0 : itemModel.itemSchema) : [];
  const initialValues = {
    serialNumber: '',
    count: '',
    lot: '',
    IMEI: '',
    expiry: '',
    mac: '',
    sim: ''
  };
  const schemaMap = {
    stock: z$1.object({
      count: z$1.number().positive()
    }),
    lot: z$1.object({
      lot: z$1.string().min(1),
      expiry: z$1.string().min(1),
      count: z$1.number().positive()
    }),
    serialized: z$1.object({
      serialNumber: z$1.string().min(1).regex(/^[A-Za-z0-9 /-]+$/, {
        message: 'No Special Characters Allowed'
      })
    }),
    tablet: z$1.object({
      serialNumber: z$1.string().min(1).regex(/^[A-Za-z0-9 /-]+$/, {
        message: 'No Special Characters Allowed'
      }),
      IMEI: z$1.string().min(1).regex(/^[A-Za-z0-9 /-]+$/, {
        message: 'No Special Characters Allowed'
      })
    }),
    sensor: z$1.object({
      serialNumber: z$1.string().min(1).regex(/^[A-Za-z0-9 /-]+$/, {
        message: 'No Special Characters Allowed'
      }),
      mac: z$1.string().min(1)
    }),
    sim: z$1.object({
      sim: z$1.string().min(1).regex(/^[0-9]+$/, {
        message: 'Numbers Only'
      })
    })
  };
  function submitForm() {
    CreateItem(itemModel._id, formik.values);
    if (!createAnother) {
      onCloseCallback();
    }
    setCreateAnother(false);
    formik.resetForm();
    setErrorFields([]);
  }
  function validate() {
    const schema = schemaMap[(itemModel === null || itemModel === void 0 ? void 0 : itemModel.itemSchema) || 'stock'];
    const validation = schema.safeParse(formik.values);
    if (!validation.success) {
      setErrorFields([]);
      validation.error.issues.forEach(issue => {
        setErrorFields(prevFields => prevFields.concat(issue.path.toString()));
      });
    }
    return validation.success;
  }
  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: () => {
      validate() ? submitForm() : console.error(`missing required fields`);
    }
  });
  function actions() {
    return [jsx(Button, Object.assign({
      "aria-label": "closeButton",
      onClick: () => {
        formik.resetForm();
        setErrorFields([]);
        onCloseCallback();
      }
    }, {
      children: localize('Close')
    }), 'CloseButton'), jsx(Button, Object.assign({
      "aria-label": "submitButton",
      variant: "contained",
      color: "primary",
      onClick: () => {
        userMetrics.trackEvent("logistics: submit new item");
        formik.handleSubmit();
      }
    }, {
      children: localize('Submit')
    }), 'SubmitButton'), jsx(Button, Object.assign({
      "aria-label": "CreateAnotherButton",
      variant: "contained",
      color: "primary",
      onClick: () => {
        userMetrics.trackEvent("logistics: submit new item and create another");
        setCreateAnother(true);
        formik.handleSubmit();
      }
    }, {
      children: localize('Create_Another')
    }), 'CreateAnotherButton')];
  }
  return jsx(ActionDialog, Object.assign({
    title: localize('NewItem_Title'),
    onClose: () => {
      formik.resetForm();
      setErrorFields([]);
      onCloseCallback();
    },
    open: open,
    actions: actions()
  }, {
    children: jsxs(Grid, Object.assign({
      container: true,
      alignItems: "center",
      spacing: 2
    }, {
      children: [jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsx(Typography, {
          children: `${localize('NewItem_Model_Label')}: ${(itemModel === null || itemModel === void 0 ? void 0 : itemModel.modelName) || ''}`
        })
      })), jsxs(Grid, Object.assign({
        item: true,
        container: true,
        alignItems: "center",
        xs: 6,
        spacing: 2
      }, {
        children: [jsx(Grid, Object.assign({
          item: true,
          xs: 4
        }, {
          children: jsx(Typography, {
            children: localize('Item_Class')
          })
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 8
        }, {
          children: jsx(TextField, {
            name: "itemClass",
            id: "itemClass",
            variant: "outlined",
            size: "small",
            inputProps: {
              readOnly: true
            },
            value: (itemModel === null || itemModel === void 0 ? void 0 : itemModel.itemClass) || '',
            fullWidth: true
          })
        }))]
      })), jsxs(Grid, Object.assign({
        item: true,
        container: true,
        alignItems: "center",
        xs: 6,
        spacing: 2
      }, {
        children: [jsx(Grid, Object.assign({
          item: true,
          xs: 4
        }, {
          children: jsx(Typography, {
            children: localize('Make')
          })
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 8
        }, {
          children: jsx(TextField, {
            name: "make",
            id: "make",
            variant: "outlined",
            size: "small",
            inputProps: {
              readOnly: true
            },
            value: (itemModel === null || itemModel === void 0 ? void 0 : itemModel.make) || '',
            fullWidth: true
          })
        }))]
      })), jsxs(Grid, Object.assign({
        item: true,
        container: true,
        alignItems: "center",
        xs: 6,
        spacing: 2
      }, {
        children: [jsx(Grid, Object.assign({
          item: true,
          xs: 4
        }, {
          children: jsx(Typography, {
            children: localize('Model_Name')
          })
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 8
        }, {
          children: jsx(TextField, {
            name: "modelName",
            id: "modelName",
            variant: "outlined",
            size: "small",
            inputProps: {
              readOnly: true
            },
            value: (itemModel === null || itemModel === void 0 ? void 0 : itemModel.modelName) || '',
            fullWidth: true
          })
        }))]
      })), jsxs(Grid, Object.assign({
        item: true,
        container: true,
        alignItems: "center",
        xs: 6,
        spacing: 2
      }, {
        children: [jsx(Grid, Object.assign({
          item: true,
          xs: 4
        }, {
          children: jsx(Typography, {
            children: localize('Model_Number')
          })
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 8
        }, {
          children: jsx(TextField, {
            name: "modelNumber",
            id: "modelNumber",
            variant: "outlined",
            size: "small",
            inputProps: {
              readOnly: true
            },
            defaultValue: (itemModel === null || itemModel === void 0 ? void 0 : itemModel.modelNumber) || '',
            fullWidth: true
          })
        }))]
      })), uniqueFields.map(field => {
        return jsxs(Grid, Object.assign({
          item: true,
          container: true,
          alignItems: "center",
          xs: 6,
          spacing: 2
        }, {
          children: [jsx(Grid, Object.assign({
            item: true,
            xs: 4
          }, {
            children: jsx(Typography, {
              children: `${localize(field)}*`
            })
          })), jsx(Grid, Object.assign({
            item: true,
            xs: 8
          }, {
            children: jsx(TextField, {
              name: field,
              id: field,
              variant: "outlined",
              size: "small",
              error: errorFields.includes(field),
              value: formik.values[field],
              onChange: formik.handleChange,
              fullWidth: true,
              type: field === 'count' ? 'number' : 'text'
            })
          }))]
        }), field);
      })]
    }))
  }));
};

var globalThis$1 = globalThis_1;
var fails = fails$m;
var uncurryThis = functionUncurryThis;
var toString = toString$9;
var trim = stringTrim.trim;
var whitespaces = whitespaces$3;

var $parseInt = globalThis$1.parseInt;
var Symbol$1 = globalThis$1.Symbol;
var ITERATOR = Symbol$1 && Symbol$1.iterator;
var hex = /^[+-]?0x/i;
var exec = uncurryThis(hex.exec);
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR && !fails(function () { $parseInt(Object(ITERATOR)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
var numberParseInt = FORCED ? function parseInt(string, radix) {
  var S = trim(toString(string));
  return $parseInt(S, (radix >>> 0) || (exec(hex, S) ? 16 : 10));
} : $parseInt;

var $ = _export;
var parseInt = numberParseInt;

// `Number.parseInt` method
// https://tc39.es/ecma262/#sec-number.parseint
// eslint-disable-next-line es/no-number-parseint -- required for testing
$({ target: 'Number', stat: true, forced: Number.parseInt !== parseInt }, {
  parseInt: parseInt
});

const serialNumberSchema = z$1.string().min(1).regex(/^[A-Za-z0-9 /-]+$/, {
  message: 'No Special Characters Allowed'
});
const itemSchema = z$1.object({
  type: z$1.array(z$1.string())
});
const serializedItemSchema = itemSchema.extend({
  serialNumber: serialNumberSchema
});
const tabletItemSchema = serializedItemSchema.extend({
  IMEI: z$1.string()
});
const stockItemSchema = z$1.object({
  count: z$1.number().positive()
});
const lotItemSchema = stockItemSchema.extend({
  lot: z$1.string(),
  expiry: z$1.string()
});
const sensorItemSchema = serializedItemSchema.extend({
  mac: z$1.string()
});
const simItemSchema = itemSchema.extend({
  sim: z$1.string()
});
const NewKit = ({
  open,
  onClose,
  kitModelData
}) => {
  const {
    addKit
  } = useKit();
  const {
    items,
    ItemModelFilter,
    QueryItems
  } = useItem();
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  const [itemData, setItemData] = useState([]);
  const [errorFields, setErrorFields] = useState([]);
  const [createAnother, setCreateAnother] = useState(false);
  const [clearKey, setClearKey] = useState('');
  const itemModels = useMemo(() => {
    const data = kitModelData ? kitModelData.itemModels.map(kitItmeModel => kitItmeModel.itemModel) : [];
    return data;
  }, [kitModelData]);
  const itemFields = useMemo(() => {
    const fields = itemModels.length ? itemModels.reduce((a, v) => Object.assign(Object.assign({}, a), {
      [v.modelNumber]: ''
    }), {}) : {};
    return fields;
  }, [itemModels]);
  useEffect(() => setItemData(items), [items]);
  useEffect(() => {
    QueryItems({
      kitId: {
        $type: ['object', 'string']
      }
    });
    ItemModelFilter(itemModels.map(model => model._id));
  }, [itemModels, ItemModelFilter, QueryItems]);
  const initialValues = {};
  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: () => {
      validate() ? submitForm() : console.error(`missing required fields`);
    }
  });
  function validate() {
    let valid = true;
    setErrorFields([]);
    const fieldsToValidate = Object.keys(itemFields);
    fieldsToValidate.forEach(fieldName => {
      const value = formik.values[fieldName];
      if (value) {
        const model = itemModels.find(model => model._id === value.itemModelId);
        const schema = model.itemSchema;
        switch (schema) {
          case 'serialized':
            {
              const parse = serializedItemSchema.safeParse(value).success;
              if (!parse) {
                setErrorFields(prevArray => prevArray.concat([fieldName]));
                valid = false;
              }
              break;
            }
          case 'tablet':
            {
              const parse = tabletItemSchema.safeParse(value).success;
              if (!parse) {
                setErrorFields(prevArray => prevArray.concat([fieldName]));
                valid = false;
              }
              break;
            }
          case 'stock':
            {
              const parse = stockItemSchema.safeParse(value);
              if (!parse.success || value.count > model.stockCount) {
                setErrorFields(prevArray => prevArray.concat([fieldName]));
                valid = false;
              }
              break;
            }
          case 'lot':
            {
              const parse = lotItemSchema.safeParse(value).success;
              if (!parse || value.count > model.stockCount) {
                setErrorFields(prevArray => prevArray.concat([fieldName]));
                valid = false;
              }
              break;
            }
          case 'sensor':
            {
              const parse = sensorItemSchema.safeParse(value).success;
              if (!parse) {
                setErrorFields(prevArray => prevArray.concat([fieldName]));
                valid = false;
              }
              break;
            }
          case 'sim':
            {
              const parse = simItemSchema.safeParse(value).success;
              if (!parse) {
                setErrorFields(prevArray => prevArray.concat([fieldName]));
                valid = false;
              }
              break;
            }
        }
      } else {
        setErrorFields(prevArray => prevArray.concat([fieldName]));
        valid = false;
      }
    });
    return valid;
  }
  function ResetForm() {
    setCreateAnother(false);
    formik.resetForm();
    setClearKey(Math.random().toString());
  }
  function submitForm() {
    const kitModelId = kitModelData._id;
    const itemData = Object.keys(itemFields).map(field => {
      const item = formik.values[field];
      return {
        itemId: item._id || '',
        modelId: item.itemModelId,
        count: item.count || 1
      };
    });
    addKit(kitModelId, itemData);
    if (!createAnother) {
      onClose();
    }
    ResetForm();
  }
  function actions() {
    return [jsx(Button, Object.assign({
      "aria-label": "close_Button",
      onClick: () => {
        userMetrics.trackEvent('logistics: close new kit modal');
        setErrorFields([]);
        formik.resetForm();
        onClose();
      }
    }, {
      children: localize('Close')
    }), 'CloseButton'), jsx(Button, Object.assign({
      "aria-label": "submit_Button",
      variant: "contained",
      color: "primary",
      onClick: () => {
        userMetrics.trackEvent('logistics: submit new kit');
        formik.handleSubmit();
      }
    }, {
      children: localize('Submit')
    }), 'SubmitButton'), jsx(Button, Object.assign({
      "aria-label": "Create_Another_Button",
      variant: "contained",
      color: "primary",
      onClick: () => {
        userMetrics.trackEvent('logistics: submit new kit and create another');
        setCreateAnother(true);
        formik.handleSubmit();
      }
    }, {
      children: localize('Create_Another')
    }), 'CreateAnotherButton')];
  }
  return jsx(ActionDialog, Object.assign({
    actions: actions(),
    title: localize('New_Kit'),
    reactKey: 'create_kit_modal',
    onClose: onClose,
    open: open
  }, {
    children: jsxs(Grid, Object.assign({
      container: true,
      alignItems: "center",
      spacing: 2
    }, {
      children: [jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsx(Typography, Object.assign({
          "aria-label": 'kit_model_label',
          variant: "subtitle1"
        }, {
          children: `${localize('Kit_Model')}: ${(kitModelData === null || kitModelData === void 0 ? void 0 : kitModelData.modelName) || ''} 
            ${(kitModelData === null || kitModelData === void 0 ? void 0 : kitModelData.modelNumber) || ''}
          `
        }))
      })), itemModels.map(model => {
        const modelNumber = model.modelNumber;
        const make = model.make;
        const itemClass = model.itemClass;
        const options = itemData.filter(item => item.itemModelId === model._id).filter(item => !item.kitId || Object.keys(item.kitId).length === 0);
        return jsxs(Grid, Object.assign({
          item: true,
          container: true,
          alignItems: "center",
          xs: 6,
          spacing: 1,
          "aria-label": `${modelNumber}_field_container`
        }, {
          children: [jsxs(Grid, Object.assign({
            item: true,
            xs: 5
          }, {
            children: [jsx(Typography, Object.assign({
              "aria-label": `${itemClass}_${modelNumber}_text_field_label`,
              variant: "subtitle2"
            }, {
              children: `${itemClass}`
            })), jsx(Typography, Object.assign({
              "aria-label": `${make}_text_field_label`
            }, {
              children: `${make} ${modelNumber}`
            }))]
          })), jsx(Grid, Object.assign({
            "aria-label": `${modelNumber}_text_field`,
            item: true,
            xs: 7
          }, {
            children: model.itemSchema === 'stock' || model.itemSchema === 'lot' ? jsx(TextField, {
              name: modelNumber,
              id: modelNumber,
              error: errorFields.includes(modelNumber),
              label: `${localize('In_Stock')}: ${model.stockCount}`,
              onChange: e => {
                if (Number.parseInt(e.target.value) > model.stockCount) {
                  setErrorFields(prev => prev.concat(modelNumber));
                }
                const lotData = {
                  itemModelId: model._id,
                  count: Number.parseInt(e.target.value)
                };
                formik.setFieldValue(modelNumber, lotData);
              },
              variant: "outlined",
              fullWidth: true,
              size: "small",
              type: "number"
            }, `${modelNumber}_${clearKey}`) : jsx(Autocomplete, {
              id: modelNumber,
              options: options,
              onChange: (e, value) => {
                formik.setFieldValue(modelNumber, value !== null ? value : '');
              },
              getOptionLabel: option => {
                if ('IMEI' in option) {
                  const tabletOption = option;
                  return `${tabletOption.serialNumber} ${tabletOption.IMEI}`;
                }
                if ('mac' in option) {
                  const sensorOption = option;
                  return `${sensorOption.serialNumber} ${sensorOption.mac}`;
                }
                if ('sim' in option) {
                  const simOption = option;
                  return `${simOption.sim}`;
                }
                if ('serialNumber' in option) {
                  const serialOption = option;
                  return `${serialOption.serialNumber}`;
                }
                const defaultOption = option;
                return `Type: ${defaultOption.type}`;
              },
              renderOption: option => {
                if ('IMEI' in option) {
                  const tabletOption = option;
                  return jsxs("div", {
                    children: [jsx(Typography, {
                      children: `SerialNumber: ${tabletOption.serialNumber}`
                    }), jsx(Typography, {
                      children: `IMEI: ${tabletOption.IMEI}`
                    })]
                  });
                }
                if ('mac' in option) {
                  const sensorOption = option;
                  return jsxs("div", {
                    children: [jsx(Typography, {
                      children: `Serial Number: ${sensorOption.serialNumber}`
                    }), jsx(Typography, {
                      children: `Mac: ${sensorOption.mac}`
                    })]
                  });
                }
                if ('sim' in option) {
                  const simOption = option;
                  return jsx(Typography, {
                    children: `SIM: ${simOption.sim}`
                  });
                }
                if ('serialNumber' in option) {
                  const serialOption = option;
                  return jsx(Typography, {
                    children: `Serial Number: ${serialOption.serialNumber}`
                  });
                }
                const defaultOption = option;
                return jsx(Typography, {
                  children: `Type: ${defaultOption.type}`
                });
              },
              renderInput: params => jsx(TextField, Object.assign({}, params, {
                name: modelNumber,
                id: modelNumber,
                error: errorFields.includes(modelNumber),
                label: localize('Select_Item'),
                variant: "outlined",
                size: "small",
                type: 'text'
              }))
            }, `${modelNumber}_${clearKey}`)
          }))]
        }), modelNumber);
      })]
    }))
  }));
};

const PatientsPageRoutingContext = /*#__PURE__*/createContext(null);

const useStyles$1 = makeStyles({
  scroll: {
    height: '70%'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  rows: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'normal'
  },
  row: {
    marginBottom: 20
  },
  search: {
    minWidth: '30%',
    padding: 8
  },
  iconButton: {
    flex: '0 0 auto',
    width: '48px',
    height: '48px',
    padding: 0,
    fontSize: '1.5rem',
    textAlign: 'center',
    transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    borderRadius: '50%'
  }
});
const ChangePatientGroups = ({
  selectedPatients
}) => {
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  const classes = useStyles$1();
  const {
    rawPatientGroupData,
    page,
    setQuery,
    setPage,
    assignUsersToManageGroup,
    removeUsersFromManageGroups
  } = usePatientGroup();
  const [title, setTitle] = useState('');
  const [modalData, setModalData] = useState('');
  const [actions, setActions] = useState();
  const [open, setOpen] = useState(false);
  const closemodalDataModal = () => {
    userMetrics.trackEvent('patients: close change patient group popup');
    setModalData('');
    setActions(undefined);
    setOpen(false);
  };
  const handleSetPage = useCallback(() => {
    setPage(page + 1);
  }, [page, setPage]);
  return jsxs(InfiniteScroll, Object.assign({
    loadMore: handleSetPage,
    className: classes.scroll
  }, {
    children: [jsxs(Grid, Object.assign({
      className: classes.container
    }, {
      children: [jsx(Button, Object.assign({
        variant: "contained",
        color: "primary",
        onClick: () => {
          userMetrics.trackEvent('patients: open remove all from patient groups popup');
          setTitle(localize('group_users_multiselection_remove_all_managegroups_confirmation_title'));
          setModalData(localize('group_users_multiselection_remove_all_managegroups_confirmation'));
          setActions([jsx(Button, Object.assign({
            onClick: () => {
              userMetrics.trackEvent('patients: remove all from patient groups');
              removeUsersFromManageGroups(selectedPatients);
              closemodalDataModal();
            }
          }, {
            children: localize('generic_ok')
          }), 'okay'), jsx(Button, Object.assign({
            onClick: closemodalDataModal
          }, {
            children: localize('common.cancel')
          }), "cancel")]);
          setOpen(true);
        }
      }, {
        children: localize('group_users_multiselection_remove_all_managegroups_button')
      })), jsx(TextField, {
        placeholder: localize('group_users_multiselection_change_managegroups_search'),
        inputProps: {
          'aria-label': localize('group_users_multiselection_change_managegroups_search')
        },
        onChange: e => setQuery(e.target.value),
        className: classes.search
      }), jsx(Grid, Object.assign({
        spacing: 2,
        item: true,
        className: classes.rows
      }, {
        children: rawPatientGroupData.map(group => jsxs(ListItem, {
          children: [jsx(ListItemText, {
            primary: group.name,
            secondary: group.description
          }), jsx(IconButton, {
            "aria-label": group.name,
            className: [classes.iconButton, 'fa fa-user-plus'].join(' '),
            disableRipple: true,
            color: "primary",
            onClick: () => {
              userMetrics.trackEvent('patients: open add to patient group popup');
              setTitle(localize('group_users_multiselection_change_managegroups_add_confirmation_title'));
              setModalData(`${localize('change_managergroup_add_confirmation')} ${group.name}?`);
              setActions([jsx(Button, Object.assign({
                onClick: () => {
                  userMetrics.trackEvent('patients: add to patient group', {
                    group: group._id,
                    patients: selectedPatients
                  });
                  assignUsersToManageGroup(selectedPatients, group._id);
                  closemodalDataModal();
                }
              }, {
                children: localize('generic_ok')
              }), 'okay'), jsx(Button, Object.assign({
                onClick: closemodalDataModal
              }, {
                children: localize('common.cancel')
              }), "cancel")]);
              setOpen(true);
            }
          })]
        }, group._id))
      }))]
    })), jsx(ActionDialog, Object.assign({
      title: title,
      open: open,
      onClose: () => closemodalDataModal,
      actions: actions
    }, {
      children: modalData
    }))]
  }));
};

const KitInfoDisplay = ({
  KitModel,
  Kit
}) => {
  const {
    localize
  } = useLocalize();
  const serialNumber = (Kit === null || Kit === void 0 ? void 0 : Kit.serialNumber) || null;
  return jsx(ThemeProvider$1, Object.assign({
    theme: LogisticsTheme
  }, {
    children: jsxs(Grid, Object.assign({
      container: true,
      direction: "column"
    }, {
      children: [jsx(Grid, Object.assign({
        item: true
      }, {
        children: jsx(Typography, {
          children: localize('Model_Name') + ':'
        })
      })), jsx(Grid, Object.assign({
        item: true
      }, {
        children: jsx(Typography, Object.assign({
          style: {
            fontWeight: 500,
            fontSize: 16
          }
        }, {
          children: (KitModel === null || KitModel === void 0 ? void 0 : KitModel.modelName) || ''
        }))
      })), jsx(Grid, Object.assign({
        item: true
      }, {
        children: jsx(Typography, {
          children: localize('Model_Number') + ':'
        })
      })), jsx(Grid, Object.assign({
        item: true
      }, {
        children: jsx(Typography, Object.assign({
          style: {
            fontWeight: 500,
            fontSize: 16
          }
        }, {
          children: (KitModel === null || KitModel === void 0 ? void 0 : KitModel.modelNumber) || ''
        }))
      })), serialNumber && jsxs(Grid, Object.assign({
        item: true
      }, {
        children: [jsx(Grid, Object.assign({
          item: true
        }, {
          children: jsx(Typography, {
            children: localize('serialNumber') + ':'
          })
        })), jsx(Grid, Object.assign({
          item: true
        }, {
          children: jsx(Typography, Object.assign({
            style: {
              fontWeight: 500,
              fontSize: 16
            }
          }, {
            children: (Kit === null || Kit === void 0 ? void 0 : Kit.serialNumber) || ''
          }))
        }))]
      }))]
    }))
  }));
};

const SimplifiedKitStatus = ({
  assignmentId,
  kitHistory,
  localize,
  noteCallback,
  historyCallback,
  unreadMap,
  userMetrics
}) => {
  return jsxs(Grid, Object.assign({
    container: true,
    spacing: 1
  }, {
    children: [jsx(Grid, Object.assign({
      item: true,
      xs: 2
    }, {
      children: jsx(Tooltip, Object.assign({
        title: localize('Kit_Notes')
      }, {
        children: jsx(IconButton, Object.assign({
          color: "primary",
          "aria-label": localize('Kit_Notes'),
          onClick: () => {
            userMetrics.trackEvent("logistics: open kit notes popup");
            noteCallback();
          },
          style: {
            right: 15,
            fontWeight: 400
          }
        }, {
          children: jsx(Badge, Object.assign({
            overlap: "rectangular",
            badgeContent: unreadMap.get(assignmentId) || 0,
            showZero: false
          }, {
            children: jsx(Note, {})
          }))
        }))
      }))
    })), jsx(Grid, Object.assign({
      item: true,
      xs: 2
    }, {
      children: jsx(Tooltip, Object.assign({
        title: localize('Kit_State_History')
      }, {
        children: jsx(IconButton, Object.assign({
          color: "primary",
          "aria-label": localize('Kit_State_History'),
          onClick: () => {
            userMetrics.trackEvent("logistics: open kit history popup");
            historyCallback(kitHistory);
          },
          style: {
            right: 5,
            fontWeight: 400
          }
        }, {
          children: jsx(History, {})
        }))
      }))
    }))]
  }));
};

const commonStyles$3 = {
  fontFamily: 'Poppins',
  fontWeight: 400,
  cursor: 'initial',
  flex: 1,
  display: 'flex',
  alignItems: 'center'
};
const patientStates = [{
  schema: 'user',
  name: 'new',
  order: 1,
  next: ['consented', 'inactive'],
  afterHook: ''
}, {
  schema: 'user',
  name: 'consented',
  order: 2,
  next: ['new', 'waiting-for-onboarding', 'on-hold'],
  afterHook: ''
}, {
  schema: 'user',
  name: 'waiting-for-onboarding',
  order: 3,
  next: ['consented', 'on-boarded', 'on-hold'],
  afterHook: ''
}, {
  schema: 'user',
  name: 'on-boarded',
  order: 4,
  next: ['waiting-for-onboarding', 'active-care', 'maintenance', 'on-hold'],
  afterHook: ''
}, {
  schema: 'user',
  name: 'active-care',
  order: 5,
  next: ['on-boarded', 'discharged', 'inactive', 'maintenance', 'on-hold'],
  afterHook: ''
}, {
  schema: 'user',
  name: 'maintenance',
  order: 6,
  next: ['on-boarded', 'discharged', 'inactive', 'active-care', 'on-hold'],
  afterHook: ''
}, {
  schema: 'user',
  name: 'discharged',
  order: 7,
  next: ['active-care', 'maintenance', 'inactive'],
  afterHook: ''
}, {
  schema: 'user',
  name: 'inactive',
  order: 8,
  next: ['discharged', 'new', 'consented', 'active-care', 'maintenance', 'waiting-for-onboarding', 'on-boarded'],
  afterHook: ''
}, {
  schema: 'user',
  name: 'on-hold',
  order: 9,
  next: ['waiting-for-onboarding', 'on-boarded', 'active-care', 'maintenance', 'discharged'],
  afterHook: ''
}];
const styles$8 = {
  cell: Object.assign({}, commonStyles$3),
  header: Object.assign(Object.assign({}, commonStyles$3), {
    backgroundColor: '#C4DFE0'
  }),
  headerMenu: Object.assign(Object.assign({}, commonStyles$3), {
    backgroundColor: '#C4DFE0',
    fontSize: 0
  }),
  headerCheckbox: Object.assign(Object.assign({}, commonStyles$3), {
    backgroundColor: '#C4DFE0',
    paddingRight: 0,
    fontSize: 0
  }),
  checkbox: {
    margin: 0,
    padding: 0
  },
  kitInfoModal: {
    position: 'absolute',
    top: '50%',
    display: 'flex',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    overflowY: 'auto',
    backgroundColor: 'white',
    padding: 20
  },
  outlineClearStyle: {
    borderRadius: '128px !important',
    width: '110px !important',
    height: '36px !important',
    border: '1px solid #102543',
    color: '#102543',
    backgroundColor: 'transparent'
  },
  outlineUnclearStyle: {
    borderRadius: '128px !important',
    width: '110px !important',
    height: '36px !important',
    border: '1px solid #506583',
    color: '#506583'
  },
  primaryStyle: {
    borderRadius: '128px !important',
    width: '110px !important',
    height: '36px !important',
    color: '#FFFFFF',
    backgroundColor: '#285E63'
  },
  errorStyle: {
    borderRadius: '128px !important',
    width: '110px !important',
    height: '36px !important',
    color: '#FFFFFF',
    backgroundColor: '#EB0000'
  },
  lowRiskStyle: {
    borderRadius: '128px !important',
    width: '110px !important',
    height: '36px !important',
    color: '##102543',
    backgroundColor: '#FFB23F'
  },
  bulkAction: {
    position: 'fixed',
    left: '50%',
    bottom: '20px',
    transform: 'translate(-50%, -50%)',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  bulkActionIconStyle: {
    width: '24px',
    height: '24px',
    color: '#FFFFFF',
    marginRight: '10px'
  }
};
const BulkActionButton = withStyles$2({
  root: {
    width: 'fit-content',
    height: '46px !important',
    color: '#FFFFFF',
    backgroundColor: '#0C3672',
    boxShadow: '0px 0px 10.3235px 1.14706px rgba(0, 0, 0, 0.12)',
    borderRadius: '148px',
    fontWeight: 300,
    fontSize: '18px',
    lineHeight: '23px',
    marginTop: '10px',
    '&:hover': {
      backgroundColor: '#2a4f84'
    }
  }
})(Button);
const patientsTableReducer = (state, action) => {
  switch (action.type) {
    case 'openRequestModal':
      return Object.assign(Object.assign({}, state), {
        kitPatientData: action.kitPatientData,
        requestModalOpen: true
      });
    case 'closeRequestModal':
      return Object.assign(Object.assign({}, state), {
        kitPatientData: undefined,
        requestModalOpen: false,
        submitLoading: false
      });
    case 'submitKitRequest':
      return Object.assign(Object.assign({}, state), {
        submitLoading: true
      });
    case 'submitKitRequestFailure':
      return Object.assign(Object.assign({}, state), {
        submitLoading: false
      });
    default:
      throw new Error('invalid action type');
  }
};
const PatientsTable = ({
  data,
  onClickItem,
  onSelected
}) => {
  var _a;
  const [renderData, setRenderData] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [unSelectedIds, setUnselectedIds] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [isInactiveOpen, setIsInactiveOpen] = useState(false);
  const [isBulkStateOpen, setIsBulkStateOpen] = useState(false);
  const [isConfirmRetrievalOpen, setIsConfirmRetrievalOpen] = useState(false);
  const [confirmRetrieve, setConfirmRetrieve] = useState(false);
  const [isOnHoldOpen, setIsOnHoldOpen] = useState(false);
  const [isOnHoldReasonOpen, setIsOnHoldReasonOpen] = useState(false);
  const [reasonForBulkOnHold, setReasonForBulkOnHold] = useState('');
  const [bulkState, setBulkState] = useState('');
  const [openNotes, setOpenNotes] = useState(false);
  const [openBulkAction, setOpenBulkAction] = useState(false);
  const [assignmentId, setAssignmentId] = useState('');
  const [patientId, setPatientId] = useState('');
  const [history, setHistory] = useState([]);
  const [dialogTitle, setDialogTitle] = useState('');
  const [openHistory, setOpenHistory] = useState(false);
  const [editData, setEditData] = useState();
  const [modalData, setModalData] = useState('');
  const [title, setTitle] = useState('');
  const [kitRetrievalRow, setKitRetrievalRow] = useState();
  const [actions, setActions] = useState();
  const [inactiveId, setInactiveId] = useState('');
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [removeWithPromptModal, setRemoveWithPromptModal] = useState(false);
  const [removePromptInput, setRemovePromptInput] = useState('');
  const [openModel, setOpenModel] = useState(false);
  const [patientToRemove, setPatientToRemove] = useState(null);
  const confirmationCallback = useCallback(() => {
    setConfirmRetrieve(prev => !prev);
  }, []);
  const [kitNumber, setKitNumber] = useState('');
  const [kitModelData, setKitModelData] = useState(null);
  const [kitData, setKitData] = useState();
  const [patientsTableState, dispatch] = useReducer(patientsTableReducer, {
    submitLoading: false,
    requestModalOpen: false,
    kitPatientData: undefined
  });
  const submitRef = useRef(null);
  const requestSubmitRef = useRef(null);
  const routing = useContext(PatientsPageRoutingContext);
  const {
    fetchToken,
    anonymousId,
    testMode,
    removeUser,
    updatePatientState,
    updatePatientStateBulk,
    bulkTestMode
  } = usePatients();
  const {
    fetchAssignment,
    kitAssignments
  } = useKitAssignment();
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  const {
    changeKitState,
    cancelRequest,
    getKitByAssignmentId
  } = useKit();
  const {
    kitModels
  } = useKitModels();
  const {
    trackUnreadNotesCount,
    unreadMap
  } = useLogisticsNotes();
  const pathname = useMemo(() => window.location.pathname, []);
  const handleReasonChange = useCallback(newReason => {
    setReasonForBulkOnHold(newReason);
  }, [setReasonForBulkOnHold]);
  const onCloseOnHold = useCallback(() => {
    setIsOnHoldOpen(false);
    setEditData(undefined);
  }, [setIsOnHoldOpen, setEditData]);
  const onCloseOnHoldReason = useCallback(() => {
    setIsOnHoldReasonOpen(false);
    setEditData(undefined);
  }, [setIsOnHoldReasonOpen, setEditData]);
  const onBulkStateChange = useCallback(newState => {
    if (newState === 'on-hold') {
      setIsOnHoldOpen(true);
    }
    setBulkState(newState);
    userMetrics.trackEvent('patients: change bulk patient state', {
      patients: selectedIds,
      state: newState
    });
  }, [setIsOnHoldOpen, setBulkState, userMetrics, selectedIds]);
  useEffect(() => {
    const urlSplit = pathname.split('/').filter(x => x !== '');
    if (urlSplit.length === 3 && urlSplit[1] === 'note') {
      const kitAssignmentId = urlSplit[2];
      const assignment = kitAssignments.find(assignment => assignment._id === kitAssignmentId);
      if (!assignment) {
        fetchAssignment(kitAssignmentId);
        return;
      }
      setPatientId(assignment.patientId);
      setAssignmentId(kitAssignmentId);
      getKitByAssignmentId(kitAssignmentId).then(x => {
        if (x) {
          setKitNumber(x.serialNumber || '');
        }
      });
      const nextState = {
        additionalInformation: 'Note Viewed, url cleared'
      };
      const newUrl = '/patients/';
      window.history.replaceState(nextState, 'Patients page', newUrl);
      setOpenNotes(true);
    }
  }, [pathname, fetchAssignment, kitAssignments]);
  useEffect(() => {
    const kitAssignmentIds = data.reduce((acc, patient) => {
      var _a, _b;
      if ((_a = patient.kit_assignment) === null || _a === void 0 ? void 0 : _a._id) acc.push((_b = patient.kit_assignment) === null || _b === void 0 ? void 0 : _b._id);
      return acc;
    }, []);
    trackUnreadNotesCount(kitAssignmentIds);
  }, [data, trackUnreadNotesCount]);
  useEffect(() => {
    const newData = data.map(patient => {
      var _a;
      const kitState = (patient === null || patient === void 0 ? void 0 : patient.kit) && (patient === null || patient === void 0 ? void 0 : patient.kit.state) || '';
      const patientStatus = patient.current_status ? patient.current_status : '';
      if (!kitState) {
        patient.kitStyle = styles$8.outlineUnclearStyle;
      } else if (['waiting-for-onboarding', 'assigned'].includes(kitState.toLowerCase())) {
        patient.kitStyle = styles$8.primaryStyle;
      } else if (['lost', 'requested'].includes(kitState.toLowerCase())) {
        patient.kitStyle = styles$8.errorStyle;
      } else {
        patient.kitStyle = styles$8.outlineUnclearStyle;
      }
      if (['new', 'waiting-for-onboarding', 'discharged'].includes((patient.state || '').toLowerCase())) {
        patient.patientStyle = styles$8.outlineUnclearStyle;
      } else {
        patient.patientStyle = styles$8.primaryStyle;
      }
      if (patientStatus === 1) {
        patient.healthStyle = styles$8.lowRiskStyle;
      } else if (patientStatus === 2) {
        patient.healthStyle = styles$8.errorStyle;
      } else {
        patient.healthStyle = styles$8.primaryStyle;
      }
      const kitModelId = (_a = patient.kit_assignment) === null || _a === void 0 ? void 0 : _a.kitModelId;
      const kitModel = getKitModelById(kitModelId) || undefined;
      patient.kitModel = kitModel;
      return patient;
    });
    if (isSelectAll) {
      let ids = selectedIds;
      newData.forEach(patient => {
        if (!ids.includes(patient._id) && !unSelectedIds.includes(patient._id)) {
          ids = ids.concat(patient._id);
        }
        return Object.assign(Object.assign({}, patient), {
          isSelected: true
        });
      });
      setSelectedIds(ids);
    } else {
      setIsSelectAll(false);
    }
    setRenderData(newData);
  }, [data, isSelectAll, selectedIds, unSelectedIds]);
  const handleRowSelected = patientId => {
    return event => {
      const isSelected = event.target.checked;
      let currentSelected = selectedIds;
      setRenderData(prevRenderData => prevRenderData.map(user => {
        if (user._id === patientId) {
          if (isSelected) {
            if (unSelectedIds.includes(patientId)) {
              const newIds = unSelectedIds.filter(userId => userId !== patientId);
              setUnselectedIds(newIds);
            }
            currentSelected = currentSelected.concat(user._id);
          } else {
            if (!unSelectedIds.includes(patientId)) {
              const newIds = unSelectedIds.concat(patientId);
              setUnselectedIds(newIds);
            }
            currentSelected = currentSelected.filter(userId => userId !== user._id);
          }
          return Object.assign(Object.assign({}, user), {
            isSelected: isSelected
          });
        }
        return user;
      }));
      onSelected(currentSelected);
      setSelectedIds(currentSelected);
    };
  };
  const handleSelectAll = event => {
    setRenderData(prevRenderData => prevRenderData.map(user => Object.assign(Object.assign({}, user), {
      isSelected: event.target.checked
    })));
    if (event.target.checked) {
      const allIds = renderData.map(user => user._id);
      setSelectedIds(allIds);
      onSelected(allIds);
      userMetrics.trackEvent('patients: select all patients in multiselect');
      setIsSelectAll(true);
    } else {
      setSelectedIds([]);
      onSelected([]);
      setUnselectedIds([]);
      setIsSelectAll(false);
      userMetrics.trackEvent('patients: deselect all patients in multiselect');
    }
  };
  const closemodalDataModal = () => {
    setModalData('');
    setActions(undefined);
    setModalOpen(false);
  };
  const getKitModelById = kitModelId => {
    if (!kitModelId) return null;
    return kitModels.find(model => model._id === kitModelId) || null;
  };
  const columns = [{
    label: jsxs(Fragment, {
      children: [jsx(Checkbox, {
        style: styles$8.checkbox,
        inputProps: {
          'aria-label': 'select all patients',
          role: 'checkbox'
        },
        onChange: handleSelectAll
      }), "Checkbox"]
    }),
    headerStyle: styles$8.headerCheckbox,
    rowStyle: styles$8.cell,
    dataKey: 'isSelected',
    dataFn: ({
      rowData
    }) => jsx(Checkbox, {
      style: styles$8.checkbox,
      inputProps: {
        'aria-label': rowData.fname + ' ' + rowData.lname
      },
      checked: !!selectedIds.includes(rowData._id),
      onChange: handleRowSelected(rowData._id)
    }),
    width: 40,
    flexShrink: 1,
    flexGrow: 0
  }, {
    label: localize('Patient'),
    dataFn: ({
      rowData
    }) => `${rowData.lname}, ${rowData.fname}`,
    width: 100,
    dataKey: 'name',
    headerStyle: styles$8.header,
    rowStyle: styles$8.cell
  }, {
    label: localize('Patient_Number'),
    dataKey: 'patientNumber',
    width: 75,
    headerStyle: styles$8.header,
    rowStyle: styles$8.cell
  }, {
    label: localize('ae_careplan_card_number'),
    dataKey: 'healthCardNumber',
    width: 100,
    headerStyle: styles$8.header,
    rowStyle: styles$8.cell
  }, {
    label: localize('Patient_State'),
    dataKey: 'patientState',
    width: 120,
    minWidth: 120,
    headerStyle: styles$8.header,
    rowStyle: styles$8.cell,
    dataFn: ({
      rowData
    }) => {
      let editState;
      if (rowData.state === 'on-hold') {
        editState = selectedIds.includes(rowData._id) && selectedIds.length === 1 ? jsx(Grid, Object.assign({
          item: true
        }, {
          children: jsx(Edit, {
            onClick: () => {
              userMetrics.trackEvent('patients: open on hold modal through pencil icon', {
                patient: rowData._id
              });
              setEditData(rowData);
              setIsOnHoldOpen(true);
            }
          })
        })) : null;
      } else {
        editState = selectedIds.includes(rowData._id) && selectedIds.length === 1 ? jsx(Grid, Object.assign({
          item: true
        }, {
          children: jsx(StateMenu, {
            title: localize('ChangePatient_State'),
            currentState: rowData === null || rowData === void 0 ? void 0 : rowData.state,
            states: patientStates,
            onChange: newState => {
              switch (newState) {
                case 'inactive':
                  setInactiveId(rowData._id);
                  setIsInactiveOpen(true);
                  break;
                case 'on-hold':
                  setEditData(rowData);
                  setIsOnHoldOpen(true);
                  break;
                default:
                  updatePatientState(rowData._id, newState);
              }
              userMetrics.trackEvent('patients: change patient state', {
                patient: rowData._id,
                state: newState
              });
            },
            localizationPrefix: 'Patient_States',
            showAll: true,
            icon: Edit
          })
        })) : null;
      }
      return jsxs(Grid, Object.assign({
        container: true,
        spacing: 1,
        alignItems: "center"
      }, {
        children: [jsx(Grid, Object.assign({
          item: true
        }, {
          children: rowData.state && jsx(Chip, {
            label: localize(`Patient_States.${rowData.state}`),
            style: rowData.patientStyle,
            onClick: () => {
              if (rowData.state === 'on-hold') {
                userMetrics.trackEvent('patients: open on hold reason modal', {
                  patient: rowData._id
                });
                setEditData(rowData);
                setIsOnHoldReasonOpen(true);
              }
            }
          })
        })), editState]
      }));
    }
  }, {
    label: localize('Health_Status'),
    dataKey: 'current_status',
    width: 50,
    minWidth: 130,
    headerStyle: styles$8.header,
    rowStyle: styles$8.cell,
    dataFn: ({
      rowData
    }) => {
      var _a;
      if (![0, 1, 2].includes(rowData.current_status)) return null;
      return jsx(Chip, {
        label: localize(((_a = ['group_user_overview_normal', 'group_user_overview_low', 'group_user_overview_high']) === null || _a === void 0 ? void 0 : _a[rowData.current_status]) || ''),
        style: rowData.healthStyle
      });
    }
  }, {
    label: localize('Kit_State'),
    dataKey: 'kitStatus',
    minWidth: 400,
    width: 200,
    headerStyle: styles$8.header,
    rowStyle: styles$8.cell,
    dataFn: ({
      rowData
    }) => {
      const {
        kit,
        kit_assignment,
        kitModel
      } = rowData;
      if (!kit && !kit_assignment) return null;
      return jsx(Grid, Object.assign({
        container: true,
        direction: "row",
        item: true,
        spacing: 3,
        xs: 12
      }, {
        children: jsxs(Grid, Object.assign({
          item: true,
          xs: 10,
          alignItems: "center",
          container: true
        }, {
          children: [jsx(Grid, Object.assign({
            item: true,
            xs: 4
          }, {
            children: jsx(Chip, {
              label: kit_assignment && !kit ? localize(`Kit_States.requested`) : localize(`Kit_States.${kit.state}`),
              style: Object.assign({}, kit_assignment && !kit ? styles$8.errorStyle : rowData.kitStyle)
            })
          })), kitModel !== undefined ? jsxs(Grid, Object.assign({
            item: true,
            xs: 8,
            container: true,
            alignItems: "center",
            style: {
              paddingLeft: 4
            }
          }, {
            children: [jsx(Tooltip, Object.assign({
              title: localize('Kit_Model')
            }, {
              children: jsx(IconButton, Object.assign({
                "aria-label": localize('Kit_Model'),
                onClick: () => {
                  setKitModelData(kitModel);
                  setKitData(kit);
                  setOpenModel(true);
                }
              }, {
                children: jsx(Info, {})
              }))
            })), jsx(Modal, Object.assign({
              open: openModel,
              onClose: () => setOpenModel(false),
              BackdropProps: {
                style: {
                  backgroundColor: 'rgba(0, 0, 0, 0.15)'
                }
              }
            }, {
              children: jsxs(Paper, Object.assign({
                style: styles$8.kitInfoModal
              }, {
                children: [jsx(IconButton, Object.assign({
                  "aria-label": "close",
                  onClick: () => setOpenModel(false),
                  style: {
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    backgroundColor: 'white'
                  }
                }, {
                  children: jsx(CloseIcon, {
                    color: "primary",
                    "aria-label": "Close Button"
                  })
                })), kitModelData && jsx(KitInfoDisplay, {
                  KitModel: kitModelData,
                  Kit: kitData !== null && kitData !== void 0 ? kitData : undefined
                })]
              }))
            })), jsx(Grid, {
              children: jsx(Grid, Object.assign({
                container: true,
                spacing: 1,
                alignItems: "center"
              }, {
                children: jsx(SimplifiedKitStatus, {
                  assignmentId: kit_assignment._id,
                  kitHistory: (kit === null || kit === void 0 ? void 0 : kit.stateHistory) || [],
                  localize: localize,
                  noteCallback: () => {
                    setKitNumber((kit === null || kit === void 0 ? void 0 : kit.serialNumber) || '');
                    setAssignmentId(kit_assignment._id);
                    setPatientId(kit_assignment.patientId);
                    setOpenNotes(true);
                  },
                  historyCallback: history => {
                    setDialogTitle(localize('Kit_State_History'));
                    setHistory(history);
                    setOpenHistory(true);
                  },
                  unreadMap: unreadMap,
                  userMetrics: userMetrics
                })
              }))
            })]
          })) : null]
        }))
      }));
    }
  }, {
    label: localize('Patient_Menu'),
    dataKey: 'patientMenu',
    width: 60,
    flexGrow: 0,
    flexShrink: 1,
    dataFn: ({
      rowData
    }) => {
      var _a, _b;
      let showToken = true;
      if (rowData.state === 'inactive') showToken = false;
      if (rowData.type.includes('user:mobile') && !rowData.type.includes('login:none')) showToken = false;
      const menuItems = [jsxs(MenuItem$1, Object.assign({
        onClick: () => {
          userMetrics.trackEvent('patients: open edit patient popup', {
            patient: rowData._id
          });
          setEditData(rowData);
          setEditModalOpen(true);
        }
      }, {
        children: [jsx(Edit, {}), jsx(Typography, Object.assign({
          style: {
            textTransform: 'capitalize'
          }
        }, {
          children: localize('common.edit')
        }))]
      }), localize('common.edit')), rowData.state !== 'inactive' && jsxs(MenuItem$1, Object.assign({
        onClick: () => {
          userMetrics.trackEvent('patients: toggle testmode for patient', {
            value: !rowData.testModeEnabled || false ? 'on' : 'off',
            patient: rowData._id
          });
          if (rowData.testModeEnabled) {
            setTitle(localize('testmode.title'));
            setModalData(localize(`testmode.disable_confirmation`));
            setActions([jsx(Button, Object.assign({
              onClick: () => {
                userMetrics.trackEvent('patients: toggle test mode', {
                  patient: rowData._id
                });
                testMode(rowData._id, !rowData.testModeEnabled || false);
                closemodalDataModal();
              }
            }, {
              children: localize('testmode.proceed')
            }), 'proceed'), jsx(Button, Object.assign({
              onClick: closemodalDataModal
            }, {
              children: localize('testmode.cancel')
            }), "cancel")]);
            setModalOpen(true);
          } else {
            setTitle(localize(`testmode.title`));
            setModalData(localize(`testmode.enable_confirmation`));
            setActions([jsx(Button, Object.assign({
              onClick: () => {
                userMetrics.trackEvent('patients: toggle test mode', {
                  patient: rowData._id
                });
                testMode(rowData._id, !rowData.testModeEnabled || false);
                closemodalDataModal();
              }
            }, {
              children: localize('testmode.proceed')
            }), 'proceed'), jsx(Button, Object.assign({
              onClick: closemodalDataModal
            }, {
              children: localize('testmode.cancel')
            }), "cancel")]);
            setModalOpen(true);
          }
        }
      }, {
        children: [jsx(BugReport, {}), jsx(Typography, Object.assign({
          style: {
            textTransform: 'capitalize'
          }
        }, {
          children: rowData.testModeEnabled ? localize('testmode.disable') : localize('testmode.enable')
        }))]
      }), localize('testmode.enable')), jsx("div", {
        children: showToken ? jsxs(MenuItem$1, Object.assign({
          onClick: () => __awaiter(void 0, void 0, void 0, function* () {
            const token = yield fetchToken(rowData._id);
            setTitle(localize('users_token_title'));
            setModalData(`${localize('users_token_message')} ${token.token}`);
            setModalOpen(true);
            userMetrics.trackEvent('patients: open token popup', {
              patient: rowData._id,
              token: token.token
            });
          })
        }, {
          children: [jsx(Lock, {}), jsx(Typography, Object.assign({
            style: {
              textTransform: 'capitalize'
            }
          }, {
            children: localize('users_token_title')
          }))]
        }), localize('users_token_title')) : null
      }, localize('users_token_title')), jsxs(MenuItem$1, Object.assign({
        onClick: () => {
          const anonID = anonymousId(rowData._id);
          setTitle(localize('anonymous_id_title'));
          setModalData(`${localize('anonymous_id_text')} ${anonID}`);
          setModalOpen(true);
          userMetrics.trackEvent('patients: open anonymous id popup', {
            patient: rowData._id,
            anonID
          });
        }
      }, {
        children: [jsx(Person, {}), jsx(Typography, Object.assign({
          style: {
            textTransform: 'capitalize'
          }
        }, {
          children: localize('anonymous_id_title')
        }))]
      }), localize('anonymous_id_title')), jsxs(MenuItem$1, Object.assign({
        onClick: () => {
          userMetrics.trackEvent('patients: navigate to patient overview page', {
            patient: rowData._id
          });
          if (routing && routing.history) routing.history.push('/user-overview/' + rowData._id);
        }
      }, {
        children: [jsx(PermIdentity, {}), jsx(Typography, Object.assign({
          style: {
            textTransform: 'capitalize'
          }
        }, {
          children: localize('user_overview')
        }))]
      }), `${rowData.fname}_${rowData.lname}_overview`), jsxs(Fragment, {
        children: [!rowData.kit && !['inactive', 'new'].includes(rowData.state || 'new') && jsxs(MenuItem$1, Object.assign({
          onClick: () => {
            userMetrics.trackEvent('patients: open request kit popup', {
              patient: rowData._id
            });
            dispatch({
              type: 'openRequestModal',
              kitPatientData: rowData
            });
          }
        }, {
          children: [jsx(LocalHospital, {}), jsx(Typography, Object.assign({
            style: {
              textTransform: 'capitalize'
            }
          }, {
            children: rowData.kit_assignment ? localize('Kit_States.view_request_kit') : localize('Kit_States.request_kit')
          }))]
        }), "Request Kit"), (((_a = rowData.kit) === null || _a === void 0 ? void 0 : _a.state) === 'received' || ((_b = rowData.kit) === null || _b === void 0 ? void 0 : _b.state) === 'setup') && jsxs(MenuItem$1, Object.assign({
          onClick: () => {
            userMetrics.trackEvent('patients: retrieve kit', {
              patient: rowData._id
            });
            if (rowData.kit) {
              setKitRetrievalRow(rowData);
              setIsConfirmRetrievalOpen(true);
            }
          }
        }, {
          children: [jsx(Reply, {}), jsx(Typography, Object.assign({
            style: {
              textTransform: 'capitalize'
            }
          }, {
            children: localize('Retrieve_Kit')
          }))]
        }), "Retrieve Kit"), rowData.kit_assignment && !rowData.kit && jsxs(MenuItem$1, Object.assign({
          onClick: () => {
            if (rowData.kit_assignment) {
              cancelRequest(rowData.kit_assignment._id);
              userMetrics.trackEvent('patients: cancel kit request', {
                patient: rowData._id
              });
            }
          }
        }, {
          children: [jsx(DeleteForever, {}), jsx(Typography, Object.assign({
            style: {
              textTransform: 'capitalize'
            }
          }, {
            children: localize('Kit_States.cancel_kit_request')
          }))]
        }), "Cancel Kit Request")]
      }), jsx("div", {
        children: rowData.state !== 'inactive' && rowData.state !== 'discharged' && jsxs(MenuItem$1, Object.assign({
          onClick: () => {
            setEditData(rowData);
            setIsOnHoldOpen(true);
          }
        }, {
          children: [jsx(HourglassEmpty, {}), jsx(Typography, {
            children: rowData.state === 'on-hold' ? localize('OnHold.set_off_hold') : localize('OnHold.set_on_hold')
          })]
        }), 'onHoldMenuItem')
      }, 'On-Hold'), jsxs(MenuItem$1, Object.assign({
        onClick: () => {
          userMetrics.trackEvent('patients: open remove patient popup', {
            patient: rowData._id
          });
          if (rowData.type.includes('user:mobile')) {
            setTitle(localize('users_remove'));
            setModalData(`Are you sure you wish to delete ${rowData.fname} ${rowData.lname}?`);
            setActions([jsx(Button, Object.assign({
              onClick: () => {
                userMetrics.trackEvent('patients: remove patient', {
                  patient: rowData._id
                });
                removeUser(rowData._id);
                closemodalDataModal();
              }
            }, {
              children: "OK"
            }), 'okay'), jsx(Button, Object.assign({
              onClick: closemodalDataModal
            }, {
              children: "CANCEL"
            }), "cancel")]);
            setModalOpen(true);
          } else {
            setRemoveWithPromptModal(true);
            setPatientToRemove(rowData);
          }
        }
      }, {
        children: [jsx(Remove, {}), jsxs(Typography, Object.assign({
          style: {
            textTransform: 'capitalize'
          }
        }, {
          children: [localize('common.remove'), " ", localize('Patient')]
        }), 'Does this work!')]
      }), localize('common.remove'))];
      return jsx(IconButtonMenu, Object.assign({
        hoverLabel: `${rowData === null || rowData === void 0 ? void 0 : rowData.fname} ${rowData === null || rowData === void 0 ? void 0 : rowData.lname} Menu`,
        icon: MoreVert,
        onOpen: () => userMetrics.trackEvent('patients: open patient menu', {
          patient: rowData._id
        }),
        onClose: () => userMetrics.trackEvent('patients: close patient menu', {
          patient: rowData._id
        })
      }, {
        children: menuItems
      }));
    },
    headerStyle: styles$8.headerMenu,
    rowStyle: styles$8.cell
  }];
  return jsx(Grid, Object.assign({
    container: true,
    style: {
      overflowX: 'auto',
      overflowY: 'hidden',
      width: '100%'
    }
  }, {
    children: jsx(Grid, Object.assign({
      item: true,
      xs: 12,
      style: {
        minWidth: '1200px'
      }
    }, {
      children: jsxs(ThemeProvider, Object.assign({
        theme: DashboardsTheme
      }, {
        children: [jsx(InactiveWarning, {
          onClose: () => setIsInactiveOpen(false),
          isOpen: isInactiveOpen,
          id: inactiveId
        }), jsx(OnHold, {
          onClose: onCloseOnHold,
          isOpen: isOnHoldOpen,
          user: editData,
          updateReason: handleReasonChange,
          requestKitOpen: () => {
            editData === null || editData === void 0 ? true : delete editData.kit_assignment;
            dispatch({
              type: 'openRequestModal',
              kitPatientData: editData || {}
            });
          }
        }), jsx(OnHoldReason, {
          onClose: onCloseOnHoldReason,
          isOpen: isOnHoldReasonOpen,
          user: editData
        }), jsx(Notes, {
          assignmentId: assignmentId,
          patient: patientId,
          open: openNotes,
          onCloseCallback: () => {
            setOpenNotes(false);
            userMetrics.trackEvent('patients: close logistics notes popup');
          }
        }), jsx(ActionDialog, Object.assign({
          title: dialogTitle,
          actions: [],
          open: openHistory,
          onClose: () => {
            setOpenHistory(false);
            setHistory([]);
          }
        }, {
          children: jsx(StateHistory, {
            data: history,
            theme: LogisticsTheme,
            tableWidth: 300
          })
        })), jsx(ActionDialog, Object.assign({
          title: localize('group_users_multiselection_change_managegroups_title'),
          open: openBulkAction,
          onClose: () => {
            setSelectedIds([]);
            setOpenBulkAction(false);
          },
          reactKey: localize('group_users_multiselection_change_managegroups_title'),
          actions: [jsx(Button, Object.assign({
            onClick: () => {
              userMetrics.trackEvent('patients: close bulk action popup');
              setSelectedIds([]);
              setOpenBulkAction(false);
            }
          }, {
            children: localize('SectionEditor_Done')
          }), localize('SectionEditor_Done'))]
        }, {
          children: jsx(ChangePatientGroups, {
            selectedPatients: selectedIds
          })
        })), jsx(ActionDialog, Object.assign({
          actions: [jsx(Button, Object.assign({
            disabled: !!((_a = patientsTableState.kitPatientData) === null || _a === void 0 ? void 0 : _a.kit_assignment) || patientsTableState.submitLoading,
            variant: "contained",
            color: "primary",
            type: "submit",
            onClick: () => {
              var _a, _b;
              userMetrics.trackEvent('patients: submit kit request', {
                patient: (_a = patientsTableState.kitPatientData) === null || _a === void 0 ? void 0 : _a._id
              });
              (_b = requestSubmitRef === null || requestSubmitRef === void 0 ? void 0 : requestSubmitRef.current) === null || _b === void 0 ? void 0 : _b.dispatchEvent(new Event('submit', {
                cancelable: true
              }));
            }
          }, {
            children: localize('common.submit')
          }), "Submit"), jsx(Button, Object.assign({
            disabled: patientsTableState.submitLoading,
            onClick: () => {
              var _a;
              userMetrics.trackEvent('patients: close kit request popup', {
                patient: (_a = patientsTableState.kitPatientData) === null || _a === void 0 ? void 0 : _a._id
              });
              dispatch({
                type: 'closeRequestModal'
              });
            }
          }, {
            children: localize('users_cancel')
          }), localize('users_cancel'))],
          title: 'Request Kit',
          open: patientsTableState.requestModalOpen,
          onClose: (event, reason) => {
            if (reason !== 'backdropClick') {
              dispatch({
                type: 'closeRequestModal'
              });
            }
          },
          showLoading: patientsTableState.submitLoading
        }, {
          children: jsx(Request, {
            user: patientsTableState.kitPatientData,
            submitRef: requestSubmitRef,
            onClosed: () => {
              dispatch({
                type: 'closeRequestModal'
              });
            },
            handleSubmitRequest: () => {
              dispatch({
                type: 'submitKitRequest'
              });
            },
            handleSubmitRequestFailure: () => {
              dispatch({
                type: 'submitKitRequestFailure'
              });
            }
          })
        })), jsx(ActionDialog, Object.assign({
          title: title,
          open: modalOpen,
          onClose: closemodalDataModal,
          reactKey: title,
          actions: actions
        }, {
          children: jsx(Typography, Object.assign({
            style: {
              userSelect: 'text'
            }
          }, {
            children: modalData
          }))
        })), jsxs(ActionDialog, Object.assign({
          title: `${localize('common.remove')} ${patientToRemove === null || patientToRemove === void 0 ? void 0 : patientToRemove.fname} ${patientToRemove === null || patientToRemove === void 0 ? void 0 : patientToRemove.lname}`,
          open: removeWithPromptModal,
          reactKey: localize('common.remove'),
          actions: [jsx(Button, Object.assign({
            onClick: () => {
              userMetrics.trackEvent('patients: close remove patient popup');
              setPatientToRemove(null);
              setRemovePromptInput('');
              setRemoveWithPromptModal(false);
            }
          }, {
            children: localize('users_cancel')
          }), "cancel")].concat(...(removePromptInput === localize('permanently_delete') ? [jsx(Button, Object.assign({
            onClick: () => {
              userMetrics.trackEvent('patients: permanently delete patient', {
                patient: patientToRemove === null || patientToRemove === void 0 ? void 0 : patientToRemove._id
              });
              patientToRemove && removeUser(patientToRemove._id);
              setPatientToRemove(null);
              setRemovePromptInput('');
              setRemoveWithPromptModal(false);
            }
          }, {
            children: localize('common.remove')
          }), localize('common.remove'))] : []))
        }, {
          children: [jsx("p", {
            children: localize('delete_ata_patient')
          }), jsxs("p", {
            children: [localize('delete_prompt_help'), jsxs("b", {
              children: [" ", localize('permanently_delete')]
            })]
          }), jsx(TextField, {
            "test-id": 'permanently_delete_textfield',
            fullWidth: true,
            onChange: e => setRemovePromptInput(e.target.value)
          }, 'permanently_delete_prompt')]
        })), jsx(ActionDialog, Object.assign({
          title: localize('ChangePatient_State'),
          open: isBulkStateOpen,
          onClose: () => setIsBulkStateOpen(false),
          reactKey: localize('ChangePatient_State'),
          actions: [jsx(Button, Object.assign({
            type: "submit",
            onClick: () => {
              userMetrics.trackEvent('patients: bulk change patient state', {
                patients: selectedIds,
                state: bulkState
              });
              updatePatientStateBulk(selectedIds, bulkState, reasonForBulkOnHold);
              setSelectedIds([]);
              setIsBulkStateOpen(false);
              setReasonForBulkOnHold('');
              setBulkState('');
            }
          }, {
            children: localize('common.save')
          }), localize('common.save')), jsx(Button, Object.assign({
            onClick: () => {
              userMetrics.trackEvent('patients: cancel bulk change patient state');
              setIsBulkStateOpen(false);
            }
          }, {
            children: localize('users_cancel')
          }), "cancel")]
        }, {
          children: jsxs(Grid, Object.assign({
            container: true,
            direction: "row",
            alignItems: "center"
          }, {
            children: [jsxs(Typography, Object.assign({
              style: {
                userSelect: 'text'
              }
            }, {
              children: [localize('ChangePatient_State'), ":"]
            })), jsx(Typography, Object.assign({
              style: {
                userSelect: 'text',
                fontWeight: 'bold',
                marginLeft: '10px'
              }
            }, {
              children: bulkState
            })), jsx(StateMenu, {
              title: localize('ChangePatient_State'),
              currentState: '',
              states: patientStates,
              onChange: onBulkStateChange,
              showAll: true,
              icon: Edit
            })]
          }))
        })), jsx(ActionDialog, Object.assign({
          title: localize('users_edit'),
          open: editModalOpen,
          onClose: (event, reason) => {
            if (reason !== 'backdropClick') {
              setEditModalOpen(false);
            }
          },
          reactKey: localize('users_edit'),
          actions: [jsx(Button, Object.assign({
            type: "submit",
            onClick: () => {
              var _a;
              userMetrics.trackEvent('patients: edit patient', {
                patient: editData === null || editData === void 0 ? void 0 : editData._id
              });
              (_a = submitRef === null || submitRef === void 0 ? void 0 : submitRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new Event('submit', {
                cancelable: true
              }));
            }
          }, {
            children: localize('common.save')
          }), localize('common.save')), jsx(Button, Object.assign({
            onClick: () => {
              userMetrics.trackEvent('patients: close edit patient popup');
              setEditModalOpen(false);
            }
          }, {
            children: localize('users_cancel')
          }), "cancel")]
        }, {
          children: jsx(PatientCreation, {
            user: editData,
            submitRef: submitRef,
            onClose: () => setEditModalOpen(false)
          })
        })), jsx(ActionDialog, Object.assign({
          open: isConfirmRetrievalOpen,
          title: localize('Confirm_Kit_Retrieval'),
          onClose: () => {
            setKitRetrievalRow(undefined);
            setIsConfirmRetrievalOpen(false);
          },
          actions: [jsx(Button, Object.assign({
            onClick: () => {
              setKitRetrievalRow(undefined);
              setIsConfirmRetrievalOpen(false);
            }
          }, {
            children: localize('generic_cancel')
          }), "cancel"), jsx(Button, Object.assign({
            disabled: !confirmRetrieve,
            onClick: () => {
              var _a;
              if ((_a = kitRetrievalRow === null || kitRetrievalRow === void 0 ? void 0 : kitRetrievalRow.kit) === null || _a === void 0 ? void 0 : _a._id) {
                changeKitState(kitRetrievalRow.kit._id, 'return-prep');
                updatePatientState(kitRetrievalRow._id, 'discharged');
              }
              setKitRetrievalRow(undefined);
              setIsConfirmRetrievalOpen(false);
            }
          }, {
            children: localize('Retrieve_Kit')
          }), "retrieve")]
        }, {
          children: jsxs(Grid, Object.assign({
            container: true,
            spacing: 2
          }, {
            children: [jsx(Grid, Object.assign({
              item: true,
              xs: 12
            }, {
              children: jsx(Typography, {
                children: `
                  ${localize('Retrieve_Kit_From')} ${kitRetrievalRow === null || kitRetrievalRow === void 0 ? void 0 : kitRetrievalRow.fname} ${kitRetrievalRow === null || kitRetrievalRow === void 0 ? void 0 : kitRetrievalRow.lname}?`
              })
            })), jsxs(Grid, Object.assign({
              container: true,
              item: true,
              xs: 12
            }, {
              children: [jsx(Grid, Object.assign({
                item: true,
                xs: 1
              }, {
                children: jsx(Checkbox, {
                  checked: confirmRetrieve,
                  onChange: confirmationCallback
                })
              })), jsx(Grid, Object.assign({
                item: true,
                xs: 11
              }, {
                children: jsx(Typography, {
                  children: localize('Retrieve_Kit_Confirm')
                })
              }))]
            }))]
          }))
        })), jsx(VirtualizedTable, {
          rowCount: renderData.length,
          rowGetter: ({
            index
          }) => renderData[index],
          headerHeight: 50,
          columns: columns
        }), selectedIds.length > 1 && jsxs("div", Object.assign({
          style: styles$8.bulkAction
        }, {
          children: [jsxs(BulkActionButton, Object.assign({
            variant: "contained",
            onClick: () => {
              userMetrics.trackEvent('patients: open bulk change patient groups popup', {
                patients: selectedIds
              });
              setOpenBulkAction(true);
            }
          }, {
            children: [jsx(SupervisorAccountIcon, {
              style: styles$8.bulkActionIconStyle
            }), localize('testmode.patient_group')]
          })), selectedIds.length > 1 && jsxs(BulkActionButton, Object.assign({
            variant: "contained",
            onClick: () => {
              userMetrics.trackEvent('patients: open bulk change patient state popup', {
                patients: selectedIds
              });
              setIsBulkStateOpen(true);
            }
          }, {
            children: [jsx(BugReportIcon, {
              style: styles$8.bulkActionIconStyle
            }), localize('testmode.patient_state')]
          })), jsxs(BulkActionButton, Object.assign({
            variant: "contained",
            onClick: () => {
              userMetrics.trackEvent('patients: bulk enable test mode', {
                patients: selectedIds
              });
              bulkTestMode(selectedIds, true);
              setSelectedIds([]);
            }
          }, {
            children: [jsx(BugReportIcon, {
              style: styles$8.bulkActionIconStyle
            }), localize('testmode.turnon')]
          })), jsxs(BulkActionButton, Object.assign({
            variant: "contained",
            onClick: () => {
              userMetrics.trackEvent('patients: bulk disable test mode', {
                patients: selectedIds
              });
              setTitle(localize('testmode.title'));
              setModalData(localize('testmode.description'));
              setActions([jsx(Button, Object.assign({
                onClick: () => {
                  userMetrics.trackEvent('patients: turn off test mode', {
                    patients: selectedIds
                  });
                  bulkTestMode(selectedIds, false);
                  setSelectedIds([]);
                  closemodalDataModal();
                }
              }, {
                children: "OK"
              }), 'okay'), jsx(Button, Object.assign({
                onClick: closemodalDataModal
              }, {
                children: "CANCEL"
              }), "cancel")]);
              setModalOpen(true);
            }
          }, {
            children: [jsx(BugReportIcon, {
              style: styles$8.bulkActionIconStyle
            }), localize('testmode.turnoff')]
          }))]
        }))]
      }))
    }))
  }));
};

const CreatePatientModal = ({
  open,
  onCloseModal
}) => {
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  const submitRef = useRef(null);
  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      onCloseModal();
    }
  };
  return jsx(ActionDialog, Object.assign({
    title: localize('users_create_new'),
    onClose: handleClose,
    open: open,
    actions: [jsx(Button, Object.assign({
      type: "submit",
      onClick: () => {
        var _a;
        userMetrics.trackEvent('patients: create new patient');
        (_a = submitRef === null || submitRef === void 0 ? void 0 : submitRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new Event('submit', {
          cancelable: true
        }));
      }
    }, {
      children: localize('users_create_new')
    }), localize('users_create_new')), jsx(Button, Object.assign({
      onClick: onCloseModal
    }, {
      children: localize('users_cancel')
    }), "cancel")]
  }, {
    children: jsx(PatientCreation, {
      submitRef: submitRef,
      onClose: onCloseModal
    })
  }), 'CreatePatientModal');
};

const StyledInfiniteScroll$1 = styled(InfiniteScroll)(({
  smallDevice
}) => ({
  padding: smallDevice ? '20px 15vh' : '20px 5vh'
}));
const PageContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column'
});
const TextFieldContainer = styled('div')({
  width: '85%'
});
const StyledButton = styled(Button$1)({
  fontFamily: 'Poppins',
  textTransform: 'none',
  fontWeight: 400,
  height: '35px'
});
const StyledShortButton = styled(Button$1)({
  fontFamily: 'Poppins',
  textTransform: 'none',
  fontWeight: 400,
  maxHeight: '40px'
});
const TopControlsContainer = styled('div')({
  display: 'flex',
  flex: 1
});
const ButtonContainer = styled('div')({
  justifyContent: 'flex-end',
  display: 'flex',
  flex: 1
});
const FiltersContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  flex: 1,
  margin: '15px 0px'
});
const Patients = () => {
  const [open, setOpen] = React__default.useState(false);
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  const {
    users,
    manageGroup = [],
    userStates = [],
    kitStates = [],
    patientStatus = [],
    apiResponse,
    isLoading,
    nextPage,
    setQueryFilter,
    setKitStatesFilter,
    setManageGroupFilter,
    setUserStateFilter,
    setPatientStatusFilter,
    resetApiResponse
  } = usePatients();
  const {
    rawPatientGroupData
  } = usePatientGroup();
  const patientGroupData = rawPatientGroupData.map(group => ({
    text: group.name,
    value: group._id
  }));
  const activeUserStateOptions = [{
    value: 'new',
    text: localize('Patient_States.new')
  }, {
    value: 'consented',
    text: localize('Patient_States.consented')
  }, {
    value: 'waiting-for-onboarding',
    text: localize('Patient_States.waiting-for-onboarding')
  }, {
    value: 'on-boarded',
    text: localize('Patient_States.on-boarded')
  }, {
    value: 'active-care',
    text: localize('Patient_States.active-care')
  }, {
    value: 'maintenance',
    text: localize('Patient_States.maintenance')
  }, {
    value: 'on-hold',
    text: localize('Patient_States.on-hold')
  }, {
    value: 'discharged',
    text: localize('Patient_States.discharged')
  }];
  const activeStates = activeUserStateOptions.map(option => option.value.toString());
  const stateFilterOptions = [{
    value: 'all_active',
    text: localize('Patient_States.All_Active')
  }, ...activeUserStateOptions, {
    value: 'inactive',
    text: localize('Patient_States.inactive')
  }];
  const kitStatesFilterOptions = [{
    value: 'requested',
    text: localize('Kit_States.requested')
  }, {
    value: 'assigned',
    text: localize('Kit_States.assigned')
  }, {
    value: 'shipping',
    text: localize('Kit_States.shipping')
  }, {
    value: 'received',
    text: localize('Kit_States.received')
  }, {
    value: 'setup',
    text: localize('Kit_States.setup')
  }, {
    value: 'return-prep',
    text: localize('Kit_States.return-prep')
  }, {
    value: 'returning',
    text: localize('Kit_States.returning')
  }, {
    value: 'returned',
    text: localize('Kit_States.returned')
  }, {
    value: 'lost',
    text: localize('Kit_States.lost')
  }];
  const healthStatusFilterOptions = [{
    value: 0,
    text: localize('group_user_overview_normal')
  }, {
    value: 1,
    text: localize('group_user_overview_low')
  }, {
    value: 2,
    text: localize('group_user_overview_high')
  }];
  const isLaptop = useMediaQuery('(min-width:1024px)');
  const getUserStateFilterUpdate = (currentTarget, prevStates, currStates) => {
    const currHasAllActive = currStates.includes('all_active');
    const prevHadAllActive = prevStates.includes('all_active');
    const currHasInactive = currStates.includes('inactive');
    const checkedActive = !prevHadAllActive && currHasAllActive;
    const uncheckedActive = prevHadAllActive && !currHasAllActive;
    const result = currHasInactive ? ['inactive'] : [];
    if (uncheckedActive) return result;
    if (checkedActive) {
      result.push('all_active');
      return result;
    }
    // if "all_active" is currently checked and an active state is clicked, then the "all_active"
    // checkbox should be unchecked, as well as the active state that was clicked.
    const isActiveState = currentTarget.getAttribute('data-active-state');
    if (currHasAllActive && isActiveState) {
      const selectedState = currentTarget.getAttribute('data-value');
      return activeStates.filter(userState => userState !== selectedState).concat(result);
    }
    return currStates;
  };
  const clearFilters = () => {
    userMetrics.trackEvent("logistics: clear filters");
    setQueryFilter('');
    setKitStatesFilter([]);
    setManageGroupFilter([]);
    setUserStateFilter([]);
    setPatientStatusFilter([]);
  };
  const renderUserStateOptions = () => {
    const isActiveState = userState => activeStates.includes(userState);
    const isChecked = userState => {
      const shouldCheckActiveStates = userStates.includes('all_active');
      if (shouldCheckActiveStates && isActiveState(userState)) return true;
      return userStates.includes(userState);
    };
    return stateFilterOptions.map(({
      value: userState,
      text
    }) => {
      const dataAttrs = {};
      if (isActiveState(userState)) dataAttrs['data-active-state'] = true;
      if (userState === 'all_active') dataAttrs['data-all_active'] = true;
      return jsxs(MenuItem, Object.assign({
        value: userState
      }, dataAttrs, {
        children: [jsx(Checkbox, Object.assign({
          checked: isChecked(userState)
        }, dataAttrs)), jsx(ListItemText, {
          primary: text
        })]
      }), userState);
    });
  };
  const debouncedSetUserStateFilter = React__default.useMemo(() => debounce(setUserStateFilter, 300), [setUserStateFilter]);
  const table = () => {
    if (isLoading && users.length === 0) return jsx("div", Object.assign({
      style: {
        display: 'flex',
        justifyContent: 'center',
        color: 'primary'
      }
    }, {
      children: jsx(SpinningIcon, {
        icon: Sync,
        spinning: true,
        hoverLabel: "Loading"
      })
    }));else if (users.length === 0 && !isLoading) return jsx(Typography, Object.assign({
      component: 'p',
      variant: "body1",
      align: "center"
    }, {
      children: "No patients found"
    }));else return jsx(PatientsTable, {
      data: users,
      onClickItem: () => {
        console.info('Not implemented');
      },
      onSelected: () => {
        console.info('Not implemented');
      }
    });
  };
  return jsxs(ThemeProvider$2, Object.assign({
    theme: DashboardsTheme
  }, {
    children: [jsxs(StyledInfiniteScroll$1, Object.assign({
      smallDevice: isLaptop,
      loadMore: nextPage
    }, {
      children: [jsx(CreatePatientModal, {
        open: open,
        onCloseModal: () => {
          userMetrics.trackEvent("patients: close add patient modal");
          setOpen(false);
        }
      }), jsxs(PageContainer, {
        children: [jsxs(TopControlsContainer, {
          children: [jsx(TextFieldContainer, {
            children: jsx(SearchBar, {
              id: 'search-patients',
              testId: 'search-patients',
              width: "100%",
              placeholder: localize('search_onNameorpatientNum'),
              theme: DashboardsTheme,
              onChange: event => {
                var _a;
                setQueryFilter((_a = event.target) === null || _a === void 0 ? void 0 : _a.value);
              }
            })
          }), jsx(ButtonContainer, {
            children: jsx(StyledButton, Object.assign({
              color: "primary",
              variant: "contained",
              startIcon: jsx(Add, {
                style: {
                  color: 'white'
                }
              }),
              "aria-label": "add patient",
              onClick: () => {
                userMetrics.trackEvent("patients: open add patient modal");
                setOpen(true);
              },
              style: {
                whiteSpace: 'nowrap'
              }
            }, {
              children: localize('add_patient')
            }))
          })]
        }), jsxs(FiltersContainer, {
          children: [jsx(TextMultiSelect, Object.assign({
            options: stateFilterOptions,
            onChange: event => {
              const values = event.target.value;
              if (!(event.currentTarget instanceof Element)) return;
              const currentTarget = event.currentTarget;
              const newState = getUserStateFilterUpdate(currentTarget, userStates, values);
              debouncedSetUserStateFilter(newState);
              userMetrics.trackEvent("logistics: filter by state", {
                state: newState
              });
            },
            renderOptions: renderUserStateOptions,
            value: userStates,
            size: 'm',
            ariaLabel: localize('State')
          }, {
            children: localize('State')
          })), jsx(TextMultiSelect, Object.assign({
            options: patientGroupData,
            onChange: event => {
              const group = event.target.value;
              setManageGroupFilter(group);
              userMetrics.trackEvent("logistics: filter by group", {
                group: group
              });
            },
            value: manageGroup,
            size: 'm',
            ariaLabel: localize('dashboards_group')
          }, {
            children: localize('dashboards_group')
          })), jsx(TextMultiSelect, Object.assign({
            options: kitStatesFilterOptions,
            onChange: event => {
              const value = event.target.value;
              setKitStatesFilter(value);
              userMetrics.trackEvent("logistics: filter by kit state", {
                kitState: value
              });
            },
            value: kitStates,
            size: 'm',
            ariaLabel: localize('Kit')
          }, {
            children: localize('Kit')
          })), jsx(TextMultiSelect, Object.assign({
            options: healthStatusFilterOptions,
            onChange: event => {
              const value = event.target.value;
              setPatientStatusFilter(value);
              userMetrics.trackEvent("logistics: filter by health status", {
                healthStatus: value
              });
            },
            value: patientStatus,
            size: 'm',
            ariaLabel: localize('Health_Status')
          }, {
            children: localize('Health_Status')
          })), jsx(StyledShortButton, Object.assign({
            size: "small",
            variant: "outlined",
            color: "primary",
            onClick: clearFilters,
            "aria-label": localize('clear_all')
          }, {
            children: localize('Clear_Filter')
          }))]
        }), table()]
      })]
    })), jsx(Snackbar$1, Object.assign({
      open: apiResponse.open && apiResponse.message !== localize("users_exists_err_msg") && apiResponse.message !== localize("patient_number_exists_err_msg"),
      onClose: resetApiResponse
    }, {
      children: jsx(MuiAlert, Object.assign({
        onClose: resetApiResponse,
        severity: apiResponse.serverity
      }, {
        children: localize(apiResponse.message) || apiResponse.message
      }))
    }))]
  }));
};

const PatientsPage = _a => {
  var {
      localizationMap
    } = _a,
    other = __rest(_a, ["localizationMap"]);
  const {
    userMetrics
  } = useUserMetrics();
  React__default.useEffect(() => {
    userMetrics.trackEvent('page view', {
      page: 'patients',
      category: 'user',
      'permission level': 'staff'
    });
  });
  return jsx(PageWithProviders, Object.assign({
    headerTitle: 'dashboards_patients',
    localizationMap: localizationMap
  }, {
    children: jsx(PatientsProvider, {
      children: jsx(PatientGroupProvider, {
        children: jsx(LogisticsNotesProvider, {
          children: jsx(KitModelsProvider, {
            children: jsx(KitProvider, {
              children: jsx(CurrentPersonProvider, {
                children: jsx(PeopleProvider, {
                  children: jsx(OrganizationNamesProvider, {
                    children: jsx(KitAssignmentProvider, {
                      children: jsx(PatientsPageRoutingContext.Provider, Object.assign({
                        value: other
                      }, {
                        children: jsx(Patients, {})
                      }))
                    })
                  })
                })
              })
            })
          })
        })
      })
    })
  }));
};

const PATIENT_SECTION_OPTIONS = ['info', 'notes', 'workflow', 'form',
// 'comment', // uncomment me when implemented
'indicator'];
// | 'end'; // uncomment me when implemented
const GROUP_SECTION_OPTIONS = ['workflow', 'form', 'comment'];
const REFINABLE_SECTION_OPTIONS = ['workflow', 'form', 'indicator'];

const ReportEditorHeader = ({
  onAddSection
}) => {
  const {
    reportSchema
  } = useReportSchema();
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  if (!reportSchema) {
    console.error('Report Schema is not defined in ReportEditorHeader');
    return null;
  }
  let newSectionOptions = [];
  if (reportSchema.type === 'group') {
    newSectionOptions = newSectionOptions.concat(GROUP_SECTION_OPTIONS);
  } else if (reportSchema.type === 'patient') {
    newSectionOptions = newSectionOptions.concat(PATIENT_SECTION_OPTIONS);
  } else {
    throw new Error(`Received illegal reportType of ${reportSchema.type} in ReportEditorHeader`);
  }
  const addSectionButton = jsx(IconButtonMenu, Object.assign({
    hoverLabel: reportSchema.sections.length === 0 ? localize('ReportEditorHeader_AddFirstSection') : localize('ReportEditorHeader_AddSectionLabel'),
    persistentTooltip: reportSchema.sections.length === 0,
    icon: Add
  }, {
    children: newSectionOptions.map((option, index) => jsx(DefaultIconbuttonMenuItem, {
      label: localize(`ReportEditorHeader_${option}`),
      onClick: () => {
        userMetrics.trackEvent('custom-reports: add section', {
          sectionType: option
        });
        onAddSection(option);
      }
    }, option.toString() + index))
  }));
  return jsxs(Grid, Object.assign({
    container: true,
    alignItems: "center",
    spacing: 1
  }, {
    children: [jsx(Grid, Object.assign({
      item: true,
      xs: "auto"
    }, {
      children: jsx(Typography, Object.assign({
        variant: "h6"
      }, {
        children: localize('ReportEditorHeader_Title')
      }))
    })), jsx(Grid, Object.assign({
      item: true,
      xs: "auto"
    }, {
      children: addSectionButton
    }))]
  }));
};

const SectionListItem = ({
  index,
  onClickEdit,
  onDeleteSection,
  onRename
}) => {
  var _a;
  const {
    localize
  } = useLocalize();
  const {
    reportSchema
  } = useReportSchema();
  const sectionSchema = index != null && ((_a = reportSchema === null || reportSchema === void 0 ? void 0 : reportSchema.sections) === null || _a === void 0 ? void 0 : _a[index]);
  if (!sectionSchema || index == null) return null;
  return jsxs(ListItem, {
    children: [jsxs("div", {
      children: [jsx(CovertTextEditor, {
        text: sectionSchema.title,
        onChange: onRename,
        placeholder: localize('SectionListItem_UnnamedSection')
      }), sectionSchema.description && jsx(Typography, Object.assign({
        variant: "subtitle2"
      }, {
        children: sectionSchema.description
      }))]
    }), jsxs(ListItemSecondaryAction, {
      children: [jsx(IconButton, Object.assign({
        edge: "end",
        "aria-label": "edit",
        onClick: onDeleteSection
      }, {
        children: jsx(Tooltip, Object.assign({
          title: localize('SectionListItem_Delete')
        }, {
          children: jsx(Delete, {})
        }))
      })), jsx(IconButton, Object.assign({
        edge: "end",
        "aria-label": "edit",
        onClick: onClickEdit
      }, {
        children: jsx(Tooltip, Object.assign({
          title: localize('SectionListItem_Edit')
        }, {
          children: jsx(Edit, {})
        }))
      }))]
    })]
  });
};

const SectionList = ({
  onEditSection
}) => {
  var _a;
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  const {
    reportSchema,
    renameSection
  } = useReportSchema();
  const [deletingSection, setDeletingSection] = React__default.useState(null);
  return jsxs(Fragment, {
    children: [((_a = reportSchema === null || reportSchema === void 0 ? void 0 : reportSchema.sections) === null || _a === void 0 ? void 0 : _a.length) ? jsx(List, {
      children: reportSchema.sections.map((sectionSchema, index) => jsx(SectionListItem, {
        onDeleteSection: () => setDeletingSection(index),
        index: index,
        onClickEdit: () => {
          userMetrics.trackEvent("custom-reports: open edit section popup");
          onEditSection(index);
        },
        onRename: newTitle => {
          userMetrics.trackEvent("custom-reports: rename section", {
            title: newTitle
          });
          renameSection(newTitle, index);
        }
      }, 'section' + index))
    }) : jsx(Grid, Object.assign({
      container: true,
      direction: "column",
      item: true,
      xs: 12,
      alignContent: "center",
      alignItems: "center",
      style: {
        height: '100%'
      }
    }, {
      children: jsx(Grid, Object.assign({
        item: true,
        container: true,
        style: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        },
        justify: "center"
      }, {
        children: jsx(Typography, {
          children: localize('SectionList_NoSections')
        })
      }))
    })), jsx(DeleteSectionModal, {
      onClose: () => setDeletingSection(null),
      deletingSection: deletingSection
    })]
  });
};
const DeleteSectionModal = ({
  deletingSection,
  onClose
}) => {
  var _a;
  const {
    localize
  } = useLocalize();
  const {
    reportSchema,
    deleteSection
  } = useReportSchema();
  if (deletingSection == null) return null;
  const sectionSchema = (_a = reportSchema === null || reportSchema === void 0 ? void 0 : reportSchema.sections) === null || _a === void 0 ? void 0 : _a[deletingSection];
  if (sectionSchema == null) return null;
  const actions = [jsx(Button, Object.assign({
    onClick: () => {
      if (deletingSection != null) {
        deleteSection(deletingSection);
        onClose();
      }
    }
  }, {
    children: localize('SectionList_Delete')
  }), "delete_section_submit")];
  const sectionTitle = sectionSchema.title || localize('SectionList_UnnamedSection');
  const sectionType = localize(`ReportEditorHeader_${sectionSchema.type}`);
  return jsx(ActionDialog, Object.assign({
    open: deletingSection != null,
    title: localize('SectionList_DeleteSection'),
    actions: actions,
    onClose: onClose
  }, {
    children: jsxs(Grid, Object.assign({
      container: true,
      spacing: 2,
      direction: "column"
    }, {
      children: [jsx(Grid, Object.assign({
        item: true
      }, {
        children: jsx(Typography, {
          children: localize('SectionList_DeleteAreYouSureYouWantTo')
        })
      })), jsxs(Grid, Object.assign({
        item: true
      }, {
        children: [jsx(Typography, {
          children: localize('SectionList_DeleteSectionTitle') + ' ' + sectionTitle
        }), jsx(Typography, {
          children: localize('SectionList_DeleteSectionType') + ' ' + sectionType
        })]
      }))]
    }))
  }));
};

const SectionEditor = ({
  index,
  onCancel
}) => {
  var _a;
  const {
    reportSchema,
    setSection
  } = useReportSchema();
  const {
    localize
  } = useLocalize();
  const sectionSchema = index != null && ((_a = reportSchema === null || reportSchema === void 0 ? void 0 : reportSchema.sections) === null || _a === void 0 ? void 0 : _a[index]);
  if (!sectionSchema || index == null) return null;
  const {
    subsections
  } = sectionSchema;
  const allSubsectionsChecked = sectionSchema.subsections.reduce((allChecked, subsection) => allChecked && !subsection.exclude, true);
  const someSubsectionsChecked = sectionSchema.subsections.reduce((atLeastOneChecked, subsection) => atLeastOneChecked || !subsection.exclude, false);
  const updateSubsections = newSubsections => {
    const newSectionSchema = Object.assign({}, sectionSchema);
    newSectionSchema.subsections = newSubsections;
    setSection(newSectionSchema, index);
  };
  return jsxs(Fragment, {
    children: [Array.isArray(subsections) && subsections.length > 1 ? jsxs(Fragment, {
      children: [jsx(CovertTextEditor, {
        onChange: newTitle => {
          const newSectionSchema = Object.assign({}, sectionSchema);
          newSectionSchema.title = newTitle;
          setSection(newSectionSchema, index);
        },
        text: sectionSchema.title,
        placeholder: localize('SectionEditor_UnnamedSection')
      }), jsx(CovertTextEditor, {
        onChange: newDescription => {
          const newSectionSchema = Object.assign({}, sectionSchema);
          newSectionSchema.description = newDescription;
          setSection(newSectionSchema, index);
        },
        text: sectionSchema.description,
        placeholder: localize('SectionEditor_EnterDescription')
      })]
    }) : undefined, Array.isArray(subsections) ? jsxs(Fragment, {
      children: [jsx(FormControlLabel, {
        label: "Select All",
        control: jsx(Checkbox, {
          checked: allSubsectionsChecked,
          indeterminate: someSubsectionsChecked && !allSubsectionsChecked,
          onChange: event => {
            if (!Array.isArray(subsections)) throw new Error(`Attempted to update a section with no subsections`);
            const newSubsections = [...subsections];
            newSubsections.map(subsection => subsection.exclude = !event.target.checked);
            updateSubsections(newSubsections);
          }
        })
      }), jsx(Grid, Object.assign({
        container: true,
        direction: 'column'
      }, {
        children: subsections.map((subsection, index) => jsx(Grid, Object.assign({
          item: true
        }, {
          children: jsx(FormControlLabel, {
            label: subsection.subtitle.toString() || 'Subsection #' + index,
            control: jsx(Checkbox, {
              checked: !subsections[index].exclude,
              onChange: event => {
                if (!Array.isArray(subsections)) throw new Error(`Attempted to update a section with no subsections`);
                const newSubsections = [...subsections];
                newSubsections[index].exclude = !event.target.checked;
                updateSubsections(newSubsections);
              }
            })
          }, subsection.subtitle.toString() || '' + index)
        }), 'grid-item' + subsection.subtitle.toString() + index))
      }))]
    }) : jsx(Typography, {
      children: localize('SectionEditor_NoSubsections')
    }), jsx(Button, Object.assign({
      onClick: onCancel
    }, {
      children: localize('SectionEditor_Done')
    }))]
  });
};

const WORKFLOW_NAME_NOT_FOUND = 'Workflow with ID ';
const getWorkflowName = (workflow, language) => {
  let localization;
  if (typeof workflow.schema.description === 'object' && language in workflow.schema.description) {
    localization = workflow.schema.description[language] || workflow.schema.description['en'];
  } else if (typeof workflow.schema.description === 'string') {
    localization = workflow.schema.description;
  }
  localization = localization || workflow.schema.title || WORKFLOW_NAME_NOT_FOUND + workflow._id.toString();
  return localization;
};
const getActionName = (action, language, key) => {
  var _a, _b;
  return action.title || ((_a = action === null || action === void 0 ? void 0 : action.localization) === null || _a === void 0 ? void 0 : _a[language]) || ((_b = action === null || action === void 0 ? void 0 : action.localization) === null || _b === void 0 ? void 0 : _b['en']) || key;
};
const FALLBACK_FORM_NAME = 'Form with ID ';
const getFormName = (form, language) => {
  var _a, _b, _c, _d, _e, _f;
  return ((_a = form === null || form === void 0 ? void 0 : form.localization) === null || _a === void 0 ? void 0 : _a[language]) || ((_b = form === null || form === void 0 ? void 0 : form.localization) === null || _b === void 0 ? void 0 : _b['en']) || ((_d = (_c = form === null || form === void 0 ? void 0 : form.schema) === null || _c === void 0 ? void 0 : _c.localization) === null || _d === void 0 ? void 0 : _d[language]) || ((_f = (_e = form === null || form === void 0 ? void 0 : form.schema) === null || _e === void 0 ? void 0 : _e.localization) === null || _f === void 0 ? void 0 : _f['en']) || FALLBACK_FORM_NAME.concat(form._id.toString());
};
const FALLBACK_INDICATOR_NAME = 'INDICATOR';
const getIndicatorName = (indicator, language) => indicator.name[language] || indicator.name['en'] || indicator.unit || FALLBACK_INDICATOR_NAME;

const ActionPicker = ({
  actions,
  checkedActions,
  onChange
}) => {
  const {
    localize,
    language
  } = useLocalize();
  if (!actions.length) {
    return jsx(Typography, {
      children: localize('RefineWorkflowSection_NoActions')
    });
  }
  const allActionsChecked = checkedActions.reduce((allChecked, value) => value && allChecked, true);
  const someActionsChecked = checkedActions.reduce((someChecked, value) => value || someChecked, false);
  return jsxs(Fragment, {
    children: [jsx(Typography, {
      children: localize('RefineWorkflowSection_Actions')
    }), actions.length > 1 && jsx(FormControlLabel, {
      label: localize('RefineWorkflowSection_SelectAllActions'),
      control: jsx(Checkbox, {
        checked: allActionsChecked || false,
        indeterminate: someActionsChecked && !allActionsChecked,
        onChange: event => onChange(Array(checkedActions.length).fill(event.target.checked))
      })
    }), jsx(Box, {
      children: actions.map((actionData, index) => {
        var _a, _b;
        return jsx(FormControlLabel, {
          label: getActionName(actionData.action, language, ((_a = actions[index]) === null || _a === void 0 ? void 0 : _a.key) || index.toString()),
          control: jsx(Checkbox, {
            checked: checkedActions[index] || false,
            onChange: event => {
              const newActions = [...checkedActions];
              newActions[index] = event.target.checked;
              onChange(newActions);
            }
          })
        }, ((_b = actionData.action) === null || _b === void 0 ? void 0 : _b.title) || actionData.key + index);
      })
    })]
  });
};

const ExternalPicker = ({
  externals,
  checkedExternals,
  onChange
}) => {
  const {
    localize,
    language
  } = useLocalize();
  const allExternalsChecked = checkedExternals.reduce((allChecked, value) => value && allChecked, true);
  const someExternalsChecked = checkedExternals.reduce((someChecked, value) => value || someChecked, false);
  if (!(externals === null || externals === void 0 ? void 0 : externals.length)) {
    return null;
  }
  return jsxs(Fragment, {
    children: [jsx(Typography, {
      children: localize('RefineWorkflowSection_RelatedForms')
    }), externals.length > 1 && jsx(FormControlLabel, {
      label: localize('RefineWorkflowSection_SelectAllExternals'),
      control: jsx(Checkbox, {
        checked: allExternalsChecked || false,
        indeterminate: someExternalsChecked && !allExternalsChecked,
        onChange: event => onChange(Array(externals.length).fill(event.target.checked))
      })
    }), jsx(Box, {
      children: externals.map((external, index) => jsx(FormControlLabel, {
        label: getFormName(external, language).toString(),
        control: jsx(Checkbox, {
          checked: checkedExternals[index] || false,
          onChange: event => {
            const newExternals = [...checkedExternals];
            newExternals[index] = event.target.checked;
            onChange(newExternals);
          }
        })
      }, getFormName(external, language).toString() + index))
    })]
  });
};

const WorkflowSectionPicker = ({
  workflow,
  onUpdate
}) => {
  const {
    formSchemasMap,
    loading: loadingOrgSchemas
  } = useOrgSchemas();
  const actions = getRenderableActions(workflow.schema.actions);
  const externals = getRenderableForms(workflow, formSchemasMap);
  const [checkedExternals, setCheckedExternals] = React__default.useState(Array(externals.length).fill(false));
  const [checkedActions, setCheckedActions] = React__default.useState(Array(actions.length).fill(false));
  React__default.useEffect(() => {
    setCheckedActions(Array(actions.length).fill(false));
    setCheckedExternals(Array(externals.length).fill(false));
  }, [actions.length, externals.length]);
  if (loadingOrgSchemas) {
    return jsx(CircularProgress, {});
  }
  const doUpdate = (newActions, newExternals) => {
    setCheckedActions(newActions);
    setCheckedExternals(newExternals);
    const actionSections = actions.filter((_actionData, index) => newActions[index]).map(({
      key
    }) => makeActionSection(key, workflow));
    const externalsSections = externals.filter((_external, index) => newExternals[index]).map(external => makeExternalSection(external));
    onUpdate([...actionSections, ...externalsSections]);
  };
  return jsxs(Fragment, {
    children: [jsx(ActionPicker, {
      actions: actions,
      checkedActions: checkedActions,
      onChange: newActions => doUpdate(newActions, checkedExternals)
    }), jsx(ExternalPicker, {
      externals: externals,
      checkedExternals: checkedExternals,
      onChange: newExternals => doUpdate(checkedActions, newExternals)
    })]
  });
};
const getRenderableActions = actions => {
  return Object.entries(actions).map(entry => ({
    key: entry[0],
    action: entry[1]
  })).filter(({
    action
  }) => hasRenderableSubproperty(action.properties || {}));
};
const getRenderableForms = (workflow, formSchemasMap) => {
  let externals = [];
  if (formSchemasMap && (workflow === null || workflow === void 0 ? void 0 : workflow.externals)) {
    const externalsIds = Object.values((workflow === null || workflow === void 0 ? void 0 : workflow.externals) || {});
    externals = externalsIds.map(externalId => formSchemasMap[externalId.toString()] || null);
    externals = externals.filter(external => {
      var _a;
      return external && hasRenderableSubproperty(((_a = external === null || external === void 0 ? void 0 : external.schema) === null || _a === void 0 ? void 0 : _a.properties) || {});
    });
  }
  return externals;
};
const hasRenderableSubproperty = properties => Object.values(properties || {}).reduce((hasRenderableProperty, property) => hasRenderableProperty || shouldRenderProperty(property), false);
const makeActionSection = (actionKey, workflow) => {
  const sectionDefinition = {
    type: 'action',
    workflow: workflow._id,
    action: actionKey
  };
  return buildWorkflowActionSection(sectionDefinition, workflow); // I use `as` here because it will never be null. We've already ensured that it has a renderable property
};
const makeExternalSection = external => {
  const sectionDefinition = {
    type: 'form',
    form: external._id
  };
  return buildFormSection(sectionDefinition, external); // I use `as` here because it will never be null. We've already ensured that it has a renderable property
};

const RefineWorkflowSection = ({
  onUpdate
}) => {
  const {
    localize,
    language
  } = useLocalize();
  const {
    workflowSchemas
  } = useOrgSchemas();
  const [selectedWorkflow, setSelectedWorkflow] = React__default.useState(null);
  const [error, setError] = React__default.useState(null);
  return jsxs(Box, {
    children: [jsx(Autocomplete, {
      options: workflowSchemas || [],
      getOptionLabel: workflow => getWorkflowName(workflow, language),
      renderInput: params => jsx(Grid, Object.assign({
        container: true,
        alignItems: "center"
      }, {
        children: jsx(Grid, Object.assign({
          item: true,
          xs: 12
        }, {
          children: jsx(TextField, Object.assign({}, params, {
            label: localize('RefineWorkflowSection_label'),
            style: {
              width: 300
            },
            variant: "outlined"
          }))
        }))
      })),
      onChange: (event, newValue) => {
        onUpdate([]);
        setSelectedWorkflow(newValue);
      }
    }), selectedWorkflow && jsx(WorkflowSectionPicker, {
      onError: setError,
      onUpdate: onUpdate,
      workflow: selectedWorkflow
    }), error && jsx(Typography, {
      children: error
    })]
  });
};

const RefineFormSection = ({
  onUpdate
}) => {
  const {
    formSchemas
  } = useOrgSchemas();
  const {
    localize
  } = useLocalize();
  const {
    personal: {
      language
    }
  } = useCurrentPerson();
  const [error, setError] = React__default.useState(undefined);
  const onChangeForm = newForm => {
    setError(undefined);
    if (!newForm) return;
    const sectionDefinition = {
      type: 'form',
      form: newForm._id
    };
    const section = buildFormSection(sectionDefinition, newForm);
    if (section == null) {
      setError(localize('RefineFormSection_NoSubsections'));
      return;
    }
    onUpdate([section]);
  };
  return jsxs(Box, {
    children: [jsx(Autocomplete, {
      options: formSchemas || [],
      getOptionLabel: form => getFormName(form, language),
      renderInput: params => jsx(Grid, Object.assign({
        container: true,
        alignItems: "center"
      }, {
        children: jsx(Grid, Object.assign({
          item: true,
          xs: 12
        }, {
          children: jsx(TextField, Object.assign({}, params, {
            label: localize('RefineFormSection_label'),
            variant: "outlined"
          }))
        }))
      })),
      onChange: (event, newValue) => {
        onChangeForm(newValue);
      }
    }), error && jsx(Typography, {
      children: error
    })]
  });
};

const RefineIndicatorSection = ({
  onUpdate
}) => {
  const {
    localize,
    language
  } = useLocalize();
  const {
    customIndicatorsMap,
    customIndicators,
    loading
  } = useOrgSchemas();
  const onChangeIndicator = indicator => __awaiter(void 0, void 0, void 0, function* () {
    if (indicator == null) {
      return;
    }
    let schema;
    if (typeof indicator === 'string') {
      // Default indicator
      schema = buildSection({
        type: 'indicator',
        indicator: indicator
      });
    } else {
      // Custom indicator
      const indicatorID = typeof indicator === 'string' ? indicator : indicator._id.toString();
      const sectionDefinition = {
        type: 'indicator',
        indicator: indicatorID,
        custom: !(typeof indicator === 'string')
      }; // Typescript hates the custom field
      schema = buildSection(sectionDefinition, customIndicatorsMap);
    }
    if (schema != null) {
      onUpdate(schema);
    }
  });
  const indicators = [...(customIndicators || []), ...DEFAULT_INDICATORS];
  return jsx(Box, {
    children: loading ? jsx(CircularProgress, {}) : jsx(Autocomplete, {
      options: indicators,
      getOptionLabel: indicator => {
        if (typeof indicator === 'string') {
          return localize(`RefineIndicatorSection_${indicator}`);
        }
        return getIndicatorName(indicator, language || 'en');
      },
      renderInput: params => jsx(TextField, Object.assign({}, params, {
        label: localize('RefineIndicatorSection_label'),
        variant: "outlined"
      })),
      onChange: (event, newValue) => {
        onChangeIndicator(newValue);
      }
    })
  });
};

const AddSectionModal = ({
  onSubmit,
  onCancel,
  type,
  open: _open = false
}) => {
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  const {
    loading
  } = useOrgSchemas();
  const [sectionName, setSectionName] = React__default.useState(undefined);
  const [sectionType, setSectionType] = React__default.useState(type || null);
  const [sectionSchemas, setSectionSchemas] = React__default.useState([]);
  React__default.useEffect(() => {
    setSectionType(type || null);
  }, [type]);
  if (sectionType == null) {
    return null;
  }
  const cantSubmit = !(sectionSchemas === null || sectionSchemas === void 0 ? void 0 : sectionSchemas.length);
  const actions = [jsx(Tooltip, Object.assign({
    title: cantSubmit ? localize('AddSectionModal_Errors') : '',
    arrow: true
  }, {
    children: jsx("span", {
      children: jsx(Button, Object.assign({
        disabled: cantSubmit,
        onClick: () => {
          userMetrics.trackEvent('custom-reports: add section', {
            sectionType,
            sectionName,
            sectionSchemas
          });
          if (sectionSchemas) {
            if (sectionSchemas.length === 1) {
              sectionSchemas[0].title = sectionName;
            }
            onSubmit(sectionSchemas);
          } else {
            onCancel();
          }
        }
      }, {
        children: localize('Add ') + sectionSchemas.length + localize(' Section(s) to report')
      }))
    })
  }), "tooltip")];
  let SectionRefiner;
  if (sectionType === 'workflow') {
    SectionRefiner = RefineWorkflowSection;
  } else if (sectionType === 'form') {
    SectionRefiner = RefineFormSection;
  } else if (sectionType === 'indicator') {
    SectionRefiner = RefineIndicatorSection;
  } else {
    throw new Error(`Received invalid sectionType of ${sectionType}`);
  }
  return jsx(ActionDialog, Object.assign({
    actions: actions,
    open: _open,
    onClose: onCancel,
    title: localize(`AddSectionModal_Title_${sectionType}`)
  }, {
    children: jsxs(Grid, Object.assign({
      container: true,
      spacing: 2,
      direction: "column"
    }, {
      children: [jsx(Grid, Object.assign({
        item: true
      }, {
        children: sectionType !== 'workflow' ? jsxs(Fragment, {
          children: [jsx(Typography, {
            children: localize('AddSectionModal_NameSection')
          }), jsx(TextField, {
            fullWidth: true,
            onChange: event => setSectionName(event.target.value)
          })]
        }) : jsx(Typography, {
          children: localize('AddSectionModal_ChooseSectionsBelow')
        })
      })), jsx(Grid, Object.assign({
        item: true
      }, {
        children: loading ? jsx(CircularProgress, {}) : jsx(SectionRefiner, {
          onUpdate: newSchemas => setSectionSchemas(newSchemas)
        })
      }))]
    }))
  }));
};

const ReportEditor = () => {
  const {
    reportSchema,
    addSections,
    addNonRefinableSection
  } = useReportSchema();
  const [currentlyEditing, setCurrentlyEditing] = React__default.useState(null);
  const [addSectionModalOpen, setAddSectionModalOpen] = React__default.useState(false);
  const [addSectionModalType, setAddSectionModalType] = React__default.useState(null);
  if (!reportSchema) return null;
  const reportType = reportSchema.type;
  if (!reportType) {
    throw new Error(`schema provided to ReportEditor is too sparse`);
  }
  const onStartEditingSection = index => setCurrentlyEditing(index);
  return jsxs(Box, Object.assign({
    style: {
      height: '100%',
      position: 'relative'
    }
  }, {
    children: [jsx(ReportEditorHeader, {
      onAddSection: type => {
        if (REFINABLE_SECTION_OPTIONS.includes(type)) {
          setAddSectionModalOpen(true);
          setAddSectionModalType(type);
        } else {
          addNonRefinableSection(type);
        }
      }
    }), jsx(Box, Object.assign({
      style: {
        height: '100%',
        position: 'relative'
      }
    }, {
      children: jsxs(Paper, Object.assign({
        elevation: 5,
        style: {
          height: '100%',
          padding: 8
        }
      }, {
        children: [jsx(SectionList, {
          onEditSection: onStartEditingSection
        }), jsx(Slide, Object.assign({
          direction: "right",
          style: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%'
          },
          in: currentlyEditing != null,
          mountOnEnter: true
        }, {
          children: jsx(Paper, Object.assign({
            elevation: 6,
            style: {
              height: '100%',
              padding: 8
            }
          }, {
            children: jsx(SectionEditor, {
              index: currentlyEditing,
              onCancel: () => setCurrentlyEditing(null)
            })
          }))
        }))]
      }))
    })), jsx(AddSectionModal, {
      onSubmit: newSections => {
        addSections(newSections);
        setAddSectionModalOpen(false);
      },
      onCancel: () => setAddSectionModalOpen(false),
      type: addSectionModalType,
      open: addSectionModalOpen
    })]
  }));
};

const ReportPreviewHeader = () => {
  var _a, _b;
  const {
    localize
  } = useLocalize();
  const {
    rawReport
  } = useRawReport();
  const creationDate = ((_a = rawReport === null || rawReport === void 0 ? void 0 : rawReport.meta) === null || _a === void 0 ? void 0 : _a.created_at) && 'Generated at: ' + new Date((_b = rawReport === null || rawReport === void 0 ? void 0 : rawReport.meta) === null || _b === void 0 ? void 0 : _b.created_at).toLocaleString();
  return jsxs(Grid, Object.assign({
    container: true,
    alignItems: "center",
    spacing: 4
  }, {
    children: [jsxs(Grid, Object.assign({
      item: true,
      xs: "auto"
    }, {
      children: [jsx(Typography, Object.assign({
        variant: "h6"
      }, {
        children: localize('ReportPreviewHeader_Title')
      })), creationDate && jsx(Typography, {
        children: creationDate
      })]
    })), jsx(Grid, Object.assign({
      item: true,
      xs: "auto"
    }, {
      children: jsx(ReportScopeSelector, {})
    }))]
  }));
};
/**
 * Returns an AutoSelect component that either lets you choose an orgGroup or a patient, depending on the report type
 */
const ReportScopeSelector = () => {
  const {
    localize
  } = useLocalize();
  const {
    reportSchema
  } = useReportSchema();
  const {
    setSelectedPatient,
    setSelectedOrgGroup
  } = useRawReport();
  const {
    patients,
    loading: loadingPatients
  } = useAllPatients();
  const {
    orgGroups,
    loading: loadingGroups
  } = useOrgGroups();
  let options = [];
  let label;
  let loading;
  let getOptionLabel;
  let onChange;
  if (reportSchema) {
    if (reportSchema.type === 'group') {
      options = orgGroups || [];
      loading = loadingGroups;
      onChange = (event, newValue) => newValue && setSelectedOrgGroup(newValue);
      getOptionLabel = orgGroup => orgGroup.name;
      label = loadingGroups ? localize('ReportPreviewHeader_LoadingGroups') : localize('ReportPreviewHeader_SelectGroup');
    } else {
      options = patients || [];
      loading = loadingPatients;
      onChange = (event, newValue) => newValue && setSelectedPatient(newValue);
      getOptionLabel = patient => getUserName(patient);
      label = loadingPatients ? localize('ReportPreviewHeader_LoadingPatients') : localize('ReportPreviewHeader_SelectPatient');
    }
  } else {
    loading = true;
    label = localize('ReportPreviewHeader_ErrorOccurred');
    getOptionLabel = () => '';
    onChange = () => {};
  }
  return jsx(Autocomplete$1, {
    disablePortal: true,
    style: {
      width: 300,
      textAlign: 'center'
    },
    options: options,
    disabled: loading,
    getOptionLabel: getOptionLabel,
    renderInput: params => jsx(TextField, Object.assign({
      label: label,
      variant: "outlined"
    }, params, {
      disabled: loading
    })),
    onChange: onChange
  });
};

const ReportSectionPreviewTable = ({
  index
}) => {
  var _a, _b;
  const {
    rawReport,
    loading
  } = useRawReport();
  if (loading) {
    return null;
  }
  const rawSection = rawReport === null || rawReport === void 0 ? void 0 : rawReport.sections[index];
  if (index > (((_a = rawReport === null || rawReport === void 0 ? void 0 : rawReport.sections) === null || _a === void 0 ? void 0 : _a.length) || 0)) {
    throw new Error(`Received an index of ${index} which is greater than the number of sections (${((_b = rawReport === null || rawReport === void 0 ? void 0 : rawReport.sections) === null || _b === void 0 ? void 0 : _b.length) || 0}) in the rawReport.`);
  } else if (rawSection == null) {
    throw new Error(`Couldn't find section with index ${index}`);
  }
  return jsx(TableContainer, Object.assign({
    component: Paper
  }, {
    children: jsxs(Table$1, {
      children: [jsx(TableHead, {
        children: jsx(TableRow, {
          children: rawSection.subtitles.map((subtitle, index) => jsx(TableCell$1, {
            children: subtitle
          }, subtitle.toString() || '' + index))
        })
      }), jsx(TableBody, {
        children: rawSection.data.map((datum, datumIndex) => jsx(TableRow, {
          children: rawSection.subtitles.map((subtitle, subtitleIndex) => {
            var _a;
            return jsx(TableCell$1, {
              children: ((datum === null || datum === void 0 ? void 0 : datum[subtitle]) != null ? datum[subtitle] : '').toString()
            }, ((_a = datum === null || datum === void 0 ? void 0 : datum[subtitle]) === null || _a === void 0 ? void 0 : _a.toString()) + subtitleIndex + datumIndex || subtitleIndex.toString() + datumIndex.toString());
          })
        }, 'row' + datumIndex.toString()))
      })]
    })
  }));
};

const ReportSectionPreview = ({
  index
}) => {
  const {
    rawReport,
    loading
  } = useRawReport();
  const {
    userMetrics
  } = useUserMetrics();
  const rawSection = rawReport === null || rawReport === void 0 ? void 0 : rawReport.sections[index];
  const [collapsed, setCollapsed] = React__default.useState(false);
  if (loading || rawSection == null) return null;
  return jsx(Grid, Object.assign({
    item: true,
    xs: 12
  }, {
    children: jsxs(Grid, Object.assign({
      container: true,
      spacing: 2
    }, {
      children: [jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsx(ReportSectionPreviewHeader, {
          collapsed: collapsed,
          toggleCollapse: () => {
            userMetrics.trackEvent("custom-reports: collapse section", {
              title: rawSection.title
            });
            setCollapsed(!collapsed);
          },
          index: index
        })
      })), jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsx(Collapse, Object.assign({
          in: !collapsed
        }, {
          children: jsx(ReportSectionPreviewTable, {
            index: index
          }, (rawSection === null || rawSection === void 0 ? void 0 : rawSection.title) || '' + index)
        }))
      }))]
    }))
  }), 'grid_item' + index);
};
const ReportSectionPreviewHeader = ({
  index,
  collapsed,
  toggleCollapse
}) => {
  const {
    localize
  } = useLocalize();
  const {
    rawReport,
    loading
  } = useRawReport();
  const rawSection = rawReport === null || rawReport === void 0 ? void 0 : rawReport.sections[index];
  if (loading || !rawSection) return null;
  return jsxs(Grid, Object.assign({
    container: true,
    direction: "column",
    spacing: 2
  }, {
    children: [jsx(Grid, Object.assign({
      item: true
    }, {
      children: jsxs(Grid, Object.assign({
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, {
        children: [jsx(Box, Object.assign({
          fontStyle: rawSection.title ? 'normal' : 'italic'
        }, {
          children: jsx(Typography, Object.assign({
            variant: "h6"
          }, {
            children: rawSection.title || localize('ReportPreviewHeader_UnnamedSection')
          }))
        })), jsx(IconButton, Object.assign({
          onClick: toggleCollapse
        }, {
          children: collapsed ? jsx(ExpandMore, {}) : jsx(ExpandLess, {})
        }))]
      }))
    })), jsx(Typography, Object.assign({
      variant: "body2"
    }, {
      children: rawSection.description
    }))]
  }));
};

var img = "data:image/png;base64,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";

const ReportPreview = () => {
  const {
    rawReport,
    loading
  } = useRawReport();
  return jsxs(Fragment, {
    children: [jsx(ReportPreviewHeader, {}), loading ? jsx(CircularProgress, {}) : rawReport != null ? jsx(Grid, Object.assign({
      container: true,
      spacing: 2
    }, {
      children: rawReport.sections.map((_, index) => jsx(ReportSectionPreview, {
        index: index
      }, `report_preview_${index}`))
    })) : jsx(EmptyReportPreview, {})]
  });
};
const EmptyReportPreview = () => {
  return jsx(Grid, Object.assign({
    container: true,
    alignItems: "center",
    spacing: 4
  }, {
    children: jsx(Grid, Object.assign({
      item: true,
      xs: 12
    }, {
      children: jsx(Paper, Object.assign({
        variant: "outlined"
      }, {
        children: jsx("img", {
          src: img,
          alt: 'nurses building a report'
        })
      }))
    }))
  }));
};

const DownloadReportIcon = () => {
  const {
    generateReport,
    rawReport,
    generatingReport
  } = useRawReport();
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  const disabled = generatingReport || !rawReport;
  let hoverLabel;
  if (generatingReport) {
    hoverLabel = localize('CustomReportsHeader_GeneratingDownload');
  } else if (!rawReport) {
    hoverLabel = localize('CustomReportsHeader_RunPreviewFirst');
  } else {
    hoverLabel = localize('CustomReportsHeader_Download');
  }
  if (generatingReport) {
    return jsx(SpinningIcon, {
      onClick: () => {},
      icon: Sync,
      spinning: true,
      disabled: true,
      highlighted: false,
      hoverLabel: hoverLabel
    });
  }
  return jsxs(IconButtonMenu, Object.assign({
    icon: FileDownload,
    hoverLabel: hoverLabel,
    disabled: disabled
  }, {
    children: [jsx(DefaultIconbuttonMenuItem, {
      label: localize('CustomReportsHeader_DownloadAsXLSX'),
      onClick: () => {
        userMetrics.trackEvent('custom-reports: download report', {
          filename: rawReport === null || rawReport === void 0 ? void 0 : rawReport.filename,
          type: "xlsx"
        });
        generateReport('xlsx');
      }
    }, 'download_xlsx'), jsx(DefaultIconbuttonMenuItem, {
      label: localize('CustomReportsHeader_DownloadAsCSV'),
      onClick: () => {
        userMetrics.trackEvent('custom-reports: download report', {
          filename: rawReport === null || rawReport === void 0 ? void 0 : rawReport.filename,
          type: "csv"
        });
        generateReport('csv');
      }
    }, 'download_csv')]
  }));
};

const MoreOptionsIcon = ({
  onScheduleReport
}) => {
  onScheduleReport(); // this is to prevent unused vars
  return null;
  /** Uncomment when report scheduling is implemented
    <IconButtonMenu
    hoverLabel={localize('CustomReportsHeader_MoreOptionsLabel')}
    menuItems={[localize('CustomReportsHeader_ScheduleReport')]}
    onClickMenuItem={[() => onScheduleReport()]}
  >
    <MoreVertIcon />
  </IconButtonMenu>
  */
};

const RefreshReportIcon = () => {
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  const {
    reportSchema
  } = useReportSchema();
  const {
    loading,
    changeReportSchema,
    currentReportSchema,
    selectedOrgGroup,
    selectedPatient
  } = useRawReport();
  let refreshHoverLabel;
  let disabled;
  let highlighted;
  if (!selectedOrgGroup && !selectedPatient) {
    disabled = true;
    highlighted = false;
    refreshHoverLabel = (reportSchema === null || reportSchema === void 0 ? void 0 : reportSchema.type) === 'patient' ? localize('CustomReportsHeader_SelectPatient') : localize('CustomReportsHeader_SelectGroup');
  } else if (loading) {
    // Loading
    disabled = true;
    highlighted = false;
    refreshHoverLabel = localize('CustomReportsHeader_ReportIsRefreshing');
  } else if (((reportSchema === null || reportSchema === void 0 ? void 0 : reportSchema.sections.length) || 0) === 0) {
    // The report is empty
    disabled = true;
    highlighted = false;
    refreshHoverLabel = localize('CustomReportsHeader_EmptyReport');
  } else if (currentReportSchema === reportSchema) {
    // No changes have been made
    highlighted = false;
    disabled = true;
    refreshHoverLabel = localize('CustomReportsHeader_ReportIsUnchanged');
  } else {
    // A change has occurred and the report is not empty
    highlighted = true;
    disabled = false;
    refreshHoverLabel = localize('CustomReportsHeader_RefreshReport');
  }
  return jsx(SpinningIcon, {
    onClick: () => {
      userMetrics.trackEvent('custom-reports: refresh report');
      changeReportSchema(reportSchema);
    },
    icon: Sync,
    spinning: loading,
    disabled: disabled,
    highlighted: highlighted,
    hoverLabel: refreshHoverLabel
  });
};

const SaveReportIcon = () => {
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  const {
    reportSchema,
    loading,
    saveSchema,
    saving,
    lastSavedSchema
  } = useReportSchema();
  if (saving) {
    return jsx(SpinningIcon, {
      onClick: () => {},
      icon: Sync,
      spinning: true,
      disabled: true,
      highlighted: false,
      hoverLabel: localize('CustomReportsHeader_Saving')
    });
  }
  let disabled;
  let highlighted;
  let hoverLabel;
  if (loading) {
    disabled = true;
    highlighted = false;
    hoverLabel = localize('CustomReportsHeader_ReportIsRefreshing');
  } else if ((reportSchema === null || reportSchema === void 0 ? void 0 : reportSchema.sections.length) === 0 && lastSavedSchema === reportSchema) {
    disabled = true;
    highlighted = false;
    hoverLabel = localize('CustomReportsHeader_EmptyReport');
  } else if (lastSavedSchema === reportSchema) {
    disabled = true;
    highlighted = false;
    hoverLabel = localize('CustomReportsHeader_ReportIsUnchanged');
  } else {
    disabled = false;
    highlighted = true;
    hoverLabel = localize('CustomReportsHeader_SaveReport');
  }
  return jsx(Tooltip, Object.assign({
    title: hoverLabel
  }, {
    children: jsx("span", {
      children: jsx(IconButton, Object.assign({
        onClick: () => {
          userMetrics.trackEvent("custom-reports: save schema", {
            report: reportSchema
          });
          saveSchema();
        },
        disabled: disabled,
        color: highlighted ? 'primary' : 'default',
        style: highlighted ? {
          backgroundColor: '#C4DFE0'
        } : undefined
      }, {
        children: jsx(Save, {
          style: {
            color: disabled ? 'grey' : '#285E63'
          }
        })
      }))
    })
  }));
};

const CustomReportsHeader = ({
  onScheduleReport
}) => {
  const {
    reportSchema,
    renameReport
  } = useReportSchema();
  const {
    localize
  } = useLocalize();
  onScheduleReport(); // this is to prevent unused vars
  return jsxs(Grid, Object.assign({
    container: true,
    direction: "row",
    alignItems: "center",
    spacing: 2
  }, {
    children: [jsx(Grid, Object.assign({
      item: true
    }, {
      children: jsx(CovertTextEditor, {
        typographyProps: {
          variant: 'h5'
        },
        tooltip: localize('CustomReportsHeader_RenameReport'),
        text: reportSchema === null || reportSchema === void 0 ? void 0 : reportSchema.name,
        onChange: newName => renameReport(newName),
        placeholder: localize('CustomReportsHeader_Untitled')
      })
    })), jsx(Grid, Object.assign({
      item: true
    }, {
      children: jsxs(Grid, Object.assign({
        container: true,
        direction: "row",
        alignItems: "center"
      }, {
        children: [jsx(SaveReportIcon, {}), jsx(RefreshReportIcon, {}), jsx(DownloadReportIcon, {}), jsx(MoreOptionsIcon, {
          onScheduleReport: onScheduleReport
        })]
      }))
    }))]
  }));
};

const WelcomeModal = () => {
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  const {
    reportSchema,
    loading
  } = useReportSchema();
  const customReportsTipsDisabled = localStorage.getItem('customReportsTipsDisabled') !== 'true';
  const [open, setOpen] = React__default.useState(customReportsTipsDisabled);
  if (loading) return null;
  if (!reportSchema) {
    throw new Error('Missing reportSchema');
  }
  return jsx(ActionDialog, Object.assign({
    title: localize('WelcomeModal_Title'),
    open: open,
    onClose: () => setOpen(false),
    actions: [jsx(Button, Object.assign({
      onClick: () => {
        userMetrics.trackEvent('custom-reports: close welcome popup and disable tips');
        localStorage.setItem('customReportsTipsDisabled', 'true');
        setOpen(false);
      }
    }, {
      children: localize('WelcomeModal_DisableTips')
    }), 'WelcomeModal_DisableTips')]
  }, {
    children: jsxs(Grid, Object.assign({
      container: true,
      spacing: 2
    }, {
      children: [jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsx(Typography, {
          children: localize('WelcomeModal_Intro')
        })
      })), jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsx(Typography, {
          children: localize('WelcomeModal_Left')
        })
      })), jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsx(Typography, {
          children: localize('WelcomeModal_Right')
        })
      })), jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsx(Typography, {
          children: reportSchema.type === 'group' ? localize('WelcomeModal_Group') : localize('WelcomeModal_Patient')
        })
      })), jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsx(Typography, {
          children: localize('WelcomeModal_AddASection')
        })
      }))]
    }))
  }));
};

const CustomReportsEditor = () => {
  const {
    loading
  } = useReportSchema();
  const {
    userMetrics
  } = useUserMetrics();
  React__default.useEffect(() => {
    userMetrics.trackEvent('page view', {
      page: 'custom-reports',
      category: 'org',
      'permission level': 'org:manager'
    });
  }, [userMetrics]);
  if (loading) return jsx(CircularProgress, {});
  return jsxs("div", Object.assign({
    style: {
      padding: 16
    }
  }, {
    children: [jsx(WelcomeModal, {}), jsxs(Grid, Object.assign({
      container: true,
      spacing: 2
    }, {
      children: [jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsx(CustomReportsHeader, {
          onScheduleReport: () => {}
        })
      })), jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsxs(Grid, Object.assign({
          container: true,
          wrap: "nowrap",
          style: {
            height: '100%'
          },
          spacing: 2
        }, {
          children: [jsx(Grid, Object.assign({
            item: true,
            xs: 4,
            style: {
              height: '100%'
            }
          }, {
            children: jsx(ReportEditor, {})
          })), jsx(Grid, Object.assign({
            item: true,
            xs: 8
          }, {
            children: jsx(ReportPreview, {})
          }))]
        }))
      }))]
    }))]
  }));
};

// import { useNavigate } from 'react-router-dom'; // use this when we upgrade react-router-dom to v6
const styles$7 = {
  disabledCancelButton: {},
  enabledCancelButton: {}
};
const NewCustomReportModal = ({
  onCancel,
  open: _open = false
}) => {
  const {
    localize
  } = useLocalize();
  const [reportTitle, setReportTitle] = useState('');
  const [reportType, setReportType] = useState(null);
  const {
    loading
  } = useReportSchema();
  const {
    createEmptySchema
  } = useReportSchema();
  const {
    userMetrics
  } = useUserMetrics();
  // const navigate = useNavigate(); // use this when we upgrade react-router-dom to v6
  const cantSubmit = !reportType;
  const actions = [jsx(Tooltip, Object.assign({
    title: cantSubmit ? localize('NewCustomReportModal_Errors') : '',
    arrow: true
  }, {
    children: jsx("span", {
      children: loading ? jsx(CircularProgress, {}) : jsx(Button, Object.assign({
        disabled: cantSubmit,
        style: cantSubmit ? styles$7.disabledCancelButton : styles$7.enabledCancelButton,
        onClick: () => __awaiter(void 0, void 0, void 0, function* () {
          userMetrics.trackEvent("click create new custom report", {
            reportType,
            reportTitle
          });
          if (!reportType) return;
          const id = yield createEmptySchema(reportType, reportTitle);
          id && window.location.assign(`/custom-reports/${id === null || id === void 0 ? void 0 : id.toString()}`);
        })
      }, {
        children: localize('NewCustomReportModal_StartBuilding')
      }))
    })
  }), "tooltip")];
  return jsx(ActionDialog, Object.assign({
    actions: actions,
    open: _open,
    title: localize('NewCustomReportModal_Title'),
    onClose: onCancel
  }, {
    children: jsxs(Grid, Object.assign({
      container: true,
      spacing: 2,
      direction: "column"
    }, {
      children: [jsxs(Grid, Object.assign({
        item: true,
        xs: 4
      }, {
        children: [jsx(Typography, {
          children: localize('NewCustomReportModal_ReportNameHeader')
        }), jsx(TextField, {
          fullWidth: true,
          onChange: event => setReportTitle(event.target.value)
        })]
      })), jsxs(Grid, Object.assign({
        item: true,
        xs: "auto"
      }, {
        children: [jsx(Typography, {
          children: localize('NewCustomReportModal_ReportTypeHeader')
        }), jsxs(ToggleButtonGroup, Object.assign({
          value: reportType,
          onChange: (event, newReportType) => setReportType(newReportType),
          exclusive: true
        }, {
          children: [jsx(ToggleButton, Object.assign({
            value: "patient",
            color: "primary"
          }, {
            children: jsx(Tooltip, Object.assign({
              title: localize('NewCustomReportModal_PatientReportExplanation')
            }, {
              children: jsx("span", {
                children: localize('NewCustomReportModal_PatientReport')
              })
            }))
          })), jsx(ToggleButton, Object.assign({
            value: "group",
            color: "primary"
          }, {
            children: jsx(Tooltip, Object.assign({
              title: localize('NewCustomReportModal_GroupReportExplanation')
            }, {
              children: jsx("span", {
                children: localize('NewCustomReportModal_GroupReport')
              })
            }))
          }))]
        }))]
      }))]
    }))
  }));
};

const useStyles = makeStyles(theme => createStyles({
  fab: {
    position: 'absolute',
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  }
}));
const CustomReportsList = () => {
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  const {
    loading: loadingReportsList,
    customReports
  } = useCustomReportsList();
  const [newCustomReportModalOpen, setNewCustomReportModalOpen] = React__default.useState(false);
  if (loadingReportsList) return jsx(CircularProgress, {});
  if (customReports == null) {
    throw new Error('Finished loading but did not receive customReportsList');
  }
  const tableWidth = 300;
  return jsxs("div", {
    children: [jsx(NewCustomReportModal, {
      onCancel: () => setNewCustomReportModalOpen(false),
      open: newCustomReportModalOpen
    }), customReports.length ? jsx(VirtualizedTable, {
      rowHeight: 60,
      rowGetter: ({
        index
      }) => customReports[index],
      rowCount: customReports.length,
      columns: [{
        label: 'Report Title',
        dataFn: ({
          rowData
        }) => {
          var _a;
          return jsxs("div", {
            children: [jsx(Typography, {
              children: ((_a = rowData === null || rowData === void 0 ? void 0 : rowData.schema) === null || _a === void 0 ? void 0 : _a.name) || localize('ReportEditorHeader_EnterReportName')
            }), rowData.schema.description && jsx(Typography, Object.assign({
              variant: "subtitle2"
            }, {
              children: rowData.schema.description
            }))]
          });
        },
        dataKey: 'title',
        width: tableWidth * 0.5
      }, {
        label: 'Report Type',
        dataFn: ({
          rowData
        }) => {
          var _a;
          return localize(`CustomReportsList_${(_a = rowData === null || rowData === void 0 ? void 0 : rowData.schema) === null || _a === void 0 ? void 0 : _a.type}`) || localize('ReportEditorHeader_EnterReportName');
        },
        dataKey: 'type',
        width: tableWidth * 0.5
      }, {
        label: 'Last Edited',
        dataKey: 'date',
        dataFn: ({
          rowData
        }) => {
          const createdAt = new Date(rowData.created_at);
          const updatedAt = rowData.updated_at ? new Date(rowData.created_at) : new Date(0);
          return (updatedAt.getTime() > createdAt.getTime() ? updatedAt : createdAt).toLocaleDateString();
        },
        width: tableWidth * 0.2
      }, {
        label: '',
        dataFn: ({
          rowData
        }) => jsx(IconButton, Object.assign({
          onClick: () => {
            var _a, _b;
            userMetrics.trackEvent("custom-reports: open edit report popup", {
              report: rowData._id
            });
            ((_a = rowData === null || rowData === void 0 ? void 0 : rowData._id) === null || _a === void 0 ? void 0 : _a.toString()) && window.location.assign(`/custom-reports/${(_b = rowData._id) === null || _b === void 0 ? void 0 : _b.toString()}`);
          }
        }, {
          children: jsx(Edit, {
            color: "primary"
          })
        })),
        dataKey: 'options',
        width: tableWidth * 0.05
      }]
    }) : jsx(Typography, {
      children: localize('CustomReportsList_NoReports')
    }), jsx(AddNewReportButton, {
      onClick: () => {
        userMetrics.trackEvent("custom-reports: open new report popup");
        setNewCustomReportModalOpen(true);
      }
    })]
  });
};
const AddNewReportButton = ({
  onClick: _onClick = () => {}
}) => {
  const classes = useStyles();
  return jsx(Fab, Object.assign({
    color: "primary",
    "aria-label": "new-report",
    className: classes.fab,
    onClick: _onClick
  }, {
    children: jsx(Add, {
      style: {
        color: 'white'
      }
    })
  }));
};

const CustomReportsPage = ({
  location
}) => {
  const {
    pathname
  } = location;
  const schemaId = pathname.split('/custom-reports/').pop();
  const {
    userMetrics
  } = useUserMetrics();
  React__default.useEffect(() => {
    userMetrics.trackEvent('page view', {
      page: 'custom-reports',
      category: 'org',
      'permission level': 'org:manager',
      report: schemaId
    });
  });
  return jsx(PageWithProviders, Object.assign({
    headerTitle: "Custom Reports"
  }, {
    children: jsx(OrgSchemasProvider, {
      children: jsx(RawReportProvider, {
        children: jsx(ReportSchemaProvider, Object.assign({
          schemaId: schemaId || null
        }, {
          children: jsx(AllPatientsProvider, Object.assign({
            fields: PATIENT_FIELDS
          }, {
            children: jsx(OrgGroupsProvider, {
              children: jsx(CustomReportsListProvider, {
                children: jsx(ThemeProvider, Object.assign({
                  theme: DashboardsTheme
                }, {
                  children: schemaId ? jsx(CustomReportsEditor, {}) : jsx(CustomReportsList, {})
                }))
              })
            })
          }))
        }))
      })
    })
  }));
};
const PATIENT_FIELDS = ['_id', 'fname', 'lname', 'patientNumber'];

const styles$6 = {
  icon: {
    marginLeft: 5
  }
};
const AdminOrganizationContextMenu = ({
  rowData,
  onEdit,
  onEditFeatureFlags,
  onEditAdministrator,
  onSetLogisticsOrg,
  onMarkLogisticsOrg
}) => {
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  return jsxs(IconButtonMenu, Object.assign({
    hoverLabel: localize('adminorg.menuHover', {
      name: rowData.name
    }),
    icon: MoreVert
  }, {
    children: [jsxs(MenuItem$1, Object.assign({
      onClick: () => {
        userMetrics.trackEvent("org-creation: open edit organization popup", {
          organizationId: rowData._id
        });
        onEdit();
      }
    }, {
      children: [jsx(Edit, {}), jsx(Typography, {
        children: localize('adminorg.editOrganization')
      })]
    }), 'admin_org_edit'), jsxs(MenuItem$1, Object.assign({
      onClick: () => {
        userMetrics.trackEvent("org-creation: open edit feature flags popup", {
          organizationId: rowData._id
        });
        onEditFeatureFlags();
      }
    }, {
      children: [jsx(Build, {}), jsx(Typography, {
        children: localize('adminorg.editflags')
      })]
    }), 'admin_org_feature_flags'), jsxs(MenuItem$1, Object.assign({
      onClick: () => {
        userMetrics.trackEvent("org-creation: open edit administrator popup", {
          organizationId: rowData._id
        });
        onEditAdministrator();
      }
    }, {
      children: [jsx(Person, {}), jsx(Typography, {
        children: localize('adminorg.editadmin')
      })]
    }), 'admin_org_feature_flags'), jsxs(MenuItem$1, Object.assign({
      onClick: () => {
        const eventText = rowData.type.includes('logistics') ? 'org-creation: open unset org as logistics provider popup' : 'org-creation: open set org as logistics provider popup';
        userMetrics.trackEvent(eventText, {
          organizationId: rowData._id
        });
        onSetLogisticsOrg();
      }
    }, {
      children: [jsx(LocalShipping, {}), jsx(Typography, Object.assign({
        style: styles$6.icon
      }, {
        children: rowData.type.includes("logistics") ? localize("adminorg.removeLogisticsOrg") : localize("adminorg.setAsLogisticsOrg")
      }))]
    }), 'admin_org_set_logistics_org'), jsxs(MenuItem$1, Object.assign({
      onClick: () => {
        userMetrics.trackEvent("org-creation: open assign logistics providers popup", {
          organizationId: rowData._id
        });
        onMarkLogisticsOrg();
      }
    }, {
      children: [jsx(Add, {}), jsx(Typography, {
        children: localize("adminorg.setLogisticsOrg")
      })]
    }), 'admin_org_set_org_logistics')]
  }));
};

const OrganizationCreate = ({
  data,
  onClose,
  onSubmit,
  submitRef
}) => {
  const {
    localize
  } = useLocalize();
  const validationSchema = yup.object({
    name: yup.string().required(localize('adminorg.errorNoName')),
    description: yup.string()
  });
  const formik = useFormik({
    initialValues: {
      name: (data === null || data === void 0 ? void 0 : data.name) || '',
      description: (data === null || data === void 0 ? void 0 : data.description) || ''
    },
    validateOnChange: true,
    validationSchema,
    onSubmit: values => {
      onSubmit(values);
      onClose();
    }
  });
  return jsx("form", Object.assign({
    ref: submitRef,
    onSubmit: formik.handleSubmit
  }, {
    children: jsx(Box, Object.assign({
      m: 1
    }, {
      children: jsxs(Grid, Object.assign({
        container: true,
        spacing: 2
      }, {
        children: [jsx(Grid, Object.assign({
          item: true,
          xs: 12
        }, {
          children: jsx(Typography, {
            children: localize('adminorg.name')
          })
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12
        }, {
          children: jsx(TextField, {
            id: "name",
            placeholder: localize('adminorg.name'),
            fullWidth: true,
            defaultValue: formik.values.name,
            onChange: formik.handleChange('name'),
            onBlur: formik.handleBlur,
            error: formik.touched.name && Boolean(formik.errors.name),
            helperText: formik.touched.name && formik.errors.name
          })
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12
        }, {
          children: jsx(Typography, {
            children: localize('adminorg.description')
          })
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 12
        }, {
          children: jsx(TextField, {
            id: "description",
            placeholder: localize('adminorg.description'),
            fullWidth: true,
            defaultValue: formik.values.description,
            onChange: formik.handleChange('description'),
            onBlur: formik.handleBlur,
            error: formik.touched.name && Boolean(formik.errors.name),
            helperText: formik.touched.name && formik.errors.name
          })
        }))]
      }))
    }))
  }));
};

const OrganizationCreateModal = _a => {
  var {
      open,
      onClose,
      data
    } = _a,
    otherProps = __rest(_a, ["open", "onClose", "data"]);
  const submitRef = useRef(null);
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  return jsxs(Dialog$1, Object.assign({
    open: !!open,
    maxWidth: "md",
    fullWidth: true,
    scroll: "body",
    onClose: onClose,
    disableEnforceFocus: true
  }, {
    children: [jsxs(DialogContent$1, {
      children: [jsx(Typography$1, Object.assign({
        variant: "h6"
      }, {
        children: data ? localize('adminorg.updateorg') : localize('adminorg.createorg')
      })), jsx(OrganizationCreate, Object.assign({
        onClose: onClose
      }, otherProps, {
        submitRef: submitRef,
        data: data
      }))]
    }), jsxs(DialogActions$2, {
      children: [jsx(Button$1, Object.assign({
        type: "submit",
        onClick: () => {
          var _a;
          userMetrics.trackEvent(`org-creation: ${data ? "update" : "create"} organization`, {
            organization: data === null || data === void 0 ? void 0 : data._id
          });
          (_a = submitRef === null || submitRef === void 0 ? void 0 : submitRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new Event('submit', {
            cancelable: true
          }));
        }
      }, {
        children: data ? localize('adminorg.updateorg') : localize('adminorg.createorg')
      }), 'org_create_submit'), jsx(Button$1, Object.assign({
        onClick: onClose
      }, {
        children: localize('users_cancel')
      }), "org_create_cancel")]
    })]
  }), 'org_create_modal');
};

const FeatureFlagEdit = ({
  data,
  onSubmit,
  submitRef
}) => {
  const routes = useRoutes();
  const {
    localize
  } = useLocalize();
  const routeList = routes['org:manager'].concat(routes['staff']).filter(route => route.key);
  const validationSchema = yup.object(Object.assign({}, routeList.reduce((result, route) => {
    result[route.key] = yup.number();
    return result;
  }, {})));
  const formik = useFormik({
    initialValues: routeList.reduce((result, route) => {
      result[route.key] = (data === null || data === void 0 ? void 0 : data[route.key]) || 0;
      return result;
    }, {}),
    validateOnChange: true,
    validationSchema,
    onSubmit: onSubmit
  });
  const checkedCount = routeList.reduce((result, route) => {
    if (formik.values[route.key] === 1) return result + 1;
    return result;
  }, 0);
  return jsx("form", Object.assign({
    ref: submitRef,
    onSubmit: formik.handleSubmit
  }, {
    children: jsxs(Table$1, Object.assign({
      size: "small",
      "aria-label": localize('adminorg.routeSelectTable')
    }, {
      children: [jsx(TableHead, {
        children: jsxs(TableRow, {
          children: [jsx(TableCell$1, {
            children: localize('adminorg.featureflagpage')
          }), jsx(TableCell$1, {
            children: jsx(Checkbox, {
              indeterminate: checkedCount !== 0 && checkedCount < routeList.length,
              checked: checkedCount !== 0 && checkedCount === routeList.length,
              inputProps: {
                'aria-label': localize('adminorg.selectallroutes')
              },
              onChange: event => {
                formik.setValues(routeList.reduce((result, route) => {
                  result[route.key] = event.target.checked ? 1 : 0;
                  return result;
                }, {}));
              }
            })
          })]
        })
      }), jsx(TableBody, {
        children: routeList.map(route => jsxs(TableRow, {
          children: [jsx(TableCell$1, {
            children: localize(route.name)
          }), jsx(TableCell$1, {
            children: jsx(Checkbox, {
              checked: !!formik.values[route.key],
              inputProps: {
                'aria-label': `${route.key}`
              },
              onChange: event => event.target.checked ? formik.setFieldValue(route.key, 1) : formik.setFieldValue(route.key, 0)
            })
          })]
        }, route.key))
      })]
    }))
  }));
};

const FeatureFlagModal = _a => {
  var {
      open,
      onClose
    } = _a,
    otherProps = __rest(_a, ["open", "onClose"]);
  const submitRef = useRef(null);
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  return jsxs(Dialog$1, Object.assign({
    open: !!open,
    maxWidth: "md",
    fullWidth: true,
    scroll: "body",
    onClose: onClose,
    disableEnforceFocus: true
  }, {
    children: [jsxs(DialogContent$1, {
      children: [jsx(Typography$1, Object.assign({
        variant: "h6"
      }, {
        children: localize('adminorg.editfeatureflags')
      })), jsx(FeatureFlagEdit, Object.assign({}, otherProps, {
        submitRef: submitRef
      }))]
    }), jsxs(DialogActions$2, {
      children: [jsx(Button$1, Object.assign({
        type: "submit",
        onClick: () => {
          var _a;
          userMetrics.trackEvent("org-creation: edit org feature flags");
          (_a = submitRef === null || submitRef === void 0 ? void 0 : submitRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new Event('submit', {
            cancelable: true
          }));
        }
      }, {
        children: localize('adminorg.editflags')
      }), 'org_feature_flag_submit'), jsx(Button$1, Object.assign({
        onClick: onClose
      }, {
        children: localize('users_cancel')
      }), "org_feature_flag_cancel")]
    })]
  }), 'org_feature_flag_modal');
};

const SetLogisticsOrg = ({
  open,
  org,
  logisticsOrganizations,
  onClose,
  onSubmit
}) => {
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  const [logisticsOrgs, setLogisticsOrgs] = React__default.useState([]);
  const [currentLogisticsOrg, setCurrentLogisticsOrg] = React__default.useState();
  const [confirmation, setConfirmation] = React__default.useState(false);
  useEffect(() => {
    if (open) setCurrentLogisticsOrg((org === null || org === void 0 ? void 0 : org.logisticsOrganization) || []);
  }, [open, org]);
  const submit = () => {
    if (org || logisticsOrgs.length > 0) onSubmit((org === null || org === void 0 ? void 0 : org._id) || '', logisticsOrgs);
  };
  return jsxs(Dialog$1, Object.assign({
    open: !!open,
    maxWidth: "md",
    fullWidth: true,
    scroll: "body",
    onClose: onClose,
    disableEnforceFocus: true
  }, {
    children: [jsx(ActionDialog, Object.assign({
      open: !!confirmation,
      onClose: () => {
        setConfirmation(false);
      },
      title: localize('common.confirm'),
      actions: [jsx(Button$1, Object.assign({
        onClick: () => {
          const eventText = "org-creation: assign logistics providers";
          userMetrics.trackEvent(eventText);
          submit();
          setConfirmation(false);
          onClose();
          setLogisticsOrgs([]);
          setCurrentLogisticsOrg([]);
        },
        color: "primary"
      }, {
        children: localize('common.confirm')
      }), 'submit'), jsx(Button$1, Object.assign({
        onClick: () => {
          const eventText = "org-creation: close assign logistics providers confirmation popup";
          userMetrics.trackEvent(eventText, {
            org: org === null || org === void 0 ? void 0 : org._id
          });
          setConfirmation(false);
        },
        color: "primary"
      }, {
        children: localize('common.cancel')
      }), 'cancel')]
    }, {
      children: jsx(Typography$1, {
        children: "Would you like to make these changes?"
      })
    })), jsx(DialogContent$1, {
      children: jsx(Typography$1, Object.assign({
        variant: "h6"
      }, {
        children: localize('adminorg.setLogisticsOrg')
      }))
    }), jsx(Table$1, Object.assign({
      size: "small",
      "aria-label": localize('adminorg.routeSelectTable')
    }, {
      children: jsx(TableBody, {
        children: logisticsOrganizations.map(logisticsOrg => jsxs(TableRow, {
          children: [jsx(TableCell$1, {
            children: localize(logisticsOrg.name)
          }), jsx(TableCell$1, {
            children: jsx(Checkbox, {
              checked: currentLogisticsOrg ? currentLogisticsOrg.filter(org => org === logisticsOrg._id).length > 0 : false,
              inputProps: {
                'aria-label': `${logisticsOrg.name}`
              },
              onChange: e => {
                if (e.target.checked) {
                  setCurrentLogisticsOrg([...(currentLogisticsOrg || []), logisticsOrg._id]);
                } else {
                  setCurrentLogisticsOrg(currentLogisticsOrg === null || currentLogisticsOrg === void 0 ? void 0 : currentLogisticsOrg.filter(org => org !== logisticsOrg._id));
                }
                if (logisticsOrgs.filter(org => org._id === logisticsOrg._id).length === 0) {
                  setLogisticsOrgs([...logisticsOrgs, {
                    _id: logisticsOrg._id,
                    isLogisticsOrg: e.target.checked
                  }]);
                } else {
                  setLogisticsOrgs(logisticsOrgs.map(org => {
                    if (org._id === logisticsOrg._id) {
                      return {
                        _id: logisticsOrg._id,
                        isLogisticsOrg: e.target.checked
                      };
                    }
                    return org;
                  }));
                }
              }
            })
          })]
        }, logisticsOrg._id))
      })
    })), jsxs(DialogActions$2, {
      children: [jsx(Button$1, Object.assign({
        onClick: () => {
          const eventText = 'org-creation: open assign logistics providers confirmation popup';
          userMetrics.trackEvent(eventText);
          setConfirmation(true);
        }
      }, {
        children: localize('confirm')
      }), "org_logistics_add"), jsx(Button$1, Object.assign({
        onClick: onClose
      }, {
        children: localize('users_cancel')
      }), "org_logistics_add_cancel")]
    })]
  }), 'org_feature_set_logistics_org');
};

const commonStyles$2 = {
  fontFamily: 'Poppins',
  fontWeight: 400,
  cursor: 'initial',
  flex: 1,
  display: 'flex',
  alignItems: 'center'
};
const styles$5 = {
  cell: Object.assign({}, commonStyles$2),
  header: Object.assign(Object.assign({}, commonStyles$2), {
    backgroundColor: '#C4DFE0'
  }),
  icon: {
    marginRight: 5
  }
};
const StyledInfiniteScroll = styled(InfiniteScroll)(({
  smallDevice
}) => ({
  padding: smallDevice ? '20px 5vh' : '20px 5vh'
}));
const AdminOrganizations = () => {
  const {
    organizations,
    logisticsOrganizations,
    nextPage,
    filterByQuery,
    updateOrg,
    createOrg,
    updateFeatureFlags,
    updateAdministrator,
    setLogistics,
    assignLogistics
  } = useAdminOrganization();
  const isLaptop = useMediaQuery('(min-width:1024px)');
  const [createOpen, setCreateOpen] = useState(false);
  const [editing, setEditing] = useState(undefined);
  const [editFlags, setEditFlags] = useState(undefined);
  const [editAdministrator, setEditAdministrator] = useState(undefined);
  const [markLogisticsOrg, setMarkLogisticsOrg] = useState(undefined);
  const [asLogisticsOrg, setAsLogisticsOrg] = useState(undefined);
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  React__default.useEffect(() => {
    userMetrics.trackEvent("page view", {
      page: "org-creation",
      category: "org",
      "permission level": "admin"
    });
  }, [userMetrics]);
  const columns = [{
    label: localize('adminorg.table.name'),
    dataFn: ({
      rowData
    }) => {
      var _a, _b, _c, _d;
      return jsxs("div", {
        children: [jsxs(Grid$1, Object.assign({
          container: true,
          alignItems: "center"
        }, {
          children: [rowData.type.includes('logistics') && jsx(LocalShipping, {
            fontSize: "small",
            style: styles$5.icon
          }), jsx(Typography$1, {
            children: rowData.name
          })]
        })), rowData.description && jsx(Typography$1, Object.assign({
          style: {
            fontSize: 12,
            color: 'black'
          }
        }, {
          children: rowData.description
        })), ((_a = rowData === null || rowData === void 0 ? void 0 : rowData.administratorData) === null || _a === void 0 ? void 0 : _a.fname) && ((_b = rowData === null || rowData === void 0 ? void 0 : rowData.administratorData) === null || _b === void 0 ? void 0 : _b.lname) && jsx(Typography$1, Object.assign({
          style: {
            fontSize: 12,
            color: 'black'
          }
        }, {
          children: localize('adminorg.adminby', {
            fname: (_c = rowData === null || rowData === void 0 ? void 0 : rowData.administratorData) === null || _c === void 0 ? void 0 : _c.fname,
            lname: (_d = rowData === null || rowData === void 0 ? void 0 : rowData.administratorData) === null || _d === void 0 ? void 0 : _d.lname
          })
        }))]
      });
    },
    width: 100,
    dataKey: 'name',
    headerStyle: styles$5.header,
    rowStyle: styles$5.cell
  }, {
    label: '',
    dataKey: 'menu',
    flexGrow: 0,
    flexShrink: 1,
    width: 65,
    headerStyle: styles$5.header,
    rowStyle: styles$5.cell,
    dataFn: ({
      rowData
    }) => jsx(AdminOrganizationContextMenu, {
      rowData: rowData,
      onEdit: () => setEditing(rowData),
      onEditFeatureFlags: () => setEditFlags(rowData),
      onEditAdministrator: () => setEditAdministrator(rowData),
      onMarkLogisticsOrg: () => setMarkLogisticsOrg(rowData),
      onSetLogisticsOrg: () => setAsLogisticsOrg(rowData)
    })
  }];
  return jsxs(StyledInfiniteScroll, Object.assign({
    smallDevice: isLaptop,
    loadMore: nextPage
  }, {
    children: [jsx(ActionDialog, Object.assign({
      open: !!asLogisticsOrg,
      onClose: () => {
        setAsLogisticsOrg(undefined);
        const eventText = (asLogisticsOrg === null || asLogisticsOrg === void 0 ? void 0 : asLogisticsOrg.type.includes('logistics')) ? 'org-creation: close unset org as logistics provider popup' : 'org-creation: close set org as logistics provider popup';
        userMetrics.trackEvent(eventText, {
          org: asLogisticsOrg === null || asLogisticsOrg === void 0 ? void 0 : asLogisticsOrg._id
        });
      },
      title: (asLogisticsOrg === null || asLogisticsOrg === void 0 ? void 0 : asLogisticsOrg.type.includes('logistics')) ? localize('adminorg.removeLogisticsOrg') : localize('adminorg.setLogisticsOrg'),
      actions: [jsx(Button$1, Object.assign({
        onClick: () => {
          const eventText = (asLogisticsOrg === null || asLogisticsOrg === void 0 ? void 0 : asLogisticsOrg.type.includes('logistics')) ? 'org-creation: unset org as logistics provider and close popup' : 'org-creation: set org as logistics provider and close popup';
          userMetrics.trackEvent(eventText, {
            org: asLogisticsOrg === null || asLogisticsOrg === void 0 ? void 0 : asLogisticsOrg._id
          });
          setLogistics((asLogisticsOrg === null || asLogisticsOrg === void 0 ? void 0 : asLogisticsOrg._id) || '', (asLogisticsOrg === null || asLogisticsOrg === void 0 ? void 0 : asLogisticsOrg.type.includes('logistics')) ? false : true);
          setAsLogisticsOrg(undefined);
        },
        color: "primary"
      }, {
        children: localize('common.confirm')
      }), 'submit'), jsx(Button$1, Object.assign({
        onClick: () => {
          setAsLogisticsOrg(undefined);
          const eventText = (asLogisticsOrg === null || asLogisticsOrg === void 0 ? void 0 : asLogisticsOrg.type.includes('logistics')) ? 'org-creation: close unset org as logistics provider popup' : 'org-creation: close set org as logistics provider popup';
          userMetrics.trackEvent(eventText, {
            org: asLogisticsOrg === null || asLogisticsOrg === void 0 ? void 0 : asLogisticsOrg._id
          });
        },
        color: "primary"
      }, {
        children: localize('common.cancel')
      }), 'cancel')]
    }, {
      children: jsx(Typography$1, {
        children: (asLogisticsOrg === null || asLogisticsOrg === void 0 ? void 0 : asLogisticsOrg.type.includes('logistics')) ? localize('adminorg.removeLogisticsOrgDescription') : localize('adminorg.setLogisticsOrgDescription')
      })
    })), jsx(SetLogisticsOrg, {
      open: !!markLogisticsOrg,
      onClose: () => {
        setMarkLogisticsOrg(undefined);
        userMetrics.trackEvent("org-creation: close assign logistics providers popup", {
          org: markLogisticsOrg === null || markLogisticsOrg === void 0 ? void 0 : markLogisticsOrg._id
        });
      },
      logisticsOrganizations: logisticsOrganizations,
      onSubmit: assignLogistics,
      org: markLogisticsOrg
    }), jsx(OrganizationCreateModal, {
      open: !!editing || !!createOpen,
      onClose: () => {
        editing ? setEditing(undefined) : setCreateOpen(false);
        userMetrics.trackEvent("org-creation: close edit org popup", {
          org: editing === null || editing === void 0 ? void 0 : editing._id
        });
      },
      data: editing,
      onSubmit: editing ? data => updateOrg(editing._id, data) : data => createOrg(data)
    }), jsx(FeatureFlagModal, {
      open: !!editFlags,
      onClose: () => {
        setEditFlags(undefined);
        userMetrics.trackEvent("org-creation: close edit feature flags popup");
      },
      data: (editFlags === null || editFlags === void 0 ? void 0 : editFlags.featureFlag) || {},
      onSubmit: flags => {
        if (editFlags) {
          updateFeatureFlags(editFlags._id, flags);
          setEditFlags(undefined);
        }
      }
    }), !!editAdministrator && jsx(SearchPeopleModal, {
      open: true,
      onClose: () => {
        setEditAdministrator(undefined);
        userMetrics.trackEvent("org-creation: close edit administrator popup");
      },
      defaults: [(editAdministrator === null || editAdministrator === void 0 ? void 0 : editAdministrator.administrator) || 'none'],
      onChange: person => {
        if (editAdministrator && editAdministrator._id) updateAdministrator(editAdministrator._id, person);
      },
      placeholder: localize('adminorg.searchadmin'),
      title: localize('adminorg.editadmin')
    }), jsxs(Grid$1, Object.assign({
      container: true,
      spacing: 2
    }, {
      children: [jsx(Grid$1, Object.assign({
        item: true,
        xs: 12,
        md: 10
      }, {
        children: jsx(SearchBar, {
          id: 'searchOrg',
          width: "100%",
          placeholder: localize('adminorg.searchOrg'),
          testId: 'searchOrg',
          onChange: event => filterByQuery(event.target.value)
        })
      })), jsx(Grid$1, Object.assign({
        item: true,
        xs: 12,
        md: 2
      }, {
        children: jsx("div", Object.assign({
          style: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end'
          }
        }, {
          children: jsx(Button$1, Object.assign({
            color: "primary",
            variant: "contained",
            startIcon: jsx(Add, {
              style: {
                color: 'white'
              }
            }),
            onClick: () => {
              userMetrics.trackEvent("org-creation: open create org modal");
              setCreateOpen(true);
            }
          }, {
            children: localize('adminorg.addOrg')
          }))
        }))
      })), jsx(Grid$1, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsx(VirtualizedTable, {
          rowCount: organizations.length,
          rowGetter: ({
            index
          }) => organizations[index],
          rowHeight: 70,
          headerHeight: 50,
          columns: columns
        })
      }))]
    }))]
  }));
};

const AdminOrganizationsPage = () => {
  const {
    userMetrics
  } = useUserMetrics();
  React__default.useEffect(() => {
    userMetrics.trackEvent('page view', {
      page: 'org-creation',
      category: 'org',
      'permission level': 'admin'
    });
  });
  return jsx(PageWithProviders, Object.assign({
    headerTitle: 'dashboards_create'
  }, {
    children: jsx(PeopleProvider, {
      children: jsx(AdminOrganizationProvider, {
        children: jsx(ThemeProvider$1, Object.assign({
          theme: DashboardsTheme
        }, {
          children: jsx(AdminOrganizations, {})
        }))
      })
    })
  }));
};

const CountDisplay = ({
  stock,
  used,
  label
}) => jsx(ThemeProvider$1, Object.assign({
  theme: LogisticsTheme
}, {
  children: jsxs(Grid, Object.assign({
    container: true,
    spacing: 1,
    direction: "column"
  }, {
    children: [jsx(Grid, Object.assign({
      item: true,
      xs: 6
    }, {
      children: jsx(Chip, {
        color: "primary",
        size: "small",
        label: `${stock} In Stock`
      })
    })), jsx(Grid, Object.assign({
      item: true,
      xs: 6
    }, {
      children: jsx(Chip, {
        color: "primary",
        variant: "outlined",
        size: "small",
        label: `${used} ${label}`
      })
    }))]
  }))
}));

const ItemTable = ({
  itemData
}) => {
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  const [openNewItem, setOpenNewItem] = useState(false);
  const [itemModel, setItemModel] = useState(itemData[0]);
  const modelCell = (name, number) => jsxs("div", {
    children: [jsx(Typography, {
      children: name
    }), jsx(Typography, Object.assign({
      style: {
        fontSize: 12
      }
    }, {
      children: number
    }))]
  });
  return jsxs(ThemeProvider$1, Object.assign({
    theme: LogisticsTheme
  }, {
    children: [jsx(NewItem, {
      open: openNewItem,
      onCloseCallback: () => {
        setOpenNewItem(false);
        userMetrics.trackEvent("logistics: close create item popup");
      },
      itemModel: itemModel
    }), jsx(TableContainer, Object.assign({
      component: Paper$1
    }, {
      children: jsxs(Table$1, {
        children: [jsx(TableHead, {
          children: jsxs(TableRow, {
            children: [jsx(TableCell$1, {
              children: localize('Class')
            }), jsx(TableCell$1, {
              children: localize('Make')
            }), jsx(TableCell$1, {
              children: localize('Model')
            }), jsx(TableCell$1, {
              children: localize('Stock')
            }), jsx(TableCell$1, {
              width: 10
            })]
          })
        }), jsx(TableBody, {
          children: itemData.map((item, index) => {
            return jsxs(TableRow, {
              children: [jsx(TableCell$1, {
                children: item.itemClass
              }), jsx(TableCell$1, {
                children: item.make
              }), jsx(TableCell$1, {
                children: modelCell(item.modelName, item.modelNumber)
              }), jsx(TableCell$1, {
                children: jsx(CountDisplay, {
                  stock: item.stockCount,
                  used: item.kitCount,
                  label: localize('In_Kits')
                })
              }), jsx(TableCell$1, Object.assign({
                align: "right",
                width: 10
              }, {
                children: jsx(IconButtonMenu, Object.assign({
                  hoverLabel: localize('Item_Menu'),
                  icon: MoreVert
                }, {
                  children: jsx(DefaultIconbuttonMenuItem, {
                    onClick: () => {
                      userMetrics.trackEvent("logistics: open create item popup");
                      setItemModel(item);
                      setOpenNewItem(true);
                    },
                    label: localize('Create_Item')
                  }, 'CreateItem')
                }))
              }))]
            }, item._id);
          })
        })]
      })
    }))]
  }));
};

const ItemInventory = () => {
  const [selectedMakes, setSelectedMakes] = useState([]);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const {
    itemModels,
    itemMakes,
    itemClasses,
    filterByMake,
    filterByClass,
    filterBySearch,
    isLoading
  } = useItemModels();
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  const makeOptions = itemMakes.map(make => ({
    value: make,
    text: make
  }));
  const classOptions = itemClasses.map(model => ({
    value: model,
    text: model
  }));
  return jsxs(Grid, Object.assign({
    container: true,
    direction: "column",
    spacing: 2
  }, {
    children: [jsx(Grid, Object.assign({
      item: true,
      xs: 12
    }, {
      children: jsx(SearchBar, {
        id: 'model-search',
        testId: 'model-search',
        width: '99%',
        placeholder: 'Model Name / Model Number',
        theme: LogisticsTheme,
        onChange: event => {
          var _a, _b;
          userMetrics.trackEvent('logistics: search in items tab', {
            search: ((_a = event.target) === null || _a === void 0 ? void 0 : _a.value) || ''
          });
          return filterBySearch(((_b = event.target) === null || _b === void 0 ? void 0 : _b.value) || '');
        }
      })
    })), jsxs(Grid, Object.assign({
      item: true,
      xs: 12,
      container: true,
      direction: "row",
      spacing: 2,
      justifyContent: "flex-start"
    }, {
      children: [jsx(TextMultiSelect, Object.assign({
        options: classOptions,
        value: selectedClasses,
        ariaLabel: localize('CLass'),
        onChange: event => {
          var _a;
          const classes = event.target.value;
          setSelectedClasses(classes);
          filterByClass(classes);
          userMetrics.trackEvent('logistics: search in items tab', {
            search: ((_a = event.target) === null || _a === void 0 ? void 0 : _a.value) || ''
          });
        },
        size: 'l'
      }, {
        children: localize('CLass')
      })), jsx(TextMultiSelect, Object.assign({
        options: makeOptions,
        ariaLabel: localize('Make'),
        value: selectedMakes,
        onChange: event => {
          var _a;
          const makes = event.target.value;
          setSelectedMakes(makes);
          filterByMake(makes);
          userMetrics.trackEvent('logistics: search in items tab', {
            search: ((_a = event.target) === null || _a === void 0 ? void 0 : _a.value) || ''
          });
        },
        size: 'l'
      }, {
        children: localize('Make')
      }))]
    })), jsxs(Grid, Object.assign({
      item: true,
      xs: 12
    }, {
      children: [jsx(ItemTable, {
        itemData: itemModels
      }), isLoading && jsx("div", Object.assign({
        style: {
          display: 'flex',
          justifyContent: 'center',
          color: 'primary'
        }
      }, {
        children: jsx(SpinningIcon, {
          icon: Sync,
          spinning: true
        })
      })), itemModels.length === 0 && !isLoading ? jsx(Typography, Object.assign({
        style: {
          padding: 25,
          fontWeight: 500,
          fontSize: 16,
          display: 'flex',
          justifyContent: 'center'
        }
      }, {
        children: localize('No_Results')
      })) : null]
    }))]
  }));
};
const ItemTab = () => jsx(ItemModelsProvider, {
  children: jsx(ItemProvider, {
    children: jsx(ItemInventory, {})
  })
});

const MakeKitTable = ({
  data
}) => {
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  const {
    isLoading
  } = useKitModels();
  const [openModelDetails, setOpenModelDetails] = useState(false);
  const [openNewKit, setOpenNewKit] = useState(false);
  const [kitModelId, setKitModelId] = useState('');
  const itemsFn = ({
    rowData: {
      itemModels
    }
  }) => {
    let itemsList = '';
    itemModels.forEach(item => itemsList += item.itemModel.itemClass + ', ');
    return itemsList;
  };
  const modelFn = ({
    rowData: {
      modelName,
      modelNumber
    }
  }) => {
    return jsxs(Grid, Object.assign({
      container: true,
      direction: "column"
    }, {
      children: [jsx(Typography, Object.assign({
        style: {
          fontWeight: 500,
          fontSize: 16
        }
      }, {
        children: modelName
      })), jsx(Typography, Object.assign({
        style: {
          fontWeight: 400,
          fontSize: 12
        }
      }, {
        children: modelNumber
      }))]
    }));
  };
  return jsxs(ThemeProvider$1, Object.assign({
    theme: LogisticsTheme
  }, {
    children: [jsxs(Paper, {
      children: [jsx(VirtualizedTable, {
        rowGetter: ({
          index
        }) => data[index],
        rowCount: data.length,
        rowHeight: 100,
        columns: [{
          label: localize('Model'),
          dataFn: modelFn,
          dataKey: 'model',
          width: 200,
          minWidth: 120,
          flexShrink: 1,
          flexGrow: 0
        }, {
          label: localize('Items'),
          dataFn: itemsFn,
          width: 100,
          dataKey: 'items'
        }, {
          label: localize('Stock'),
          dataFn: ({
            rowData: {
              stockCount,
              assignedCount
            }
          }) => jsx(CountDisplay, {
            stock: stockCount,
            used: assignedCount,
            label: localize('Assigned')
          }),
          width: 80,
          minWidth: 130,
          dataKey: 'stock',
          flexShrink: 1,
          flexGrow: 0
        }, {
          label: '',
          dataFn: ({
            rowData
          }) => jsxs(IconButtonMenu, Object.assign({
            hoverLabel: localize('Item_Menu'),
            icon: MoreVert
          }, {
            children: [jsx(DefaultIconbuttonMenuItem, {
              label: localize('Kit_Model_Details'),
              onClick: () => {
                userMetrics.trackEvent("logistics: open kit model details popup", {
                  model: rowData._id
                });
                setKitModelId(rowData._id);
                setOpenModelDetails(true);
              }
            }, 'kit_model_details'), jsx(DefaultIconbuttonMenuItem, {
              label: localize('New_Kit'),
              onClick: () => {
                userMetrics.trackEvent("logistics: open build new kit popup", {
                  model: rowData._id
                });
                setKitModelId(rowData._id);
                setOpenNewKit(true);
              }
            }, 'create_new_kit')]
          })),
          flexGrow: 0,
          flexShrink: 1,
          minWidth: 80,
          dataKey: 'options',
          width: 80
        }]
      }), isLoading && jsx("div", Object.assign({
        style: {
          display: 'flex',
          justifyContent: 'center',
          color: 'primary'
        }
      }, {
        children: jsx(SpinningIcon, {
          icon: Sync,
          spinning: true
        })
      })), data.length === 0 && !isLoading ? jsx(Typography, Object.assign({
        style: {
          padding: 25,
          fontWeight: 500,
          fontSize: 16,
          display: 'flex',
          justifyContent: 'center'
        }
      }, {
        children: localize('No_Results')
      })) : null]
    }), jsx(ActionDialog, Object.assign({
      title: localize('Kit_Model_Details'),
      actions: [],
      open: openModelDetails,
      onClose: () => {
        setOpenModelDetails(false);
        userMetrics.trackEvent("logistics: close kit model details popup");
      }
    }, {
      children: jsx(KitModelDetails, {
        kitModel: data.filter(kit => kit._id === kitModelId)[0],
        theme: LogisticsTheme
      })
    })), jsx(NewKit, {
      open: openNewKit,
      onClose: () => {
        setOpenNewKit(false);
        userMetrics.trackEvent("logistics: close build new kit popup");
      },
      kitModelData: data.find(kitModel => kitModel._id === kitModelId)
    })]
  }));
};
const KitTable = ({
  data
}) => jsx(KitProvider, {
  children: jsx(ItemProvider, {
    children: jsx(MakeKitTable, {
      data: data
    })
  })
});

const KitInventory = () => {
  const [selectedItems, setSelectedItems] = useState([]);
  const {
    userMetrics
  } = useUserMetrics();
  const {
    localize
  } = useLocalize();
  const {
    kitModels,
    itemClasses,
    filterByItem,
    filterBySearch,
    nextPage
  } = useKitModels();
  return jsx(InfiniteScroll, Object.assign({
    loadMore: nextPage
  }, {
    children: jsxs(Grid, Object.assign({
      container: true,
      spacing: 2
    }, {
      children: [jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsx(SearchBar, {
          id: 'KitSearch',
          testId: 'KitSearch',
          width: "100%",
          placeholder: 'Model Name / Model Number',
          theme: LogisticsTheme,
          onChange: event => {
            var _a, _b;
            filterBySearch(((_a = event.target) === null || _a === void 0 ? void 0 : _a.value) || '');
            userMetrics.trackEvent('logistics: search in kit tab', {
              search: ((_b = event.target) === null || _b === void 0 ? void 0 : _b.value) || ''
            });
          }
        })
      })), jsx(Grid, Object.assign({
        item: true,
        xs: 12,
        container: true,
        direction: "row",
        spacing: 2,
        justifyContent: "flex-start"
      }, {
        children: jsx(Grid, Object.assign({
          item: true,
          "aria-label": `${localize('Items')} Grid`,
          xs: 3
        }, {
          children: jsx(TextMultiSelect, Object.assign({
            options: itemClasses.map(item => ({
              value: item,
              text: item
            })),
            value: selectedItems,
            ariaLabel: localize('Items'),
            onChange: event => {
              const items = event.target.value;
              setSelectedItems(items);
              filterByItem(items);
              userMetrics.trackEvent('logistics: filter by items in kit tab', {
                itemClass: event.target.value
              });
            },
            size: 'l'
          }, {
            children: localize('Items')
          }))
        }), "ItemFilter")
      })), jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsx(KitTable, {
          data: kitModels
        })
      }))]
    }))
  }));
};
const KitTab = () => jsx(KitModelsProvider, {
  children: jsx(KitInventory, {})
});

const PatientInfoDisplay = ({
  patientInfo,
  shippingAddress,
  organization,
  kit
}) => {
  var _a;
  const {
    localize
  } = useLocalize();
  const shippingLabel = useMemo(() => `${shippingAddress.apartment || ''} ${shippingAddress.street || ''} ${shippingAddress.city || ''}, ${shippingAddress.province || ''} ${shippingAddress.country || ''} ${shippingAddress.postal || ''}`, [shippingAddress]);
  const patientAddress = useMemo(() => {
    if (!patientInfo.street && !patientInfo.city && !patientInfo.province && !patientInfo.country && !patientInfo.postal || patientInfo.street === shippingAddress.street && patientInfo.city === shippingAddress.city && patientInfo.province === shippingAddress.province && patientInfo.country === shippingAddress.country && patientInfo.postal === shippingAddress.postal) return null;else return `${patientInfo.apartment || ''} ${patientInfo.street || ''} ${patientInfo.city || ''}, ${patientInfo.province || ''} ${patientInfo.country || ''} ${patientInfo.postal || ''}`;
  }, [patientInfo, shippingAddress]);
  const {
    phoneNumber1,
    phoneNumber2,
    patientPhoneNumber
  } = useMemo(() => {
    return {
      phoneNumber1: (shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.phone) ? formatPhoneNumber(shippingAddress.phone) : undefined,
      phoneNumber2: (shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.phone2) ? formatPhoneNumber(shippingAddress.phone2) : undefined,
      patientPhoneNumber: (patientInfo === null || patientInfo === void 0 ? void 0 : patientInfo.phone) ? formatPhoneNumber(patientInfo.phone) : undefined
    };
  }, [shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.phone, shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.phone2, patientInfo === null || patientInfo === void 0 ? void 0 : patientInfo.phone]);
  const patientNumber = (_a = patientInfo === null || patientInfo === void 0 ? void 0 : patientInfo.patientNumber) !== null && _a !== void 0 ? _a : null;
  return jsx(ThemeProvider$1, Object.assign({
    theme: LogisticsTheme
  }, {
    children: jsxs(Grid, Object.assign({
      container: true,
      direction: "column"
    }, {
      children: [jsx(Grid, Object.assign({
        item: true
      }, {
        children: jsx(Typography, Object.assign({
          style: {
            fontWeight: 500,
            fontSize: 16,
            paddingBottom: 10
          }
        }, {
          children: `${(patientInfo === null || patientInfo === void 0 ? void 0 : patientInfo.lname) || ''}, ${(patientInfo === null || patientInfo === void 0 ? void 0 : patientInfo.fname) || ''}`
        }))
      })), jsxs(Grid, Object.assign({
        item: true,
        container: true
      }, {
        children: [jsx(Grid, Object.assign({
          item: true,
          xs: 2
        }, {
          children: jsx(Call, {
            color: "primary"
          })
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 10
        }, {
          children: jsx(Typography, {
            children: phoneNumber1 || jsx("i", {
              children: localize('PatientInfoDisplay_NotProvided')
            })
          })
        }))]
      })), phoneNumber2 ? jsxs(Grid, Object.assign({
        item: true,
        container: true
      }, {
        children: [jsx(Grid, Object.assign({
          item: true,
          xs: 2
        }, {
          children: jsx(Call, {
            color: "primary"
          })
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 10
        }, {
          children: jsx(Typography, {
            children: phoneNumber2 || ''
          })
        }))]
      })) : null, patientPhoneNumber ? jsxs(Grid, Object.assign({
        item: true,
        container: true
      }, {
        children: [jsx(Grid, Object.assign({
          item: true,
          xs: 2
        }, {
          children: jsx(ContactPhone, {
            color: "primary"
          })
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 10
        }, {
          children: jsx(Typography, {
            children: patientPhoneNumber || ''
          })
        }))]
      })) : null, jsxs(Grid, Object.assign({
        item: true,
        container: true,
        alignItems: "center",
        style: {
          marginBottom: 2
        }
      }, {
        children: [jsx(Grid, Object.assign({
          item: true,
          xs: 2
        }, {
          children: jsx(LocalHospital, {
            color: "primary"
          })
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 10
        }, {
          children: jsx(Typography, {
            children: organization || ''
          })
        }))]
      })), jsxs(Grid, Object.assign({
        item: true,
        container: true
      }, {
        children: [jsx(Grid, Object.assign({
          item: true,
          xs: 2
        }, {
          children: jsx(LocalShipping, {
            color: "primary"
          })
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 10
        }, {
          children: jsx(Typography, Object.assign({
            style: {}
          }, {
            children: shippingLabel
          }))
        }))]
      })), patientAddress && jsxs(Grid, Object.assign({
        item: true,
        container: true
      }, {
        children: [jsx(Grid, Object.assign({
          item: true,
          xs: 2
        }, {
          children: jsx(Home, {
            color: "primary"
          })
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 10
        }, {
          children: jsx(Typography, Object.assign({
            style: {}
          }, {
            children: patientAddress
          }))
        }))]
      })), patientNumber && jsxs(Grid, Object.assign({
        item: true,
        container: true
      }, {
        children: [jsx(Grid, Object.assign({
          item: true,
          xs: 2
        }, {
          children: jsx(Typography, {
            children: localize('group_users_overview_PatientNumber') + ':'
          })
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 10
        }, {
          children: jsx(Typography, Object.assign({
            style: {}
          }, {
            children: patientNumber
          }))
        }))]
      }))]
    }))
  }));
};
function formatPhoneNumber(phoneString) {
  if (!phoneString) {
    return null;
  }
  const phone = phoneString.replace(/\D/g, '');
  if (phone.length > 10) {
    return `(${phone.substring(phone.length - 10, phone.length - 7)})-${phone.substring(phone.length - 7, phone.length - 4)}-${phone.substring(phone.length - 4)}`;
  }
  return `(${phone.substring(0, 3)})-${phone.substring(3, 6)}-${phone.substring(6)}`;
}

const getStateDateLabel = (state, localize) => {
  switch (state) {
    case 'requested':
      {
        return localize('Requested_Label');
      }
    case 'assigned':
      {
        return localize('Assigned_Label');
      }
    case 'shipping':
      {
        return localize('Shipping_Label');
      }
    case 'received':
      {
        return localize('Received_Label');
      }
    case 'setup':
      {
        return localize('Setup_Label');
      }
    case 'return prep':
      {
        return localize('Return_Prep_Label');
      }
    case 'returning':
      {
        return localize('Returning_Label');
      }
    case 'returned':
      {
        return localize('Returned_Label');
      }
    default:
      return '';
  }
};
const KitStatus = ({
  kit,
  requestByDate,
  assignmentId,
  noteCallback,
  historyCallback,
  showStatus
}) => {
  var _a;
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  const {
    getUnreadNotesCount,
    unreadMap
  } = useLogisticsNotes();
  useEffect(() => {
    if (!assignmentId) return;
    getUnreadNotesCount(assignmentId);
  }, [assignmentId, getUnreadNotesCount]);
  const kitState = kit ? kit.state : 'requested';
  const kitHistory = kit ? kit.stateHistory : [];
  const dateLabel = getStateDateLabel(kitState, localize);
  const date = kit ? (_a = kitHistory[kitHistory.length - 1]) === null || _a === void 0 ? void 0 : _a.timestamp : requestByDate;
  const makeDate = new Date(date);
  const buildDate = `${makeDate.getUTCFullYear()}/${makeDate.getUTCMonth() + 1}/${makeDate.getUTCDate()}`;
  const getChip = state => {
    if (state === 'setup') {
      return jsx(Chip, {
        color: "primary",
        label: localize(`Kit_States.${kitState}`)
      });
    }
    if (state === 'requested') {
      return jsx(Chip, {
        color: "secondary",
        label: localize(`Kit_States.${kitState}`)
      });
    }
    return jsx(Chip, {
      variant: "outlined",
      color: "secondary",
      label: localize(`Kit_States.${kitState}`)
    });
  };
  return jsx(ThemeProvider$1, Object.assign({
    theme: LogisticsTheme
  }, {
    children: jsxs(Grid, Object.assign({
      container: true,
      spacing: 1
    }, {
      children: [showStatus && jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: getChip(kitState)
      })), jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsx(Typography, {
          children: date ? dateLabel : ''
        })
      })), jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsx(Typography, Object.assign({
          style: {
            fontWeight: 700,
            fontSize: 14
          }
        }, {
          children: date ? buildDate : ''
        }))
      })), jsx(Grid, Object.assign({
        item: true,
        xs: 2
      }, {
        children: jsx(Tooltip, Object.assign({
          title: localize('Kit Notes')
        }, {
          children: jsx(IconButton, Object.assign({
            color: "primary",
            "aria-label": "Kit_Notes",
            onClick: () => {
              userMetrics.trackEvent("logistics: open kit notes popup");
              noteCallback();
            },
            style: {
              right: 5,
              fontWeight: 400
            }
          }, {
            children: jsx(Badge, Object.assign({
              overlap: 'rectangular',
              badgeContent: unreadMap.get(assignmentId) || 0,
              showZero: false
            }, {
              children: jsx(Note, {})
            }))
          }))
        }))
      })), jsx(Grid, Object.assign({
        item: true,
        xs: 2
      }, {
        children: jsx(Tooltip, Object.assign({
          title: localize('Kit History')
        }, {
          children: jsx(IconButton, Object.assign({
            color: "primary",
            "aria-label": "Kit_History",
            onClick: () => {
              userMetrics.trackEvent("logistics: open kit history popup");
              historyCallback(kitHistory);
            },
            style: {
              right: 5,
              fontWeight: 400
            }
          }, {
            children: jsx(History, {})
          }))
        }))
      }))]
    }))
  }));
};
const PatientStatus = ({
  state
}) => {
  const {
    localize
  } = useLocalize();
  if (!state) {
    return null;
  }
  if (state === 'active-care' || state === 'consented' || state === 'maintenance') {
    return jsx(Tooltip, Object.assign({
      title: localize('Patient_State')
    }, {
      children: jsx(Chip, {
        color: "primary",
        label: localize(`Patient_States.${state}`)
      })
    }));
  }
  return jsx(Tooltip, Object.assign({
    title: localize('Patient_State')
  }, {
    children: jsx(Chip, {
      color: "secondary",
      variant: "outlined",
      label: localize(`Patient_States.${state}`)
    })
  }));
};

const AssignKit = ({
  options,
  open,
  onSubmit,
  onClose
}) => {
  const {
    localize
  } = useLocalize();
  const [kitId, setKitId] = useState('');
  const actions = [jsx(Button, Object.assign({
    variant: "text",
    color: "primary",
    onClick: () => {
      onClose();
    }
  }, {
    children: localize('Close')
  }), 'close-button'), jsx(Button, Object.assign({
    variant: "contained",
    color: "primary",
    onClick: () => {
      onSubmit(kitId);
    }
  }, {
    children: localize('Assign')
  }), 'assign-button')];
  return jsx(ActionDialog, Object.assign({
    title: localize('Kit_States.assign_kit'),
    open: open,
    actions: actions,
    onClose: onClose
  }, {
    children: jsxs(Grid, Object.assign({
      container: true,
      spacing: 2
    }, {
      children: [jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsx(Typography, {
          children: localize('Assign_Kit_Header')
        })
      })), jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsx(Autocomplete, {
          options: options,
          onChange: (event, newValue) => {
            setKitId((newValue === null || newValue === void 0 ? void 0 : newValue._id) || '');
          },
          getOptionLabel: kit => kit === null || kit === void 0 ? void 0 : kit.serialNumber,
          renderInput: params => jsx(TextField, Object.assign({}, params, {
            label: localize('Select_Kit'),
            variant: "outlined"
          }))
        })
      }))]
    }))
  }));
};

const kit_states = [{
  schema: 'kit',
  name: 'assembling',
  order: 1,
  next: ['ready'],
  afterHook: ''
}, {
  schema: 'kit',
  name: 'ready',
  order: 2,
  next: ['assembling', 'assigned', 'lost'],
  afterHook: ''
}, {
  schema: 'kit',
  name: 'assigned',
  order: 3,
  next: ['ready', 'shipping'],
  afterHook: ''
}, {
  schema: 'kit',
  name: 'shipping',
  order: 4,
  next: ['assigned', 'received', 'lost'],
  afterHook: ''
}, {
  schema: 'kit',
  name: 'received',
  order: 5,
  next: ['shipping', 'return-prep', 'returning', 'setup', 'lost'],
  afterHook: 'setUserready'
}, {
  schema: 'kit',
  name: 'setup',
  order: 6,
  next: ['received', 'return-prep', 'returning', 'lost'],
  afterHook: 'setUserOnBoarded'
}, {
  schema: 'kit',
  name: 'return-prep',
  order: 7,
  next: ['setup', 'returning', 'lost'],
  afterHook: ''
}, {
  schema: 'kit',
  name: 'returning',
  order: 8,
  next: ['return-prep', 'returned', 'lost'],
  afterHook: ''
}, {
  schema: 'kit',
  name: 'returned',
  order: 9,
  next: ['returning', 'dismantling', 'lost'],
  afterHook: 'archiveKitAssignment'
}, {
  schema: 'kit',
  name: 'dismantling',
  order: 10,
  next: ['returned', 'dismantled', 'lost'],
  afterHook: 'unassignKitItems'
}, {
  schema: 'kit',
  name: 'dismantled',
  order: 11,
  next: ['dismantling'],
  afterHook: ''
}, {
  schema: 'kit',
  name: 'lost',
  order: 12,
  next: ['assembling', 'ready', 'assigned', 'shipping', 'received', 'setup', 'return-prep', 'returning', 'returned', 'dismantling'],
  afterHook: ''
}];
const MakeManagementTable = ({
  data
}) => {
  const {
    organizationMap
  } = useOrganizationNames();
  const {
    localize
  } = useLocalize();
  const {
    changeKitState,
    kits,
    filterKits
  } = useKit();
  const {
    AssignKit: AssignKit$1,
    isLoading,
    fetchAssignment
  } = useKitAssignment();
  const [openNotes, setOpenNotes] = useState(false);
  const [openHistory, setOpenHistory] = useState(false);
  const [openKitAssign, setOpenKitAssign] = useState(false);
  const [assignmentKitId, setAssignmentKitId] = useState('');
  const [history, setHistory] = useState([]);
  const [assignmentId, setAssignmentId] = useState('');
  const [patientId, setPatientId] = useState('');
  const [kitRequestModelId, setKitRequestModelId] = useState('');
  const [dialogTitle, setDialogTitle] = useState('');
  const [fetchAttempted, setFetchAttempted] = useState({});
  const {
    userMetrics
  } = useUserMetrics();
  useEffect(() => {
    const split = window.location.pathname.split('/').filter(x => x !== '');
    if (split.length === 3 && split[1] === 'note') {
      const id = split[2];
      const assignment = data.find(x => x._id === id);
      if (!assignment && !fetchAttempted[id]) {
        fetchAssignment(id);
        setFetchAttempted(prev => Object.assign(Object.assign({}, prev), {
          [id]: true
        }));
        return;
      }
      if (assignment && assignmentId !== id) {
        setPatientId(assignment.patientId);
        setAssignmentId(id);
        setOpenNotes(true);
        const newUrl = '/logistics/';
        const nextState = {
          additionalInformation: 'Note Viewed, url cleared'
        };
        window.history.replaceState(nextState, 'Logistics page', newUrl);
      }
    }
  }, [assignmentId, data, fetchAssignment, fetchAttempted, localize]);
  const kitStateDisplay = ({
    rowData: {
      _id,
      patientId,
      kit,
      requestByDate
    }
  }) => {
    return jsx(KitStatus, {
      kit: kit,
      requestByDate: requestByDate,
      showStatus: true,
      assignmentId: _id,
      noteCallback: () => {
        setAssignmentId(_id);
        setPatientId(patientId);
        setOpenNotes(true);
      },
      historyCallback: history => {
        setDialogTitle(localize('Kit_State_History'));
        setHistory(history);
        setOpenHistory(true);
      }
    });
  };
  const patientInfoDisplay = ({
    rowData: {
      patient,
      shippingAddress,
      kit
    }
  }) => {
    var _a;
    return jsx(PatientInfoDisplay, {
      patientInfo: patient,
      organization: ((_a = organizationMap[patient === null || patient === void 0 ? void 0 : patient.organization]) === null || _a === void 0 ? void 0 : _a.name) || '',
      shippingAddress: shippingAddress,
      kit: kit
    });
  };
  return jsx(ThemeProvider$1, Object.assign({
    theme: LogisticsTheme
  }, {
    children: jsxs(Paper, {
      children: [jsx(VirtualizedTable, {
        rowGetter: ({
          index
        }) => data[index],
        rowCount: data.length,
        rowHeight: 215,
        columns: [{
          label: localize('Patient'),
          dataFn: patientInfoDisplay,
          width: 100,
          minWidth: 150,
          dataKey: 'info'
        }, {
          label: localize('Patient_State'),
          dataFn: ({
            rowData
          }) => {
            var _a;
            return jsx(PatientStatus, {
              state: (_a = rowData === null || rowData === void 0 ? void 0 : rowData.patient) === null || _a === void 0 ? void 0 : _a.state
            });
          },
          dataKey: 'patientState',
          width: 100
        }, {
          label: localize('Kit'),
          dataFn: ({
            rowData: {
              kitModel,
              kit
            }
          }) => jsx(KitInfoDisplay, {
            KitModel: kitModel,
            Kit: kit
          }),
          width: 100,
          dataKey: 'kit'
        }, {
          label: localize('Kit_State'),
          dataFn: kitStateDisplay,
          width: 60,
          minWidth: 150,
          dataKey: 'kitState'
        }, {
          label: '',
          dataFn: ({
            rowData: {
              _id,
              kitModelId,
              kit,
              kitId
            }
          }) => {
            const state = kitId ? kit === null || kit === void 0 ? void 0 : kit.state : 'requested';
            const title = state === 'requested' ? '' : localize('Change_Kit_State');
            return jsx(StateMenu, {
              currentState: state,
              title: title,
              localizationPrefix: 'Kit_States',
              states: kit_states,
              icon: MoreVert,
              onChange: clicked => {
                if (clicked === 'assign_kit') {
                  setAssignmentKitId(_id);
                  if (kitRequestModelId !== kitModelId) {
                    filterKits(kitModelId, 'ready');
                    setKitRequestModelId(kitModelId);
                  }
                  setOpenKitAssign(true);
                  userMetrics.trackEvent('logistics: open assign kit popup', {
                    assignmentId: _id
                  });
                  return;
                }
                changeKitState(kitId, clicked);
                userMetrics.trackEvent('logistics: kit state changed', {
                  kit: kitId,
                  assignmentId: _id,
                  state: clicked
                });
              }
            });
          },
          dataKey: 'menu',
          width: 100,
          minWidth: 75,
          flexGrow: 0,
          flexShrink: 1
        }]
      }), isLoading && jsx("div", Object.assign({
        style: {
          display: 'flex',
          justifyContent: 'center',
          color: 'primary'
        }
      }, {
        children: jsx(SpinningIcon, {
          icon: Sync,
          spinning: true
        })
      })), data.length === 0 && !isLoading ? jsx(Typography, Object.assign({
        style: {
          padding: 25,
          fontWeight: 500,
          fontSize: 16,
          display: 'flex',
          justifyContent: 'center'
        }
      }, {
        children: localize('No_Results')
      })) : null, jsx(Notes, {
        open: openNotes,
        assignmentId: assignmentId,
        patient: patientId,
        onCloseCallback: () => {
          setOpenNotes(false);
          setAssignmentId('');
        }
      }), jsx(ActionDialog, Object.assign({
        title: dialogTitle,
        actions: [],
        open: openHistory,
        onClose: () => {
          setOpenHistory(false);
          setHistory([]);
          userMetrics.trackEvent('logistics: close kit history popup', {
            assignment: assignmentKitId
          });
        }
      }, {
        children: jsx(StateHistory, {
          data: history,
          theme: LogisticsTheme,
          tableWidth: 300
        })
      })), jsx(AssignKit, {
        options: kits,
        open: openKitAssign,
        onSubmit: kitId => {
          AssignKit$1(assignmentKitId, kitId);
          setAssignmentKitId('');
          setOpenKitAssign(false);
          userMetrics.trackEvent('logistics: kit assigned', {
            kitId: kitId,
            assignmentId: assignmentKitId
          });
        },
        onClose: () => {
          setAssignmentKitId('');
          setOpenKitAssign(false);
          userMetrics.trackEvent('logistics: close assign kit popup', {
            assignmentId: assignmentKitId
          });
        }
      }, 'assign-kit-modal')]
    })
  }));
};
const ManagementTable = ({
  data
}) => jsx(PeopleProvider, {
  children: jsx(LogisticsNotesProvider, {
    children: jsx(KitProvider, {
      children: jsx(MakeManagementTable, {
        data: data
      })
    })
  })
});

const ManagementInventory = () => {
  const [orgFilter, setOrgFilter] = useState([]);
  const [patientFilter, setPatientFilter] = useState([]);
  const [kitStateFilter, setKitStateFilter] = useState([]);
  const {
    kitAssignments,
    filterBySearch,
    filterByKitState,
    filterByPatientState,
    filterByOrg,
    nextPage
  } = useKitAssignment();
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  const {
    organizationMap
  } = useOrganizationNames();
  const kitStateFilterOptions = [localize('Kit_States.requested')];
  const kitStateFilterBlacklist = ['returned', 'dismantling', 'dismantled'];
  KitStates.forEach(state => {
    if (kitStateFilterBlacklist.includes(state)) return;
    kitStateFilterOptions.push(localize(`Kit_States.${state}`));
  });
  const patientStates = PatientStates.map(state => localize(`Patient_States.${state}`));
  const organizations = Object.values(organizationMap);
  return jsx(InfiniteScroll, Object.assign({
    loadMore: nextPage
  }, {
    children: jsxs(Grid, Object.assign({
      container: true,
      direction: "column",
      spacing: 2
    }, {
      children: [jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsx(SearchBar, {
          id: 'search-kit',
          testId: 'search-kit',
          width: "100%",
          placeholder: 'Patient First Name / Patient Last Name / Kit Model Name / Kit Model Number / Kit Serial Number / Patient EMR ID / Phone Number / Kit Assignment ID',
          theme: LogisticsTheme,
          onChange: event => {
            var _a;
            userMetrics.trackEvent('logistics: search in management tab'); // Don't include query because it could include PI
            return filterBySearch(((_a = event.target) === null || _a === void 0 ? void 0 : _a.value) || '');
          }
        })
      })), jsxs(Grid, Object.assign({
        item: true,
        xs: 12,
        container: true,
        direction: "row",
        spacing: 2,
        justifyContent: "flex-start"
      }, {
        children: [jsx(Grid, Object.assign({
          item: true,
          "aria-label": `${localize('admin_promo_code_org')} Grid`,
          xs: 3
        }, {
          children: jsx(TextMultiSelect, Object.assign({
            id: "admin_promo_code_org",
            ariaLabel: localize('admin_promo_code_org'),
            options: organizations.map(org => ({
              value: org._id,
              text: org.name
            })),
            value: orgFilter,
            onChange: event => {
              const orgs = event.target.value;
              setOrgFilter(orgs);
              filterByOrg(orgs);
              userMetrics.trackEvent('logistics: filter by organization in management tab', {
                organizationId: orgs
              });
            },
            size: "m"
          }, {
            children: localize('admin_promo_code_org')
          }))
        }), localize('admin_promo_code_org')), jsx(Grid, Object.assign({
          item: true,
          "aria-label": `${localize('Patient_State')} Grid`,
          xs: 3
        }, {
          children: jsx(TextMultiSelect, Object.assign({
            id: "Patient_State",
            ariaLabel: localize('Patient_State'),
            options: patientStates.map(states => ({
              value: states,
              text: states
            })),
            value: patientFilter,
            onChange: event => {
              const values = event.target.value;
              setPatientFilter(values);
              filterByPatientState(values);
              userMetrics.trackEvent('logistics: filter by patient state in management tab', {
                patientState: event.target.value
              });
            },
            size: "m"
          }, {
            children: localize('Patient_State')
          }))
        }), localize('Patient_State')), jsx(Grid, Object.assign({
          item: true,
          "aria-label": `${localize('Kit_State')} Grid`,
          xs: 3
        }, {
          children: jsx(TextMultiSelect, Object.assign({
            id: "Kit_State",
            ariaLabel: localize('Kit_State'),
            options: kitStateFilterOptions.map(states => ({
              value: states,
              text: states
            })),
            value: kitStateFilter,
            onChange: event => {
              const values = event.target.value;
              setKitStateFilter(values);
              filterByKitState(values);
              userMetrics.trackEvent('logistics: filter by kit state in management tab', {
                kitState: event.target.value
              });
            },
            size: "m"
          }, {
            children: localize('Kit_State')
          }))
        }), localize('Kit_State'))]
      })), jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsx(ManagementTable, {
          data: kitAssignments
        })
      }))]
    }))
  }));
};
const ManagementTab = () => jsx(OrganizationNamesProvider, {
  children: jsx(KitAssignmentProvider, {
    children: jsx(ManagementInventory, {})
  })
});

const LogisticsPage = () => {
  const {
    userMetrics
  } = useUserMetrics();
  useEffect(() => {
    userMetrics.trackEvent('page view', {
      "page": "logistics",
      "category": "logistics",
      "permission level": "logistics"
    });
  });
  const onChangeTabs = index => {
    const event = ["logistics: navigate to management tab", "logistics: navigate to kits tab", "logistics: navigate to items tab"][index];
    userMetrics.trackEvent(event);
  };
  return jsx(PageWithProviders, Object.assign({
    headerTitle: "Logistics"
  }, {
    children: jsx("div", Object.assign({
      style: {
        paddingTop: 25,
        backgroundColor: '#FFFFFF'
      }
    }, {
      children: jsx(TabNavigation, {
        variant: "standard",
        theme: LogisticsTheme,
        onChange: onChangeTabs,
        tabs: [{
          name: 'Management',
          index: 0,
          body: jsx(ManagementTab, {})
        }, {
          name: 'Kits',
          index: 1,
          body: jsx(KitTab, {})
        }, {
          name: 'Items',
          index: 2,
          body: jsx(ItemTab, {})
        }]
      })
    }))
  }));
};

const dateOptions$1 = {
  year: 'numeric',
  month: 'short',
  hourCycle: 'h24',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit'
};
const containerStyle$1 = read => ({
  fontFamily: 'Poppins',
  color: '#000000',
  fontWeight: !read ? 600 : 400
});
const Banner$1 = ({
  messageLine1,
  banner
}) => {
  const {
    personal: {
      locale
    }
  } = useCurrentPerson();
  return jsx("div", {
    children: jsxs("div", Object.assign({
      style: containerStyle$1(banner.read)
    }, {
      children: [messageLine1, jsxs("span", Object.assign({
        style: {
          color: DashboardsTheme.palette.primary.main
        }
      }, {
        children: [' ', new Date(banner.created_at).toLocaleDateString(locale, dateOptions$1)]
      }))]
    }))
  });
};

const Unknown$1 = ({
  banner
}) => {
  const {
    localize
  } = useLocalize();
  const messageLine1 = localize('banner.unknown');
  return jsx(Banner$1, {
    banner: banner,
    messageLine1: messageLine1
  });
};

const NewMessage = ({
  banner
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const {
    localize
  } = useLocalize();
  const messageLine1 = localize('banner.new_message_from', {
    fname: (_b = (_a = banner === null || banner === void 0 ? void 0 : banner.from) === null || _a === void 0 ? void 0 : _a.fname) !== null && _b !== void 0 ? _b : '',
    lname: (_d = (_c = banner === null || banner === void 0 ? void 0 : banner.from) === null || _c === void 0 ? void 0 : _c.lname) !== null && _d !== void 0 ? _d : '',
    patientFName: (_f = (_e = banner === null || banner === void 0 ? void 0 : banner.content) === null || _e === void 0 ? void 0 : _e.fname) !== null && _f !== void 0 ? _f : '',
    patientLName: (_h = (_g = banner === null || banner === void 0 ? void 0 : banner.content) === null || _g === void 0 ? void 0 : _g.lname) !== null && _h !== void 0 ? _h : ''
  });
  return jsx(Banner$1, {
    banner: banner,
    messageLine1: messageLine1
  });
};

const BannerText$1 = ({
  banner
}) => {
  switch (banner.banner_type) {
    case 'message:logistics:note':
      return jsx(NewMessage, {
        banner: banner
      });
  }
  return jsx(Unknown$1, {
    banner: banner
  });
};

const commonStyles$1 = {
  fontFamily: 'Poppins',
  fontWeight: 400,
  cursor: 'initial',
  flex: 1,
  display: 'flex',
  alignItems: 'center'
};
const styles$4 = {
  cell: Object.assign({}, commonStyles$1),
  header: Object.assign(Object.assign({}, commonStyles$1), {
    backgroundColor: '#C4DFE0'
  }),
  headerMenu: Object.assign(Object.assign({}, commonStyles$1), {
    backgroundColor: '#C4DFE0',
    fontSize: 0
  }),
  headerCheckbox: Object.assign(Object.assign({}, commonStyles$1), {
    backgroundColor: '#C4DFE0',
    paddingRight: 0,
    fontSize: 0
  }),
  checkbox: {
    margin: 0,
    padding: 0
  },
  outlineClearStyle: {
    border: '1px solid #102543',
    color: '#102543',
    backgroundColor: 'transparent'
  },
  outlineUnclearStyle: {
    border: '1px solid #506583',
    color: '#506583'
  },
  primaryStyle: {
    color: '#FFFFFF',
    backgroundColor: '#285E63'
  },
  errorStyle: {
    color: '#FFFFFF',
    backgroundColor: '#EB0000'
  }
};
const NotificationsTable$1 = ({
  data,
  onSelected
}) => {
  const [renderData, setRenderData] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [openNotes, setOpenNotes] = useState(false);
  const [kitAssignmentId, setKitAssignmentId] = useState('');
  const [patientId, setPatientId] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const {
    userMetrics
  } = useUserMetrics();
  const {
    markAllBannersRead
  } = useLogisticBanners();
  const {
    fetchAssignment,
    kitAssignments
  } = useKitAssignment();
  const menuOpen = useMemo(() => !!anchorEl, [anchorEl]);
  const {
    localize
  } = useLocalize();
  const {
    personal
  } = useCurrentPerson();
  useEffect(() => {
    setRenderData(data);
  }, [data]);
  const notificationIds = useMemo(() => data.map(notification => notification._id), [data]);
  useEffect(() => {
    notificationIds.length && userMetrics.trackEvent('notifications: view notifications', {
      notifications: notificationIds
    });
  }, [notificationIds, userMetrics]);
  const listMenuItems = useMemo(() => [jsx(DefaultIconbuttonMenuItem, {
    label: localize('Clear_All_History'),
    onClick: () => markAllBannersRead()
  }, "clearAll")], [localize, markAllBannersRead]);
  function closeMenu() {
    setAnchorEl(null);
  }
  const handleRowSelected = useCallback(notificationId => {
    return event => {
      let currentSelected = selectedIds;
      userMetrics.trackEvent('notifications: mark notification as read', {
        notificationId
      });
      setRenderData(prevRenderData => prevRenderData.map(banner => {
        if (banner._id === notificationId) {
          if (event.target.checked) {
            currentSelected = currentSelected.concat(banner._id);
          } else {
            currentSelected = currentSelected.filter(userId => userId !== banner._id);
          }
          return Object.assign(Object.assign({}, banner), {
            isSelected: event.target.checked
          });
        }
        return banner;
      }));
      onSelected(currentSelected);
      setSelectedIds(currentSelected);
    };
  }, [onSelected, selectedIds, userMetrics]);
  const handleCloseNotes = useCallback(() => {
    setOpenNotes(false);
    setKitAssignmentId('');
  }, []);
  const handleSelectAll = useCallback(event => {
    setRenderData(prevRenderData => prevRenderData.map(user => Object.assign(Object.assign({}, user), {
      isSelected: event.target.checked
    })));
    userMetrics.trackEvent('notifications: mark all notifications as read');
    if (event.target.checked) {
      const allIds = renderData.filter(row => !row.read).map(row => row._id);
      setSelectedIds(allIds);
      onSelected(allIds);
    } else {
      setSelectedIds([]);
      onSelected([]);
    }
  }, [onSelected, renderData, userMetrics]);
  const columns = useMemo(() => [{
    label: jsxs(Grid, Object.assign({
      container: true,
      spacing: 0,
      justifyContent: 'flex-start',
      alignItems: 'center',
      style: {
        maxWidth: 60
      }
    }, {
      children: [jsx(Grid, Object.assign({
        item: true,
        xs: 6
      }, {
        children: jsx(Checkbox, {
          style: styles$4.checkbox,
          inputProps: {
            'aria-label': 'select all patients',
            role: 'checkbox'
          },
          onChange: handleSelectAll
        })
      })), jsx(Grid, Object.assign({
        item: true,
        xs: 6
      }, {
        children: jsxs("div", {
          children: [jsx(IconButton, Object.assign({
            onClick: e => {
              setAnchorEl(e.currentTarget);
            },
            size: 'small'
          }, {
            children: jsx(KeyboardArrowDown, {
              color: 'primary',
              fontSize: 'small'
            })
          })), jsx(Menu$1, Object.assign({
            getContentAnchorEl: null,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'center'
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'center'
            },
            onClick: closeMenu,
            anchorEl: anchorEl,
            open: menuOpen,
            onClose: closeMenu,
            MenuListProps: {
              'aria-labelledby': 'basic-button'
            }
          }, {
            children: listMenuItems
          }))]
        })
      }))]
    })),
    headerStyle: styles$4.headerCheckbox,
    rowStyle: styles$4.cell,
    dataKey: 'isSelected',
    dataFn: ({
      rowData
    }) => jsx(Checkbox, {
      style: styles$4.checkbox,
      inputProps: {
        'aria-label': rowData._id
      },
      checked: !!rowData.isSelected,
      onChange: handleRowSelected(rowData._id),
      disabled: rowData.banner_type === "message:logistics:note"
    }),
    width: 60,
    flexShrink: 1,
    flexGrow: 0
  }, {
    label: jsx(Typography, Object.assign({
      style: {
        paddingLeft: 10
      }
    }, {
      children: 'Link'
    })),
    headerStyle: styles$4.header,
    dataKey: 'link',
    dataFn: ({
      rowData
    }) => {
      var _a, _b;
      const kitAssignmentId = (_a = rowData.content) === null || _a === void 0 ? void 0 : _a.kitAssignmentId;
      if ((_b = personal.type) === null || _b === void 0 ? void 0 : _b.includes('logistics')) {
        const url = `/logistics/note/${kitAssignmentId}`;
        return jsx(IconButton, Object.assign({
          component: Link,
          to: url
        }, {
          children: jsx(OpenInNewIcon, {})
        }));
      }
      return jsx(IconButton, Object.assign({
        onClick: () => {
          setKitAssignmentId(kitAssignmentId || '');
          fetchAssignment(kitAssignmentId || '');
          const assignment = kitAssignments.find(assignment => assignment._id === kitAssignmentId);
          if (assignment) {
            setPatientId(assignment.patientId);
            setOpenNotes(true);
          }
        }
      }, {
        children: jsx(OpenInNewIcon, {})
      }));
    },
    width: 80,
    flexGrow: 0
  }, {
    label: jsx(Typography, {
      children: 'Alert'
    }),
    headerStyle: styles$4.header,
    dataKey: '',
    dataFn: ({
      rowData
    }) => jsx(BannerText$1, {
      banner: rowData
    }),
    width: 500,
    flexGrow: 1
  }], [anchorEl, fetchAssignment, handleRowSelected, handleSelectAll, kitAssignments, listMenuItems, menuOpen, personal.type]);
  return jsx(OrganizationNamesProvider, {
    children: jsx(KitAssignmentProvider, {
      children: jsx(LogisticsNotesProvider, {
        children: jsx(Grid, Object.assign({
          container: true,
          direction: "column"
        }, {
          children: jsx(Grid, Object.assign({
            item: true
          }, {
            children: jsxs(Paper, Object.assign({
              style: {
                display: 'flex',
                flex: 1
              }
            }, {
              children: [jsx(VirtualizedTable, {
                rowCount: renderData.length,
                rowGetter: ({
                  index
                }) => renderData[index],
                headerHeight: 50,
                columns: columns
              }), jsx(Notes, {
                assignmentId: kitAssignmentId,
                open: openNotes,
                onCloseCallback: handleCloseNotes,
                patient: patientId
              })]
            }))
          }))
        }))
      })
    })
  });
};

const styles$3 = {
  filterTitle: {
    fontFamily: 'Poppins',
    color: '#006064',
    fontSize: 14,
    marginBottom: 3
  },
  filterGridContainer: {
    paddingTop: 8,
    paddingBottom: 8
  },
  clearFiltersButtonContainer: {
    paddingTop: 20,
    paddingBottom: 10
  },
  selectContainer: {
    display: 'flex',
    width: '200px',
    justifyContent: 'center'
  }
};
const Notifications$1 = props => {
  const {
    localize
  } = useLocalize();
  const {
    banners,
    nextPage,
    markBannerRead,
    isLoading,
    noDataLeft,
    clearFilters,
    filterBySearch,
    filterByStartDate,
    filterByEndDate
  } = useLogisticBanners();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const clearAllFilters = useCallback(() => {
    setStartDate(null);
    setEndDate(null);
    clearFilters();
  }, [clearFilters]);
  const handleNextPage = useCallback(() => {
    if (banners.length > 24 && !noDataLeft) {
      nextPage();
    }
  }, [nextPage, banners.length, noDataLeft]);
  return jsxs(Grid, Object.assign({
    container: true,
    spacing: 2,
    style: {
      padding: 10
    }
  }, {
    children: [jsxs(Grid, Object.assign({
      item: true,
      container: true,
      xs: 12,
      alignItems: "center"
    }, {
      children: [jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsx(SearchBar, {
          id: "search",
          testId: 'search-logistics-notifications',
          placeholder: localize('notification_search_placeholder'),
          theme: LogisticsTheme,
          width: "100%",
          onChange: event => filterBySearch(event.target.value)
        })
      })), jsxs(Grid, Object.assign({
        container: true,
        direction: "row",
        spacing: 2
      }, {
        children: [jsx(Grid, Object.assign({
          item: true,
          xs: 2
        }, {
          children: jsxs("div", Object.assign({
            style: styles$3.filterGridContainer
          }, {
            children: [jsx("div", Object.assign({
              style: styles$3.filterTitle
            }, {
              children: 'Start Date'
            })), jsx(MuiPickersUtilsProvider, Object.assign({
              utils: DateFnsUtils
            }, {
              children: jsx(KeyboardDatePicker, {
                autoOk: true,
                clearable: true,
                variant: "inline",
                format: "MM/dd/yyyy",
                id: "startDate",
                value: startDate,
                onChange: useCallback(e => {
                  setStartDate(e);
                  filterByStartDate(e);
                }, [filterByStartDate]),
                KeyboardButtonProps: {
                  'aria-label': 'change start date'
                }
              })
            }))]
          }))
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 2
        }, {
          children: jsxs("div", Object.assign({
            style: styles$3.filterGridContainer
          }, {
            children: [jsx("div", Object.assign({
              style: styles$3.filterTitle
            }, {
              children: 'End Date'
            })), jsx(MuiPickersUtilsProvider, Object.assign({
              utils: DateFnsUtils
            }, {
              children: jsx(KeyboardDatePicker, {
                autoOk: true,
                clearable: true,
                variant: "inline",
                format: "MM/dd/yyyy",
                id: "endDate",
                value: endDate,
                onChange: useCallback(e => {
                  setEndDate(e);
                  filterByEndDate(e);
                }, [filterByEndDate]),
                KeyboardButtonProps: {
                  'aria-label': 'change end date'
                }
              })
            }))]
          }))
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 2
        }, {
          children: jsx("div", Object.assign({
            style: styles$3.clearFiltersButtonContainer
          }, {
            children: jsx(Button, Object.assign({
              variant: "contained",
              color: "primary",
              onClick: clearAllFilters
            }, {
              children: localize('Clear_Filter')
            }))
          }))
        }))]
      }))]
    })), jsx(Grid, Object.assign({
      item: true,
      container: true,
      xs: 12
    }, {
      children: jsx(InfiniteScroll, Object.assign({
        loadMore: handleNextPage,
        isLoading: isLoading
      }, {
        children: jsx(NotificationsTable$1, {
          data: banners,
          onSelected: selected => markBannerRead(selected)
        })
      }))
    })), jsx(Grid, Object.assign({
      item: true,
      xs: 12
    }, {
      children: isLoading && jsx(Box, Object.assign({
        style: {
          display: 'flex',
          justifyContent: 'center',
          color: 'primary'
        }
      }, {
        children: jsx(SpinningIcon, {
          icon: Sync,
          spinning: true
        })
      }))
    }))]
  }));
};
const LogisticsNotificationsPage = props => jsx(PageWithProviders, Object.assign({
  headerTitle: "dashboards_notifications",
  padding: 23
}, {
  children: jsx(UserPublicDataProvider, {
    children: jsx(OrganizationNamesProvider, {
      children: jsx(LogisticBannersProvider, {
        children: jsx(KitAssignmentProvider, {
          children: jsx(Notifications$1, Object.assign({}, props))
        })
      })
    })
  })
}));

const dateOptions = {
  year: 'numeric',
  month: 'short',
  hourCycle: 'h24',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit'
};
const containerStyle = read => ({
  fontFamily: 'Poppins',
  color: '#000000',
  fontWeight: !read ? 600 : 400
});
const Banner = ({
  messageLine1,
  banner,
  onClick
}) => {
  const {
    personal: {
      locale
    }
  } = useCurrentPerson();
  return jsx("div", {
    children: jsxs("div", Object.assign({
      style: containerStyle(banner.kind === "workflow:action" ? false : banner.read),
      onClick: onClick
    }, {
      children: [messageLine1, jsxs("span", Object.assign({
        style: {
          color: DashboardsTheme.palette.primary.main
        }
      }, {
        children: [' ', new Date(banner.created_at).toLocaleDateString(locale, dateOptions)]
      }))]
    }))
  });
};

const Indicator = ({
  type,
  banner
}) => {
  var _a, _b, _c, _d, _e;
  const {
    localize
  } = useLocalize();
  const cleanBannerType = type.replace(/'/g, "");
  const messageLine1 = localize(`banner.indicator.${cleanBannerType}.${(_a = banner === null || banner === void 0 ? void 0 : banner.content) === null || _a === void 0 ? void 0 : _a.status}`, {
    fname: (_c = (_b = banner === null || banner === void 0 ? void 0 : banner.from) === null || _b === void 0 ? void 0 : _b.fname) !== null && _c !== void 0 ? _c : '',
    lname: (_e = (_d = banner === null || banner === void 0 ? void 0 : banner.from) === null || _d === void 0 ? void 0 : _d.lname) !== null && _e !== void 0 ? _e : ''
  });
  return jsx(Banner, {
    messageLine1: messageLine1,
    banner: banner
  });
};

const BraceletWander = ({
  banner
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
  const {
    localize
  } = useLocalize();
  const content = banner.content;
  const wandering = content === null || content === void 0 ? void 0 : content.wandering;
  const invalid = content === null || content === void 0 ? void 0 : content.invalid;
  let messageLine2,
    messageLine1 = localize('banner.unknown');
  if (wandering && wandering !== 2) {
    messageLine1 = localize('banner.wanderLeftzone', {
      fname: (_b = (_a = banner === null || banner === void 0 ? void 0 : banner.from) === null || _a === void 0 ? void 0 : _a.fname) !== null && _b !== void 0 ? _b : '',
      lname: (_d = (_c = banner === null || banner === void 0 ? void 0 : banner.from) === null || _c === void 0 ? void 0 : _c.lname) !== null && _d !== void 0 ? _d : ''
    });
  }
  if (!wandering && !invalid) {
    messageLine1 = localize('banner.wanderInzone', {
      fname: (_f = (_e = banner === null || banner === void 0 ? void 0 : banner.from) === null || _e === void 0 ? void 0 : _e.fname) !== null && _f !== void 0 ? _f : '',
      lname: (_h = (_g = banner === null || banner === void 0 ? void 0 : banner.from) === null || _g === void 0 ? void 0 : _g.lname) !== null && _h !== void 0 ? _h : ''
    });
    messageLine2 = localize('banner.wander_acknowledge', {
      fname: (_k = (_j = content === null || content === void 0 ? void 0 : content.acknowledge) === null || _j === void 0 ? void 0 : _j.fname) !== null && _k !== void 0 ? _k : '',
      lname: (_m = (_l = content === null || content === void 0 ? void 0 : content.acknowledge) === null || _l === void 0 ? void 0 : _l.lname) !== null && _m !== void 0 ? _m : ''
    });
  }
  return jsx(Banner, {
    banner: banner,
    messageLine1: messageLine1,
    messageLine2: messageLine2
  });
};

const UrgencyCall = ({
  banner
}) => {
  var _a, _b, _c, _d, _e, _f;
  const {
    localize
  } = useLocalize();
  const content = banner === null || banner === void 0 ? void 0 : banner.content;
  const to = content === null || content === void 0 ? void 0 : content.to;
  let messageLine2;
  const messageLine1 = localize('banner.urgency_from', {
    fname: (_b = (_a = banner === null || banner === void 0 ? void 0 : banner.from) === null || _a === void 0 ? void 0 : _a.fname) !== null && _b !== void 0 ? _b : '',
    lname: (_d = (_c = banner === null || banner === void 0 ? void 0 : banner.from) === null || _c === void 0 ? void 0 : _c.lname) !== null && _d !== void 0 ? _d : ''
  });
  if (to) {
    messageLine2 = localize('banner.urgency_calling', {
      fname: (_e = to.fname) !== null && _e !== void 0 ? _e : '',
      lname: (_f = to.lname) !== null && _f !== void 0 ? _f : ''
    });
  }
  return jsx(Banner, {
    banner: banner,
    messageLine1: messageLine1,
    messageLine2: messageLine2
  });
};

const UrgencyCancelled = ({
  banner
}) => {
  var _a, _b, _c, _d;
  const {
    localize
  } = useLocalize();
  const messageLine1 = localize('banner.urgency_cancelled', {
    fname: (_b = (_a = banner === null || banner === void 0 ? void 0 : banner.from) === null || _a === void 0 ? void 0 : _a.fname) !== null && _b !== void 0 ? _b : '',
    lname: (_d = (_c = banner === null || banner === void 0 ? void 0 : banner.from) === null || _c === void 0 ? void 0 : _c.lname) !== null && _d !== void 0 ? _d : ''
  });
  return jsx(Banner, {
    banner: banner,
    messageLine1: messageLine1
  });
};

const UrgencyAccepted = ({
  banner
}) => {
  var _a, _b, _c, _d;
  const {
    localize
  } = useLocalize();
  const messageLine1 = localize('banner.urgency_accepted', {
    fname: (_b = (_a = banner === null || banner === void 0 ? void 0 : banner.from) === null || _a === void 0 ? void 0 : _a.fname) !== null && _b !== void 0 ? _b : '',
    lname: (_d = (_c = banner === null || banner === void 0 ? void 0 : banner.from) === null || _c === void 0 ? void 0 : _c.lname) !== null && _d !== void 0 ? _d : ''
  });
  return jsx(Banner, {
    banner: banner,
    messageLine1: messageLine1
  });
};

const BraceletConnected = ({
  banner
}) => {
  var _a, _b, _c, _d;
  const {
    localize
  } = useLocalize();
  const messageLine1 = localize('banner.braceletreconnect', {
    fname: (_b = (_a = banner === null || banner === void 0 ? void 0 : banner.from) === null || _a === void 0 ? void 0 : _a.fname) !== null && _b !== void 0 ? _b : '',
    lname: (_d = (_c = banner === null || banner === void 0 ? void 0 : banner.from) === null || _c === void 0 ? void 0 : _c.lname) !== null && _d !== void 0 ? _d : ''
  });
  return jsx(Banner, {
    banner: banner,
    messageLine1: messageLine1
  });
};

const DeviceBattery = ({
  banner
}) => {
  var _a, _b, _c, _d;
  const {
    localize
  } = useLocalize();
  const messageLine1 = localize('banner.batterylow', {
    fname: (_b = (_a = banner === null || banner === void 0 ? void 0 : banner.from) === null || _a === void 0 ? void 0 : _a.fname) !== null && _b !== void 0 ? _b : '',
    lname: (_d = (_c = banner === null || banner === void 0 ? void 0 : banner.from) === null || _c === void 0 ? void 0 : _c.lname) !== null && _d !== void 0 ? _d : ''
  });
  return jsx(Banner, {
    banner: banner,
    messageLine1: messageLine1
  });
};

const DeviceBatteryChanged = ({
  banner
}) => {
  var _a, _b, _c, _d;
  const {
    localize
  } = useLocalize();
  const messageLine1 = localize('banner.batterychanged', {
    fname: (_b = (_a = banner === null || banner === void 0 ? void 0 : banner.from) === null || _a === void 0 ? void 0 : _a.fname) !== null && _b !== void 0 ? _b : '',
    lname: (_d = (_c = banner === null || banner === void 0 ? void 0 : banner.from) === null || _c === void 0 ? void 0 : _c.lname) !== null && _d !== void 0 ? _d : ''
  });
  return jsx(Banner, {
    banner: banner,
    messageLine1: messageLine1
  });
};

const ManagedNew = ({
  banner
}) => {
  var _a, _b, _c, _d;
  const {
    localize
  } = useLocalize();
  const messageLine1 = localize('banner.managedusernew', {
    fname: (_b = (_a = banner === null || banner === void 0 ? void 0 : banner.from) === null || _a === void 0 ? void 0 : _a.fname) !== null && _b !== void 0 ? _b : '',
    lname: (_d = (_c = banner === null || banner === void 0 ? void 0 : banner.from) === null || _c === void 0 ? void 0 : _c.lname) !== null && _d !== void 0 ? _d : ''
  });
  return jsx(Banner, {
    banner: banner,
    messageLine1: messageLine1
  });
};

const BraceletDisconnected = ({
  banner
}) => {
  var _a, _b, _c, _d;
  const {
    localize
  } = useLocalize();
  const messageLine1 = localize('banner.braceletdisconnect', {
    fname: (_b = (_a = banner === null || banner === void 0 ? void 0 : banner.from) === null || _a === void 0 ? void 0 : _a.fname) !== null && _b !== void 0 ? _b : '',
    lname: (_d = (_c = banner === null || banner === void 0 ? void 0 : banner.from) === null || _c === void 0 ? void 0 : _c.lname) !== null && _d !== void 0 ? _d : ''
  });
  return jsx(Banner, {
    banner: banner,
    messageLine1: messageLine1
  });
};

const Unknown = ({
  banner
}) => {
  const {
    localize
  } = useLocalize();
  const messageLine1 = localize('banner.unknown');
  return jsx(Banner, {
    banner: banner,
    messageLine1: messageLine1
  });
};

const CustomIndicator = ({
  banner,
  indicatorId
}) => {
  var _a, _b, _c, _d, _e;
  const {
    localize,
    localizeFrom
  } = useLocalize();
  const {
    indicatorMap
  } = useCustomIndicators();
  const indicator = indicatorMap[indicatorId];
  let messageLine1 = localize('banner.unknown');
  if (indicator) {
    messageLine1 = localize(`banner.indicator.custom.${(_a = banner === null || banner === void 0 ? void 0 : banner.content) === null || _a === void 0 ? void 0 : _a.status}`, {
      indicator: localizeFrom(indicator.name, '.'),
      fname: (_c = (_b = banner === null || banner === void 0 ? void 0 : banner.from) === null || _b === void 0 ? void 0 : _b.fname) !== null && _c !== void 0 ? _c : '',
      lname: (_e = (_d = banner === null || banner === void 0 ? void 0 : banner.from) === null || _d === void 0 ? void 0 : _d.lname) !== null && _e !== void 0 ? _e : ''
    });
  }
  return jsx(Banner, {
    banner: banner,
    messageLine1: messageLine1
  });
};

const Inactive = ({
  banner
}) => {
  var _a, _b, _c, _d;
  const {
    localize
  } = useLocalize();
  const messageLine1 = localize('banner.inactivity', {
    fname: (_b = (_a = banner === null || banner === void 0 ? void 0 : banner.from) === null || _a === void 0 ? void 0 : _a.fname) !== null && _b !== void 0 ? _b : '',
    lname: (_d = (_c = banner === null || banner === void 0 ? void 0 : banner.from) === null || _c === void 0 ? void 0 : _c.lname) !== null && _d !== void 0 ? _d : ''
  });
  return jsx(Banner, {
    banner: banner,
    messageLine1: messageLine1
  });
};

const MeetingNew = ({
  banner
}) => {
  var _a, _b, _c, _d;
  const {
    localize
  } = useLocalize();
  const messageLine1 = localize('banner.meeting_new', {
    fname: (_b = (_a = banner === null || banner === void 0 ? void 0 : banner.from) === null || _a === void 0 ? void 0 : _a.fname) !== null && _b !== void 0 ? _b : '',
    lname: (_d = (_c = banner === null || banner === void 0 ? void 0 : banner.from) === null || _c === void 0 ? void 0 : _c.lname) !== null && _d !== void 0 ? _d : ''
  });
  return jsx(Banner, {
    banner: banner,
    messageLine1: messageLine1
  });
};

const dispatchEvents = {
  "linkopener:trigger:open": uri => {
    window.open(uri, "_blank");
  }
};

const styles$2 = {
  header: {
    fontSize: '28px'
  },
  message: {
    display: 'inline',
    cursor: 'pointer'
  }
};
const Workflow = ({
  banner
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
  const {
    localize,
    localizeFrom
  } = useLocalize();
  const {
    submitWorkflow
  } = useWorkflow();
  const [openWorkflow, setOpenWorkflow] = useState(false);
  const [openFeatureNotSupported, setOpenFeatureNotSupported] = useState(false);
  const blockedFeatures = useMemo(() => ['bluetooth:trigger:scan:stop', 'managedbluetoothscanner:trigger:stop:scan', 'bluetooth:trigger:scan', 'managedbluetoothscanner:trigger:start:scan', 'activeworkflowaction:trigger:form', 'activeworkflowaction:trigger:call', 'activeworkflowaction:trigger:call', 'calling:trigger:call', 'myhealthdevice:trigger:workflow', 'activeworkflowaction:trigger:manager:resource', 'activeworkflowaction:trigger:resource'], []);
  const schemaLocalization = (_e = (_d = (_c = (_b = (_a = banner === null || banner === void 0 ? void 0 : banner.ongoingWorkflowData) === null || _a === void 0 ? void 0 : _a.workflowData) === null || _b === void 0 ? void 0 : _b.schema) === null || _c === void 0 ? void 0 : _c.actions) === null || _d === void 0 ? void 0 : _d[banner.action]) === null || _e === void 0 ? void 0 : _e.localization;
  const schemaMessage = schemaLocalization ? localizeFrom(schemaLocalization, '.') : "";
  const actionSchema = (_j = (_h = (_g = (_f = banner === null || banner === void 0 ? void 0 : banner.ongoingWorkflowData) === null || _f === void 0 ? void 0 : _f.workflowData) === null || _g === void 0 ? void 0 : _g.schema) === null || _h === void 0 ? void 0 : _h.actions) === null || _j === void 0 ? void 0 : _j[banner.action];
  const message = `${localize('workflow.actionforuser', {
    fname: ((_l = (_k = banner === null || banner === void 0 ? void 0 : banner.ongoingWorkflowData) === null || _k === void 0 ? void 0 : _k.ownerData) === null || _l === void 0 ? void 0 : _l.fname) || "",
    lname: ((_o = (_m = banner === null || banner === void 0 ? void 0 : banner.ongoingWorkflowData) === null || _m === void 0 ? void 0 : _m.ownerData) === null || _o === void 0 ? void 0 : _o.lname) || ""
  })}:

  ${schemaMessage}
  `;
  const message_line1 = jsx("p", Object.assign({
    style: styles$2.message
  }, {
    children: message
  }));
  const onSubmit = data => {
    submitWorkflow(data, banner);
    setOpenWorkflow(false);
  };
  const cancel = () => {
    setOpenWorkflow(false);
  };
  return jsxs("div", {
    children: [jsx(Banner, {
      banner: banner,
      messageLine1: message_line1,
      onClick: useCallback(() => {
        setOpenWorkflow(true);
      }, [])
    }), jsx(ThemeProvider, Object.assign({
      theme: DashboardsTheme
    }, {
      children: jsx(ActionDialog, Object.assign({
        title: localize('workflow.featureNotSupportedTittle'),
        open: openFeatureNotSupported,
        onClose: () => {
          setOpenFeatureNotSupported(false);
        }
      }, {
        children: jsx(Typography, Object.assign({
          component: 'p',
          variant: 'body1'
        }, {
          children: localize('workflow.featureNotSupported')
        }))
      }))
    })), openWorkflow && jsx(ThemeProvider, Object.assign({
      theme: DashboardsTheme
    }, {
      children: jsxs(ActionDialog, Object.assign({
        title: '',
        open: openWorkflow,
        onClose: () => {
          setOpenWorkflow(false);
        }
      }, {
        children: [jsx(Typography, Object.assign({
          variant: "h2",
          component: 'h2',
          style: styles$2.header
        }, {
          children: schemaMessage
        })), !!actionSchema && jsx(Form, {
          dataId: banner._id,
          id: banner._id,
          schema: actionSchema,
          onCancel: cancel,
          cancelText: localize('common.cancel'),
          defaultData: banner.defaults,
          onSubmit: onSubmit,
          submitText: localize('callsurvey.send'),
          externalForms: (_s = (_r = (_q = (_p = banner === null || banner === void 0 ? void 0 : banner.ongoingWorkflowData) === null || _p === void 0 ? void 0 : _p.workflowData) === null || _q === void 0 ? void 0 : _q.schema) === null || _r === void 0 ? void 0 : _r.actions) === null || _s === void 0 ? void 0 : _s[banner.action],
          isATouchAway: false,
          localizeFrom: localizeFrom,
          localize: localize,
          unsupportedFeatures: ["file", "fileList", "reading", "call"],
          dispatch: (e, data) => {
            return function (newData) {
              const finalData = typeof data === "undefined" ? newData : data;
              const foundEvent = dispatchEvents[e];
              if (foundEvent) {
                foundEvent(finalData);
              } else if (blockedFeatures.includes(e)) {
                setOpenFeatureNotSupported(true);
                setOpenWorkflow(false);
              }
            };
          },
          platform: "dashboards"
        }, banner._id)]
      }))
    }))]
  });
};

const BannerText = ({
  banner
}) => {
  const customIndicatorRegex = /info:indicator:([a-f0-9]+)/g;
  if (banner.kind === "workflow:action") {
    return jsx(WorkflowProvider, {
      children: jsx(Workflow, {
        banner: banner
      })
    });
  } else if (banner.kind === "banner") {
    switch (banner.banner_type) {
      case 'info:indicator:bpPulserate':
        return jsx(Indicator, {
          type: "'bpPulserate'",
          banner: banner
        });
      case 'info:indicator:heartrate':
        return jsx(Indicator, {
          type: "heartrate",
          banner: banner
        });
      case 'info:indicator:oxygensaturation':
        return jsx(Indicator, {
          type: "oxygensaturation",
          banner: banner
        });
      case 'info:indicator:bloodpressure':
        return jsx(Indicator, {
          type: "bloodpressure",
          banner: banner
        });
      case 'info:indicator:bloodsugar':
        return jsx(Indicator, {
          type: "bloodsugar",
          banner: banner
        });
      case 'info:indicator:bodytemperature':
        return jsx(Indicator, {
          type: "bodytemperature",
          banner: banner
        });
      case 'info:indicator:steps':
        return jsx(Indicator, {
          type: "steps",
          banner: banner
        });
      case 'info:indicator:weight':
        return jsx(Indicator, {
          type: "weight",
          banner: banner
        });
      case 'warning:device:wandering':
        return jsx(BraceletWander, {
          banner: banner
        });
      case 'urgency:call':
        return jsx(UrgencyCall, {
          banner: banner
        });
      case 'urgency:cancelled':
        return jsx(UrgencyCancelled, {
          banner: banner
        });
      case 'urgency:accepted':
        return jsx(UrgencyAccepted, {
          banner: banner
        });
      case 'info:manageduser:new':
        return jsx(ManagedNew, {
          banner: banner
        });
      case 'warning:device:disconnected':
        return jsx(BraceletDisconnected, {
          banner: banner
        });
      case 'warning:device:connected':
        return jsx(BraceletConnected, {
          banner: banner
        });
      case 'warning:device:battery':
        return jsx(DeviceBattery, {
          banner: banner
        });
      case 'warning:device:batterychanged':
        return jsx(DeviceBatteryChanged, {
          banner: banner
        });
      case 'warning:inactive':
        return jsx(Inactive, {
          banner: banner
        });
      case 'info:meeting:new':
        return jsx(MeetingNew, {
          banner: banner
        });
    }
    const customIndicatorMatch = customIndicatorRegex.exec(banner.banner_type);
    if (customIndicatorMatch) {
      return jsx(CustomIndicatorsProvider, {
        children: jsx(CustomIndicator, {
          banner: banner,
          indicatorId: customIndicatorMatch[1]
        })
      });
    }
    if (!banner.banner_type) {
      return jsx(Indicator, {
        type: "info",
        banner: banner
      });
    }
  }
  return jsx(Unknown, {
    banner: banner
  });
};

const commonStyles = {
  fontFamily: 'Poppins',
  fontWeight: 400,
  cursor: 'initial',
  flex: 1,
  display: 'flex',
  alignItems: 'center'
};
const styles$1 = {
  cell: Object.assign({}, commonStyles),
  header: Object.assign(Object.assign({}, commonStyles), {
    backgroundColor: '#C4DFE0'
  }),
  headerMenu: Object.assign(Object.assign({}, commonStyles), {
    backgroundColor: '#C4DFE0',
    fontSize: 0
  }),
  headerCheckbox: Object.assign(Object.assign({}, commonStyles), {
    backgroundColor: '#C4DFE0',
    paddingRight: 0,
    fontSize: 0
  }),
  checkbox: {
    margin: 0,
    padding: 0
  },
  outlineClearStyle: {
    border: '1px solid #102543',
    color: '#102543',
    backgroundColor: 'transparent'
  },
  outlineUnclearStyle: {
    border: '1px solid #506583',
    color: '#506583'
  },
  primaryStyle: {
    color: '#FFFFFF',
    backgroundColor: '#285E63'
  },
  errorStyle: {
    color: '#FFFFFF',
    backgroundColor: '#EB0000'
  }
};
const NotificationsTable = ({
  data,
  onSelected
}) => {
  const [renderData, setRenderData] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const {
    markAllBannersRead
  } = useBanners();
  const menuOpen = useMemo(() => !!anchorEl, [anchorEl]);
  const {
    localize
  } = useLocalize();
  useEffect(() => {
    setRenderData(data);
  }, [data]);
  const listMenuItems = useMemo(() => [jsx(DefaultIconbuttonMenuItem, {
    label: localize('Clear_All_History'),
    onClick: () => markAllBannersRead()
  }, "clearAll")], [localize, markAllBannersRead]);
  const noLinkBannerTypes = useMemo(() => ['warning:device:battery', 'warning:device:disconnected', 'warning:device:connected', 'warning:device:wandering', 'warning:device:acknowledge', 'warning:device:battery', 'warning:device:batterychanged'], []);
  const closeMenu = () => {
    setAnchorEl(null);
  };
  const handleRowSelected = useCallback(notificationId => {
    return event => {
      let currentSelected = selectedIds;
      setRenderData(prevRenderData => prevRenderData.map(banner => {
        if (banner._id === notificationId) {
          if (event.target.checked) {
            currentSelected = currentSelected.concat(banner._id);
          } else {
            currentSelected = currentSelected.filter(userId => userId !== banner._id);
          }
          return Object.assign(Object.assign({}, banner), {
            isSelected: event.target.checked
          });
        }
        return banner;
      }));
      onSelected(currentSelected);
      setSelectedIds(currentSelected);
    };
  }, [onSelected, selectedIds]);
  const handleSelectAll = useCallback(event => {
    setRenderData(prevRenderData => prevRenderData.map(user => Object.assign(Object.assign({}, user), {
      isSelected: event.target.checked
    })));
    if (event.target.checked) {
      const allIds = renderData.map(user => user._id);
      setSelectedIds(allIds);
      onSelected(allIds);
    } else {
      setSelectedIds([]);
      onSelected([]);
    }
  }, [onSelected, renderData]);
  const columns = useMemo(() => [{
    label: jsxs(Grid, Object.assign({
      container: true,
      spacing: 0,
      justifyContent: 'flex-start',
      alignItems: 'center',
      style: {
        maxWidth: 60
      }
    }, {
      children: [jsx(Grid, Object.assign({
        item: true,
        xs: 6
      }, {
        children: jsx(Checkbox, {
          style: styles$1.checkbox,
          inputProps: {
            'aria-label': 'select all patients',
            role: 'checkbox'
          },
          onChange: handleSelectAll
        })
      })), jsx(Grid, Object.assign({
        item: true,
        xs: 6
      }, {
        children: jsxs("div", {
          children: [jsx(IconButton, Object.assign({
            onClick: e => {
              setAnchorEl(e.currentTarget);
            },
            size: 'small'
          }, {
            children: jsx(KeyboardArrowDown, {
              color: 'primary',
              fontSize: 'small'
            })
          })), jsx(Menu$1, Object.assign({
            getContentAnchorEl: null,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'center'
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'center'
            },
            onClick: closeMenu,
            anchorEl: anchorEl,
            open: menuOpen,
            onClose: closeMenu,
            MenuListProps: {
              'aria-labelledby': 'basic-button'
            }
          }, {
            children: listMenuItems
          }))]
        })
      }))]
    })),
    headerStyle: styles$1.headerCheckbox,
    rowStyle: styles$1.cell,
    dataKey: 'isSelected',
    dataFn: ({
      rowData
    }) => {
      if (rowData.from) return jsx(Checkbox, {
        style: styles$1.checkbox,
        inputProps: {
          'aria-label': rowData._id
        },
        checked: !!rowData.isSelected,
        onChange: handleRowSelected(rowData._id)
      });else return jsx(IndeterminateCheckBoxIcon, {
        style: styles$1.checkbox,
        "aria-label": rowData._id,
        color: 'disabled'
      });
    },
    width: 60,
    flexShrink: 1,
    flexGrow: 0
  }, {
    label: jsx(Typography, Object.assign({
      style: {
        paddingLeft: 10,
        textAlign: 'center'
      }
    }, {
      children: localize('go_to_user_overview')
    })),
    headerStyle: styles$1.header,
    dataKey: 'link',
    dataFn: ({
      rowData
    }) => {
      var _a;
      const from = (_a = rowData.content) === null || _a === void 0 ? void 0 : _a.from;
      const url = `/user-overview/${from === null || from === void 0 ? void 0 : from._id}`;
      if (rowData.from && !noLinkBannerTypes.includes(rowData.banner_type)) {
        return jsx(IconButton, Object.assign({
          component: Link,
          to: url,
          style: {
            marginRight: 'auto',
            marginLeft: 'auto'
          }
        }, {
          children: jsx(OpenInNewIcon, {})
        }));
      } else return jsx(IconButton, Object.assign({
        disabled: true,
        style: {
          marginRight: 'auto',
          marginLeft: 'auto'
        }
      }, {
        children: jsx(OpenInNewIcon, {})
      }));
    },
    width: 160,
    flexGrow: 0
  }, {
    label: jsx(Typography, {
      children: 'Alert'
    }),
    headerStyle: styles$1.header,
    dataKey: '',
    dataFn: ({
      rowData
    }) => jsx(BannerText, {
      banner: rowData
    }),
    width: 500,
    flexGrow: 1
  }], [anchorEl, handleRowSelected, handleSelectAll, listMenuItems, localize, menuOpen, noLinkBannerTypes]);
  return jsx(VirtualizedTable, {
    rowCount: renderData.length,
    rowGetter: ({
      index
    }) => renderData[index],
    headerHeight: 50,
    columns: columns
  });
};

const styles = {
  filterTitle: {
    fontFamily: 'Poppins',
    color: '#006064',
    fontSize: 14,
    marginBottom: 3
  },
  filterGridContainer: {
    paddingTop: 8,
    paddingBottom: 8
  },
  clearFiltersButtonContainer: {
    paddingTop: 20,
    paddingBottom: 10
  },
  selectContainer: {
    display: 'flex',
    width: '200px',
    justifyContent: 'center'
  }
};
const Notifications = props => {
  const {
    localize
  } = useLocalize();
  const {
    userMetrics
  } = useUserMetrics();
  const {
    banners,
    isLoading,
    noDataLeft,
    nextPage,
    markBannerRead,
    clearFilters,
    filterBySearch,
    filterByStartDate,
    filterByEndDate
  } = useBanners();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const clear = useCallback(() => {
    userMetrics.trackEvent("notifications: clear filters");
    setStartDate(null);
    setEndDate(null);
    clearFilters();
  }, [clearFilters, userMetrics]);
  const handleNextPage = useCallback(() => {
    if (banners.length > 24 && !noDataLeft) {
      nextPage();
    }
  }, [nextPage, banners.length, noDataLeft]);
  React__default.useEffect(() => {
    userMetrics.trackEvent("page view", {
      page: "notifications",
      category: "notifications",
      "permission level": "notifications"
    });
  }, [userMetrics]);
  return jsxs(Grid, Object.assign({
    container: true,
    spacing: 2,
    style: {
      padding: 10
    }
  }, {
    children: [jsxs(Grid, Object.assign({
      item: true,
      container: true,
      xs: 12,
      alignItems: "center"
    }, {
      children: [jsx(Grid, Object.assign({
        item: true,
        xs: 12
      }, {
        children: jsx(SearchBar, {
          id: 'search-notifications',
          testId: 'search-notifications',
          placeholder: localize("notification_search_placeholder"),
          theme: LogisticsTheme,
          width: "100%",
          onChange: event => filterBySearch(event.target.value)
        })
      })), jsxs(Grid, Object.assign({
        container: true,
        direction: "row",
        spacing: 2
      }, {
        children: [jsx(Grid, Object.assign({
          item: true,
          xs: 2
        }, {
          children: jsxs("div", Object.assign({
            style: styles.filterGridContainer
          }, {
            children: [jsx("div", Object.assign({
              style: styles.filterTitle
            }, {
              children: 'Start Date'
            })), jsx(MuiPickersUtilsProvider, Object.assign({
              utils: DateFnsUtils
            }, {
              children: jsx(KeyboardDatePicker, {
                autoOk: true,
                clearable: true,
                variant: "inline",
                format: "MM/dd/yyyy",
                id: "startDate",
                value: startDate,
                onChange: e => {
                  setStartDate(e);
                  filterByStartDate(e);
                  userMetrics.trackEvent("notifications: filter by start date", {
                    startDate: e
                  });
                },
                KeyboardButtonProps: {
                  'aria-label': 'change start date'
                }
              })
            }))]
          }))
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 2
        }, {
          children: jsxs("div", Object.assign({
            style: styles.filterGridContainer
          }, {
            children: [jsx("div", Object.assign({
              style: styles.filterTitle
            }, {
              children: 'End Date'
            })), jsx(MuiPickersUtilsProvider, Object.assign({
              utils: DateFnsUtils
            }, {
              children: jsx(KeyboardDatePicker, {
                autoOk: true,
                clearable: true,
                variant: "inline",
                format: "MM/dd/yyyy",
                id: "endDate",
                value: endDate,
                onChange: e => {
                  setEndDate(e);
                  filterByEndDate(e);
                  userMetrics.trackEvent("notifications: filter by end date", {
                    endDate: e
                  });
                },
                KeyboardButtonProps: {
                  'aria-label': 'change end date'
                }
              })
            }))]
          }))
        })), jsx(Grid, Object.assign({
          item: true,
          xs: 2
        }, {
          children: jsx("div", Object.assign({
            style: styles.clearFiltersButtonContainer
          }, {
            children: jsx(Button, Object.assign({
              variant: "contained",
              color: "primary",
              onClick: clear
            }, {
              children: localize('Clear_Filter')
            }))
          }))
        }))]
      }))]
    })), jsx(Grid, Object.assign({
      item: true,
      container: true,
      xs: 12
    }, {
      children: jsx(InfiniteScroll, Object.assign({
        loadMore: handleNextPage,
        isLoading: isLoading
      }, {
        children: jsx(Paper, Object.assign({
          style: {
            display: 'flex',
            flex: 1
          }
        }, {
          children: jsx(NotificationsTable, {
            data: banners,
            onSelected: selected => markBannerRead(selected)
          })
        }))
      }))
    })), jsx(Grid, Object.assign({
      item: true,
      xs: 12
    }, {
      children: isLoading && jsx(Box, Object.assign({
        style: {
          display: 'flex',
          justifyContent: 'center',
          color: 'primary'
        }
      }, {
        children: jsx(SpinningIcon, {
          icon: Sync,
          spinning: true
        })
      }))
    }))]
  }));
};
const PatientNotificationsPage = props => jsx(PageWithProviders, Object.assign({
  headerTitle: "dashboards_notifications",
  padding: 23
}, {
  children: jsx(UserPublicDataProvider, {
    children: jsx(WorkflowDefinitionTrackerProvider, {
      children: jsx(OngoingWorkflowTrackerProvider, {
        children: jsx(BannersProvider, {
          children: jsx(Notifications, Object.assign({}, props))
        })
      })
    })
  })
}));

export { ActionDialog, AdminOrganizationsPage, ChainStoreInitializer, CovertTextEditor, CustomRadio, CustomReportsPage, ErrorToast, Filters, Header$2 as Header, IconButtonMenu, InfiniteScroll, LogisticsNotificationsPage, LogisticsPage, MaskedHealthCardInput, MaskedInput, MaskedInputWithSelect, MaskedPhoneInput, MaskedPostalInput, PageWithProviders as Page, PatientNotificationsPage, PatientsPage, SearchBar, SearchPeopleModal, SometimesPersistentTooltip, SpinningIcon, StoreInitializer, TabModal, TabNavigation, TextInput, TextMultiSelect, TextSelect, VirtualizedTable, index as themes };
